export const buildings = [
    {
      "type": "Feature",
      "properties": {
        "@id": "relation/6457444",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "N23",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "yes",
        "image": "https://map.um.edu.mo/emap_images/building_N23.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "科研大樓 Edifício de Ciências (N23)",
        "name:en": "Research Building (N23)",
        "name:pt": "Edifício de Ciências (N23)",
        "name:zh": "科研大樓 (N23)",
        "ref": "N23",
        "type": "multipolygon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.544729,
              22.1357538
            ],
            [
              113.5447287,
              22.135601
            ],
            [
              113.5447285,
              22.1354533
            ],
            [
              113.5447844,
              22.1354545
            ],
            [
              113.5448745,
              22.1354554
            ],
            [
              113.5450138,
              22.1354468
            ],
            [
              113.5451209,
              22.1354528
            ],
            [
              113.5452044,
              22.1354468
            ],
            [
              113.5452639,
              22.1354533
            ],
            [
              113.5452696,
              22.1351922
            ],
            [
              113.545327,
              22.1351944
            ],
            [
              113.5453266,
              22.1354538
            ],
            [
              113.5457244,
              22.1354552
            ],
            [
              113.5457247,
              22.1351942
            ],
            [
              113.5458051,
              22.1351946
            ],
            [
              113.5458081,
              22.1357523
            ],
            [
              113.544729,
              22.1357538
            ]
          ]
        ]
      },
      "id": "relation/6457444"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "relation/7786319",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "E3 E4 E5 E6 E7",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "university",
        "image": "https://map.um.edu.mo/emap_images/building_E3_to_E7.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "中央教學樓 Sala de Aulas: Edifício Central (E3,E4,E5,E6,E7)",
        "name:en": "Central Teaching Building (E3,E4,E5,E6,E7)",
        "name:pt": "Sala de Aulas: Edifício Central (E3,E4,E5,E6,E7)",
        "name:zh": "中央教學樓 (E3,E4,E5,E6,E7)",
        "type": "multipolygon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5450081,
              22.1282833
            ],
            [
              113.5450081,
              22.128258
            ],
            [
              113.5450081,
              22.1282232
            ],
            [
              113.5449427,
              22.1282232
            ],
            [
              113.5449429,
              22.1279736
            ],
            [
              113.5449429,
              22.1279517
            ],
            [
              113.5449537,
              22.1279517
            ],
            [
              113.5449537,
              22.1279414
            ],
            [
              113.5458111,
              22.1279419
            ],
            [
              113.5458112,
              22.1277506
            ],
            [
              113.5461152,
              22.1277508
            ],
            [
              113.5461138,
              22.1279536
            ],
            [
              113.546115,
              22.1281123
            ],
            [
              113.545963,
              22.1281122
            ],
            [
              113.545963,
              22.1281326
            ],
            [
              113.5460175,
              22.1281326
            ],
            [
              113.5460174,
              22.1282254
            ],
            [
              113.5460174,
              22.1282934
            ],
            [
              113.5459631,
              22.1282934
            ],
            [
              113.545963,
              22.1283235
            ],
            [
              113.5461804,
              22.1283236
            ],
            [
              113.5461801,
              22.1287661
            ],
            [
              113.5462673,
              22.1287661
            ],
            [
              113.5462672,
              22.1288668
            ],
            [
              113.5462671,
              22.1291279
            ],
            [
              113.5462997,
              22.1291279
            ],
            [
              113.5462996,
              22.1292486
            ],
            [
              113.5461695,
              22.1292485
            ],
            [
              113.5461695,
              22.1292287
            ],
            [
              113.5459198,
              22.1292286
            ],
            [
              113.5459197,
              22.1292683
            ],
            [
              113.5457973,
              22.1292682
            ],
            [
              113.5456528,
              22.1292681
            ],
            [
              113.5456528,
              22.129221
            ],
            [
              113.545453,
              22.1292209
            ],
            [
              113.545453,
              22.1292586
            ],
            [
              113.5453853,
              22.1292586
            ],
            [
              113.545312,
              22.1292585
            ],
            [
              113.5453121,
              22.129128
            ],
            [
              113.5453554,
              22.1291281
            ],
            [
              113.5453554,
              22.129098
            ],
            [
              113.5448667,
              22.1290977
            ],
            [
              113.5448667,
              22.1290176
            ],
            [
              113.5448342,
              22.1290176
            ],
            [
              113.5448341,
              22.1290275
            ],
            [
              113.5447042,
              22.1290274
            ],
            [
              113.5447043,
              22.1288965
            ],
            [
              113.544769,
              22.1288966
            ],
            [
              113.544769,
              22.1288763
            ],
            [
              113.5446388,
              22.1288762
            ],
            [
              113.5446388,
              22.1288469
            ],
            [
              113.544639,
              22.1286053
            ],
            [
              113.5448453,
              22.1286054
            ],
            [
              113.5448453,
              22.1285817
            ],
            [
              113.5448454,
              22.1285548
            ],
            [
              113.5447907,
              22.1285548
            ],
            [
              113.5447909,
              22.1282832
            ],
            [
              113.5450081,
              22.1282833
            ]
          ],
          [
            [
              113.5454653,
              22.1288347
            ],
            [
              113.5459589,
              22.1288347
            ],
            [
              113.5459575,
              22.1284757
            ],
            [
              113.5454658,
              22.1284794
            ],
            [
              113.5454653,
              22.1288347
            ]
          ]
        ]
      },
      "id": "relation/7786319"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "relation/7786320",
        "UM-built-type:en": "Academics",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "E21A E21B",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "academics",
        "building": "university",
        "image": "https://map.um.edu.mo/emap_images/building_E21.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "人文學院 Faculdade de Letras(E21A) 社會科學學院 Faculdade de Ciências Sociais (E21B)",
        "name:en": "Faculty of Arts and Humanities (E21A) Faculty of Social Sciences (E21B)",
        "name:pt": "Faculdade de Letras (E21A) Faculdade de Ciências Sociais (E21B)",
        "name:zh": "人文學院 (E21A) 社會科學學院 (E21B)",
        "note": "Zone East, Academics",
        "type": "multipolygon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5433527,
              22.1297015
            ],
            [
              113.5424711,
              22.1297083
            ],
            [
              113.5424701,
              22.1296028
            ],
            [
              113.5424693,
              22.1295103
            ],
            [
              113.5427439,
              22.1295081
            ],
            [
              113.5427436,
              22.1294669
            ],
            [
              113.5426024,
              22.1294584
            ],
            [
              113.542599,
              22.1290756
            ],
            [
              113.5424764,
              22.1290813
            ],
            [
              113.5424754,
              22.128974
            ],
            [
              113.5424745,
              22.1288766
            ],
            [
              113.5424794,
              22.1288501
            ],
            [
              113.5428876,
              22.1288493
            ],
            [
              113.5436008,
              22.1288477
            ],
            [
              113.5435318,
              22.1290741
            ],
            [
              113.5435367,
              22.1296271
            ],
            [
              113.5434687,
              22.1296276
            ],
            [
              113.543469,
              22.1296669
            ],
            [
              113.54347,
              22.1297773
            ],
            [
              113.5433889,
              22.1297779
            ],
            [
              113.5433534,
              22.1297782
            ],
            [
              113.5433527,
              22.1297015
            ]
          ],
          [
            [
              113.5428806,
              22.1294287
            ],
            [
              113.5433004,
              22.1294287
            ],
            [
              113.5433004,
              22.1291119
            ],
            [
              113.5428819,
              22.1291156
            ],
            [
              113.5428806,
              22.1294287
            ]
          ]
        ]
      },
      "id": "relation/7786320"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "relation/9124054",
        "area": "yes",
        "leisure": "track",
        "sport": "running",
        "type": "multipolygon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5416532,
              22.1344734
            ],
            [
              113.5416438,
              22.1345504
            ],
            [
              113.5416196,
              22.1346076
            ],
            [
              113.5415848,
              22.1346635
            ],
            [
              113.5415271,
              22.1347268
            ],
            [
              113.5414547,
              22.1347753
            ],
            [
              113.5413621,
              22.1348175
            ],
            [
              113.5412776,
              22.1348324
            ],
            [
              113.5412039,
              22.1348324
            ],
            [
              113.5411194,
              22.1348213
            ],
            [
              113.541047,
              22.1347989
            ],
            [
              113.5409933,
              22.1347591
            ],
            [
              113.5409477,
              22.1347132
            ],
            [
              113.5409115,
              22.1346672
            ],
            [
              113.5408136,
              22.134666
            ],
            [
              113.5408123,
              22.1334038
            ],
            [
              113.5408995,
              22.1334038
            ],
            [
              113.5409531,
              22.1333454
            ],
            [
              113.5410081,
              22.1333007
            ],
            [
              113.5410698,
              22.1332734
            ],
            [
              113.5411462,
              22.133256
            ],
            [
              113.5412307,
              22.1332498
            ],
            [
              113.5413112,
              22.1332523
            ],
            [
              113.541401,
              22.1332684
            ],
            [
              113.5414667,
              22.133292
            ],
            [
              113.5415311,
              22.1333293
            ],
            [
              113.5415901,
              22.1333839
            ],
            [
              113.5416317,
              22.1334498
            ],
            [
              113.5416505,
              22.1335181
            ],
            [
              113.5416612,
              22.13361
            ],
            [
              113.5416532,
              22.1344734
            ]
          ],
          [
            [
              113.5409252,
              22.13459
            ],
            [
              113.5409856,
              22.1346631
            ],
            [
              113.5410602,
              22.1347161
            ],
            [
              113.5411451,
              22.1347399
            ],
            [
              113.541221,
              22.1347513
            ],
            [
              113.5413071,
              22.1347479
            ],
            [
              113.5413929,
              22.1347254
            ],
            [
              113.5414587,
              22.1346803
            ],
            [
              113.5415132,
              22.1346232
            ],
            [
              113.5415444,
              22.1345744
            ],
            [
              113.5415665,
              22.1345105
            ],
            [
              113.5415671,
              22.1344665
            ],
            [
              113.5415764,
              22.1336209
            ],
            [
              113.5415651,
              22.1335229
            ],
            [
              113.5415377,
              22.133443
            ],
            [
              113.5414861,
              22.1333979
            ],
            [
              113.5414243,
              22.1333601
            ],
            [
              113.541354,
              22.1333356
            ],
            [
              113.5412575,
              22.1333273
            ],
            [
              113.5411692,
              22.1333348
            ],
            [
              113.5410957,
              22.1333548
            ],
            [
              113.5410314,
              22.1333856
            ],
            [
              113.5409831,
              22.1334287
            ],
            [
              113.5409444,
              22.1334669
            ],
            [
              113.540921,
              22.1335034
            ],
            [
              113.5409002,
              22.1335604
            ],
            [
              113.5408916,
              22.1336212
            ],
            [
              113.5408866,
              22.1344743
            ],
            [
              113.5408992,
              22.1345284
            ],
            [
              113.5409252,
              22.13459
            ]
          ]
        ]
      },
      "id": "relation/9124054"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "relation/17688658",
        "leisure": "park",
        "name": "天沐河公园",
        "type": "multipolygon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.534831,
              22.134989
            ],
            [
              113.5349554,
              22.1349927
            ],
            [
              113.5349441,
              22.1352982
            ],
            [
              113.5378421,
              22.1353663
            ],
            [
              113.5390876,
              22.1354136
            ],
            [
              113.5392614,
              22.1354946
            ],
            [
              113.5393094,
              22.1355649
            ],
            [
              113.5392605,
              22.1363214
            ],
            [
              113.5392012,
              22.136409
            ],
            [
              113.539125,
              22.1364499
            ],
            [
              113.5390688,
              22.1364685
            ],
            [
              113.5366931,
              22.1363384
            ],
            [
              113.5364001,
              22.1363495
            ],
            [
              113.5358784,
              22.1363867
            ],
            [
              113.5351962,
              22.1363607
            ],
            [
              113.5349869,
              22.1363357
            ],
            [
              113.5336894,
              22.1363292
            ],
            [
              113.533277,
              22.1363093
            ],
            [
              113.5330651,
              22.136304
            ],
            [
              113.5328122,
              22.1363128
            ],
            [
              113.5324686,
              22.1363128
            ],
            [
              113.5323111,
              22.1362598
            ],
            [
              113.5319341,
              22.1362731
            ],
            [
              113.5317576,
              22.1363173
            ],
            [
              113.5272192,
              22.136388
            ],
            [
              113.5271714,
              22.1364322
            ],
            [
              113.5271158,
              22.1364322
            ],
            [
              113.5269602,
              22.1364322
            ],
            [
              113.5267419,
              22.1364322
            ],
            [
              113.5262027,
              22.1364013
            ],
            [
              113.5259927,
              22.1364013
            ],
            [
              113.5257923,
              22.1364322
            ],
            [
              113.5255823,
              22.136441
            ],
            [
              113.5241745,
              22.1364764
            ],
            [
              113.523702,
              22.1364852
            ],
            [
              113.5235842,
              22.1364893
            ],
            [
              113.5233155,
              22.136525
            ],
            [
              113.5232057,
              22.1364985
            ],
            [
              113.5206621,
              22.1365162
            ],
            [
              113.5205619,
              22.1365471
            ],
            [
              113.5201324,
              22.1365692
            ],
            [
              113.5200322,
              22.136556
            ],
            [
              113.5190968,
              22.1365692
            ],
            [
              113.5177511,
              22.1365427
            ],
            [
              113.5171879,
              22.1364985
            ],
            [
              113.5170018,
              22.1364543
            ],
            [
              113.5167632,
              22.1364543
            ],
            [
              113.5166344,
              22.1364543
            ],
            [
              113.5154986,
              22.1363084
            ],
            [
              113.5145728,
              22.1361891
            ],
            [
              113.5141337,
              22.1361139
            ],
            [
              113.5130934,
              22.1358841
            ],
            [
              113.5129597,
              22.1358133
            ],
            [
              113.5125923,
              22.1357691
            ],
            [
              113.5124711,
              22.1357851
            ],
            [
              113.5120769,
              22.1356188
            ],
            [
              113.5120148,
              22.1355393
            ],
            [
              113.5120064,
              22.1354463
            ],
            [
              113.5120437,
              22.1352993
            ],
            [
              113.5116712,
              22.1352033
            ],
            [
              113.511614,
              22.1353492
            ],
            [
              113.5115185,
              22.1354111
            ],
            [
              113.5113849,
              22.1354243
            ],
            [
              113.5108075,
              22.1352343
            ],
            [
              113.5105593,
              22.1352121
            ],
            [
              113.5097719,
              22.1349602
            ],
            [
              113.5096764,
              22.1349513
            ],
            [
              113.5092715,
              22.1347966
            ],
            [
              113.5087506,
              22.1345977
            ],
            [
              113.5071806,
              22.1339965
            ],
            [
              113.505978,
              22.1335456
            ],
            [
              113.5053146,
              22.1333069
            ],
            [
              113.5051094,
              22.1332406
            ],
            [
              113.5046131,
              22.1330505
            ],
            [
              113.5029476,
              22.1324449
            ],
            [
              113.5008526,
              22.1316359
            ],
            [
              113.4967008,
              22.1300799
            ],
            [
              113.4970062,
              22.1295096
            ],
            [
              113.4973307,
              22.129514
            ],
            [
              113.4973151,
              22.1284004
            ],
            [
              113.4973593,
              22.1282983
            ],
            [
              113.4973975,
              22.1281392
            ],
            [
              113.4975168,
              22.1279181
            ],
            [
              113.4978652,
              22.1280463
            ],
            [
              113.4980148,
              22.1278573
            ],
            [
              113.5018769,
              22.1296168
            ],
            [
              113.5018192,
              22.1300524
            ],
            [
              113.5019609,
              22.1300872
            ],
            [
              113.502006,
              22.1301756
            ],
            [
              113.5021508,
              22.1304597
            ],
            [
              113.5028952,
              22.1307932
            ],
            [
              113.5040005,
              22.1312884
            ],
            [
              113.5053684,
              22.1319013
            ],
            [
              113.5056792,
              22.1320452
            ],
            [
              113.5059276,
              22.1314973
            ],
            [
              113.5076817,
              22.1320647
            ],
            [
              113.5102062,
              22.1328118
            ],
            [
              113.5120339,
              22.1332981
            ],
            [
              113.5119814,
              22.1335014
            ],
            [
              113.5127879,
              22.1336924
            ],
            [
              113.512843,
              22.133518
            ],
            [
              113.5149354,
              22.1340319
            ],
            [
              113.5155367,
              22.1341556
            ],
            [
              113.5165055,
              22.1342838
            ],
            [
              113.5171927,
              22.1342485
            ],
            [
              113.5177686,
              22.134199
            ],
            [
              113.5182474,
              22.1341999
            ],
            [
              113.5184478,
              22.1342175
            ],
            [
              113.5184908,
              22.1343104
            ],
            [
              113.5188057,
              22.1342971
            ],
            [
              113.5189107,
              22.1341866
            ],
            [
              113.519555,
              22.1341026
            ],
            [
              113.5200274,
              22.1340009
            ],
            [
              113.5205667,
              22.1338993
            ],
            [
              113.5205428,
              22.1338639
            ],
            [
              113.5216404,
              22.1333069
            ],
            [
              113.5224469,
              22.1329488
            ],
            [
              113.5230482,
              22.1328074
            ],
            [
              113.5233727,
              22.1327366
            ],
            [
              113.5246708,
              22.1325598
            ],
            [
              113.5264938,
              22.1324651
            ],
            [
              113.5281593,
              22.1323786
            ],
            [
              113.5306218,
              22.1324007
            ],
            [
              113.5317044,
              22.132286
            ],
            [
              113.5325093,
              22.1325936
            ],
            [
              113.5330397,
              22.1328362
            ],
            [
              113.5334272,
              22.133063
            ],
            [
              113.5335226,
              22.1331859
            ],
            [
              113.5338001,
              22.1336826
            ],
            [
              113.5339241,
              22.1338506
            ],
            [
              113.533948,
              22.1341159
            ],
            [
              113.5339766,
              22.1343236
            ],
            [
              113.5342821,
              22.1343546
            ],
            [
              113.5346301,
              22.1343832
            ],
            [
              113.5346865,
              22.1337697
            ],
            [
              113.5347587,
              22.1334017
            ],
            [
              113.5347668,
              22.1333051
            ],
            [
              113.5347587,
              22.1332233
            ],
            [
              113.5347989,
              22.1328367
            ],
            [
              113.5348697,
              22.1327793
            ],
            [
              113.5349915,
              22.1327474
            ],
            [
              113.5350597,
              22.1328515
            ],
            [
              113.534831,
              22.134989
            ]
          ]
        ]
      },
      "id": "relation/17688658"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "relation/18474349",
        "access": "private",
        "leisure": "track",
        "type": "multipolygon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.536374,
              22.1312963
            ],
            [
              113.5363734,
              22.131407
            ],
            [
              113.5362861,
              22.1314065
            ],
            [
              113.5362912,
              22.1304854
            ],
            [
              113.5363785,
              22.1304858
            ],
            [
              113.5363781,
              22.1305559
            ],
            [
              113.5364012,
              22.1305371
            ],
            [
              113.5364562,
              22.1305107
            ],
            [
              113.5365164,
              22.1304973
            ],
            [
              113.5365783,
              22.1304976
            ],
            [
              113.5366383,
              22.1305116
            ],
            [
              113.536693,
              22.1305385
            ],
            [
              113.5367391,
              22.1305768
            ],
            [
              113.536774,
              22.1306241
            ],
            [
              113.5367957,
              22.1306779
            ],
            [
              113.5368022,
              22.1307299
            ],
            [
              113.5368,
              22.1311263
            ],
            [
              113.5367929,
              22.1311783
            ],
            [
              113.5367707,
              22.1312319
            ],
            [
              113.5367352,
              22.1312789
            ],
            [
              113.5366887,
              22.1313167
            ],
            [
              113.5366337,
              22.1313431
            ],
            [
              113.5365735,
              22.1313565
            ],
            [
              113.5365116,
              22.1313562
            ],
            [
              113.5364516,
              22.1313422
            ],
            [
              113.5363969,
              22.1313153
            ],
            [
              113.536374,
              22.1312963
            ]
          ],
          [
            [
              113.536375,
              22.1311194
            ],
            [
              113.5363797,
              22.1311569
            ],
            [
              113.5363939,
              22.1311922
            ],
            [
              113.5364169,
              22.1312234
            ],
            [
              113.5364472,
              22.1312485
            ],
            [
              113.5364832,
              22.1312662
            ],
            [
              113.5365227,
              22.1312754
            ],
            [
              113.5365634,
              22.1312756
            ],
            [
              113.536603,
              22.1312668
            ],
            [
              113.5366391,
              22.1312494
            ],
            [
              113.5366697,
              22.1312246
            ],
            [
              113.536693,
              22.1311936
            ],
            [
              113.5367077,
              22.1311584
            ],
            [
              113.5367128,
              22.131121
            ],
            [
              113.5367149,
              22.1307344
            ],
            [
              113.5367102,
              22.1306969
            ],
            [
              113.536696,
              22.1306616
            ],
            [
              113.536673,
              22.1306305
            ],
            [
              113.5366427,
              22.1306053
            ],
            [
              113.5366067,
              22.1305876
            ],
            [
              113.5365672,
              22.1305784
            ],
            [
              113.5365265,
              22.1305782
            ],
            [
              113.5364869,
              22.130587
            ],
            [
              113.5364508,
              22.1306044
            ],
            [
              113.5364202,
              22.1306293
            ],
            [
              113.5363969,
              22.1306602
            ],
            [
              113.5363822,
              22.1306954
            ],
            [
              113.5363771,
              22.1307328
            ],
            [
              113.536375,
              22.1311194
            ]
          ]
        ]
      },
      "id": "relation/18474349"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/163703169",
        "addr:housenumber": "199",
        "addr:province": "澳門",
        "addr:street": "石排灣廣場",
        "email": "info@mgc-mo.com",
        "facebook": "https://www.facebook.com/caesarsgolfmacau/",
        "fax": "+853-2888-0133",
        "leisure": "golf_course",
        "name": "澳門國際高爾夫 Macau Golfe Internacional",
        "name:en": "Macau International Golf",
        "name:pt": "Macau Golfe Internacional",
        "name:zh": "澳門國際高爾夫",
        "name:zh-Hans": "澳门国际高尔夫",
        "name:zh-Hant": "澳門國際高爾夫",
        "old_name": "澳門凱撒高爾夫球會 Caesars Golf Macau",
        "old_name:en": "Caesars Golf Macau",
        "old_name:zh": "澳門凱撒高爾夫球會",
        "phone": "+853-2831-3139",
        "website": "http://www.migmacau.com/",
        "wikipedia": "en:Caesars Golf Macau"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.553152,
              22.1393266
            ],
            [
              113.5530193,
              22.1392838
            ],
            [
              113.5529322,
              22.1392189
            ],
            [
              113.5528162,
              22.1389762
            ],
            [
              113.5527137,
              22.138735
            ],
            [
              113.5526932,
              22.1384617
            ],
            [
              113.5526236,
              22.1350121
            ],
            [
              113.5526243,
              22.1343546
            ],
            [
              113.5526022,
              22.1340563
            ],
            [
              113.5526195,
              22.1338529
            ],
            [
              113.5526469,
              22.1336411
            ],
            [
              113.552711,
              22.1334349
            ],
            [
              113.5527973,
              22.1332532
            ],
            [
              113.5530006,
              22.1329086
            ],
            [
              113.5531104,
              22.1327702
            ],
            [
              113.5536226,
              22.1323381
            ],
            [
              113.5538808,
              22.1322063
            ],
            [
              113.5541888,
              22.1320914
            ],
            [
              113.5544611,
              22.1320331
            ],
            [
              113.5546604,
              22.132018
            ],
            [
              113.5577532,
              22.131889
            ],
            [
              113.558304,
              22.1319097
            ],
            [
              113.5583318,
              22.1319096
            ],
            [
              113.5589106,
              22.1319068
            ],
            [
              113.5590906,
              22.1318957
            ],
            [
              113.5591292,
              22.1319327
            ],
            [
              113.5592934,
              22.13209
            ],
            [
              113.5593363,
              22.132408
            ],
            [
              113.5593685,
              22.1335069
            ],
            [
              113.5594358,
              22.1335897
            ],
            [
              113.5596373,
              22.1335833
            ],
            [
              113.5597824,
              22.1336989
            ],
            [
              113.55986,
              22.1337608
            ],
            [
              113.5601108,
              22.1339839
            ],
            [
              113.5602256,
              22.1340228
            ],
            [
              113.560245,
              22.1340294
            ],
            [
              113.5605325,
              22.1340497
            ],
            [
              113.560707,
              22.133973
            ],
            [
              113.560933,
              22.1337761
            ],
            [
              113.5610155,
              22.1337066
            ],
            [
              113.56109,
              22.1336439
            ],
            [
              113.561108,
              22.1336287
            ],
            [
              113.5611597,
              22.1336273
            ],
            [
              113.5616707,
              22.133614
            ],
            [
              113.5617328,
              22.1336124
            ],
            [
              113.5617929,
              22.1336108
            ],
            [
              113.5618906,
              22.1336083
            ],
            [
              113.5620569,
              22.1336028
            ],
            [
              113.5621082,
              22.1336026
            ],
            [
              113.5622299,
              22.1335994
            ],
            [
              113.5623758,
              22.1335956
            ],
            [
              113.5625004,
              22.1335924
            ],
            [
              113.5626475,
              22.1335885
            ],
            [
              113.5628437,
              22.1335834
            ],
            [
              113.5628974,
              22.133582
            ],
            [
              113.5629521,
              22.1350082
            ],
            [
              113.5629277,
              22.1352963
            ],
            [
              113.5629874,
              22.136647
            ],
            [
              113.5630021,
              22.1369775
            ],
            [
              113.5630446,
              22.1379396
            ],
            [
              113.5630274,
              22.1380235
            ],
            [
              113.5629853,
              22.1381171
            ],
            [
              113.5629246,
              22.1382268
            ],
            [
              113.5628875,
              22.1383063
            ],
            [
              113.5627947,
              22.1384044
            ],
            [
              113.5627188,
              22.1384963
            ],
            [
              113.5626671,
              22.1385379
            ],
            [
              113.5626153,
              22.1385547
            ],
            [
              113.5615035,
              22.1386591
            ],
            [
              113.5615009,
              22.13851
            ],
            [
              113.5614717,
              22.1384979
            ],
            [
              113.5613748,
              22.1384578
            ],
            [
              113.561246,
              22.138341
            ],
            [
              113.5610244,
              22.1382665
            ],
            [
              113.5605054,
              22.1382503
            ],
            [
              113.5604213,
              22.138228
            ],
            [
              113.5599651,
              22.1379831
            ],
            [
              113.5596378,
              22.1383088
            ],
            [
              113.5593578,
              22.1381323
            ],
            [
              113.5592183,
              22.1380827
            ],
            [
              113.5584599,
              22.1381353
            ],
            [
              113.5582924,
              22.1381469
            ],
            [
              113.5582121,
              22.1381524
            ],
            [
              113.5576412,
              22.138192
            ],
            [
              113.5574266,
              22.1382914
            ],
            [
              113.5570937,
              22.1386519
            ],
            [
              113.5568705,
              22.1388936
            ],
            [
              113.5567292,
              22.1390466
            ],
            [
              113.553152,
              22.1393266
            ]
          ]
        ]
      },
      "id": "way/163703169"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/173697075",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5520124,
              22.1218606
            ],
            [
              113.5524062,
              22.1214629
            ],
            [
              113.5526752,
              22.1216618
            ],
            [
              113.5522781,
              22.1220679
            ],
            [
              113.5520124,
              22.1218606
            ]
          ]
        ]
      },
      "id": "way/173697075"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/229205164",
        "internet_access": "wlan",
        "leisure": "park",
        "name": "石排灣郊野公園 Parque de Seac Pai Van",
        "name:en": "Seac Pai Van Park",
        "name:pt": "Parque de Seac Pai Van",
        "name:zh": "石排灣郊野公園",
        "name:zh-Hans": "石排湾郊野公园",
        "name:zh-Hant": "石排灣郊野公園",
        "opening_hours": "06:00-22:00",
        "operator": "IAM",
        "operator:type": "government"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5558958,
              22.1258101
            ],
            [
              113.555891,
              22.1257838
            ],
            [
              113.5558862,
              22.1257576
            ],
            [
              113.5563524,
              22.1259074
            ],
            [
              113.5564071,
              22.1256085
            ],
            [
              113.5564958,
              22.1255068
            ],
            [
              113.5566728,
              22.1254023
            ],
            [
              113.5570295,
              22.1253501
            ],
            [
              113.5574479,
              22.1256234
            ],
            [
              113.5579468,
              22.1254669
            ],
            [
              113.5584135,
              22.1255762
            ],
            [
              113.5582794,
              22.1258694
            ],
            [
              113.5586665,
              22.1263303
            ],
            [
              113.5590678,
              22.1263895
            ],
            [
              113.5598737,
              22.1265454
            ],
            [
              113.5600577,
              22.1267465
            ],
            [
              113.5596742,
              22.1267614
            ],
            [
              113.5595854,
              22.1268398
            ],
            [
              113.5592853,
              22.126995
            ],
            [
              113.5592021,
              22.1271093
            ],
            [
              113.5589875,
              22.1272608
            ],
            [
              113.5592423,
              22.1275714
            ],
            [
              113.5593775,
              22.1277801
            ],
            [
              113.5591906,
              22.1279628
            ],
            [
              113.5591266,
              22.128126
            ],
            [
              113.5587705,
              22.128224
            ],
            [
              113.5587434,
              22.1282315
            ],
            [
              113.5586932,
              22.1280577
            ],
            [
              113.5585389,
              22.1275229
            ],
            [
              113.5585091,
              22.1274729
            ],
            [
              113.5584019,
              22.1272935
            ],
            [
              113.5583221,
              22.1271653
            ],
            [
              113.5582412,
              22.1270351
            ],
            [
              113.5580553,
              22.1268068
            ],
            [
              113.5580202,
              22.1267637
            ],
            [
              113.5577922,
              22.1265523
            ],
            [
              113.5576556,
              22.1264382
            ],
            [
              113.5574676,
              22.126328
            ],
            [
              113.5571909,
              22.1262232
            ],
            [
              113.5558958,
              22.1258101
            ]
          ]
        ]
      },
      "id": "way/229205164"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/229290441",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5526242,
              22.1196733
            ],
            [
              113.55289,
              22.1197775
            ],
            [
              113.5528509,
              22.119863
            ],
            [
              113.5525851,
              22.1197587
            ],
            [
              113.5526242,
              22.1196733
            ]
          ]
        ]
      },
      "id": "way/229290441"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/229290458",
        "amenity": "police",
        "building": "yes",
        "name": "路環警司處分站 Posto do Comissariado de Coloane",
        "name:pt": "Posto do Comissariado de Coloane",
        "name:zh": "路環警司處分站",
        "opening_hours": "24/7"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5532861,
              22.1197862
            ],
            [
              113.5533555,
              22.1197883
            ],
            [
              113.5534572,
              22.1197913
            ],
            [
              113.5534531,
              22.1199079
            ],
            [
              113.553282,
              22.1199027
            ],
            [
              113.5532861,
              22.1197862
            ]
          ]
        ]
      },
      "id": "way/229290458"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/230853696",
        "building": "yes",
        "height": "15.7",
        "man_made": "works",
        "name": "聯生變電站 Subestação Concórdia",
        "operator": "澳門電力股份有限公司",
        "voltage": "66000"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5540935,
              22.1250118
            ],
            [
              113.5541925,
              22.1248609
            ],
            [
              113.5544963,
              22.1250247
            ],
            [
              113.5543998,
              22.1251655
            ],
            [
              113.5540935,
              22.1250118
            ]
          ]
        ]
      },
      "id": "way/230853696"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/241702230",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "N26",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "university",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "危險品倉庫 Armazém de Mercadorias Perigosas (N26)",
        "name:en": "Dangerous Goods Store (N26)",
        "name:pt": "Armazém de Mercadorias Perigosas (N26)",
        "name:zh": "危險品倉庫(N26)",
        "ref": "N26"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5427056,
              22.1357443
            ],
            [
              113.5427061,
              22.1354027
            ],
            [
              113.5430198,
              22.135403
            ],
            [
              113.5430193,
              22.1357446
            ],
            [
              113.5427056,
              22.1357443
            ]
          ]
        ]
      },
      "id": "way/241702230"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/241702235",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "N25",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "university",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "醫藥檢測樓 Medical and Pharmaceutical Testing Building (N25)",
        "name:en": "Medical and Pharmaceutical Testing Building (N25)",
        "name:zh": "醫藥檢測樓 (N25)",
        "old_name": "動物實驗樓 Edifício dos Testes com Animais (N25)",
        "old_name:en": "Animal Testing Laboratory (N25)",
        "old_name:pt": "Edifício dos Testes com Animais (N25)",
        "old_name:zh": "動物實驗樓",
        "ref": "N25"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5431089,
              22.1357725
            ],
            [
              113.5431098,
              22.1353816
            ],
            [
              113.5434999,
              22.1353824
            ],
            [
              113.5434994,
              22.1356197
            ],
            [
              113.5434991,
              22.1357732
            ],
            [
              113.5431089,
              22.1357725
            ]
          ]
        ]
      },
      "id": "way/241702235"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/241702236",
        "addr:housenumber": "E2",
        "amenity": "library",
        "building": "university",
        "description": "Location: 6/F, UM Wu Yee Sun Library",
        "description:en": "Location: 6/F, UM Wu Yee Sun Library",
        "description:zh": "所在位置: 澳門大學伍宜孫圖書館, 6樓",
        "email": "lib_suggestion@um.edu.mo",
        "image": "https://map.um.edu.mo/emap_images/building_E2.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "伍宜孫圖書館 Biblioteca Wu Yee Sun (E2)",
        "name:en": "Wu Yee Sun Library of the University of Macau (E2)",
        "name:pt": "Biblioteca Wu Yee Sun da Universidade de Macau (E2)",
        "name:zh": "澳門大學伍宜孫圖書館(E2)",
        "opening_hours": "Mo-Fr 08:00-24:00; Sa,Su 09:00-24:00",
        "phone": "+853 8822 8160,  +853 8822 8170",
        "ref": "E2",
        "short_name": "澳門大學圖書館",
        "website": "https://library.umac.mo/",
        "wheelchair": "yes",
        "wikidata": "Q122701651",
        "wikimedia_commons": "Category:University of Macau Wu Yee Sun Library",
        "wikipedia": "zh:澳門大學伍宜孫圖書館"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.544465,
              22.130484
            ],
            [
              113.5444655,
              22.1304152
            ],
            [
              113.5444191,
              22.1304149
            ],
            [
              113.5444218,
              22.1300296
            ],
            [
              113.5444244,
              22.1296707
            ],
            [
              113.5444649,
              22.129671
            ],
            [
              113.5444651,
              22.1296398
            ],
            [
              113.5445726,
              22.1296405
            ],
            [
              113.5445742,
              22.1294189
            ],
            [
              113.5448345,
              22.1294205
            ],
            [
              113.5448343,
              22.1294493
            ],
            [
              113.5448883,
              22.1294496
            ],
            [
              113.5448885,
              22.1294185
            ],
            [
              113.545313,
              22.1294211
            ],
            [
              113.545312,
              22.1295597
            ],
            [
              113.5453554,
              22.1295598
            ],
            [
              113.5453555,
              22.1296509
            ],
            [
              113.5453009,
              22.1296508
            ],
            [
              113.5453008,
              22.1296811
            ],
            [
              113.545192,
              22.1296811
            ],
            [
              113.5451918,
              22.1296508
            ],
            [
              113.545149,
              22.1296509
            ],
            [
              113.545149,
              22.1296709
            ],
            [
              113.5451705,
              22.1296711
            ],
            [
              113.5451707,
              22.129852
            ],
            [
              113.5451599,
              22.1298521
            ],
            [
              113.5451598,
              22.1299426
            ],
            [
              113.5452145,
              22.1299926
            ],
            [
              113.5453443,
              22.1299927
            ],
            [
              113.5453444,
              22.1299125
            ],
            [
              113.5453826,
              22.1299126
            ],
            [
              113.5454107,
              22.1299126
            ],
            [
              113.5454653,
              22.1299127
            ],
            [
              113.5454643,
              22.1300525
            ],
            [
              113.5454634,
              22.1301747
            ],
            [
              113.545409,
              22.1301744
            ],
            [
              113.5453334,
              22.1301739
            ],
            [
              113.5453339,
              22.130104
            ],
            [
              113.5452035,
              22.1301031
            ],
            [
              113.5451604,
              22.1301638
            ],
            [
              113.5451598,
              22.1302442
            ],
            [
              113.5451718,
              22.1302442
            ],
            [
              113.5451705,
              22.1304242
            ],
            [
              113.5451704,
              22.1304353
            ],
            [
              113.5451599,
              22.1304352
            ],
            [
              113.5451597,
              22.130465
            ],
            [
              113.5451923,
              22.1304652
            ],
            [
              113.5451924,
              22.1304449
            ],
            [
              113.545301,
              22.1304456
            ],
            [
              113.5453008,
              22.1304751
            ],
            [
              113.5453655,
              22.1304755
            ],
            [
              113.5453653,
              22.1305025
            ],
            [
              113.5453651,
              22.1305358
            ],
            [
              113.5453115,
              22.1305355
            ],
            [
              113.5453104,
              22.1306869
            ],
            [
              113.5448664,
              22.1306842
            ],
            [
              113.5448677,
              22.1304951
            ],
            [
              113.544921,
              22.1304955
            ],
            [
              113.544921,
              22.1304868
            ],
            [
              113.544465,
              22.130484
            ]
          ]
        ]
      },
      "id": "way/241702236"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/241741095",
        "addr:street": "西堤馬路 Estrada do Dique Oeste",
        "building": "yes",
        "height": "13.9",
        "man_made": "wastewater_plant",
        "name": "路環污水處理廠 Estação de tratamento de Águas residuais de Coloane"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.552238,
              22.132034
            ],
            [
              113.5522264,
              22.1303889
            ],
            [
              113.5523388,
              22.1303927
            ],
            [
              113.5523365,
              22.1305199
            ],
            [
              113.5528193,
              22.1305205
            ],
            [
              113.552835,
              22.1320262
            ],
            [
              113.552238,
              22.132034
            ]
          ]
        ]
      },
      "id": "way/241741095"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/241741096",
        "building": "yes",
        "height": "12.9",
        "man_made": "wastewater_plant",
        "name": "路環污水處理廠"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5527252,
              22.130319
            ],
            [
              113.5527242,
              22.1301899
            ],
            [
              113.5526374,
              22.1301905
            ],
            [
              113.552637,
              22.1301408
            ],
            [
              113.5526909,
              22.1301405
            ],
            [
              113.5526904,
              22.1300788
            ],
            [
              113.5527221,
              22.1300786
            ],
            [
              113.5527216,
              22.1300206
            ],
            [
              113.5526414,
              22.1300211
            ],
            [
              113.5526401,
              22.1298698
            ],
            [
              113.5527305,
              22.1298692
            ],
            [
              113.5527303,
              22.1298393
            ],
            [
              113.5532441,
              22.1298359
            ],
            [
              113.5532479,
              22.1303155
            ],
            [
              113.5527252,
              22.130319
            ]
          ]
        ]
      },
      "id": "way/241741096"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/241741097",
        "addr:housenumber": "78-84",
        "addr:street": "合歡街 Rua das Albizias",
        "building": "industrial",
        "height": "8",
        "name": "金龍工業有限公司, 分子態(澳門)中藥科技有限公司, 分子態工廠 Golden Dragon - Indústrias, Limitada, Authenmole (Macau) Tecnologia de Medicina Tradicional Chinesa, Limitada, Fábrica Authenmole"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5522753,
              22.1228369
            ],
            [
              113.552698,
              22.1228357
            ],
            [
              113.5527005,
              22.1235654
            ],
            [
              113.55273,
              22.1235686
            ],
            [
              113.5527335,
              22.1236457
            ],
            [
              113.5527688,
              22.1236495
            ],
            [
              113.5527692,
              22.1238992
            ],
            [
              113.5524109,
              22.123899
            ],
            [
              113.552331,
              22.1238992
            ],
            [
              113.5523314,
              22.1240204
            ],
            [
              113.5522412,
              22.1240207
            ],
            [
              113.5522408,
              22.1239064
            ],
            [
              113.5522789,
              22.1239063
            ],
            [
              113.5522753,
              22.1228369
            ]
          ]
        ]
      },
      "id": "way/241741097"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/262650944",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "N8",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "university",
        "image": "https://map.um.edu.mo/emap_images/building_N8.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "leisure": "sports_centre",
        "name": "澳大綜合體育館 Complexo Desportivo da Universidade de Macau (N8)",
        "name:en": "Sports Complex of the University of Macau(N8)",
        "name:pt": "Complexo Desportivo da Universidade de Macau (N8)",
        "name:zh": "澳大綜合體育館(N8)",
        "ref": "N8",
        "sport": "badminton;swimming;table_tennis",
        "website": "https://facility.osa.um.edu.mo/",
        "website:en": "https://facility.osa.um.edu.mo/",
        "website:zh": "https://facility.osa.um.edu.mo/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5420781,
              22.1344971
            ],
            [
              113.542078,
              22.1343851
            ],
            [
              113.5420776,
              22.1334407
            ],
            [
              113.5424241,
              22.1334406
            ],
            [
              113.5424241,
              22.1334107
            ],
            [
              113.5426138,
              22.1334132
            ],
            [
              113.542796,
              22.1334106
            ],
            [
              113.5427961,
              22.133431
            ],
            [
              113.542914,
              22.133431
            ],
            [
              113.5429141,
              22.1335928
            ],
            [
              113.5431622,
              22.1335927
            ],
            [
              113.5431625,
              22.1341252
            ],
            [
              113.5431416,
              22.1341252
            ],
            [
              113.5431417,
              22.134296
            ],
            [
              113.5430986,
              22.134296
            ],
            [
              113.5430327,
              22.134296
            ],
            [
              113.5430328,
              22.1344967
            ],
            [
              113.5420781,
              22.1344971
            ]
          ]
        ]
      },
      "id": "way/262650944"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/288151232",
        "amenity": "fire_station",
        "building": "university",
        "email": "cb-info@fsm.gov.mo",
        "fax": "+853 2836 1128",
        "image": "https://map.um.edu.mo/emap_images/building_fire-station.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "橫琴島消防站 Posto Operacional em Ilha da Montanha",
        "name:en": "Fire Station in Hengqin",
        "name:pt": "Posto Operacional em Ilha da Montanha",
        "name:zh": "橫琴島消防站",
        "phone": "+853 2850 6205",
        "website": "http://www.fsm.gov.mo/"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5461157,
              22.135431
            ],
            [
              113.5461156,
              22.1353626
            ],
            [
              113.5461153,
              22.1349392
            ],
            [
              113.5462671,
              22.134939
            ],
            [
              113.5462671,
              22.1349597
            ],
            [
              113.5464322,
              22.1349596
            ],
            [
              113.5465053,
              22.1349595
            ],
            [
              113.5465053,
              22.1349385
            ],
            [
              113.5466577,
              22.1349383
            ],
            [
              113.5466577,
              22.134959
            ],
            [
              113.5467228,
              22.134959
            ],
            [
              113.5467228,
              22.1350005
            ],
            [
              113.5467455,
              22.1350005
            ],
            [
              113.5467456,
              22.1351908
            ],
            [
              113.5467456,
              22.1352304
            ],
            [
              113.5467233,
              22.1352304
            ],
            [
              113.5467235,
              22.1354306
            ],
            [
              113.5461157,
              22.135431
            ]
          ]
        ]
      },
      "id": "way/288151232"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/288151233",
        "amenity": "sport",
        "image": "https://map.um.edu.mo/emap_images/building_N9.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "leisure": "stadium",
        "name": "澳大運動場 UM Stadium",
        "name:ar": "استاد جامعة ماكاو",
        "name:en": "UM Stadium",
        "name:pt": "Estádio da Universidade de Macau",
        "name:zh": "澳大運動場",
        "ref": "N9",
        "sport": "multi",
        "website": "https://facility.osa.um.edu.mo/projects/um-stadium-managed-by-sports-bureau/",
        "website:en": "https://facility.osa.um.edu.mo/projects/um-stadium-managed-by-sports-bureau/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/um-stadium-managed-by-sports-bureau/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5404352,
              22.134863
            ],
            [
              113.5404789,
              22.1335597
            ],
            [
              113.540757,
              22.1335582
            ],
            [
              113.5407615,
              22.1333771
            ],
            [
              113.5408748,
              22.1333741
            ],
            [
              113.5409326,
              22.1333197
            ],
            [
              113.5409902,
              22.1332663
            ],
            [
              113.5410674,
              22.13323
            ],
            [
              113.5411504,
              22.1332108
            ],
            [
              113.5412637,
              22.1332002
            ],
            [
              113.5413836,
              22.1332071
            ],
            [
              113.5414982,
              22.1332438
            ],
            [
              113.5415874,
              22.1332974
            ],
            [
              113.5416388,
              22.1333585
            ],
            [
              113.5416741,
              22.1334297
            ],
            [
              113.5417742,
              22.1334303
            ],
            [
              113.5417371,
              22.1348714
            ],
            [
              113.5410937,
              22.134889
            ],
            [
              113.5404352,
              22.134863
            ]
          ]
        ]
      },
      "id": "way/288151233"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/288151239",
        "leisure": "pitch",
        "sport": "soccer"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5409093,
              22.1344488
            ],
            [
              113.5409063,
              22.1336429
            ],
            [
              113.5415421,
              22.1336408
            ],
            [
              113.5415451,
              22.1344468
            ],
            [
              113.5409093,
              22.1344488
            ]
          ]
        ]
      },
      "id": "way/288151239"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598361",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "W31",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "residential",
        "image": "https://map.um.edu.mo/emap_images/building_W31.jpg",
        "name": "研究生宿舍 Postgraduate House (W31)",
        "name:en": "Postgraduate House (W31)",
        "name:pt": "Dormitório de Estudantes de Pós-Graduação (W31)",
        "name:zh": "研究生宿舍 (W31)",
        "residential": "university"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5418448,
              22.1261417
            ],
            [
              113.5419799,
              22.1261421
            ],
            [
              113.5419801,
              22.1261017
            ],
            [
              113.5420205,
              22.1261019
            ],
            [
              113.5420556,
              22.126102
            ],
            [
              113.5420556,
              22.1260878
            ],
            [
              113.5424132,
              22.126089
            ],
            [
              113.5424131,
              22.1261029
            ],
            [
              113.5424415,
              22.126103
            ],
            [
              113.5424415,
              22.12609
            ],
            [
              113.5425444,
              22.1260904
            ],
            [
              113.5425442,
              22.1261409
            ],
            [
              113.5425565,
              22.1261409
            ],
            [
              113.5425565,
              22.126151
            ],
            [
              113.5425969,
              22.1261512
            ],
            [
              113.5425949,
              22.1266604
            ],
            [
              113.5425771,
              22.1266603
            ],
            [
              113.5425769,
              22.1267056
            ],
            [
              113.5425455,
              22.1267055
            ],
            [
              113.5425454,
              22.1267247
            ],
            [
              113.5424462,
              22.1267244
            ],
            [
              113.5424463,
              22.1267049
            ],
            [
              113.5424136,
              22.1267048
            ],
            [
              113.5424135,
              22.126733
            ],
            [
              113.5421115,
              22.1267321
            ],
            [
              113.5421116,
              22.1267155
            ],
            [
              113.5418497,
              22.1267146
            ],
            [
              113.5418496,
              22.1267349
            ],
            [
              113.5417575,
              22.1267346
            ],
            [
              113.5417587,
              22.1264269
            ],
            [
              113.5418122,
              22.1264269
            ],
            [
              113.5418683,
              22.1262125
            ],
            [
              113.5418159,
              22.1262121
            ],
            [
              113.5418448,
              22.1261417
            ]
          ]
        ]
      },
      "id": "way/289598361"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598362",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "W32",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "residential",
        "image": "https://map.um.edu.mo/emap_images/building_W32.jpg",
        "name": "研究生宿舍 Postgraduate House (W32)",
        "name:en": "Postgraduate House (W32)",
        "name:pt": "Dormitório de Estudantes de Pós-Graduação (W32)",
        "name:zh": "研究生宿舍 (W32)",
        "residential": "university"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5418448,
              22.1261417
            ],
            [
              113.5418159,
              22.1262121
            ],
            [
              113.5417674,
              22.1262121
            ],
            [
              113.5417024,
              22.1264268
            ],
            [
              113.5417587,
              22.1264269
            ],
            [
              113.5417575,
              22.1267346
            ],
            [
              113.5413059,
              22.1267331
            ],
            [
              113.5413063,
              22.1266442
            ],
            [
              113.541155,
              22.1266437
            ],
            [
              113.5411551,
              22.1266224
            ],
            [
              113.5411323,
              22.1266224
            ],
            [
              113.5411322,
              22.1266448
            ],
            [
              113.5410258,
              22.1266445
            ],
            [
              113.541026,
              22.1265823
            ],
            [
              113.5410133,
              22.1265822
            ],
            [
              113.5410133,
              22.1265641
            ],
            [
              113.540969,
              22.1265639
            ],
            [
              113.540971,
              22.1260602
            ],
            [
              113.5410345,
              22.1260604
            ],
            [
              113.5410347,
              22.1260207
            ],
            [
              113.5411334,
              22.126021
            ],
            [
              113.5411334,
              22.1260289
            ],
            [
              113.5411535,
              22.1260289
            ],
            [
              113.5411535,
              22.1260098
            ],
            [
              113.5416671,
              22.1260067
            ],
            [
              113.541712,
              22.1260028
            ],
            [
              113.5417105,
              22.1260421
            ],
            [
              113.5417101,
              22.1261412
            ],
            [
              113.5417589,
              22.1261389
            ],
            [
              113.5418448,
              22.1261417
            ]
          ]
        ]
      },
      "id": "way/289598362"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598363",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "W33",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "residential",
        "image": "https://map.um.edu.mo/emap_images/building_W33.jpg",
        "name": "馬萬祺羅柏心書院 Ma Man Kei and Lo Pak Sam College (W33)",
        "name:en": "Ma Man Kei and Lo Pak Sam College (W33)",
        "name:pt": "Colégio Ma Man Kei e Lo Pak Sam (W33)",
        "name:zh": "馬萬祺羅柏心書院 (W33)",
        "ref": "W23",
        "residential": "university",
        "website": "https://mlc.rc.um.edu.mo/"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5419548,
              22.1257498
            ],
            [
              113.5419648,
              22.12571
            ],
            [
              113.5420122,
              22.1257093
            ],
            [
              113.5421004,
              22.1254277
            ],
            [
              113.5420445,
              22.125427
            ],
            [
              113.5420495,
              22.1251364
            ],
            [
              113.542772,
              22.1251366
            ],
            [
              113.542772,
              22.1251867
            ],
            [
              113.5428155,
              22.1251867
            ],
            [
              113.5428153,
              22.1256892
            ],
            [
              113.5427611,
              22.1256892
            ],
            [
              113.5427611,
              22.1257496
            ],
            [
              113.5426747,
              22.1257496
            ],
            [
              113.5426747,
              22.1257398
            ],
            [
              113.5426309,
              22.1257398
            ],
            [
              113.5426309,
              22.1257597
            ],
            [
              113.5424577,
              22.1257597
            ],
            [
              113.5424577,
              22.1257391
            ],
            [
              113.542436,
              22.1257391
            ],
            [
              113.542436,
              22.1257796
            ],
            [
              113.5424034,
              22.1257796
            ],
            [
              113.5424034,
              22.125739
            ],
            [
              113.5423814,
              22.125739
            ],
            [
              113.5423814,
              22.1257595
            ],
            [
              113.5422076,
              22.1257595
            ],
            [
              113.5422077,
              22.1257498
            ],
            [
              113.5420617,
              22.1257498
            ],
            [
              113.5419548,
              22.1257498
            ]
          ]
        ]
      },
      "id": "way/289598363"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598364",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "W34",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "residential",
        "image": "https://map.um.edu.mo/emap_images/building_W34.jpg",
        "name": "張崑崙書院 Cheong Kun Lun College (W34)",
        "name:en": "Cheong Kun Lun College (W34)",
        "name:pt": "Colégio Cheong Kun Lun (W34)",
        "name:zh": "張崑崙書院 (W34)",
        "ref": "W34",
        "residential": "university",
        "website": "https://cklc.rc.um.edu.mo"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5420495,
              22.1251364
            ],
            [
              113.5420445,
              22.125427
            ],
            [
              113.5419885,
              22.125427
            ],
            [
              113.5419141,
              22.1257103
            ],
            [
              113.5419648,
              22.12571
            ],
            [
              113.5419548,
              22.1257498
            ],
            [
              113.5418552,
              22.1257497
            ],
            [
              113.5418063,
              22.1257497
            ],
            [
              113.5418063,
              22.1258399
            ],
            [
              113.5417297,
              22.1258399
            ],
            [
              113.5417297,
              22.1258502
            ],
            [
              113.5413722,
              22.1258501
            ],
            [
              113.5413722,
              22.1258405
            ],
            [
              113.5413387,
              22.1258405
            ],
            [
              113.5413387,
              22.1258498
            ],
            [
              113.5412411,
              22.1258498
            ],
            [
              113.5412411,
              22.1257998
            ],
            [
              113.5412201,
              22.1257998
            ],
            [
              113.5412202,
              22.1257794
            ],
            [
              113.5411871,
              22.1257794
            ],
            [
              113.5411873,
              22.1252971
            ],
            [
              113.5412093,
              22.1252971
            ],
            [
              113.5412093,
              22.1252771
            ],
            [
              113.5412415,
              22.1252771
            ],
            [
              113.5412415,
              22.1252168
            ],
            [
              113.5413392,
              22.1252168
            ],
            [
              113.5413392,
              22.1252367
            ],
            [
              113.5413824,
              22.1252367
            ],
            [
              113.5413824,
              22.1252166
            ],
            [
              113.5419043,
              22.1252168
            ],
            [
              113.5419043,
              22.1251363
            ],
            [
              113.5420495,
              22.1251364
            ]
          ]
        ]
      },
      "id": "way/289598364"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598365",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "W13",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "residential",
        "image": "https://map.um.edu.mo/emap_images/building_W13.jpg",
        "name": "何鴻燊東亞書院 Stanley Ho East Asia College (W13)",
        "name:en": "Stanley Ho East Asia College (W13)",
        "name:pt": "Colégio Ásia Oriental do Stanley Ho (W13)",
        "name:zh": "何鴻燊東亞書院 (W13)",
        "ref": "W13",
        "residential": "university",
        "website": "https://sheac.rc.um.edu.mo/"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5414128,
              22.1315613
            ],
            [
              113.5414128,
              22.1315214
            ],
            [
              113.5415678,
              22.1315213
            ],
            [
              113.5415675,
              22.1312601
            ],
            [
              113.5413613,
              22.1312603
            ],
            [
              113.5413609,
              22.1308464
            ],
            [
              113.5414141,
              22.1308464
            ],
            [
              113.5414141,
              22.1308672
            ],
            [
              113.5414368,
              22.1308672
            ],
            [
              113.5414369,
              22.1309481
            ],
            [
              113.5414909,
              22.130948
            ],
            [
              113.541491,
              22.1309881
            ],
            [
              113.5415669,
              22.130988
            ],
            [
              113.5415669,
              22.1309783
            ],
            [
              113.5416756,
              22.1309782
            ],
            [
              113.5416757,
              22.1310383
            ],
            [
              113.5417303,
              22.1310383
            ],
            [
              113.5417304,
              22.1310681
            ],
            [
              113.5417408,
              22.1310681
            ],
            [
              113.5417408,
              22.1310487
            ],
            [
              113.5420015,
              22.1310485
            ],
            [
              113.5420016,
              22.1310886
            ],
            [
              113.5420345,
              22.1310886
            ],
            [
              113.5420345,
              22.1310787
            ],
            [
              113.5421429,
              22.1310786
            ],
            [
              113.542143,
              22.131159
            ],
            [
              113.542175,
              22.131159
            ],
            [
              113.5421755,
              22.1315811
            ],
            [
              113.5421967,
              22.1315811
            ],
            [
              113.5421968,
              22.1316713
            ],
            [
              113.5420988,
              22.1316714
            ],
            [
              113.5420987,
              22.1316524
            ],
            [
              113.5420773,
              22.1316524
            ],
            [
              113.5420773,
              22.1316816
            ],
            [
              113.5417083,
              22.131682
            ],
            [
              113.5417083,
              22.1317219
            ],
            [
              113.5416318,
              22.1317219
            ],
            [
              113.5415565,
              22.131722
            ],
            [
              113.5415563,
              22.1315612
            ],
            [
              113.5414128,
              22.1315613
            ]
          ]
        ]
      },
      "id": "way/289598365"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598366",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "E12",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "academics",
        "building": "university",
        "description": "Location: Room 4045, Faculty of Health Sciences (E12)",
        "description:en": "Location: Room 4045, Faculty of Health Sciences (E12)",
        "description:zh": "所在位置: 健康科學學院 (E12), 4045室",
        "email": "fhs.enquiry@um.edu.mo",
        "fax": "+853 8822 2314",
        "image": "https://map.um.edu.mo/emap_images/building_E12.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "健康科學學院 Faculdade de Ciências da Saúde (E12)",
        "name:en": "Faculty of Health Sciences (E12)",
        "name:zh": "健康科學學院 (E12)",
        "note": "Zone East, Academics",
        "phone": "+853 8822 4296",
        "website": "https://fhs.um.edu.mo/"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5426298,
              22.1312489
            ],
            [
              113.5426297,
              22.1309586
            ],
            [
              113.5427616,
              22.1309586
            ],
            [
              113.5427616,
              22.1310082
            ],
            [
              113.542881,
              22.1310082
            ],
            [
              113.5428809,
              22.1309081
            ],
            [
              113.5427609,
              22.1309081
            ],
            [
              113.5427608,
              22.1307004
            ],
            [
              113.5427607,
              22.130496
            ],
            [
              113.5427934,
              22.130496
            ],
            [
              113.5427933,
              22.130375
            ],
            [
              113.5429461,
              22.130375
            ],
            [
              113.5429461,
              22.1304958
            ],
            [
              113.5430102,
              22.1304958
            ],
            [
              113.5430102,
              22.1304857
            ],
            [
              113.5433777,
              22.1304856
            ],
            [
              113.5435103,
              22.1304855
            ],
            [
              113.5435103,
              22.1305352
            ],
            [
              113.5435208,
              22.1305352
            ],
            [
              113.5435208,
              22.1304654
            ],
            [
              113.5436946,
              22.1304654
            ],
            [
              113.5436925,
              22.1306125
            ],
            [
              113.5438407,
              22.1306304
            ],
            [
              113.5438449,
              22.130847
            ],
            [
              113.5438343,
              22.1311742
            ],
            [
              113.5437689,
              22.1311644
            ],
            [
              113.5437744,
              22.1312692
            ],
            [
              113.5431928,
              22.1312893
            ],
            [
              113.5427724,
              22.1312895
            ],
            [
              113.5427724,
              22.1312786
            ],
            [
              113.5427372,
              22.1312786
            ],
            [
              113.5426298,
              22.1312489
            ]
          ]
        ]
      },
      "id": "way/289598366"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598373",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "W22",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "residential",
        "image": "https://map.um.edu.mo/emap_images/building_W22.jpg",
        "name": "呂志和書院 Lui Che Woo College (W22)",
        "name:en": "Lui Che Woo College (W22)",
        "name:pt": "Colégio Lui Che Woo (W22)",
        "name:zh": "呂志和書院 (W22)",
        "ref": "W22",
        "residential": "university",
        "website": "https://lcwc.rc.um.edu.mo/"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5413874,
              22.1289266
            ],
            [
              113.5413875,
              22.1298312
            ],
            [
              113.5412962,
              22.1298312
            ],
            [
              113.5412962,
              22.1297815
            ],
            [
              113.541232,
              22.1297815
            ],
            [
              113.541232,
              22.1298315
            ],
            [
              113.5408614,
              22.1298315
            ],
            [
              113.5408613,
              22.1296608
            ],
            [
              113.5408719,
              22.1296608
            ],
            [
              113.5408719,
              22.1296203
            ],
            [
              113.5408624,
              22.1296204
            ],
            [
              113.5408624,
              22.1295806
            ],
            [
              113.5408825,
              22.1295806
            ],
            [
              113.5408825,
              22.1293698
            ],
            [
              113.5408506,
              22.1293698
            ],
            [
              113.5408505,
              22.1292387
            ],
            [
              113.5412958,
              22.1292387
            ],
            [
              113.5412958,
              22.1290779
            ],
            [
              113.5408508,
              22.1290779
            ],
            [
              113.5408508,
              22.128967
            ],
            [
              113.5408727,
              22.128967
            ],
            [
              113.5408727,
              22.1289171
            ],
            [
              113.5411759,
              22.1289171
            ],
            [
              113.5411759,
              22.1289063
            ],
            [
              113.5412575,
              22.1289063
            ],
            [
              113.5413395,
              22.1289063
            ],
            [
              113.5413395,
              22.1289266
            ],
            [
              113.5413874,
              22.1289266
            ]
          ]
        ]
      },
      "id": "way/289598373"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598376",
        "addr:housenumber": "E1",
        "amenity": "exhibition_centre",
        "building": "university",
        "image": "https://map.um.edu.mo/emap_images/building_E1.jpg",
        "name": "大學展館 Galeria da Universidade (E1)",
        "name:en": "University Gallery (E1)",
        "name:pt": "Galeria da Universidade de Macau (E1)",
        "name:zh": "大學展館(E1)",
        "ref": "E1"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5455605,
              22.1311729
            ],
            [
              113.545559,
              22.1309775
            ],
            [
              113.5455571,
              22.130742
            ],
            [
              113.5458143,
              22.1307402
            ],
            [
              113.5460208,
              22.1307388
            ],
            [
              113.5460283,
              22.1311698
            ],
            [
              113.5455605,
              22.1311729
            ]
          ]
        ]
      },
      "id": "way/289598376"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598378",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "N2",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "theatre",
        "building": "university",
        "image": "https://map.um.edu.mo/emap_images/building_N2.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "大學會堂 Aula Magna da Universidade (N2)",
        "name:en": "University of Macau Grand Hall (N2)",
        "name:pt": "Aula Magna da Universidade de Macau (N2)",
        "name:zh": "大學會堂(N2)",
        "ref": "N2"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5449533,
              22.1344772
            ],
            [
              113.5449532,
              22.133968
            ],
            [
              113.5452322,
              22.1339676
            ],
            [
              113.5459832,
              22.1339666
            ],
            [
              113.5460552,
              22.1339665
            ],
            [
              113.5460499,
              22.134105
            ],
            [
              113.5460931,
              22.134105
            ],
            [
              113.5460931,
              22.1341983
            ],
            [
              113.5460931,
              22.1342859
            ],
            [
              113.5460499,
              22.1342859
            ],
            [
              113.5460499,
              22.1344167
            ],
            [
              113.5459957,
              22.1344167
            ],
            [
              113.5459957,
              22.1344772
            ],
            [
              113.5449533,
              22.1344772
            ]
          ]
        ]
      },
      "id": "way/289598378"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598379",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "E31",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "social_centre",
        "building": "university",
        "building:levels": "3",
        "image": "https://map.um.edu.mo/emap_images/building_E31.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "學生活動中心 Centro das Actividades Estudantis da Universidade de Macau (E31)",
        "name:en": "Student Activity Centre of the University of Macau (E31)",
        "name:pt": "Centro das Actividades Estudantis da Universidade de Macau(E31)",
        "name:zh": "學生活動中心(E31)",
        "ref": "E31"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5446721,
              22.127006
            ],
            [
              113.5446063,
              22.1270067
            ],
            [
              113.544607,
              22.1270562
            ],
            [
              113.5445415,
              22.1270569
            ],
            [
              113.5445412,
              22.1270364
            ],
            [
              113.5445292,
              22.1270365
            ],
            [
              113.5445317,
              22.1272176
            ],
            [
              113.5445083,
              22.1272178
            ],
            [
              113.5445089,
              22.1272673
            ],
            [
              113.5444436,
              22.1272681
            ],
            [
              113.5444442,
              22.1273077
            ],
            [
              113.5444002,
              22.1273082
            ],
            [
              113.5444001,
              22.1272981
            ],
            [
              113.5443459,
              22.1272988
            ],
            [
              113.5443454,
              22.127258
            ],
            [
              113.5443891,
              22.1272575
            ],
            [
              113.5443886,
              22.1272176
            ],
            [
              113.544368,
              22.1272179
            ],
            [
              113.5443674,
              22.1271678
            ],
            [
              113.5443902,
              22.1271675
            ],
            [
              113.5443879,
              22.1269949
            ],
            [
              113.5440943,
              22.1269983
            ],
            [
              113.5440957,
              22.1272873
            ],
            [
              113.543911,
              22.1274188
            ],
            [
              113.5439171,
              22.1274365
            ],
            [
              113.5439101,
              22.1274542
            ],
            [
              113.5438842,
              22.1274644
            ],
            [
              113.5438658,
              22.1274572
            ],
            [
              113.5438556,
              22.1274344
            ],
            [
              113.54387,
              22.1274118
            ],
            [
              113.5438899,
              22.1274087
            ],
            [
              113.5438901,
              22.1273986
            ],
            [
              113.543835,
              22.1273987
            ],
            [
              113.543803,
              22.1273675
            ],
            [
              113.5438009,
              22.1271166
            ],
            [
              113.5437599,
              22.1271171
            ],
            [
              113.5437593,
              22.1270764
            ],
            [
              113.5437169,
              22.1270769
            ],
            [
              113.5437164,
              22.1270449
            ],
            [
              113.543716,
              22.1270161
            ],
            [
              113.5436843,
              22.1270165
            ],
            [
              113.5436835,
              22.1269569
            ],
            [
              113.5438036,
              22.1269555
            ],
            [
              113.5438017,
              22.1268206
            ],
            [
              113.5446694,
              22.1268105
            ],
            [
              113.5446717,
              22.1269774
            ],
            [
              113.5446721,
              22.127006
            ]
          ]
        ]
      },
      "id": "way/289598379"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598381",
        "building": "university",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "operator": "澳門電訊有限公司"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5467047,
              22.1346442
            ],
            [
              113.5467047,
              22.1344941
            ],
            [
              113.5469571,
              22.134494
            ],
            [
              113.5469572,
              22.1346441
            ],
            [
              113.5467047,
              22.1346442
            ]
          ]
        ]
      },
      "id": "way/289598381"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598382",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.546223,
              22.1313815
            ],
            [
              113.5462223,
              22.1312105
            ],
            [
              113.5463318,
              22.1312102
            ],
            [
              113.5463325,
              22.1313811
            ],
            [
              113.546223,
              22.1313815
            ]
          ]
        ]
      },
      "id": "way/289598382"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598383",
        "building": "yes",
        "name": "澳門大學行人隧道出入口 Entrada do túnel do pedestres para Universidade",
        "name:en": "UM Pedestrian tunnel Entrance and Exit",
        "name:pt": "Entrada do túnel do pedestres para Universidade",
        "name:zh": "澳門大學行人隧道出入口"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.546224,
              22.1310081
            ],
            [
              113.5462239,
              22.1307971
            ],
            [
              113.546277,
              22.1307971
            ],
            [
              113.5463321,
              22.1307971
            ],
            [
              113.5463322,
              22.1310081
            ],
            [
              113.546224,
              22.1310081
            ]
          ]
        ]
      },
      "id": "way/289598383"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598384",
        "building": "yes",
        "building:levels": "2",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5452252,
              22.1249851
            ],
            [
              113.5451486,
              22.1249241
            ],
            [
              113.5451483,
              22.1247948
            ],
            [
              113.5453544,
              22.1247944
            ],
            [
              113.5453548,
              22.1249848
            ],
            [
              113.5452252,
              22.1249851
            ]
          ]
        ]
      },
      "id": "way/289598384"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598385",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S31",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "accommodation",
        "building": "residential",
        "building:levels": "12",
        "description": "Location: Staff Quarters S31",
        "description:en": "Location: Staff Quarters S31",
        "description:zh": "所在位置: 教職員宿舍南三十一座",
        "image": "https://map.um.edu.mo/emap_images/building_S31.jpg",
        "name": "教職員宿舍南三十一座 Quadra S31",
        "name:en": "Staff Quarters S31",
        "name:pt": "Quadra S31",
        "name:zh": "教職員宿舍南三十一座 (S31)",
        "ref": "S31",
        "short_name": "教職員宿舍"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5453393,
              22.1214865
            ],
            [
              113.5453716,
              22.1214115
            ],
            [
              113.5454373,
              22.1214358
            ],
            [
              113.5454535,
              22.121398
            ],
            [
              113.5454171,
              22.1213845
            ],
            [
              113.545451,
              22.1213056
            ],
            [
              113.545504,
              22.1213252
            ],
            [
              113.5457056,
              22.1213997
            ],
            [
              113.5456733,
              22.1214746
            ],
            [
              113.5456394,
              22.1215533
            ],
            [
              113.5455808,
              22.1215316
            ],
            [
              113.5455939,
              22.1215011
            ],
            [
              113.5455722,
              22.1214931
            ],
            [
              113.5455495,
              22.1215457
            ],
            [
              113.5454916,
              22.1215243
            ],
            [
              113.5455004,
              22.1215038
            ],
            [
              113.5454845,
              22.1214979
            ],
            [
              113.5454688,
              22.1215343
            ],
            [
              113.5453393,
              22.1214865
            ]
          ]
        ]
      },
      "id": "way/289598385"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598386",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S33",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "accommodation",
        "building": "residential",
        "building:levels": "12",
        "description": "Location: Staff Quarters S33",
        "description:en": "Location: Staff Quarters S33",
        "description:zh": "所在位置: 教職員宿舍南三十三座",
        "image": "https://map.um.edu.mo/emap_images/building_S33.jpg",
        "name": "教職員宿舍南三十三座 Quadra S33",
        "name:en": "Staff Quarters S33",
        "name:pt": "Quadra S33",
        "name:zh": "教職員宿舍南三十三座 (S33)",
        "ref": "S33",
        "short_name": "教職員宿舍"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5445399,
              22.1220651
            ],
            [
              113.5445397,
              22.1220027
            ],
            [
              113.5445891,
              22.1220025
            ],
            [
              113.544589,
              22.1219827
            ],
            [
              113.5445056,
              22.121983
            ],
            [
              113.5445055,
              22.1219635
            ],
            [
              113.5444746,
              22.1219636
            ],
            [
              113.5444743,
              22.1218844
            ],
            [
              113.5444859,
              22.1218844
            ],
            [
              113.5444858,
              22.1218743
            ],
            [
              113.5445418,
              22.1218741
            ],
            [
              113.5445418,
              22.1218834
            ],
            [
              113.5445824,
              22.1218832
            ],
            [
              113.5445823,
              22.1218629
            ],
            [
              113.5445926,
              22.1218629
            ],
            [
              113.5445926,
              22.1218539
            ],
            [
              113.5446489,
              22.1218536
            ],
            [
              113.5446489,
              22.1218636
            ],
            [
              113.5446579,
              22.1218636
            ],
            [
              113.544658,
              22.121902
            ],
            [
              113.5446809,
              22.1219019
            ],
            [
              113.5446807,
              22.121864
            ],
            [
              113.5446914,
              22.1218639
            ],
            [
              113.5446914,
              22.1218531
            ],
            [
              113.5447375,
              22.1218529
            ],
            [
              113.5447375,
              22.1218622
            ],
            [
              113.5447485,
              22.1218621
            ],
            [
              113.5447485,
              22.121882
            ],
            [
              113.5448158,
              22.1218818
            ],
            [
              113.544854,
              22.1218816
            ],
            [
              113.5448541,
              22.1218921
            ],
            [
              113.5448653,
              22.121892
            ],
            [
              113.5448656,
              22.1219631
            ],
            [
              113.5448217,
              22.1219633
            ],
            [
              113.5448218,
              22.121982
            ],
            [
              113.5447469,
              22.1219823
            ],
            [
              113.544747,
              22.1220049
            ],
            [
              113.5448,
              22.1220047
            ],
            [
              113.5448002,
              22.1220649
            ],
            [
              113.5447572,
              22.122065
            ],
            [
              113.5447573,
              22.1220745
            ],
            [
              113.5447455,
              22.1220746
            ],
            [
              113.5447455,
              22.1220846
            ],
            [
              113.5447119,
              22.1220847
            ],
            [
              113.5446918,
              22.1220848
            ],
            [
              113.5446917,
              22.1220745
            ],
            [
              113.5446816,
              22.1220745
            ],
            [
              113.5446814,
              22.1220234
            ],
            [
              113.5446691,
              22.1220234
            ],
            [
              113.5446693,
              22.1220747
            ],
            [
              113.544659,
              22.1220747
            ],
            [
              113.544659,
              22.1220825
            ],
            [
              113.5446028,
              22.1220827
            ],
            [
              113.5446028,
              22.1220649
            ],
            [
              113.5445399,
              22.1220651
            ]
          ]
        ]
      },
      "id": "way/289598386"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598387",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S32",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "accommodation",
        "building": "dormitory",
        "building:levels": "12",
        "description": "Location: Staff Quarters S32",
        "description:en": "Location: Staff Quarters S32",
        "description:zh": "所在位置: 教職員宿舍南三十二座",
        "name": "教職員宿舍南三十二座 Quadra S32",
        "name:en": "Staff Quarters S32",
        "name:pt": "Quadra S32",
        "name:zh": "教職員宿舍南三十二座 (S32)",
        "ref": "S32",
        "short_name": "教職員宿舍"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5449432,
              22.1218083
            ],
            [
              113.5449429,
              22.1217459
            ],
            [
              113.5449923,
              22.1217457
            ],
            [
              113.5449922,
              22.1217259
            ],
            [
              113.5449088,
              22.1217262
            ],
            [
              113.5449088,
              22.1217067
            ],
            [
              113.5448779,
              22.1217068
            ],
            [
              113.5448775,
              22.1216276
            ],
            [
              113.5448891,
              22.1216276
            ],
            [
              113.5448891,
              22.1216175
            ],
            [
              113.544945,
              22.1216173
            ],
            [
              113.544945,
              22.1216266
            ],
            [
              113.5449856,
              22.1216264
            ],
            [
              113.5449855,
              22.1216061
            ],
            [
              113.5449958,
              22.121606
            ],
            [
              113.5449958,
              22.1215971
            ],
            [
              113.5450521,
              22.1215968
            ],
            [
              113.5450521,
              22.1216068
            ],
            [
              113.5450611,
              22.1216068
            ],
            [
              113.5450613,
              22.1216451
            ],
            [
              113.5450841,
              22.1216451
            ],
            [
              113.5450839,
              22.1216072
            ],
            [
              113.5450947,
              22.1216071
            ],
            [
              113.5450946,
              22.1215963
            ],
            [
              113.5451407,
              22.1215961
            ],
            [
              113.5451408,
              22.1216054
            ],
            [
              113.5451517,
              22.1216053
            ],
            [
              113.5451518,
              22.1216252
            ],
            [
              113.5452221,
              22.121625
            ],
            [
              113.5452573,
              22.1216248
            ],
            [
              113.5452573,
              22.1216353
            ],
            [
              113.5452685,
              22.1216352
            ],
            [
              113.5452689,
              22.1217063
            ],
            [
              113.5452249,
              22.1217065
            ],
            [
              113.545225,
              22.1217252
            ],
            [
              113.5451501,
              22.1217255
            ],
            [
              113.5451502,
              22.1217481
            ],
            [
              113.5452032,
              22.1217479
            ],
            [
              113.5452035,
              22.1218081
            ],
            [
              113.5451605,
              22.1218082
            ],
            [
              113.5451605,
              22.1218177
            ],
            [
              113.5451487,
              22.1218178
            ],
            [
              113.5451488,
              22.1218278
            ],
            [
              113.5451175,
              22.1218279
            ],
            [
              113.545095,
              22.121828
            ],
            [
              113.545095,
              22.1218177
            ],
            [
              113.5450848,
              22.1218177
            ],
            [
              113.5450846,
              22.1217666
            ],
            [
              113.5450724,
              22.1217666
            ],
            [
              113.5450726,
              22.1218178
            ],
            [
              113.5450622,
              22.1218179
            ],
            [
              113.5450623,
              22.1218257
            ],
            [
              113.5450439,
              22.1218258
            ],
            [
              113.5450061,
              22.1218259
            ],
            [
              113.545006,
              22.121808
            ],
            [
              113.5449432,
              22.1218083
            ]
          ]
        ]
      },
      "id": "way/289598387"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598388",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S35",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "accommodation",
        "building": "residential",
        "building:levels": "12",
        "description": "Location: Staff Quarters S35",
        "description:en": "Location: Staff Quarters S35",
        "description:zh": "所在位置: 教職員宿舍南三十五座, 室",
        "image": "https://map.um.edu.mo/emap_images/building_S35.jpg",
        "name": "教職員宿舍南三十五座 Quadra S35",
        "name:en": "Staff Quarters S35",
        "name:pt": "Quadra S35",
        "name:zh": "教職員宿舍南三十五座 (S35)",
        "ref": "S35",
        "short_name": "教職員宿舍"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5437256,
              22.1225802
            ],
            [
              113.5437255,
              22.1225364
            ],
            [
              113.5437254,
              22.1225177
            ],
            [
              113.5437748,
              22.1225176
            ],
            [
              113.5437747,
              22.1224978
            ],
            [
              113.5436913,
              22.1224981
            ],
            [
              113.5436912,
              22.1224786
            ],
            [
              113.5436603,
              22.1224787
            ],
            [
              113.5436599,
              22.1223995
            ],
            [
              113.5436716,
              22.1223994
            ],
            [
              113.5436715,
              22.1223894
            ],
            [
              113.5437274,
              22.1223892
            ],
            [
              113.5437275,
              22.1223985
            ],
            [
              113.5437681,
              22.1223983
            ],
            [
              113.543768,
              22.122378
            ],
            [
              113.5437783,
              22.1223779
            ],
            [
              113.5437782,
              22.1223689
            ],
            [
              113.5438345,
              22.1223687
            ],
            [
              113.5438346,
              22.1223787
            ],
            [
              113.5438435,
              22.1223787
            ],
            [
              113.5438437,
              22.122417
            ],
            [
              113.5438665,
              22.1224169
            ],
            [
              113.5438664,
              22.1223791
            ],
            [
              113.5438771,
              22.122379
            ],
            [
              113.5438771,
              22.1223682
            ],
            [
              113.5439231,
              22.122368
            ],
            [
              113.5439232,
              22.1223772
            ],
            [
              113.5439341,
              22.1223772
            ],
            [
              113.5439342,
              22.1223971
            ],
            [
              113.5440078,
              22.1223968
            ],
            [
              113.5440397,
              22.1223967
            ],
            [
              113.5440397,
              22.1224071
            ],
            [
              113.544051,
              22.1224071
            ],
            [
              113.5440513,
              22.1224782
            ],
            [
              113.5440074,
              22.1224783
            ],
            [
              113.5440075,
              22.1224971
            ],
            [
              113.5439326,
              22.1224974
            ],
            [
              113.5439327,
              22.1225199
            ],
            [
              113.5439856,
              22.1225197
            ],
            [
              113.5439859,
              22.1225799
            ],
            [
              113.5439429,
              22.1225801
            ],
            [
              113.543943,
              22.1225896
            ],
            [
              113.5439312,
              22.1225896
            ],
            [
              113.5439312,
              22.1225997
            ],
            [
              113.5438775,
              22.1225999
            ],
            [
              113.5438774,
              22.1225895
            ],
            [
              113.5438673,
              22.1225896
            ],
            [
              113.543867,
              22.1225384
            ],
            [
              113.5438548,
              22.1225385
            ],
            [
              113.543855,
              22.1225897
            ],
            [
              113.5438447,
              22.1225898
            ],
            [
              113.5438447,
              22.1225975
            ],
            [
              113.5438048,
              22.1225977
            ],
            [
              113.5437885,
              22.1225978
            ],
            [
              113.5437885,
              22.1225799
            ],
            [
              113.5437256,
              22.1225802
            ]
          ]
        ]
      },
      "id": "way/289598388"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598389",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S34",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "accommodation",
        "building": "residential",
        "building:levels": "12",
        "description": "Location: Staff Quarters S34",
        "description:en": "Location: Staff Quarters S34",
        "description:zh": "所在位置: 教職員宿舍南三十四座",
        "image": "https://map.um.edu.mo/emap_images/building_S34.jpg",
        "name": "教職員宿舍南三十四座 Quadra S32",
        "name:en": "Staff Quarters S34",
        "name:pt": "Quadra S34",
        "name:zh": "教職員宿舍南三十四座 (S34)",
        "ref": "S34",
        "short_name": "教職員宿舍"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5441304,
              22.1223234
            ],
            [
              113.5441301,
              22.1222609
            ],
            [
              113.5441796,
              22.1222608
            ],
            [
              113.5441795,
              22.122241
            ],
            [
              113.5440961,
              22.1222413
            ],
            [
              113.544096,
              22.1222218
            ],
            [
              113.5440651,
              22.1222219
            ],
            [
              113.5440647,
              22.1221427
            ],
            [
              113.5440764,
              22.1221426
            ],
            [
              113.5440763,
              22.1221326
            ],
            [
              113.5441322,
              22.1221323
            ],
            [
              113.5441323,
              22.1221416
            ],
            [
              113.5441729,
              22.1221415
            ],
            [
              113.5441728,
              22.1221212
            ],
            [
              113.5441831,
              22.1221211
            ],
            [
              113.544183,
              22.1221121
            ],
            [
              113.5442393,
              22.1221119
            ],
            [
              113.5442394,
              22.1221219
            ],
            [
              113.5442483,
              22.1221219
            ],
            [
              113.5442485,
              22.1221602
            ],
            [
              113.5442713,
              22.1221601
            ],
            [
              113.5442712,
              22.1221223
            ],
            [
              113.5442819,
              22.1221222
            ],
            [
              113.5442819,
              22.1221114
            ],
            [
              113.5443279,
              22.1221112
            ],
            [
              113.544328,
              22.1221204
            ],
            [
              113.5443389,
              22.1221204
            ],
            [
              113.544339,
              22.1221403
            ],
            [
              113.5444125,
              22.12214
            ],
            [
              113.5444445,
              22.1221399
            ],
            [
              113.5444445,
              22.1221503
            ],
            [
              113.5444558,
              22.1221503
            ],
            [
              113.5444561,
              22.1222214
            ],
            [
              113.5444122,
              22.1222215
            ],
            [
              113.5444123,
              22.1222403
            ],
            [
              113.5443374,
              22.1222406
            ],
            [
              113.5443375,
              22.1222631
            ],
            [
              113.5443904,
              22.1222629
            ],
            [
              113.5443907,
              22.1223231
            ],
            [
              113.5443477,
              22.1223233
            ],
            [
              113.5443478,
              22.1223328
            ],
            [
              113.544336,
              22.1223328
            ],
            [
              113.544336,
              22.1223429
            ],
            [
              113.5442823,
              22.1223431
            ],
            [
              113.5442822,
              22.1223327
            ],
            [
              113.5442721,
              22.1223328
            ],
            [
              113.5442718,
              22.1222816
            ],
            [
              113.5442596,
              22.1222817
            ],
            [
              113.5442598,
              22.1223329
            ],
            [
              113.5442495,
              22.122333
            ],
            [
              113.5442495,
              22.1223407
            ],
            [
              113.5442236,
              22.1223408
            ],
            [
              113.5441933,
              22.122341
            ],
            [
              113.5441932,
              22.1223231
            ],
            [
              113.5441304,
              22.1223234
            ]
          ]
        ]
      },
      "id": "way/289598389"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598390",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S30",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "accommodation",
        "building": "residential",
        "building:levels": "12",
        "description": "Location: Staff Quarters S30",
        "description:en": "Location: Staff Quarters S30",
        "description:zh": "所在位置: 教職員宿舍南三十座",
        "image": "https://map.um.edu.mo/emap_images/building_S30.jpg",
        "name": "教職員宿舍南三十座 Quadra S30",
        "name:en": "Staff Quarters S30",
        "name:pt": "Quadra S30",
        "name:zh": "教職員宿舍南三十座 (S30)",
        "ref": "S30",
        "short_name": "教職員宿舍"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5453739,
              22.1220276
            ],
            [
              113.5454062,
              22.1219526
            ],
            [
              113.5454719,
              22.1219769
            ],
            [
              113.5454881,
              22.1219392
            ],
            [
              113.5454516,
              22.1219257
            ],
            [
              113.5454856,
              22.1218468
            ],
            [
              113.5456338,
              22.1219015
            ],
            [
              113.5457402,
              22.1219408
            ],
            [
              113.5457079,
              22.1220158
            ],
            [
              113.545674,
              22.1220944
            ],
            [
              113.5456154,
              22.1220728
            ],
            [
              113.5456285,
              22.1220423
            ],
            [
              113.5456068,
              22.1220342
            ],
            [
              113.5455841,
              22.1220869
            ],
            [
              113.5455262,
              22.1220655
            ],
            [
              113.545535,
              22.1220449
            ],
            [
              113.545519,
              22.122039
            ],
            [
              113.5455033,
              22.1220754
            ],
            [
              113.5453739,
              22.1220276
            ]
          ]
        ]
      },
      "id": "way/289598390"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598391",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S21",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "accommodation",
        "building": "residential",
        "building:levels": "12",
        "description": "Location: Staff Quarters S21",
        "description:en": "Location: Staff Quarters S21",
        "description:zh": "所在位置: 教職員宿舍南二十一座",
        "image": "https://map.um.edu.mo/emap_images/building_S21.jpg",
        "name": "教職員宿舍南二十一座 Quadra S21",
        "name:en": "Staff Quarters S21",
        "name:pt": "Quadra S21",
        "name:zh": "教職員宿舍南二十一座 (S21)",
        "ref": "S21",
        "short_name": "教職員宿舍"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5456568,
              22.1231153
            ],
            [
              113.5456562,
              22.1229345
            ],
            [
              113.5457135,
              22.1229343
            ],
            [
              113.5457133,
              22.122864
            ],
            [
              113.5457351,
              22.1228639
            ],
            [
              113.545735,
              22.1228537
            ],
            [
              113.5457676,
              22.1228536
            ],
            [
              113.5457676,
              22.1228438
            ],
            [
              113.5458427,
              22.1228436
            ],
            [
              113.5458767,
              22.1228435
            ],
            [
              113.5458768,
              22.1228539
            ],
            [
              113.54593,
              22.1228537
            ],
            [
              113.5459417,
              22.1228537
            ],
            [
              113.545942,
              22.1229344
            ],
            [
              113.546017,
              22.1229342
            ],
            [
              113.5460175,
              22.1230848
            ],
            [
              113.5459196,
              22.1230851
            ],
            [
              113.5459197,
              22.123105
            ],
            [
              113.5459088,
              22.1231051
            ],
            [
              113.5459088,
              22.1231153
            ],
            [
              113.5458438,
              22.1231155
            ],
            [
              113.5458438,
              22.1231052
            ],
            [
              113.5458112,
              22.1231053
            ],
            [
              113.5458112,
              22.1231148
            ],
            [
              113.5456568,
              22.1231153
            ]
          ]
        ]
      },
      "id": "way/289598391"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598392",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S27",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "accommodation",
        "building": "residential",
        "building:levels": "12",
        "description": "Location: Staff Quarters S27",
        "description:en": "Location: Staff Quarters S27",
        "description:zh": "所在位置: 教職員宿舍南二十七座",
        "image": "https://map.um.edu.mo/emap_images/building_S27.jpg",
        "name": "教職員宿舍南二十七座 Quadra S27",
        "name:en": "Staff Quarters S27",
        "name:pt": "Quadra S27",
        "name:zh": "教職員宿舍南二十七座 (S27)",
        "ref": "S27",
        "short_name": "教職員宿舍"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.543658,
              22.1229541
            ],
            [
              113.5436582,
              22.1230956
            ],
            [
              113.5435745,
              22.1230958
            ],
            [
              113.5435746,
              22.1231042
            ],
            [
              113.5434334,
              22.1231043
            ],
            [
              113.5434334,
              22.1230749
            ],
            [
              113.5434119,
              22.1230749
            ],
            [
              113.5434119,
              22.1230956
            ],
            [
              113.5433031,
              22.1230958
            ],
            [
              113.543303,
              22.1230849
            ],
            [
              113.5432822,
              22.1230849
            ],
            [
              113.5432821,
              22.123039
            ],
            [
              113.5432821,
              22.1230151
            ],
            [
              113.5432938,
              22.1230151
            ],
            [
              113.5432938,
              22.1229844
            ],
            [
              113.5432606,
              22.1229844
            ],
            [
              113.5432605,
              22.122914
            ],
            [
              113.5432935,
              22.122914
            ],
            [
              113.5432933,
              22.1228039
            ],
            [
              113.5433576,
              22.1228039
            ],
            [
              113.5434231,
              22.1228038
            ],
            [
              113.5434232,
              22.1228735
            ],
            [
              113.5434131,
              22.1228735
            ],
            [
              113.5434132,
              22.1229341
            ],
            [
              113.5434342,
              22.1229341
            ],
            [
              113.5434341,
              22.1228738
            ],
            [
              113.5435639,
              22.1228736
            ],
            [
              113.543564,
              22.1229163
            ],
            [
              113.543564,
              22.1229547
            ],
            [
              113.5435318,
              22.1229547
            ],
            [
              113.5435318,
              22.1229648
            ],
            [
              113.5436293,
              22.1229647
            ],
            [
              113.5436293,
              22.1229542
            ],
            [
              113.543658,
              22.1229541
            ]
          ]
        ]
      },
      "id": "way/289598392"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598393",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S23",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "accommodation",
        "building": "residential",
        "building:levels": "12",
        "description": "Location: Staff Quarters S23",
        "description:en": "Location: Staff Quarters S23",
        "description:zh": "所在位置: 教職員宿舍南二十三座",
        "image": "https://map.um.edu.mo/emap_images/building_S23.jpg",
        "name": "教職員宿舍南二十三座 Quadra S23",
        "name:en": "Staff Quarters S23",
        "name:pt": "Quadra S23",
        "name:zh": "教職員宿舍南二十三座 (S23)",
        "ref": "S23",
        "short_name": "教職員宿舍"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5448464,
              22.1231149
            ],
            [
              113.5448457,
              22.1229345
            ],
            [
              113.5449104,
              22.1229343
            ],
            [
              113.5449101,
              22.1228642
            ],
            [
              113.544921,
              22.1228642
            ],
            [
              113.544921,
              22.1228542
            ],
            [
              113.5449535,
              22.1228541
            ],
            [
              113.5449534,
              22.122844
            ],
            [
              113.5450237,
              22.1228438
            ],
            [
              113.5450622,
              22.1228437
            ],
            [
              113.5450622,
              22.1228539
            ],
            [
              113.5451164,
              22.1228537
            ],
            [
              113.5451164,
              22.1228639
            ],
            [
              113.5451274,
              22.1228639
            ],
            [
              113.5451277,
              22.1229342
            ],
            [
              113.5451815,
              22.1229341
            ],
            [
              113.5451813,
              22.1228741
            ],
            [
              113.5452504,
              22.1228739
            ],
            [
              113.5452512,
              22.1231052
            ],
            [
              113.5450947,
              22.1231057
            ],
            [
              113.5450947,
              22.1231151
            ],
            [
              113.5450404,
              22.1231153
            ],
            [
              113.5450404,
              22.1231053
            ],
            [
              113.5450079,
              22.1231054
            ],
            [
              113.545008,
              22.1231144
            ],
            [
              113.5448464,
              22.1231149
            ]
          ]
        ]
      },
      "id": "way/289598393"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598394",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S29",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "accommodation",
        "building": "residential",
        "building:levels": "12",
        "description": "Location: Staff Quarters S29",
        "description:en": "Location: Staff Quarters S29",
        "description:zh": "所在位置: 教職員宿舍南二十九座",
        "image": "https://map.um.edu.mo/emap_images/building_S29.jpg",
        "name": "教職員宿舍南二十九座 Quadra S29",
        "name:en": "Staff Quarters S29",
        "name:pt": "Quadra S29",
        "name:zh": "教職員宿舍南二十九座 (S29)",
        "ref": "S29",
        "short_name": "教職員宿舍"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5457079,
              22.1220158
            ],
            [
              113.5457402,
              22.1219408
            ],
            [
              113.5458063,
              22.1219653
            ],
            [
              113.5458225,
              22.1219275
            ],
            [
              113.5457861,
              22.1219141
            ],
            [
              113.5458201,
              22.1218351
            ],
            [
              113.5459441,
              22.1218858
            ],
            [
              113.5460744,
              22.1219291
            ],
            [
              113.5460082,
              22.1220827
            ],
            [
              113.5459733,
              22.1220698
            ],
            [
              113.5459498,
              22.1220611
            ],
            [
              113.5459629,
              22.1220306
            ],
            [
              113.5459412,
              22.1220226
            ],
            [
              113.5459185,
              22.1220752
            ],
            [
              113.5458606,
              22.1220538
            ],
            [
              113.5458694,
              22.1220333
            ],
            [
              113.5458535,
              22.1220274
            ],
            [
              113.5458378,
              22.1220638
            ],
            [
              113.5457079,
              22.1220158
            ]
          ]
        ]
      },
      "id": "way/289598394"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598395",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S22",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "accommodation",
        "building": "residential",
        "building:levels": "12",
        "description": "Location: Staff Quarters S22",
        "description:en": "Location: Staff Quarters S22",
        "description:zh": "所在位置: 教職員宿舍南二十二座",
        "image": "https://map.um.edu.mo/emap_images/building_S22.jpg",
        "name": "教職員宿舍南二十二座 Quadra S22",
        "name:en": "Staff Quarters S22",
        "name:pt": "Quadra S22",
        "name:zh": "教職員宿舍南二十二座 (S22)",
        "ref": "S22",
        "short_name": "教職員宿舍"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5452512,
              22.1231052
            ],
            [
              113.5452504,
              22.1228739
            ],
            [
              113.5453225,
              22.1228737
            ],
            [
              113.5453227,
              22.1229344
            ],
            [
              113.5453661,
              22.1229342
            ],
            [
              113.5453658,
              22.1228638
            ],
            [
              113.5453876,
              22.1228637
            ],
            [
              113.5453875,
              22.1228538
            ],
            [
              113.5454094,
              22.1228538
            ],
            [
              113.5454094,
              22.122844
            ],
            [
              113.5454899,
              22.1228438
            ],
            [
              113.5455289,
              22.1228436
            ],
            [
              113.5455289,
              22.1228538
            ],
            [
              113.5455829,
              22.1228537
            ],
            [
              113.545583,
              22.1228638
            ],
            [
              113.5455944,
              22.1228638
            ],
            [
              113.5455946,
              22.1229347
            ],
            [
              113.5456562,
              22.1229345
            ],
            [
              113.5456568,
              22.1231153
            ],
            [
              113.5455074,
              22.1231158
            ],
            [
              113.5455074,
              22.1231053
            ],
            [
              113.5454746,
              22.1231054
            ],
            [
              113.5454747,
              22.1231152
            ],
            [
              113.5454096,
              22.1231154
            ],
            [
              113.5454095,
              22.1231047
            ],
            [
              113.5452512,
              22.1231052
            ]
          ]
        ]
      },
      "id": "way/289598395"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598396",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S25",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "accommodation",
        "building": "residential",
        "building:levels": "12",
        "description": "Location: Staff Quarters S25",
        "description:en": "Location: Staff Quarters S25",
        "description:zh": "所在位置: 教職員宿舍南二十五座",
        "image": "https://map.um.edu.mo/emap_images/building_S25.jpg",
        "name": "教職員宿舍南二十五座 Quadra S25",
        "name:en": "Staff Quarters S25",
        "name:pt": "Quadra S25",
        "name:zh": "教職員宿舍南二十五座 (S25)",
        "ref": "S25",
        "short_name": "教職員宿舍"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5440153,
              22.1230846
            ],
            [
              113.5440151,
              22.1229745
            ],
            [
              113.5441071,
              22.1229744
            ],
            [
              113.5441071,
              22.1229641
            ],
            [
              113.544053,
              22.1229642
            ],
            [
              113.5440529,
              22.122874
            ],
            [
              113.5441943,
              22.1228738
            ],
            [
              113.5441943,
              22.1228539
            ],
            [
              113.5442598,
              22.1228538
            ],
            [
              113.5443234,
              22.1228537
            ],
            [
              113.5443235,
              22.1229442
            ],
            [
              113.5443355,
              22.1229442
            ],
            [
              113.5443354,
              22.1229047
            ],
            [
              113.5443889,
              22.1229046
            ],
            [
              113.544389,
              22.1229806
            ],
            [
              113.5443891,
              22.1230146
            ],
            [
              113.5443781,
              22.1230146
            ],
            [
              113.5443782,
              22.1230755
            ],
            [
              113.5442588,
              22.1230756
            ],
            [
              113.5442589,
              22.1231043
            ],
            [
              113.5441076,
              22.1231045
            ],
            [
              113.5441076,
              22.1230844
            ],
            [
              113.5440153,
              22.1230846
            ]
          ]
        ]
      },
      "id": "way/289598396"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598397",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S28",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "accommodation",
        "building": "residential",
        "building:levels": "12",
        "description": "Location: Staff Quarters S28",
        "description:en": "Location: Staff Quarters S28",
        "description:zh": "所在位置: 教職員宿舍南二十八座",
        "image": "https://map.um.edu.mo/emap_images/building_S28.jpg",
        "name": "教職員宿舍南二十八座 Quadra S28",
        "name:en": "Staff Quarters S28",
        "name:pt": "Quadra S28",
        "name:zh": "教職員宿舍南二十八座 (S28)",
        "ref": "S28",
        "short_name": "教職員宿舍"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5456989,
              22.1225314
            ],
            [
              113.5457312,
              22.1224565
            ],
            [
              113.5457974,
              22.1224809
            ],
            [
              113.5458136,
              22.1224432
            ],
            [
              113.5457771,
              22.1224297
            ],
            [
              113.5458111,
              22.1223508
            ],
            [
              113.545896,
              22.1223821
            ],
            [
              113.5460654,
              22.1224447
            ],
            [
              113.5459993,
              22.1225983
            ],
            [
              113.5459409,
              22.1225768
            ],
            [
              113.545954,
              22.1225463
            ],
            [
              113.5459323,
              22.1225382
            ],
            [
              113.5459096,
              22.1225909
            ],
            [
              113.545879,
              22.1225796
            ],
            [
              113.5458517,
              22.1225695
            ],
            [
              113.5458605,
              22.1225489
            ],
            [
              113.5458445,
              22.122543
            ],
            [
              113.5458288,
              22.1225794
            ],
            [
              113.5456989,
              22.1225314
            ]
          ]
        ]
      },
      "id": "way/289598397"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598398",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S26",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "accommodation",
        "building": "residential",
        "building:levels": "12",
        "description": "Location: Staff Quarters S26",
        "description:en": "Location: Staff Quarters S26",
        "description:zh": "所在位置: 教職員宿舍南二十六座",
        "image": "https://map.um.edu.mo/emap_images/building_S26.jpg",
        "name": "教職員宿舍南二十六座 Quadra S26",
        "name:en": "Staff Quarters S26",
        "name:pt": "Quadra S27",
        "name:zh": "教職員宿舍南二十六座 (S26)",
        "ref": "S26",
        "short_name": "教職員宿舍"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5436582,
              22.1230956
            ],
            [
              113.543658,
              22.1229541
            ],
            [
              113.5436836,
              22.1229541
            ],
            [
              113.5436835,
              22.1228746
            ],
            [
              113.5438597,
              22.1228744
            ],
            [
              113.5439544,
              22.1228742
            ],
            [
              113.5439546,
              22.1229641
            ],
            [
              113.5439013,
              22.1229642
            ],
            [
              113.5439013,
              22.1229747
            ],
            [
              113.5440151,
              22.1229745
            ],
            [
              113.5440153,
              22.1230846
            ],
            [
              113.5439991,
              22.1230846
            ],
            [
              113.5438904,
              22.1230847
            ],
            [
              113.5438905,
              22.1231052
            ],
            [
              113.5436835,
              22.1231055
            ],
            [
              113.5436835,
              22.1230956
            ],
            [
              113.5436582,
              22.1230956
            ]
          ]
        ]
      },
      "id": "way/289598398"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598399",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S24",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "accommodation",
        "building": "residential",
        "building:levels": "12",
        "description": "Location: Staff Quarters S24",
        "description:en": "Location: Staff Quarters S24",
        "description:zh": "所在位置: 教職員宿舍南二十四座",
        "image": "https://map.um.edu.mo/emap_images/building_S24.jpg",
        "name": "教職員宿舍南二十四座 Quadra S24",
        "name:en": "Staff Quarters S24",
        "name:pt": "Quadra S24",
        "name:zh": "教職員宿舍南二十四座 (S24)",
        "ref": "S24",
        "short_name": "教職員宿舍"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5448464,
              22.1231149
            ],
            [
              113.5446931,
              22.1231154
            ],
            [
              113.544693,
              22.1231051
            ],
            [
              113.5446605,
              22.1231052
            ],
            [
              113.5446606,
              22.1231152
            ],
            [
              113.5445741,
              22.1231155
            ],
            [
              113.544574,
              22.1230952
            ],
            [
              113.5445508,
              22.1230953
            ],
            [
              113.5444977,
              22.1230955
            ],
            [
              113.5444977,
              22.1230851
            ],
            [
              113.5444869,
              22.1230852
            ],
            [
              113.5444865,
              22.1229793
            ],
            [
              113.5444864,
              22.1229448
            ],
            [
              113.5444977,
              22.1229448
            ],
            [
              113.5444977,
              22.1229345
            ],
            [
              113.5445629,
              22.1229343
            ],
            [
              113.5445627,
              22.1228638
            ],
            [
              113.5445739,
              22.1228638
            ],
            [
              113.5445738,
              22.1228535
            ],
            [
              113.5446068,
              22.1228534
            ],
            [
              113.5446069,
              22.1228641
            ],
            [
              113.5446279,
              22.122864
            ],
            [
              113.5446279,
              22.1228438
            ],
            [
              113.5446677,
              22.1228436
            ],
            [
              113.5447257,
              22.1228435
            ],
            [
              113.5447257,
              22.122854
            ],
            [
              113.5447692,
              22.1228539
            ],
            [
              113.5447692,
              22.1228637
            ],
            [
              113.5447801,
              22.1228637
            ],
            [
              113.5447804,
              22.1229347
            ],
            [
              113.5448457,
              22.1229345
            ],
            [
              113.5448464,
              22.1231149
            ]
          ]
        ]
      },
      "id": "way/289598399"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598402",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "W21",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "residential",
        "image": "https://map.um.edu.mo/emap_images/building_W21.jpg",
        "name": "曹光彪書院 Chao Kuang Piu College (W21)",
        "name:en": "Chao Kuang Piu College (W21)",
        "name:pt": "Colégio Chao Kuang Piu (W21)",
        "name:zh": "曹光彪書院(W21)",
        "ref": "W21",
        "residential": "university",
        "website": "https://ckpc.rc.um.edu.mo"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5413874,
              22.1289266
            ],
            [
              113.5414369,
              22.1289266
            ],
            [
              113.5414369,
              22.1289062
            ],
            [
              113.5415444,
              22.1289062
            ],
            [
              113.5415671,
              22.1289062
            ],
            [
              113.5415671,
              22.1289272
            ],
            [
              113.5418815,
              22.1289271
            ],
            [
              113.5418815,
              22.1289671
            ],
            [
              113.5419256,
              22.1289671
            ],
            [
              113.5419256,
              22.1290576
            ],
            [
              113.5414693,
              22.1290576
            ],
            [
              113.5414693,
              22.129249
            ],
            [
              113.5419147,
              22.1292489
            ],
            [
              113.5419147,
              22.1293597
            ],
            [
              113.5418929,
              22.1293597
            ],
            [
              113.5418929,
              22.1295802
            ],
            [
              113.5419149,
              22.1295802
            ],
            [
              113.5419149,
              22.1296106
            ],
            [
              113.5418926,
              22.1296106
            ],
            [
              113.5418927,
              22.1296504
            ],
            [
              113.5419145,
              22.1296504
            ],
            [
              113.5419146,
              22.129832
            ],
            [
              113.5415455,
              22.129832
            ],
            [
              113.5415455,
              22.1297811
            ],
            [
              113.5414806,
              22.1297811
            ],
            [
              113.5414806,
              22.1298311
            ],
            [
              113.5413875,
              22.1298312
            ],
            [
              113.5413874,
              22.1289266
            ]
          ]
        ]
      },
      "id": "way/289598402"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598404",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "W11",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "residential",
        "image": "https://map.um.edu.mo/emap_images/building_W11.jpg",
        "name": "滿珍紀念書院 Moon Chun Memorial College (W11)",
        "name:en": "Moon Chun Memorial College (W11)",
        "name:pt": "Colégios Memorial Moon Chun (W11)",
        "name:zh": "滿珍紀念書院 (W11)",
        "ref": "W11",
        "residential": "university",
        "website": "https://mcmc.rc.um.edu.mo/"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.541467,
              22.1319733
            ],
            [
              113.5415554,
              22.1319731
            ],
            [
              113.5415554,
              22.1319639
            ],
            [
              113.5416255,
              22.1319637
            ],
            [
              113.5417083,
              22.1319635
            ],
            [
              113.5417084,
              22.131994
            ],
            [
              113.5420885,
              22.131993
            ],
            [
              113.5420887,
              22.1320439
            ],
            [
              113.5420988,
              22.1320439
            ],
            [
              113.5420987,
              22.1320139
            ],
            [
              113.5421966,
              22.1320136
            ],
            [
              113.5421969,
              22.132104
            ],
            [
              113.5420989,
              22.1321043
            ],
            [
              113.5420989,
              22.1320945
            ],
            [
              113.5420878,
              22.1320945
            ],
            [
              113.542088,
              22.1321545
            ],
            [
              113.5421422,
              22.1321544
            ],
            [
              113.5421425,
              22.1322449
            ],
            [
              113.5421641,
              22.1322448
            ],
            [
              113.5421642,
              22.1322852
            ],
            [
              113.5421419,
              22.1322852
            ],
            [
              113.5421425,
              22.1324666
            ],
            [
              113.5421751,
              22.1324665
            ],
            [
              113.5421753,
              22.1325259
            ],
            [
              113.5421423,
              22.132526
            ],
            [
              113.5421426,
              22.1326061
            ],
            [
              113.5420015,
              22.1326065
            ],
            [
              113.5420016,
              22.1326472
            ],
            [
              113.541752,
              22.1326479
            ],
            [
              113.5417519,
              22.1326169
            ],
            [
              113.5417298,
              22.1326169
            ],
            [
              113.5417299,
              22.1326473
            ],
            [
              113.5416757,
              22.1326474
            ],
            [
              113.5416759,
              22.1326872
            ],
            [
              113.5415797,
              22.1326874
            ],
            [
              113.5415783,
              22.132266
            ],
            [
              113.5415779,
              22.1321429
            ],
            [
              113.5415476,
              22.132143
            ],
            [
              113.5415472,
              22.1320412
            ],
            [
              113.5415652,
              22.1320411
            ],
            [
              113.5415651,
              22.1320126
            ],
            [
              113.5414672,
              22.1320129
            ],
            [
              113.541467,
              22.1319733
            ]
          ]
        ]
      },
      "id": "way/289598404"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598405",
        "building": "yes",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "substation": "distribution"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5418395,
              22.1352012
            ],
            [
              113.5418389,
              22.1349495
            ],
            [
              113.5422941,
              22.1349486
            ],
            [
              113.5422947,
              22.1352003
            ],
            [
              113.5418395,
              22.1352012
            ]
          ]
        ]
      },
      "id": "way/289598405"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598406",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "N1",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "accommodation",
        "building": "university",
        "description": "Location: UM Guest House",
        "description:en": "Location: UM Guest House",
        "description:zh": "所在位置: 聚賢樓",
        "email": "N1.booking@um.edu.mo",
        "image": "https://map.um.edu.mo/emap_images/building_N1.jpg",
        "internet_access": "yes",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "聚賢樓 Pousada da Universidade de Macau (N1)",
        "name:en": "UM Guest House (N1)",
        "name:pt": "Pousada da Universidade de Macau (N1)",
        "name:zh": "聚賢樓 (N1)",
        "phone": "+853 8822 3000",
        "ref": "N1",
        "rooms": "101",
        "tourism": "hotel",
        "website": "https://srs.sao.um.edu.mo/um-guest-house/"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5449532,
              22.133968
            ],
            [
              113.5449534,
              22.1336727
            ],
            [
              113.5449376,
              22.1336727
            ],
            [
              113.5449376,
              22.1336385
            ],
            [
              113.5449377,
              22.1336019
            ],
            [
              113.5449377,
              22.1335821
            ],
            [
              113.545138,
              22.1335823
            ],
            [
              113.5451382,
              22.1334615
            ],
            [
              113.5453877,
              22.1334617
            ],
            [
              113.5453877,
              22.1334209
            ],
            [
              113.5459957,
              22.1334214
            ],
            [
              113.5459957,
              22.1334717
            ],
            [
              113.5460497,
              22.1334717
            ],
            [
              113.5460495,
              22.1336323
            ],
            [
              113.546137,
              22.1336323
            ],
            [
              113.5461369,
              22.133688
            ],
            [
              113.5461368,
              22.133743
            ],
            [
              113.5460501,
              22.133743
            ],
            [
              113.5460552,
              22.1339665
            ],
            [
              113.5459832,
              22.1339666
            ],
            [
              113.545985,
              22.1338035
            ],
            [
              113.5457207,
              22.1337986
            ],
            [
              113.5457142,
              22.1339235
            ],
            [
              113.5452385,
              22.1339296
            ],
            [
              113.5452322,
              22.1339676
            ],
            [
              113.5449532,
              22.133968
            ]
          ]
        ]
      },
      "id": "way/289598406"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598407",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S1",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "residential",
        "image": "https://map.um.edu.mo/emap_images/building_S1.jpg",
        "name": "研究生宿舍 Postgraduates House (S1)",
        "name:en": "Postgraduates House (S1)",
        "name:pt": "Dormitório de Estudantes de Pós-Graduação (S1)",
        "name:zh": "研究生宿舍 (S1)",
        "ref": "S1",
        "residential": "university"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5453983,
              22.1251465
            ],
            [
              113.5453981,
              22.1249052
            ],
            [
              113.5453877,
              22.1249052
            ],
            [
              113.5453877,
              22.1248554
            ],
            [
              113.5454747,
              22.1248553
            ],
            [
              113.5454747,
              22.1248697
            ],
            [
              113.5454748,
              22.1248948
            ],
            [
              113.5455073,
              22.1248948
            ],
            [
              113.5455074,
              22.1250461
            ],
            [
              113.5456158,
              22.125046
            ],
            [
              113.5457907,
              22.1250459
            ],
            [
              113.5459315,
              22.1250458
            ],
            [
              113.5459314,
              22.1249991
            ],
            [
              113.5459314,
              22.1249554
            ],
            [
              113.5458985,
              22.1249554
            ],
            [
              113.5458984,
              22.1248843
            ],
            [
              113.5458982,
              22.1247038
            ],
            [
              113.5457823,
              22.1247039
            ],
            [
              113.5456665,
              22.124704
            ],
            [
              113.5456373,
              22.124704
            ],
            [
              113.5456373,
              22.1246787
            ],
            [
              113.5456372,
              22.1246236
            ],
            [
              113.5456674,
              22.1246236
            ],
            [
              113.5457027,
              22.1246236
            ],
            [
              113.5457027,
              22.124634
            ],
            [
              113.5459467,
              22.1246338
            ],
            [
              113.5460385,
              22.1246337
            ],
            [
              113.5460388,
              22.1249454
            ],
            [
              113.5460607,
              22.1249454
            ],
            [
              113.5460608,
              22.1249956
            ],
            [
              113.5460831,
              22.1249956
            ],
            [
              113.5460832,
              22.1250532
            ],
            [
              113.5460832,
              22.1250961
            ],
            [
              113.5460394,
              22.1250961
            ],
            [
              113.5460394,
              22.1250865
            ],
            [
              113.5460067,
              22.1250866
            ],
            [
              113.5460068,
              22.1251468
            ],
            [
              113.5458587,
              22.1251469
            ],
            [
              113.5456042,
              22.1251471
            ],
            [
              113.5455407,
              22.1251471
            ],
            [
              113.5455407,
              22.1251565
            ],
            [
              113.5454637,
              22.1251565
            ],
            [
              113.5454637,
              22.1251465
            ],
            [
              113.5453983,
              22.1251465
            ]
          ]
        ]
      },
      "id": "way/289598407"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598408",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S3",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "residential",
        "image": "https://map.um.edu.mo/emap_images/building_S3.jpg",
        "name": "研究生宿舍 Postgraduates House (S3)",
        "name:en": "Postgraduates House (S3)",
        "name:pt": "Dormitório de Estudantes de Pós-Graduação (S3)",
        "name:zh": "研究生宿舍 (S3)",
        "ref": "S3",
        "residential": "university"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5454532,
              22.1240604
            ],
            [
              113.5453706,
              22.1240605
            ],
            [
              113.545301,
              22.1240606
            ],
            [
              113.5453009,
              22.1239899
            ],
            [
              113.5452792,
              22.1239899
            ],
            [
              113.5452788,
              22.1238091
            ],
            [
              113.545301,
              22.1238091
            ],
            [
              113.5453009,
              22.1237793
            ],
            [
              113.5452792,
              22.1237793
            ],
            [
              113.5452792,
              22.1237388
            ],
            [
              113.5453117,
              22.1237388
            ],
            [
              113.5453116,
              22.1236787
            ],
            [
              113.5454112,
              22.1236785
            ],
            [
              113.5455506,
              22.1236783
            ],
            [
              113.5455504,
              22.1235574
            ],
            [
              113.5455502,
              22.1234774
            ],
            [
              113.5459206,
              22.1234768
            ],
            [
              113.5459969,
              22.1234767
            ],
            [
              113.5459969,
              22.1234969
            ],
            [
              113.5460181,
              22.1234969
            ],
            [
              113.5460182,
              22.1235677
            ],
            [
              113.5460503,
              22.1235677
            ],
            [
              113.5460507,
              22.1238089
            ],
            [
              113.5460608,
              22.1238089
            ],
            [
              113.5460611,
              22.1239798
            ],
            [
              113.5460498,
              22.1239798
            ],
            [
              113.5460502,
              22.1242213
            ],
            [
              113.5460283,
              22.1242213
            ],
            [
              113.5460284,
              22.1242614
            ],
            [
              113.5460065,
              22.1242615
            ],
            [
              113.5460066,
              22.1243216
            ],
            [
              113.5458365,
              22.1243218
            ],
            [
              113.5456482,
              22.1243221
            ],
            [
              113.545648,
              22.1241817
            ],
            [
              113.545724,
              22.1241816
            ],
            [
              113.545724,
              22.1241706
            ],
            [
              113.5458981,
              22.1241704
            ],
            [
              113.545898,
              22.1241338
            ],
            [
              113.5458977,
              22.1239297
            ],
            [
              113.5459305,
              22.1239297
            ],
            [
              113.5459305,
              22.1239075
            ],
            [
              113.5459304,
              22.1238795
            ],
            [
              113.545898,
              22.1238796
            ],
            [
              113.5458976,
              22.1236484
            ],
            [
              113.5459302,
              22.1236483
            ],
            [
              113.5459302,
              22.1236379
            ],
            [
              113.5458575,
              22.123638
            ],
            [
              113.545696,
              22.1236383
            ],
            [
              113.5456156,
              22.1236384
            ],
            [
              113.5456157,
              22.1236683
            ],
            [
              113.5456699,
              22.1236682
            ],
            [
              113.54567,
              22.1237471
            ],
            [
              113.5456701,
              22.1238085
            ],
            [
              113.5454748,
              22.1238088
            ],
            [
              113.5454748,
              22.1237888
            ],
            [
              113.5454528,
              22.1237889
            ],
            [
              113.5454532,
              22.1240604
            ]
          ]
        ]
      },
      "id": "way/289598408"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598409",
        "addr:housenumber": "S2",
        "building": "residential",
        "image": "https://map.um.edu.mo/emap_images/building_S2.jpg",
        "name": "研究生宿舍 Postgraduates House (S2)",
        "name:en": "Postgraduates House (S2)",
        "name:pt": "Dormitório de Estudantes de Pós-Graduação (S2)",
        "name:zh": "研究生宿舍南二座 (S2)",
        "ref": "S2",
        "residential": "university"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5450628,
              22.1247346
            ],
            [
              113.5450627,
              22.1246941
            ],
            [
              113.5449646,
              22.1246942
            ],
            [
              113.5449644,
              22.1245033
            ],
            [
              113.5449861,
              22.1245032
            ],
            [
              113.5449861,
              22.1244528
            ],
            [
              113.5449647,
              22.1244528
            ],
            [
              113.5449646,
              22.1242717
            ],
            [
              113.5450621,
              22.1242716
            ],
            [
              113.5450621,
              22.1242214
            ],
            [
              113.5455181,
              22.124221
            ],
            [
              113.5455182,
              22.1243018
            ],
            [
              113.5455073,
              22.1243018
            ],
            [
              113.5455073,
              22.1243222
            ],
            [
              113.5455288,
              22.1243222
            ],
            [
              113.5455288,
              22.1243468
            ],
            [
              113.5455289,
              22.1243718
            ],
            [
              113.5454436,
              22.1243715
            ],
            [
              113.5451935,
              22.1243706
            ],
            [
              113.5451381,
              22.1243721
            ],
            [
              113.5451377,
              22.124401
            ],
            [
              113.5451368,
              22.1244729
            ],
            [
              113.5451384,
              22.1245554
            ],
            [
              113.5451383,
              22.1245835
            ],
            [
              113.545194,
              22.1245835
            ],
            [
              113.5454388,
              22.1245833
            ],
            [
              113.5455182,
              22.1245832
            ],
            [
              113.5455182,
              22.1246082
            ],
            [
              113.5455183,
              22.1246336
            ],
            [
              113.5455071,
              22.1246336
            ],
            [
              113.5455071,
              22.1246539
            ],
            [
              113.545518,
              22.1246539
            ],
            [
              113.5455181,
              22.1247342
            ],
            [
              113.5450628,
              22.1247346
            ]
          ]
        ]
      },
      "id": "way/289598409"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598410",
        "addr:housenumber": "S4",
        "building": "residential",
        "image": "https://map.um.edu.mo/emap_images/building_S4.jpg",
        "name": "研究生宿舍 Postgraduates House (S4)",
        "name:en": "Postgraduates House (S4)",
        "name:pt": "Dormitório de Estudantes de Pós-Graduação (S4)",
        "name:zh": "研究生宿舍 (S4)",
        "ref": "S4",
        "residential": "university"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.544737,
              22.1240709
            ],
            [
              113.5447367,
              22.1237629
            ],
            [
              113.5447364,
              22.1234772
            ],
            [
              113.5452466,
              22.1234768
            ],
            [
              113.5452467,
              22.1235589
            ],
            [
              113.5452468,
              22.1236179
            ],
            [
              113.5451709,
              22.1236179
            ],
            [
              113.5451709,
              22.1236281
            ],
            [
              113.5449803,
              22.1236282
            ],
            [
              113.5449102,
              22.1236283
            ],
            [
              113.5449102,
              22.123608
            ],
            [
              113.5448778,
              22.123608
            ],
            [
              113.5448778,
              22.1236582
            ],
            [
              113.5449101,
              22.1236582
            ],
            [
              113.5449102,
              22.1237693
            ],
            [
              113.5449104,
              22.1238993
            ],
            [
              113.5448774,
              22.1238993
            ],
            [
              113.5448774,
              22.1239498
            ],
            [
              113.5448992,
              22.1239498
            ],
            [
              113.5448992,
              22.1239297
            ],
            [
              113.5449803,
              22.1239297
            ],
            [
              113.5450946,
              22.1239296
            ],
            [
              113.5450946,
              22.1239799
            ],
            [
              113.5451272,
              22.1239799
            ],
            [
              113.5451273,
              22.1240365
            ],
            [
              113.5451273,
              22.1240807
            ],
            [
              113.5450733,
              22.1240807
            ],
            [
              113.5450733,
              22.1240707
            ],
            [
              113.544737,
              22.1240709
            ]
          ]
        ]
      },
      "id": "way/289598410"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598411",
        "UM-built-type:en": "Academics",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "E11",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "university",
        "description": "Location: Room 4040, Faculty of Science and Technology (E11)",
        "description:en": "Location: Room 4040, Faculty of Science and Technology (E11)",
        "description:zh": "所在位置: 科技學院 (E11), 4040室",
        "email": "fst.enquiry@um.edu.mo",
        "fax": "+853 8822 2426",
        "image": "https://map.um.edu.mo/emap_images/building_E11.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "科技學院 Faculdade de Ciências e Tecnologia (E11)",
        "name:en": "Faculty of Science and Technology (E11)",
        "name:pt": "Faculdade de Ciências e Tecnologia (E11)",
        "name:zh": "科技學院 (E11)",
        "note": "Zone East, Academics",
        "phone": "+853 8822 4963",
        "website": "https://www.fst.um.edu.mo/"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5428686,
              22.1328889
            ],
            [
              113.5428681,
              22.1325854
            ],
            [
              113.5428677,
              22.1322855
            ],
            [
              113.5434013,
              22.1322848
            ],
            [
              113.5434015,
              22.1323956
            ],
            [
              113.5435526,
              22.1323954
            ],
            [
              113.5435522,
              22.1321545
            ],
            [
              113.5429994,
              22.1321552
            ],
            [
              113.5429995,
              22.1322354
            ],
            [
              113.5427832,
              22.1322357
            ],
            [
              113.5427831,
              22.1321646
            ],
            [
              113.5426532,
              22.1321648
            ],
            [
              113.5426528,
              22.1319037
            ],
            [
              113.5427373,
              22.1319036
            ],
            [
              113.5438246,
              22.1319021
            ],
            [
              113.5438247,
              22.131994
            ],
            [
              113.543825,
              22.1321545
            ],
            [
              113.5438027,
              22.1321546
            ],
            [
              113.5438029,
              22.1322853
            ],
            [
              113.5438243,
              22.1322853
            ],
            [
              113.5438247,
              22.1325527
            ],
            [
              113.543825,
              22.1327281
            ],
            [
              113.5437709,
              22.1327282
            ],
            [
              113.5437709,
              22.132748
            ],
            [
              113.5438465,
              22.1327479
            ],
            [
              113.5438467,
              22.1328876
            ],
            [
              113.5428686,
              22.1328889
            ]
          ]
        ]
      },
      "id": "way/289598411"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598413",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "N21",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "yes",
        "image": "https://map.um.edu.mo/emap_images/building_N21.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "科研大樓 Edifício de Ciências (N21)",
        "name:en": "Research Building (N21)",
        "name:pt": "Edifício de Ciências (N21)",
        "name:zh": "科研大樓 (N21)",
        "ref": "N21",
        "type": "multipolygon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5458051,
              22.1351946
            ],
            [
              113.5457247,
              22.1351942
            ],
            [
              113.5455444,
              22.1351943
            ],
            [
              113.545327,
              22.1351944
            ],
            [
              113.5452696,
              22.1351922
            ],
            [
              113.5452147,
              22.135192
            ],
            [
              113.5445292,
              22.135189
            ],
            [
              113.5445309,
              22.1348768
            ],
            [
              113.5451318,
              22.1348762
            ],
            [
              113.545807,
              22.1348824
            ],
            [
              113.5458051,
              22.1351946
            ]
          ]
        ]
      },
      "id": "way/289598413"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598415",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "N22",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "yes",
        "image": "https://map.um.edu.mo/emap_images/building_N22.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "科研大樓 Edifício de Ciências (N22)",
        "name:en": "Research Building (N22)",
        "name:pt": "Edifício de Ciências (N22)",
        "name:zh": "科研大樓 (N22)",
        "ref": "N22",
        "type": "multipolygon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5427493,
              22.1353097
            ],
            [
              113.5427495,
              22.1352375
            ],
            [
              113.5427505,
              22.1348884
            ],
            [
              113.5433048,
              22.1348897
            ],
            [
              113.5433047,
              22.1349194
            ],
            [
              113.5433682,
              22.1349196
            ],
            [
              113.5439231,
              22.1349209
            ],
            [
              113.5439225,
              22.13513
            ],
            [
              113.5435777,
              22.1351292
            ],
            [
              113.5435775,
              22.1351907
            ],
            [
              113.5434663,
              22.1351904
            ],
            [
              113.5434664,
              22.1351307
            ],
            [
              113.5433053,
              22.1351303
            ],
            [
              113.5433048,
              22.135311
            ],
            [
              113.5427493,
              22.1353097
            ]
          ]
        ]
      },
      "id": "way/289598415"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598416",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "N24",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "yes",
        "image": "https://map.um.edu.mo/emap_images/building_N24.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "科研大樓 Edifício de Ciências (N24)",
        "name:en": "Research Building (N24)",
        "name:pt": "Edifício de Ciências (N24)",
        "name:zh": "科研大樓 (N24)",
        "ref": "N24",
        "type": "multipolygon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5436183,
              22.135774
            ],
            [
              113.5436181,
              22.1354624
            ],
            [
              113.5442373,
              22.1354621
            ],
            [
              113.5446116,
              22.1354531
            ],
            [
              113.5446275,
              22.1354541
            ],
            [
              113.5446636,
              22.135457
            ],
            [
              113.5446596,
              22.135589
            ],
            [
              113.5446588,
              22.1356319
            ],
            [
              113.5446585,
              22.1357735
            ],
            [
              113.5436183,
              22.135774
            ]
          ]
        ]
      },
      "id": "way/289598416"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598417",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S9",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "residential",
        "image": "https://map.um.edu.mo/emap_images/building_S9.jpg",
        "name": "紹邦書院 Shiu Pong College (S9)",
        "name:en": "Shiu Pong College (S9)",
        "name:pt": "Colégio Shiu Pong (S9)",
        "name:zh": "紹邦書院 (S9)",
        "ref": "S9",
        "residential": "university",
        "website": "https://spc.rc.um.edu.mo/"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5433256,
              22.1246537
            ],
            [
              113.5433256,
              22.1246437
            ],
            [
              113.5432715,
              22.1246437
            ],
            [
              113.5432715,
              22.1242641
            ],
            [
              113.5432715,
              22.1240806
            ],
            [
              113.5435971,
              22.1240806
            ],
            [
              113.5435971,
              22.1240103
            ],
            [
              113.5439442,
              22.1240103
            ],
            [
              113.5439442,
              22.1242715
            ],
            [
              113.5439117,
              22.1242715
            ],
            [
              113.5439117,
              22.1246434
            ],
            [
              113.5438573,
              22.1246434
            ],
            [
              113.5438573,
              22.1246537
            ],
            [
              113.5433256,
              22.1246537
            ]
          ]
        ]
      },
      "id": "way/289598417"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598418",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "W12",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "residential",
        "image": "https://map.um.edu.mo/emap_images/building_W12.jpg",
        "name": "蔡繼有書院 Choi Kai Yau College (W12)",
        "name:en": "Choi Kai Yau College (W12)",
        "name:pt": "Colégios Choi Kai Yau (W12)",
        "name:zh": "蔡繼有書院 (W12)",
        "ref": "W12",
        "residential": "university",
        "website": "https://ckyc.rc.um.edu.mo/"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.541467,
              22.1319733
            ],
            [
              113.5414672,
              22.1320129
            ],
            [
              113.5413478,
              22.1320132
            ],
            [
              113.5413486,
              22.1322667
            ],
            [
              113.5415783,
              22.132266
            ],
            [
              113.5415797,
              22.1326874
            ],
            [
              113.5414916,
              22.1326877
            ],
            [
              113.5414913,
              22.1325972
            ],
            [
              113.5414369,
              22.1325974
            ],
            [
              113.5414368,
              22.1325562
            ],
            [
              113.541361,
              22.1325564
            ],
            [
              113.541361,
              22.1325668
            ],
            [
              113.5412634,
              22.1325671
            ],
            [
              113.5412631,
              22.1324963
            ],
            [
              113.541209,
              22.1324964
            ],
            [
              113.5412089,
              22.1324555
            ],
            [
              113.5411877,
              22.1324555
            ],
            [
              113.5411878,
              22.1324945
            ],
            [
              113.540981,
              22.1324951
            ],
            [
              113.5409811,
              22.1325062
            ],
            [
              113.5409384,
              22.1325063
            ],
            [
              113.5409383,
              22.1324866
            ],
            [
              113.5409273,
              22.1324866
            ],
            [
              113.5409271,
              22.1324356
            ],
            [
              113.5408942,
              22.1324357
            ],
            [
              113.5408943,
              22.1324658
            ],
            [
              113.5407968,
              22.1324661
            ],
            [
              113.5407963,
              22.1323257
            ],
            [
              113.5407751,
              22.1323257
            ],
            [
              113.5407741,
              22.1320137
            ],
            [
              113.5408508,
              22.1320135
            ],
            [
              113.5408505,
              22.1319336
            ],
            [
              113.5408295,
              22.1319337
            ],
            [
              113.5408295,
              22.131943
            ],
            [
              113.5407419,
              22.1319432
            ],
            [
              113.5407417,
              22.1318629
            ],
            [
              113.5408289,
              22.1318626
            ],
            [
              113.540829,
              22.1318928
            ],
            [
              113.5408507,
              22.1318928
            ],
            [
              113.5408506,
              22.1318431
            ],
            [
              113.5412632,
              22.1318419
            ],
            [
              113.5412631,
              22.131813
            ],
            [
              113.5413199,
              22.1318128
            ],
            [
              113.5413823,
              22.1318127
            ],
            [
              113.5413829,
              22.1319736
            ],
            [
              113.541467,
              22.1319733
            ]
          ]
        ]
      },
      "id": "way/289598418"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598419",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "S8",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "yes",
        "building:levels": "3",
        "image": "https://map.um.edu.mo/emap_images/building_S8.jpg",
        "name": "薈萃坊 Centro Comercial da Universidade de Macau (S8)",
        "name:en": "University Mall (S8)",
        "name:pt": "Centro Comercial da Universidade de Macau (S8)",
        "name:zh": "薈萃坊 (S8)",
        "ref": "S8",
        "shop": "mall"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5442093,
              22.1245979
            ],
            [
              113.5442093,
              22.1245239
            ],
            [
              113.544194,
              22.1245239
            ],
            [
              113.5441937,
              22.1240394
            ],
            [
              113.5443914,
              22.1240392
            ],
            [
              113.5444341,
              22.1240392
            ],
            [
              113.5445489,
              22.1240392
            ],
            [
              113.544549,
              22.1241622
            ],
            [
              113.544549,
              22.1241966
            ],
            [
              113.5447587,
              22.1241964
            ],
            [
              113.5447589,
              22.1245226
            ],
            [
              113.5446471,
              22.1245227
            ],
            [
              113.5445004,
              22.1245227
            ],
            [
              113.5443489,
              22.1245228
            ],
            [
              113.5442759,
              22.1245229
            ],
            [
              113.544276,
              22.1245979
            ],
            [
              113.5442093,
              22.1245979
            ]
          ]
        ]
      },
      "id": "way/289598419"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598420",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "N6",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "university",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "layer": "2",
        "name": "行政樓 Edifício Administrativo da Universidade (N6)",
        "name:en": "Administration Building of the University of Macau (N6)",
        "name:pt": "Edifício Administrativo da Universidade de Macau (N6)",
        "name:zh": "行政樓(N6)",
        "ref": "N6"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5437489,
              22.1342458
            ],
            [
              113.543749,
              22.1339944
            ],
            [
              113.5436402,
              22.1339944
            ],
            [
              113.543642,
              22.1338669
            ],
            [
              113.5436403,
              22.1336025
            ],
            [
              113.5440747,
              22.1336026
            ],
            [
              113.5440747,
              22.1335429
            ],
            [
              113.5442206,
              22.1335429
            ],
            [
              113.5443567,
              22.133543
            ],
            [
              113.5443567,
              22.1336017
            ],
            [
              113.5449156,
              22.1336019
            ],
            [
              113.5449377,
              22.1336019
            ],
            [
              113.5449376,
              22.1336385
            ],
            [
              113.5449376,
              22.1336727
            ],
            [
              113.5448456,
              22.1336727
            ],
            [
              113.5448455,
              22.1339741
            ],
            [
              113.544628,
              22.133974
            ],
            [
              113.544628,
              22.1340147
            ],
            [
              113.5444217,
              22.1340146
            ],
            [
              113.5444217,
              22.1339742
            ],
            [
              113.5443244,
              22.1339742
            ],
            [
              113.5443243,
              22.1342462
            ],
            [
              113.544107,
              22.1342461
            ],
            [
              113.5441072,
              22.1339639
            ],
            [
              113.5439335,
              22.1339639
            ],
            [
              113.5439335,
              22.1340044
            ],
            [
              113.5440314,
              22.1340045
            ],
            [
              113.5440313,
              22.1342459
            ],
            [
              113.5437489,
              22.1342458
            ]
          ]
        ]
      },
      "id": "way/289598420"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598421",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "W23",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "residential",
        "image": "https://map.um.edu.mo/emap_images/building_W23.jpg",
        "name": "鄭裕彤書院 Cheng Yu Tung College (W23)",
        "name:en": "Cheng Yu Tung College (W23)",
        "name:pt": "Colégio Cheng Yu Tung (W23)",
        "name:zh": "鄭裕彤書院(W23)",
        "ref": "W23",
        "residential": "university",
        "website": "https://cytc.rc.um.edu.mo/"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5410784,
              22.1285952
            ],
            [
              113.541133,
              22.1285952
            ],
            [
              113.541133,
              22.128545
            ],
            [
              113.5410787,
              22.1285451
            ],
            [
              113.5410787,
              22.128505
            ],
            [
              113.5410573,
              22.128505
            ],
            [
              113.5410569,
              22.1277505
            ],
            [
              113.5413068,
              22.1277504
            ],
            [
              113.5413069,
              22.1279519
            ],
            [
              113.5412958,
              22.127952
            ],
            [
              113.5412959,
              22.1279919
            ],
            [
              113.5413935,
              22.1279919
            ],
            [
              113.5413935,
              22.1280121
            ],
            [
              113.5418168,
              22.1280119
            ],
            [
              113.5418169,
              22.1281127
            ],
            [
              113.5418058,
              22.1281127
            ],
            [
              113.541806,
              22.1284242
            ],
            [
              113.5417733,
              22.1284242
            ],
            [
              113.5417733,
              22.1285448
            ],
            [
              113.5417409,
              22.1285448
            ],
            [
              113.5417409,
              22.128575
            ],
            [
              113.5416757,
              22.128575
            ],
            [
              113.5416757,
              22.1285953
            ],
            [
              113.5415914,
              22.1285954
            ],
            [
              113.5415236,
              22.1285954
            ],
            [
              113.5415236,
              22.1285751
            ],
            [
              113.5412411,
              22.1285752
            ],
            [
              113.5411654,
              22.1285753
            ],
            [
              113.5411654,
              22.1285951
            ],
            [
              113.5412199,
              22.1285951
            ],
            [
              113.54122,
              22.1287254
            ],
            [
              113.5410785,
              22.1287255
            ],
            [
              113.5410784,
              22.1285952
            ]
          ]
        ]
      },
      "id": "way/289598421"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/289598422",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "W14",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "residential",
        "image": "https://map.um.edu.mo/emap_images/building_W14.jpg",
        "name": "霍英東珍禧書院 Henry Fok Pearl Jubilee College (W14)",
        "name:en": "Henry Fok Pearl Jubilee College (W14)",
        "name:pt": "Colégio do Jubileu da Pérola de Henry Fok (W14)",
        "name:zh": "霍英東珍禧書院 (W14)",
        "ref": "W14",
        "residential": "university",
        "website": "https://hfpjc.rc.um.edu.mo/"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5414128,
              22.1315613
            ],
            [
              113.5413231,
              22.1315614
            ],
            [
              113.541274,
              22.1315614
            ],
            [
              113.5412739,
              22.1315306
            ],
            [
              113.5408619,
              22.131531
            ],
            [
              113.5408619,
              22.1314906
            ],
            [
              113.5408292,
              22.1314906
            ],
            [
              113.5408293,
              22.1315208
            ],
            [
              113.5407307,
              22.1315209
            ],
            [
              113.5407306,
              22.131431
            ],
            [
              113.5407533,
              22.131431
            ],
            [
              113.5407529,
              22.1310095
            ],
            [
              113.540786,
              22.1310095
            ],
            [
              113.5407859,
              22.1309283
            ],
            [
              113.540872,
              22.1309282
            ],
            [
              113.540872,
              22.1309079
            ],
            [
              113.5409054,
              22.1309079
            ],
            [
              113.5409054,
              22.1309363
            ],
            [
              113.540926,
              22.1309363
            ],
            [
              113.540926,
              22.1308868
            ],
            [
              113.5409374,
              22.1308867
            ],
            [
              113.5409374,
              22.1308772
            ],
            [
              113.5409814,
              22.1308772
            ],
            [
              113.5409814,
              22.1308887
            ],
            [
              113.5412629,
              22.1308884
            ],
            [
              113.5412629,
              22.1308465
            ],
            [
              113.5413609,
              22.1308464
            ],
            [
              113.5413613,
              22.1312603
            ],
            [
              113.5413614,
              22.1313802
            ],
            [
              113.5412967,
              22.1313803
            ],
            [
              113.5412967,
              22.1313903
            ],
            [
              113.5413827,
              22.1313902
            ],
            [
              113.5413828,
              22.1315214
            ],
            [
              113.5414128,
              22.1315214
            ],
            [
              113.5414128,
              22.1315613
            ]
          ]
        ]
      },
      "id": "way/289598422"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/291592970",
        "addr:street": "蓮花海濱大馬路 Avenida Marginal Flor de Lótus",
        "building": "industrial"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5533961,
              22.1314239
            ],
            [
              113.5533725,
              22.1310223
            ],
            [
              113.5549137,
              22.1309458
            ],
            [
              113.5549167,
              22.1309881
            ],
            [
              113.5551014,
              22.1309809
            ],
            [
              113.5551423,
              22.1309702
            ],
            [
              113.5551878,
              22.130983
            ],
            [
              113.5552155,
              22.1310129
            ],
            [
              113.555223,
              22.1310497
            ],
            [
              113.5552102,
              22.1310853
            ],
            [
              113.5551653,
              22.1311161
            ],
            [
              113.5551748,
              22.1312818
            ],
            [
              113.5552426,
              22.131342
            ],
            [
              113.5551836,
              22.1314062
            ],
            [
              113.5549167,
              22.1314171
            ],
            [
              113.5549152,
              22.131357
            ],
            [
              113.5533961,
              22.1314239
            ]
          ]
        ]
      },
      "id": "way/291592970"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/295507046",
        "building": "yes",
        "name": "澳門大學行人隧道出入口"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5520936,
              22.1351983
            ],
            [
              113.5520825,
              22.1345229
            ],
            [
              113.5521566,
              22.1345219
            ],
            [
              113.5521677,
              22.1351973
            ],
            [
              113.5520936,
              22.1351983
            ]
          ]
        ]
      },
      "id": "way/295507046"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/296744844",
        "amenity": "sport",
        "image": "https://map.um.edu.mo/emap_images/sport_archery-range.jpg",
        "leisure": "pitch",
        "lit": "yes",
        "name": "射箭場（亦稱AR） Archery Range (aka AR)",
        "name:en": "Archery Range (aka AR)",
        "name:zh": "射箭場（亦稱AR）",
        "ref": "AR",
        "sport": "archery",
        "website": "https://facility.osa.um.edu.mo/projects/archery-range/",
        "website:en": "https://facility.osa.um.edu.mo/projects/archery-range/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/archery-range/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.541565,
              22.1247713
            ],
            [
              113.5415658,
              22.1245851
            ],
            [
              113.5424382,
              22.1245884
            ],
            [
              113.5424374,
              22.1247745
            ],
            [
              113.541565,
              22.1247713
            ]
          ]
        ]
      },
      "id": "way/296744844"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/296744847",
        "amenity": "sport",
        "leisure": "pitch",
        "lit": "yes",
        "name": "小型人造草足球場（亦稱MSP） Mini Artificial Turf Soccer Pitch (aka MSP)",
        "name:en": "Mini Artificial Turf Soccer Pitch (aka MSP)",
        "name:zh": "小型人造草足球場（亦稱MSP）",
        "ref": "MSP",
        "sport": "football",
        "surface": "artificial_turf",
        "website": "https://facility.osa.um.edu.mo/projects/mini-artificial-turf-soccer-pitch/",
        "website:en": "https://facility.osa.um.edu.mo/projects/mini-artificial-turf-soccer-pitch/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/mini-artificial-turf-soccer-pitch/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5411326,
              22.1244463
            ],
            [
              113.541133,
              22.1240233
            ],
            [
              113.5414565,
              22.1240236
            ],
            [
              113.5414563,
              22.1242369
            ],
            [
              113.5414561,
              22.1244466
            ],
            [
              113.5411326,
              22.1244463
            ]
          ]
        ]
      },
      "id": "way/296744847"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/296744849",
        "amenity": "sport",
        "hoops": "2",
        "leisure": "pitch",
        "lit": "yes",
        "name": "6號室外籃球場（亦稱BA6） Outdoor Basketball Court no. 6 (aka BA6)",
        "name:en": "Outdoor Basketball Court no. 6 (aka BA6)",
        "name:zh": "6號室外籃球場（亦稱BA6）",
        "ref": "BA6",
        "sport": "basketball",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5413816,
              22.1271016
            ],
            [
              113.5413803,
              22.126855
            ],
            [
              113.5415211,
              22.1268543
            ],
            [
              113.5415224,
              22.127101
            ],
            [
              113.5413816,
              22.1271016
            ]
          ]
        ]
      },
      "id": "way/296744849"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/296744854",
        "amenity": "sport",
        "covered": "no",
        "leisure": "pitch",
        "lit": "yes",
        "name": "沙灘運動場（亦稱BB） Beach Court (aka BB)",
        "name:en": "Beach Court (aka BB)",
        "name:zh": "沙灘運動場（亦稱BB）",
        "ref": "BB",
        "sport": "beachvolleyball",
        "surface": "sand",
        "website": "https://facility.osa.um.edu.mo/projects/beach-court/",
        "website:en": "https://facility.osa.um.edu.mo/projects/beach-court/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/beach-court/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5410996,
              22.127181
            ],
            [
              113.5410974,
              22.1268349
            ],
            [
              113.5413086,
              22.1268337
            ],
            [
              113.541311,
              22.1271799
            ],
            [
              113.5410996,
              22.127181
            ]
          ]
        ]
      },
      "id": "way/296744854"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/296744857",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "leisure": "garden",
        "name": "修簧花園 Jardim Mola",
        "name:en": "Spring Garden",
        "name:pt": "Jardim Mola",
        "name:zh": "修簧花園"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.544593,
              22.1354243
            ],
            [
              113.5445932,
              22.1353491
            ],
            [
              113.544593,
              22.1352781
            ],
            [
              113.544593,
              22.135228
            ],
            [
              113.5452017,
              22.135228
            ],
            [
              113.5452036,
              22.1352721
            ],
            [
              113.5452017,
              22.1354243
            ],
            [
              113.544593,
              22.1354243
            ]
          ]
        ]
      },
      "id": "way/296744857"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/296744879",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "leisure": "garden",
        "name": "哲學花園 Jardim da Filosofia",
        "name:en": "Philosophical Garden",
        "name:pt": "Jardim da Filosofia",
        "name:zh": "哲學花園"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5440697,
              22.1348327
            ],
            [
              113.5444031,
              22.1348142
            ],
            [
              113.5444168,
              22.1348714
            ],
            [
              113.5444176,
              22.1352616
            ],
            [
              113.544395,
              22.1353262
            ],
            [
              113.5444253,
              22.1353649
            ],
            [
              113.5440744,
              22.1353691
            ],
            [
              113.5440722,
              22.1348878
            ],
            [
              113.5440697,
              22.1348327
            ]
          ]
        ]
      },
      "id": "way/296744879"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/296744887",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "leisure": "garden",
        "name": "哲思花園 Jardim da Filosofia",
        "name:en": "Philosophical Garden",
        "name:pt": "Jardim da Filosofia",
        "name:zh": "哲思花園"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5414102,
              22.1319433
            ],
            [
              113.5414107,
              22.1317731
            ],
            [
              113.5407266,
              22.1317714
            ],
            [
              113.540727,
              22.1316207
            ],
            [
              113.5415448,
              22.1316227
            ],
            [
              113.5415438,
              22.1319437
            ],
            [
              113.5414102,
              22.1319433
            ]
          ]
        ]
      },
      "id": "way/296744887"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/296744889",
        "leisure": "park",
        "name": "啟航公園 Parque Náutico",
        "name:en": "Sailing Park",
        "name:pt": "Parque Náutico",
        "name:zh": "啟航公園"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5447994,
              22.1263569
            ],
            [
              113.5448167,
              22.1254966
            ],
            [
              113.5450876,
              22.1253101
            ],
            [
              113.5451996,
              22.1254462
            ],
            [
              113.545215,
              22.1255269
            ],
            [
              113.5452091,
              22.1255989
            ],
            [
              113.5451819,
              22.125653
            ],
            [
              113.5451582,
              22.1257418
            ],
            [
              113.5451176,
              22.1259456
            ],
            [
              113.5450851,
              22.1260848
            ],
            [
              113.5450823,
              22.1261228
            ],
            [
              113.54511,
              22.1261766
            ],
            [
              113.5451073,
              22.1261942
            ],
            [
              113.5451005,
              22.1262077
            ],
            [
              113.5450293,
              22.1262238
            ],
            [
              113.5449967,
              22.1262589
            ],
            [
              113.5449608,
              22.1263414
            ],
            [
              113.5449461,
              22.1263546
            ],
            [
              113.5447994,
              22.1263569
            ]
          ]
        ]
      },
      "id": "way/296744889"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/296744891",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "leisure": "garden",
        "name": "回憶花園 Jardim da Lembrança",
        "name:en": "Memory Garden",
        "name:pt": "Jardim da Lembrança",
        "name:zh": "回憶花園"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5431099,
              22.1318591
            ],
            [
              113.5431125,
              22.1317487
            ],
            [
              113.5430715,
              22.1317483
            ],
            [
              113.5430712,
              22.1315822
            ],
            [
              113.5433592,
              22.1313309
            ],
            [
              113.5434539,
              22.1313351
            ],
            [
              113.5435395,
              22.131429
            ],
            [
              113.5436973,
              22.1314269
            ],
            [
              113.5436973,
              22.1318539
            ],
            [
              113.5431099,
              22.1318591
            ]
          ]
        ]
      },
      "id": "way/296744891"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/296744896",
        "amenity": "waste_transfer_station",
        "building": "yes",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "垃圾收集中心 Centro de coleta de lixo",
        "name:pt": "Centro de coleta de lixo",
        "name:zh": "垃圾收集中心"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5420897,
              22.1355851
            ],
            [
              113.5420883,
              22.1354838
            ],
            [
              113.5421767,
              22.1354838
            ],
            [
              113.5421795,
              22.1354013
            ],
            [
              113.5422782,
              22.1354026
            ],
            [
              113.5422767,
              22.1354823
            ],
            [
              113.5423773,
              22.1354824
            ],
            [
              113.5423787,
              22.135584
            ],
            [
              113.5420897,
              22.1355851
            ]
          ]
        ]
      },
      "id": "way/296744896"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/296744903",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.546514,
              22.1254583
            ],
            [
              113.5466087,
              22.1254573
            ],
            [
              113.5466097,
              22.1255387
            ],
            [
              113.5465151,
              22.1255398
            ],
            [
              113.546514,
              22.1254583
            ]
          ]
        ]
      },
      "id": "way/296744903"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/296744911",
        "leisure": "garden",
        "name": "故新花園 Jardim do Estudioso Li Guxin",
        "name:en": "Old and New Garden",
        "name:pt": "Jardim do Estudioso Li Guxin",
        "name:zh": "故新花園"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.542037,
              22.1259823
            ],
            [
              113.5420848,
              22.1258244
            ],
            [
              113.542711,
              22.1258214
            ],
            [
              113.5427318,
              22.1258908
            ],
            [
              113.542633,
              22.1259808
            ],
            [
              113.542037,
              22.1259823
            ]
          ]
        ]
      },
      "id": "way/296744911"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/320028415",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5461201,
              22.1203839
            ],
            [
              113.5461183,
              22.120185
            ],
            [
              113.5462738,
              22.1201838
            ],
            [
              113.5462756,
              22.1203827
            ],
            [
              113.5461201,
              22.1203839
            ]
          ]
        ]
      },
      "id": "way/320028415"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/322228666",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5545529,
              22.1246392
            ],
            [
              113.5545106,
              22.1246079
            ],
            [
              113.554556,
              22.1245554
            ],
            [
              113.5545983,
              22.1245867
            ],
            [
              113.5545529,
              22.1246392
            ]
          ]
        ]
      },
      "id": "way/322228666"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/322228673",
        "building": "yes",
        "shop": "convenience"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5542391,
              22.1245012
            ],
            [
              113.5542306,
              22.124495
            ],
            [
              113.5542205,
              22.1244876
            ],
            [
              113.5543131,
              22.1243793
            ],
            [
              113.554372,
              22.1244225
            ],
            [
              113.5543253,
              22.1244772
            ],
            [
              113.5542849,
              22.1244476
            ],
            [
              113.5542391,
              22.1245012
            ]
          ]
        ]
      },
      "id": "way/322228673"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/322228675",
        "addr:housenumber": "250-272",
        "addr:street": "石排灣馬路 Estrada de Seac Pai Van",
        "building": "roof",
        "building:levels": "1",
        "opening_hours": "24/7"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5544053,
              22.124639
            ],
            [
              113.5543326,
              22.1245859
            ],
            [
              113.5543482,
              22.1245677
            ],
            [
              113.5543839,
              22.1245259
            ],
            [
              113.5544364,
              22.1244642
            ],
            [
              113.554509,
              22.1245173
            ],
            [
              113.5544577,
              22.1245777
            ],
            [
              113.5544219,
              22.1246194
            ],
            [
              113.5544053,
              22.124639
            ]
          ]
        ]
      },
      "id": "way/322228675"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771705",
        "access": "private",
        "leisure": "swimming_pool",
        "sport": "swimming"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.557179,
              22.1280523
            ],
            [
              113.557219,
              22.1279573
            ],
            [
              113.5572512,
              22.1279505
            ],
            [
              113.557323,
              22.1279309
            ],
            [
              113.5573745,
              22.12789
            ],
            [
              113.5574012,
              22.1278312
            ],
            [
              113.5574002,
              22.1277715
            ],
            [
              113.5574953,
              22.1277009
            ],
            [
              113.5575213,
              22.1277574
            ],
            [
              113.5575176,
              22.1278392
            ],
            [
              113.5574826,
              22.127933
            ],
            [
              113.5574311,
              22.1279927
            ],
            [
              113.5573649,
              22.1280353
            ],
            [
              113.557271,
              22.1280625
            ],
            [
              113.557179,
              22.1280523
            ]
          ]
        ]
      },
      "id": "way/326771705"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771717",
        "addr:housenumber": "91-115",
        "addr:street": "桉樹街 Rua dos Eucaliptos",
        "building": "industrial"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5525876,
              22.127688
            ],
            [
              113.5525886,
              22.1270439
            ],
            [
              113.5528352,
              22.1270442
            ],
            [
              113.5528351,
              22.1270686
            ],
            [
              113.5529238,
              22.1270687
            ],
            [
              113.5529234,
              22.1273412
            ],
            [
              113.5529856,
              22.1273413
            ],
            [
              113.5529855,
              22.1274363
            ],
            [
              113.5530845,
              22.1274364
            ],
            [
              113.5530842,
              22.1276886
            ],
            [
              113.5525876,
              22.127688
            ]
          ]
        ]
      },
      "id": "way/326771717"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771719",
        "addr:housenumber": "98",
        "addr:street": "樟樹街 Rua das Canforeiras",
        "building": "industrial",
        "height": "14.5"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5530878,
              22.128505
            ],
            [
              113.552897,
              22.1284578
            ],
            [
              113.552896,
              22.1283563
            ],
            [
              113.5526112,
              22.1283588
            ],
            [
              113.5526098,
              22.1282198
            ],
            [
              113.5525679,
              22.1282202
            ],
            [
              113.5525636,
              22.1277928
            ],
            [
              113.5527281,
              22.1277913
            ],
            [
              113.5527277,
              22.1277477
            ],
            [
              113.5529204,
              22.127746
            ],
            [
              113.5529208,
              22.1277861
            ],
            [
              113.5530806,
              22.1277847
            ],
            [
              113.5530878,
              22.128505
            ]
          ]
        ]
      },
      "id": "way/326771719"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771720",
        "addr:street": "芒果街 Rua das Mangueiras",
        "building": "industrial",
        "height": "13.8"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5545244,
              22.1269911
            ],
            [
              113.5545505,
              22.126998
            ],
            [
              113.5545705,
              22.1270224
            ],
            [
              113.5545705,
              22.1270833
            ],
            [
              113.5544541,
              22.1270833
            ],
            [
              113.5544541,
              22.1272359
            ],
            [
              113.5544702,
              22.1272359
            ],
            [
              113.5544702,
              22.127493
            ],
            [
              113.5538806,
              22.1274931
            ],
            [
              113.5538806,
              22.1274417
            ],
            [
              113.5533649,
              22.1274418
            ],
            [
              113.5533648,
              22.1270381
            ],
            [
              113.5544583,
              22.1270379
            ],
            [
              113.5544583,
              22.1269912
            ],
            [
              113.5545244,
              22.1269911
            ]
          ]
        ]
      },
      "id": "way/326771720"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771721",
        "addr:housenumber": "204",
        "addr:street": "聯生海濱路 Rua Marginal da Concórdia",
        "building": "industrial",
        "height": "10.6"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5521309,
              22.1267184
            ],
            [
              113.5521294,
              22.1265115
            ],
            [
              113.5519568,
              22.1265125
            ],
            [
              113.5519508,
              22.125637
            ],
            [
              113.5521254,
              22.1256359
            ],
            [
              113.552124,
              22.1254387
            ],
            [
              113.552727,
              22.1254352
            ],
            [
              113.5527274,
              22.125496
            ],
            [
              113.5527796,
              22.1254957
            ],
            [
              113.5527802,
              22.1255765
            ],
            [
              113.5530286,
              22.125575
            ],
            [
              113.5530314,
              22.1259891
            ],
            [
              113.5530543,
              22.1259889
            ],
            [
              113.5530593,
              22.1267129
            ],
            [
              113.5521309,
              22.1267184
            ]
          ]
        ]
      },
      "id": "way/326771721"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771722",
        "addr:housenumber": "16-40",
        "addr:street": "聯生海濱路 Rua Marginal da Concórdia",
        "building": "yes",
        "height": "11.7"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5519436,
              22.1247042
            ],
            [
              113.5519464,
              22.1242721
            ],
            [
              113.5520636,
              22.1242727
            ],
            [
              113.5520638,
              22.124247
            ],
            [
              113.5521446,
              22.1242475
            ],
            [
              113.5521445,
              22.124266
            ],
            [
              113.5522905,
              22.1242668
            ],
            [
              113.5522907,
              22.124243
            ],
            [
              113.5523841,
              22.1242435
            ],
            [
              113.5523839,
              22.1242676
            ],
            [
              113.5526744,
              22.1242692
            ],
            [
              113.5526745,
              22.1242551
            ],
            [
              113.5527657,
              22.1242556
            ],
            [
              113.5527656,
              22.1242748
            ],
            [
              113.5530512,
              22.1242764
            ],
            [
              113.5530484,
              22.1247102
            ],
            [
              113.5523753,
              22.1247065
            ],
            [
              113.5523752,
              22.1247219
            ],
            [
              113.5522856,
              22.1247214
            ],
            [
              113.5522857,
              22.1247049
            ],
            [
              113.5521435,
              22.1247041
            ],
            [
              113.5521434,
              22.1247178
            ],
            [
              113.5520544,
              22.1247173
            ],
            [
              113.5520544,
              22.1247048
            ],
            [
              113.5519436,
              22.1247042
            ]
          ]
        ]
      },
      "id": "way/326771722"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771723",
        "addr:street": "芒果街 Rua das Mangueiras",
        "building": "industrial",
        "height": "12.1",
        "name": "康澤工商 Liu's Comércio e Indústria, Lda.",
        "name:en": "Liu's Commerce and Industry Ltd.",
        "name:pt": "Liu's Comércio e Indústria, Lda.",
        "name:zh": "康澤工商"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5535221,
              22.1285632
            ],
            [
              113.5535203,
              22.1281876
            ],
            [
              113.5536063,
              22.1281872
            ],
            [
              113.5536055,
              22.128039
            ],
            [
              113.5535251,
              22.1280394
            ],
            [
              113.5535241,
              22.1278219
            ],
            [
              113.5539897,
              22.1278199
            ],
            [
              113.5539901,
              22.1278918
            ],
            [
              113.5542039,
              22.1278909
            ],
            [
              113.5542037,
              22.1278643
            ],
            [
              113.5542813,
              22.127864
            ],
            [
              113.5542815,
              22.1278948
            ],
            [
              113.5544869,
              22.1278939
            ],
            [
              113.5544875,
              22.1280065
            ],
            [
              113.5545136,
              22.1280064
            ],
            [
              113.554514,
              22.1281035
            ],
            [
              113.5544839,
              22.1281036
            ],
            [
              113.5544851,
              22.1283516
            ],
            [
              113.5545136,
              22.1283514
            ],
            [
              113.554514,
              22.128442
            ],
            [
              113.5544891,
              22.1284421
            ],
            [
              113.5544897,
              22.1285636
            ],
            [
              113.5541869,
              22.1285649
            ],
            [
              113.554187,
              22.1285887
            ],
            [
              113.5541148,
              22.128589
            ],
            [
              113.5541147,
              22.128561
            ],
            [
              113.5537971,
              22.1285624
            ],
            [
              113.5537972,
              22.1285912
            ],
            [
              113.5537245,
              22.1285916
            ],
            [
              113.5537243,
              22.1285623
            ],
            [
              113.5535221,
              22.1285632
            ]
          ]
        ]
      },
      "id": "way/326771723"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771724",
        "addr:housenumber": "92-126",
        "addr:street": "蒲桃街 Rua dos Jamboleiros",
        "building": "industrial",
        "height": "12",
        "name": "再生塑料廠 Fábrica de Reciclagem de Plástico"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5526306,
              22.125028
            ],
            [
              113.55263,
              22.1248292
            ],
            [
              113.5530904,
              22.124828
            ],
            [
              113.553091,
              22.1250268
            ],
            [
              113.5526306,
              22.125028
            ]
          ]
        ]
      },
      "id": "way/326771724"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771725",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5517869,
              22.1251348
            ],
            [
              113.5517868,
              22.1250637
            ],
            [
              113.5519197,
              22.1250635
            ],
            [
              113.5519198,
              22.1251134
            ],
            [
              113.5519198,
              22.1251346
            ],
            [
              113.5517869,
              22.1251348
            ]
          ]
        ]
      },
      "id": "way/326771725"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771726",
        "addr:street": "蒲桃街 Rua dos Jamboleiros",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5519198,
              22.1251134
            ],
            [
              113.5519197,
              22.1250635
            ],
            [
              113.5519195,
              22.12494
            ],
            [
              113.5519193,
              22.1248084
            ],
            [
              113.5524964,
              22.1248075
            ],
            [
              113.5524969,
              22.1251126
            ],
            [
              113.5519198,
              22.1251134
            ]
          ]
        ]
      },
      "id": "way/326771726"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771727",
        "building": "yes",
        "height": "10.4"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.551864,
              22.1249401
            ],
            [
              113.5518437,
              22.1249314
            ],
            [
              113.5518289,
              22.1249158
            ],
            [
              113.5518221,
              22.124896
            ],
            [
              113.551822,
              22.1248085
            ],
            [
              113.5519193,
              22.1248084
            ],
            [
              113.5519195,
              22.12494
            ],
            [
              113.551864,
              22.1249401
            ]
          ]
        ]
      },
      "id": "way/326771727"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771729",
        "addr:housename": "第七座 Bloco VII",
        "addr:housenumber": "397-415",
        "addr:street": "棕櫚圓形地 Rotunda das Palmeiras",
        "building": "apartments",
        "building:levels": "24",
        "name": "御名峰 Kensington Tower",
        "name:en": "Kensington Tower",
        "name:zh": "御名峰(第七座)",
        "ref": "7",
        "short_name": "金峰．南岸"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5567136,
              22.1265582
            ],
            [
              113.5567295,
              22.1265684
            ],
            [
              113.5567309,
              22.1265763
            ],
            [
              113.5567565,
              22.1265723
            ],
            [
              113.5567522,
              22.1265487
            ],
            [
              113.556812,
              22.1265394
            ],
            [
              113.5568307,
              22.1266424
            ],
            [
              113.5564345,
              22.1267042
            ],
            [
              113.5564169,
              22.1266075
            ],
            [
              113.5564774,
              22.1265981
            ],
            [
              113.5564806,
              22.1266157
            ],
            [
              113.5565076,
              22.1266115
            ],
            [
              113.5565062,
              22.1266036
            ],
            [
              113.5565166,
              22.1265891
            ],
            [
              113.5565517,
              22.1265836
            ],
            [
              113.5565496,
              22.1265724
            ],
            [
              113.5565673,
              22.1265696
            ],
            [
              113.556564,
              22.1265518
            ],
            [
              113.5564883,
              22.1265638
            ],
            [
              113.5564703,
              22.1264663
            ],
            [
              113.5564843,
              22.1264641
            ],
            [
              113.5564769,
              22.1264239
            ],
            [
              113.5564485,
              22.1264284
            ],
            [
              113.5564346,
              22.1263531
            ],
            [
              113.5564946,
              22.1263437
            ],
            [
              113.5564937,
              22.1263385
            ],
            [
              113.5567065,
              22.1263048
            ],
            [
              113.556721,
              22.1263832
            ],
            [
              113.5566926,
              22.1263877
            ],
            [
              113.5567004,
              22.1264304
            ],
            [
              113.5567142,
              22.1264282
            ],
            [
              113.5567318,
              22.126524
            ],
            [
              113.5566523,
              22.1265366
            ],
            [
              113.5566558,
              22.1265555
            ],
            [
              113.5566772,
              22.1265522
            ],
            [
              113.5566793,
              22.1265636
            ],
            [
              113.5567136,
              22.1265582
            ]
          ]
        ]
      },
      "id": "way/326771729"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771731",
        "addr:housename": "第九座 Bloco IX",
        "addr:housenumber": "59-65",
        "addr:street": "紅棉路 Rua dos Bombaxes",
        "building": "apartments",
        "building:levels": "33",
        "height": "150.3",
        "name": "御領峰 Pena Tower",
        "name:en": "Pena Tower",
        "name:zh": "御領峰(第九座)",
        "ref": "9",
        "short_name": "金峰．南岸"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5556129,
              22.1263812
            ],
            [
              113.5556065,
              22.1263454
            ],
            [
              113.5555913,
              22.1263477
            ],
            [
              113.555577,
              22.1262672
            ],
            [
              113.5555836,
              22.1262662
            ],
            [
              113.5555827,
              22.1262613
            ],
            [
              113.5557102,
              22.1262419
            ],
            [
              113.5557112,
              22.1262472
            ],
            [
              113.5557169,
              22.1262464
            ],
            [
              113.5557311,
              22.1263265
            ],
            [
              113.5557158,
              22.1263288
            ],
            [
              113.5557228,
              22.1263683
            ],
            [
              113.5557346,
              22.1263763
            ],
            [
              113.5557602,
              22.1263435
            ],
            [
              113.5557651,
              22.1263468
            ],
            [
              113.5557695,
              22.1263413
            ],
            [
              113.5558708,
              22.1264091
            ],
            [
              113.5557053,
              22.1266211
            ],
            [
              113.5556461,
              22.1265813
            ],
            [
              113.5556604,
              22.126563
            ],
            [
              113.5556269,
              22.1265406
            ],
            [
              113.5556174,
              22.1265528
            ],
            [
              113.5554855,
              22.1264644
            ],
            [
              113.5555588,
              22.1263705
            ],
            [
              113.5555642,
              22.1263741
            ],
            [
              113.5555678,
              22.1263695
            ],
            [
              113.5556034,
              22.1263933
            ],
            [
              113.5556129,
              22.1263812
            ]
          ]
        ]
      },
      "id": "way/326771731"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771733",
        "addr:housename": "第五座 Bloco V",
        "addr:housenumber": "343-355",
        "addr:street": "棕櫚圓形地 Rotunda das Palmeiras",
        "building": "apartments",
        "building:levels": "23",
        "name": "金巒峰 Pine Tower",
        "name:en": "One Oasis Cotal South (Block V)",
        "name:zh": "金巒峰(第五座)",
        "ref": "5",
        "short_name": "金峰．南岸"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5574639,
              22.1267815
            ],
            [
              113.5574777,
              22.1267805
            ],
            [
              113.5574764,
              22.126765
            ],
            [
              113.5576806,
              22.126751
            ],
            [
              113.5576828,
              22.1267792
            ],
            [
              113.5576731,
              22.1267798
            ],
            [
              113.5576765,
              22.1268233
            ],
            [
              113.5576392,
              22.1268259
            ],
            [
              113.5576406,
              22.1268432
            ],
            [
              113.5576599,
              22.1268419
            ],
            [
              113.5576673,
              22.1269348
            ],
            [
              113.5576566,
              22.1269355
            ],
            [
              113.5576576,
              22.1269489
            ],
            [
              113.5576606,
              22.1269514
            ],
            [
              113.5576649,
              22.1269469
            ],
            [
              113.557669,
              22.1269502
            ],
            [
              113.5576746,
              22.1269444
            ],
            [
              113.5577224,
              22.1269838
            ],
            [
              113.5576354,
              22.1270743
            ],
            [
              113.5575825,
              22.1270306
            ],
            [
              113.5575875,
              22.1270254
            ],
            [
              113.5575842,
              22.1270226
            ],
            [
              113.5575897,
              22.1270169
            ],
            [
              113.5575798,
              22.1270088
            ],
            [
              113.5575666,
              22.1270097
            ],
            [
              113.5575679,
              22.1270251
            ],
            [
              113.5573641,
              22.1270394
            ],
            [
              113.5573618,
              22.1270107
            ],
            [
              113.5573713,
              22.12701
            ],
            [
              113.5573677,
              22.1269671
            ],
            [
              113.5574054,
              22.1269644
            ],
            [
              113.557404,
              22.1269473
            ],
            [
              113.5573847,
              22.1269487
            ],
            [
              113.5573771,
              22.1268558
            ],
            [
              113.5573875,
              22.126855
            ],
            [
              113.5573865,
              22.1268416
            ],
            [
              113.5573835,
              22.1268393
            ],
            [
              113.5573796,
              22.1268435
            ],
            [
              113.5573755,
              22.1268402
            ],
            [
              113.5573703,
              22.1268459
            ],
            [
              113.5573351,
              22.1268179
            ],
            [
              113.5573405,
              22.126812
            ],
            [
              113.5573333,
              22.1268063
            ],
            [
              113.5574131,
              22.1267202
            ],
            [
              113.5574619,
              22.126759
            ],
            [
              113.5574562,
              22.1267651
            ],
            [
              113.5574602,
              22.1267683
            ],
            [
              113.5574548,
              22.1267742
            ],
            [
              113.5574639,
              22.1267815
            ]
          ]
        ]
      },
      "id": "way/326771733"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771734",
        "addr:housename": "第八座 Bloco VIII",
        "building": "apartments",
        "building:levels": "33",
        "height": "149",
        "name": "御庭峰 Versailles Tower",
        "name:en": "Versailles Tower",
        "name:zh": "御庭峰(第八座)",
        "ref": "8",
        "short_name": "金峰．南岸"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5556624,
              22.1261128
            ],
            [
              113.555669,
              22.1261458
            ],
            [
              113.5556827,
              22.1261434
            ],
            [
              113.5556978,
              22.126218
            ],
            [
              113.5556913,
              22.1262191
            ],
            [
              113.555692,
              22.1262228
            ],
            [
              113.5555752,
              22.1262431
            ],
            [
              113.5555744,
              22.1262391
            ],
            [
              113.5555675,
              22.1262403
            ],
            [
              113.5555526,
              22.1261667
            ],
            [
              113.5555672,
              22.1261641
            ],
            [
              113.5555635,
              22.126146
            ],
            [
              113.5555464,
              22.1261349
            ],
            [
              113.5555296,
              22.1261572
            ],
            [
              113.5555252,
              22.1261544
            ],
            [
              113.5555208,
              22.1261602
            ],
            [
              113.5553763,
              22.1260667
            ],
            [
              113.5554107,
              22.1260211
            ],
            [
              113.5554055,
              22.1260178
            ],
            [
              113.5554205,
              22.1259979
            ],
            [
              113.555449,
              22.1260164
            ],
            [
              113.5554759,
              22.1259808
            ],
            [
              113.5554484,
              22.125963
            ],
            [
              113.555499,
              22.1258959
            ],
            [
              113.5557422,
              22.1260532
            ],
            [
              113.5557092,
              22.126097
            ],
            [
              113.5557137,
              22.1260999
            ],
            [
              113.5556977,
              22.1261211
            ],
            [
              113.5556698,
              22.126103
            ],
            [
              113.5556624,
              22.1261128
            ]
          ]
        ]
      },
      "id": "way/326771734"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771735",
        "addr:housename": "第六座 Bloco VI",
        "addr:housenumber": "371",
        "addr:street": "棕櫚圓形地 Rotunda das Palmeiras",
        "building": "apartments",
        "building:levels": "24",
        "name": "御豪峰 Hermitage Tower",
        "name:en": "One Oasis Cotal South (Block VI)",
        "name:zh": "御豪峰(第六座)",
        "ref": "6",
        "short_name": "金峰．南岸"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5569552,
              22.1267473
            ],
            [
              113.5569335,
              22.1266273
            ],
            [
              113.5568341,
              22.1266439
            ],
            [
              113.5568134,
              22.1265358
            ],
            [
              113.5571831,
              22.1264749
            ],
            [
              113.5572168,
              22.1266523
            ],
            [
              113.55723,
              22.1266501
            ],
            [
              113.5572394,
              22.1267013
            ],
            [
              113.5569552,
              22.1267473
            ]
          ]
        ]
      },
      "id": "way/326771735"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771736",
        "addr:housename": "第十一座 Bloco XI",
        "addr:housenumber": "S/N",
        "addr:street": "紅棉路 Rua dos Bombaxes",
        "building": "yes",
        "height": "150",
        "name": "尚濤峰 Central Park Tower",
        "name:en": "One Oasis Cotal South (Block XI)",
        "name:zh": "尚堤峰 (第十一座)",
        "ref": "11",
        "short_name": "金峰．南岸"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5558258,
              22.1275293
            ],
            [
              113.5558283,
              22.1275238
            ],
            [
              113.5558176,
              22.1275195
            ],
            [
              113.5558129,
              22.1275295
            ],
            [
              113.5557186,
              22.1274919
            ],
            [
              113.5557252,
              22.1274778
            ],
            [
              113.5557102,
              22.1274718
            ],
            [
              113.555695,
              22.1275045
            ],
            [
              113.5556507,
              22.1274869
            ],
            [
              113.5556473,
              22.1274941
            ],
            [
              113.5556169,
              22.127482
            ],
            [
              113.5556838,
              22.1273381
            ],
            [
              113.5556902,
              22.1273406
            ],
            [
              113.5556934,
              22.1273336
            ],
            [
              113.5557011,
              22.1273366
            ],
            [
              113.5557069,
              22.1273239
            ],
            [
              113.5557003,
              22.1273089
            ],
            [
              113.5556933,
              22.1273115
            ],
            [
              113.5556545,
              22.127223
            ],
            [
              113.555803,
              22.1271671
            ],
            [
              113.5558418,
              22.1272558
            ],
            [
              113.5558345,
              22.1272585
            ],
            [
              113.555837,
              22.1272641
            ],
            [
              113.5558266,
              22.127268
            ],
            [
              113.5558293,
              22.1272741
            ],
            [
              113.5558551,
              22.1272842
            ],
            [
              113.555858,
              22.1272777
            ],
            [
              113.555919,
              22.1273016
            ],
            [
              113.5559339,
              22.127269
            ],
            [
              113.5559781,
              22.1272863
            ],
            [
              113.5559813,
              22.1272794
            ],
            [
              113.5560115,
              22.1272912
            ],
            [
              113.5559333,
              22.1274627
            ],
            [
              113.5559251,
              22.1274595
            ],
            [
              113.5559225,
              22.1274652
            ],
            [
              113.555919,
              22.1274638
            ],
            [
              113.555914,
              22.1274745
            ],
            [
              113.5559205,
              22.1274891
            ],
            [
              113.555929,
              22.1274858
            ],
            [
              113.5559305,
              22.1274892
            ],
            [
              113.5559376,
              22.1274865
            ],
            [
              113.5559592,
              22.1275353
            ],
            [
              113.5559513,
              22.1275383
            ],
            [
              113.5559549,
              22.1275463
            ],
            [
              113.5558436,
              22.1275886
            ],
            [
              113.5558217,
              22.1275392
            ],
            [
              113.555829,
              22.1275364
            ],
            [
              113.5558258,
              22.1275293
            ]
          ]
        ]
      },
      "id": "way/326771736"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771737",
        "addr:housename": "第十二座 Bloco XII",
        "building": "yes",
        "name": "尚澄峰 Regent Park Tower",
        "name:en": "Regent Park Tower",
        "name:zh": "尚澄峰 (第十二座)",
        "ref": "12",
        "short_name": "金峰．南岸"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.55605,
              22.127898
            ],
            [
              113.5560516,
              22.1278923
            ],
            [
              113.5560403,
              22.1278895
            ],
            [
              113.5560373,
              22.1279001
            ],
            [
              113.5559379,
              22.1278763
            ],
            [
              113.5559421,
              22.1278614
            ],
            [
              113.5559263,
              22.1278576
            ],
            [
              113.5559167,
              22.1278921
            ],
            [
              113.55587,
              22.1278809
            ],
            [
              113.5558678,
              22.1278886
            ],
            [
              113.5558358,
              22.1278809
            ],
            [
              113.5558782,
              22.1277292
            ],
            [
              113.5558849,
              22.1277308
            ],
            [
              113.555887,
              22.1277233
            ],
            [
              113.555895,
              22.1277253
            ],
            [
              113.5558987,
              22.1277119
            ],
            [
              113.5558897,
              22.127698
            ],
            [
              113.5558832,
              22.1277016
            ],
            [
              113.5558302,
              22.1276195
            ],
            [
              113.5559678,
              22.1275433
            ],
            [
              113.5560208,
              22.1276255
            ],
            [
              113.556014,
              22.1276292
            ],
            [
              113.5560174,
              22.1276344
            ],
            [
              113.5560078,
              22.1276397
            ],
            [
              113.5560115,
              22.1276454
            ],
            [
              113.5560385,
              22.1276517
            ],
            [
              113.5560404,
              22.1276449
            ],
            [
              113.5561046,
              22.1276598
            ],
            [
              113.556114,
              22.1276255
            ],
            [
              113.5561605,
              22.1276364
            ],
            [
              113.5561625,
              22.1276291
            ],
            [
              113.5561943,
              22.1276365
            ],
            [
              113.5561453,
              22.127817
            ],
            [
              113.5561367,
              22.127815
            ],
            [
              113.5561351,
              22.127821
            ],
            [
              113.5561313,
              22.1278201
            ],
            [
              113.5561282,
              22.1278314
            ],
            [
              113.556137,
              22.1278449
            ],
            [
              113.5561449,
              22.1278405
            ],
            [
              113.5561469,
              22.1278437
            ],
            [
              113.5561535,
              22.12784
            ],
            [
              113.5561829,
              22.1278851
            ],
            [
              113.5561756,
              22.1278892
            ],
            [
              113.5561804,
              22.1278966
            ],
            [
              113.5560774,
              22.1279542
            ],
            [
              113.5560476,
              22.1279084
            ],
            [
              113.5560543,
              22.1279047
            ],
            [
              113.55605,
              22.127898
            ]
          ]
        ]
      },
      "id": "way/326771737"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771738",
        "addr:housename": "第十座 Bloco X",
        "addr:housenumber": "S/N",
        "addr:street": "紅棉路 Rua dos Bombaxes",
        "building": "apartments",
        "building:levels": "38",
        "height": "142.4",
        "name": "尚堤峰 Hyde Park Tower",
        "name:en": "One Oasis Hyde Park (Tower 10)",
        "name:zh": "尚濤峰(第十座)",
        "ref": "10",
        "short_name": "金峰．南岸"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5556707,
              22.1271156
            ],
            [
              113.5556748,
              22.1271109
            ],
            [
              113.5556658,
              22.1271041
            ],
            [
              113.5556583,
              22.1271125
            ],
            [
              113.555579,
              22.1270521
            ],
            [
              113.5555896,
              22.1270402
            ],
            [
              113.555577,
              22.1270306
            ],
            [
              113.5555525,
              22.1270581
            ],
            [
              113.5555153,
              22.1270297
            ],
            [
              113.5555098,
              22.1270358
            ],
            [
              113.5554843,
              22.1270164
            ],
            [
              113.5555917,
              22.1268953
            ],
            [
              113.5555971,
              22.1268994
            ],
            [
              113.5556024,
              22.1268935
            ],
            [
              113.5556088,
              22.1268984
            ],
            [
              113.5556182,
              22.1268877
            ],
            [
              113.5556164,
              22.1268716
            ],
            [
              113.5556089,
              22.1268723
            ],
            [
              113.5555982,
              22.1267772
            ],
            [
              113.5557576,
              22.1267618
            ],
            [
              113.5557683,
              22.126857
            ],
            [
              113.5557604,
              22.1268578
            ],
            [
              113.5557611,
              22.1268637
            ],
            [
              113.55575,
              22.1268648
            ],
            [
              113.5557507,
              22.1268714
            ],
            [
              113.5557725,
              22.1268877
            ],
            [
              113.5557772,
              22.1268822
            ],
            [
              113.5558287,
              22.1269209
            ],
            [
              113.5558527,
              22.1268934
            ],
            [
              113.55589,
              22.1269215
            ],
            [
              113.5558951,
              22.1269156
            ],
            [
              113.5559206,
              22.1269347
            ],
            [
              113.555794,
              22.1270793
            ],
            [
              113.5557871,
              22.1270741
            ],
            [
              113.5557829,
              22.1270789
            ],
            [
              113.5557799,
              22.1270767
            ],
            [
              113.5557719,
              22.1270857
            ],
            [
              113.5557738,
              22.1271014
            ],
            [
              113.5557829,
              22.1271005
            ],
            [
              113.5557834,
              22.1271041
            ],
            [
              113.555791,
              22.1271034
            ],
            [
              113.5557971,
              22.1271557
            ],
            [
              113.5557886,
              22.1271566
            ],
            [
              113.5557896,
              22.1271652
            ],
            [
              113.55567,
              22.1271772
            ],
            [
              113.5556638,
              22.1271241
            ],
            [
              113.5556716,
              22.1271233
            ],
            [
              113.5556707,
              22.1271156
            ]
          ]
        ]
      },
      "id": "way/326771738"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/326771741",
        "addr:housenumber": "138-236",
        "addr:street": "棕櫚圓形地 Rotunda das Palmeiras",
        "building": "yes",
        "name": "金峰南岸會所 Club Oasis",
        "name:en": "Club Oasis",
        "name:zh": "金峰南岸會所"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5574953,
              22.1277009
            ],
            [
              113.5574002,
              22.1277715
            ],
            [
              113.5574012,
              22.1278312
            ],
            [
              113.5573745,
              22.12789
            ],
            [
              113.557323,
              22.1279309
            ],
            [
              113.5572512,
              22.1279505
            ],
            [
              113.557219,
              22.1279573
            ],
            [
              113.557179,
              22.1280523
            ],
            [
              113.5570815,
              22.1280353
            ],
            [
              113.5569361,
              22.1279688
            ],
            [
              113.5569629,
              22.1278759
            ],
            [
              113.5569863,
              22.1278072
            ],
            [
              113.5570111,
              22.127818
            ],
            [
              113.5570423,
              22.1277638
            ],
            [
              113.5570748,
              22.1277119
            ],
            [
              113.5571243,
              22.1276493
            ],
            [
              113.5571854,
              22.127589
            ],
            [
              113.557168,
              22.1275699
            ],
            [
              113.5572563,
              22.1275017
            ],
            [
              113.5573538,
              22.1274489
            ],
            [
              113.5574587,
              22.1276211
            ],
            [
              113.5574953,
              22.1277009
            ]
          ]
        ]
      },
      "id": "way/326771741"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/327416819",
        "area": "yes",
        "highway": "pedestrian",
        "leisure": "common",
        "name": "圓型廣場 Rotunda",
        "name:en": "Circular Plaza",
        "name:pt": "Rotunda",
        "name:zh": "圓型廣場"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5570635,
              22.1257087
            ],
            [
              113.5570846,
              22.1256743
            ],
            [
              113.5570895,
              22.1256664
            ],
            [
              113.5571291,
              22.1256344
            ],
            [
              113.5571779,
              22.125616
            ],
            [
              113.5572304,
              22.1256135
            ],
            [
              113.5572809,
              22.125627
            ],
            [
              113.5573239,
              22.1256551
            ],
            [
              113.5573546,
              22.1256947
            ],
            [
              113.5573696,
              22.1257413
            ],
            [
              113.5573674,
              22.12579
            ],
            [
              113.5573481,
              22.1258353
            ],
            [
              113.5573261,
              22.1258591
            ],
            [
              113.5573144,
              22.1258718
            ],
            [
              113.55727,
              22.1258963
            ],
            [
              113.5572194,
              22.1259062
            ],
            [
              113.5571858,
              22.1259025
            ],
            [
              113.5571679,
              22.1259005
            ],
            [
              113.5571213,
              22.1258798
            ],
            [
              113.5570843,
              22.1258461
            ],
            [
              113.5570609,
              22.1258034
            ],
            [
              113.5570537,
              22.1257558
            ],
            [
              113.5570635,
              22.1257087
            ]
          ]
        ]
      },
      "id": "way/327416819"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/330666067",
        "building": "yes",
        "height": "7.8"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.553395,
              22.1304534
            ],
            [
              113.5533945,
              22.1303241
            ],
            [
              113.5535415,
              22.1303236
            ],
            [
              113.5536425,
              22.1303232
            ],
            [
              113.5536965,
              22.130323
            ],
            [
              113.553697,
              22.1304535
            ],
            [
              113.5535465,
              22.1304541
            ],
            [
              113.5535467,
              22.1304822
            ],
            [
              113.5534941,
              22.1304823
            ],
            [
              113.553494,
              22.1304531
            ],
            [
              113.553395,
              22.1304534
            ]
          ]
        ]
      },
      "id": "way/330666067"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/367209065",
        "area": "yes",
        "highway": "pedestrian",
        "leisure": "common"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5557092,
              22.1256736
            ],
            [
              113.5553398,
              22.1254001
            ],
            [
              113.5552984,
              22.1254091
            ],
            [
              113.5548838,
              22.1250867
            ],
            [
              113.554878,
              22.1250669
            ],
            [
              113.5548786,
              22.1250472
            ],
            [
              113.5549744,
              22.1249261
            ],
            [
              113.5549957,
              22.1249435
            ],
            [
              113.5549013,
              22.1250568
            ],
            [
              113.5552033,
              22.1252922
            ],
            [
              113.5552842,
              22.1252018
            ],
            [
              113.5553527,
              22.1253641
            ],
            [
              113.5556753,
              22.1256117
            ],
            [
              113.5557595,
              22.1256558
            ],
            [
              113.5557659,
              22.1256664
            ],
            [
              113.5557835,
              22.1257214
            ],
            [
              113.5557897,
              22.1257405
            ],
            [
              113.5557901,
              22.1257503
            ],
            [
              113.5557856,
              22.1257562
            ],
            [
              113.5557796,
              22.1257579
            ],
            [
              113.5557709,
              22.1257536
            ],
            [
              113.5557475,
              22.1257365
            ],
            [
              113.5557229,
              22.1257185
            ],
            [
              113.5557092,
              22.1256736
            ]
          ]
        ]
      },
      "id": "way/367209065"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/367209081",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5545632,
              22.1247753
            ],
            [
              113.554591,
              22.124741
            ],
            [
              113.5546901,
              22.1248098
            ],
            [
              113.5547787,
              22.1248713
            ],
            [
              113.5547509,
              22.1249057
            ],
            [
              113.5546603,
              22.1248427
            ],
            [
              113.5545632,
              22.1247753
            ]
          ]
        ]
      },
      "id": "way/367209081"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/377932735",
        "addr:housenumber": "566A-703A",
        "addr:street": "蓮花海濱大馬路 Avenida Marginal Flor de Lótus",
        "building": "industrial",
        "height": "20.2",
        "name": "澳門城市燃氣營運中心 Centro de Operação de Companhia de Gás da Cidade de Macau",
        "name:en": "Macau City Gas Operation Center",
        "name:pt": "Centro de Operação de Companhia de Gás da Cidade de Macau",
        "name:zh": "澳門城市燃氣營運中心"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.553123,
              22.1322253
            ],
            [
              113.5533361,
              22.1321319
            ],
            [
              113.5534128,
              22.1320924
            ],
            [
              113.5534733,
              22.1320616
            ],
            [
              113.5534939,
              22.1320883
            ],
            [
              113.5535234,
              22.1320718
            ],
            [
              113.5535624,
              22.1321575
            ],
            [
              113.5535475,
              22.132169
            ],
            [
              113.553524,
              22.132185
            ],
            [
              113.5535431,
              22.1322093
            ],
            [
              113.5532461,
              22.1324311
            ],
            [
              113.553123,
              22.1322253
            ]
          ]
        ]
      },
      "id": "way/377932735"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/378652698",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5378669,
              22.1239577
            ],
            [
              113.537993,
              22.1238285
            ],
            [
              113.5379313,
              22.1237888
            ],
            [
              113.5380412,
              22.1236621
            ],
            [
              113.5381163,
              22.1237242
            ],
            [
              113.5381539,
              22.1236894
            ],
            [
              113.5381324,
              22.1236596
            ],
            [
              113.5382049,
              22.1235751
            ],
            [
              113.538229,
              22.1235999
            ],
            [
              113.5382478,
              22.1235776
            ],
            [
              113.5383041,
              22.1236223
            ],
            [
              113.538296,
              22.1236472
            ],
            [
              113.5383497,
              22.1236819
            ],
            [
              113.5380037,
              22.1240571
            ],
            [
              113.5378669,
              22.1239577
            ]
          ]
        ]
      },
      "id": "way/378652698"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/378848863",
        "addr:street": "聯生海濱路 Rua Marginal da Concórdia",
        "amenity": "fire_station",
        "building": "yes",
        "name": "消防局路環臨時車輛清洗中心"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5555945,
              22.1304303
            ],
            [
              113.5557164,
              22.1304258
            ],
            [
              113.5557232,
              22.1306143
            ],
            [
              113.5564155,
              22.1305956
            ],
            [
              113.5564195,
              22.130699
            ],
            [
              113.5556121,
              22.1307295
            ],
            [
              113.5555945,
              22.1304303
            ]
          ]
        ]
      },
      "id": "way/378848863"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/378848864",
        "addr:housenumber": "332-434",
        "addr:street": "聯生海濱路 Rua Marginal da Concórdia",
        "building": "industrial",
        "height": "11.8"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5520002,
              22.1271819
            ],
            [
              113.5519257,
              22.1271818
            ],
            [
              113.5519259,
              22.1270364
            ],
            [
              113.5525402,
              22.1270372
            ],
            [
              113.5525386,
              22.1281141
            ],
            [
              113.5519988,
              22.1281134
            ],
            [
              113.5520002,
              22.1271819
            ]
          ]
        ]
      },
      "id": "way/378848864"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/378848865",
        "building": "yes",
        "height": "7.5"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5535415,
              22.1303236
            ],
            [
              113.5535412,
              22.1302639
            ],
            [
              113.5535274,
              22.1302639
            ],
            [
              113.5535271,
              22.1301853
            ],
            [
              113.5535401,
              22.1301853
            ],
            [
              113.5535398,
              22.1301288
            ],
            [
              113.5536417,
              22.1301284
            ],
            [
              113.5536422,
              22.1302396
            ],
            [
              113.5536425,
              22.1303232
            ],
            [
              113.5535415,
              22.1303236
            ]
          ]
        ]
      },
      "id": "way/378848865"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/394107340",
        "addr:housenumber": "1659-1773",
        "addr:street": "路環高頂馬路 Estrada do Alto de Coloane",
        "amenity": "clinic",
        "building": "yes",
        "healthcare": "clinic",
        "name": "公共衛生臨床中心 Centro Clínico de Saúde Pública",
        "name:pt": "Centro Clínico de Saúde Pública",
        "name:zh": "公共衛生臨床中心"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5560611,
              22.1246473
            ],
            [
              113.5559074,
              22.1241802
            ],
            [
              113.5563281,
              22.1240614
            ],
            [
              113.5564802,
              22.1240184
            ],
            [
              113.5566186,
              22.1240648
            ],
            [
              113.556674,
              22.124185
            ],
            [
              113.5566365,
              22.1243397
            ],
            [
              113.556298,
              22.1244404
            ],
            [
              113.5562601,
              22.124515
            ],
            [
              113.556215,
              22.1246038
            ],
            [
              113.5560611,
              22.1246473
            ]
          ]
        ]
      },
      "id": "way/394107340"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/405598230",
        "leisure": "park"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.547174,
              22.1360664
            ],
            [
              113.5471789,
              22.1359173
            ],
            [
              113.547242,
              22.1358987
            ],
            [
              113.5473117,
              22.1358393
            ],
            [
              113.5473101,
              22.1357637
            ],
            [
              113.5473086,
              22.1356942
            ],
            [
              113.5472916,
              22.1349076
            ],
            [
              113.5472909,
              22.1348738
            ],
            [
              113.5472661,
              22.1348116
            ],
            [
              113.5472485,
              22.1347799
            ],
            [
              113.5472186,
              22.1347531
            ],
            [
              113.5471884,
              22.1347338
            ],
            [
              113.5471283,
              22.1347161
            ],
            [
              113.5471298,
              22.1346596
            ],
            [
              113.5471911,
              22.1346595
            ],
            [
              113.5471953,
              22.1344804
            ],
            [
              113.5466964,
              22.134478
            ],
            [
              113.5466878,
              22.1346271
            ],
            [
              113.5466585,
              22.1346318
            ],
            [
              113.5466236,
              22.1346191
            ],
            [
              113.5466029,
              22.1345957
            ],
            [
              113.5465889,
              22.1345745
            ],
            [
              113.5465816,
              22.1344814
            ],
            [
              113.5466073,
              22.1330645
            ],
            [
              113.5466231,
              22.1329693
            ],
            [
              113.5466428,
              22.1328638
            ],
            [
              113.546707,
              22.132828
            ],
            [
              113.5467659,
              22.1327254
            ],
            [
              113.5467771,
              22.132603
            ],
            [
              113.5467534,
              22.132526
            ],
            [
              113.5466509,
              22.1324152
            ],
            [
              113.5465897,
              22.1322878
            ],
            [
              113.5465706,
              22.1321531
            ],
            [
              113.5465696,
              22.1315006
            ],
            [
              113.5466509,
              22.131047
            ],
            [
              113.5467971,
              22.1306357
            ],
            [
              113.546823,
              22.1305629
            ],
            [
              113.5468638,
              22.1305398
            ],
            [
              113.5469219,
              22.1297915
            ],
            [
              113.5467951,
              22.1273389
            ],
            [
              113.5467366,
              22.1272045
            ],
            [
              113.5466894,
              22.1261181
            ],
            [
              113.5466894,
              22.1260384
            ],
            [
              113.5466398,
              22.1258902
            ],
            [
              113.5465539,
              22.1257906
            ],
            [
              113.5464731,
              22.1256665
            ],
            [
              113.546443,
              22.1255444
            ],
            [
              113.5464294,
              22.1251064
            ],
            [
              113.5463906,
              22.1238614
            ],
            [
              113.5463793,
              22.1234978
            ],
            [
              113.546449,
              22.1234366
            ],
            [
              113.5465029,
              22.1233801
            ],
            [
              113.5465413,
              22.1233002
            ],
            [
              113.5465476,
              22.1232203
            ],
            [
              113.5465324,
              22.1231464
            ],
            [
              113.5465094,
              22.1231075
            ],
            [
              113.5464726,
              22.1230698
            ],
            [
              113.5464376,
              22.123039
            ],
            [
              113.5464068,
              22.1230021
            ],
            [
              113.5463845,
              22.1229654
            ],
            [
              113.5463666,
              22.1229201
            ],
            [
              113.5463578,
              22.1228765
            ],
            [
              113.5463542,
              22.1228301
            ],
            [
              113.5463542,
              22.1211692
            ],
            [
              113.5463383,
              22.121102
            ],
            [
              113.5462919,
              22.1210338
            ],
            [
              113.5462268,
              22.1209856
            ],
            [
              113.5461009,
              22.1209447
            ],
            [
              113.5460201,
              22.1209295
            ],
            [
              113.5458813,
              22.1209247
            ],
            [
              113.5456952,
              22.1209188
            ],
            [
              113.5455736,
              22.1209242
            ],
            [
              113.5455026,
              22.1209383
            ],
            [
              113.5454964,
              22.1208084
            ],
            [
              113.5456142,
              22.1207626
            ],
            [
              113.5457969,
              22.1207177
            ],
            [
              113.5458717,
              22.1207136
            ],
            [
              113.545972,
              22.1207176
            ],
            [
              113.5460582,
              22.1207281
            ],
            [
              113.5461521,
              22.1207489
            ],
            [
              113.5462419,
              22.120777
            ],
            [
              113.5463098,
              22.1207774
            ],
            [
              113.5463794,
              22.1207491
            ],
            [
              113.5464288,
              22.1207275
            ],
            [
              113.5464599,
              22.1207013
            ],
            [
              113.5465036,
              22.1207015
            ],
            [
              113.5465411,
              22.1207139
            ],
            [
              113.5465464,
              22.1207386
            ],
            [
              113.5473243,
              22.1347732
            ],
            [
              113.5473752,
              22.1360738
            ],
            [
              113.547174,
              22.1360664
            ]
          ]
        ]
      },
      "id": "way/405598230"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/405602204",
        "leisure": "park"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5522527,
              22.1337025
            ],
            [
              113.5522039,
              22.1341595
            ],
            [
              113.5522069,
              22.1345505
            ],
            [
              113.5522074,
              22.1346008
            ],
            [
              113.552223,
              22.136275
            ],
            [
              113.5522717,
              22.137206
            ],
            [
              113.5522948,
              22.1379775
            ],
            [
              113.5522951,
              22.1388147
            ],
            [
              113.5522777,
              22.1389264
            ],
            [
              113.5522525,
              22.1390849
            ],
            [
              113.5521845,
              22.1393179
            ],
            [
              113.5521429,
              22.139553
            ],
            [
              113.5521358,
              22.1398048
            ],
            [
              113.5521504,
              22.1400557
            ],
            [
              113.5521801,
              22.1403124
            ],
            [
              113.5522687,
              22.1405694
            ],
            [
              113.5523268,
              22.1408502
            ],
            [
              113.5523303,
              22.1409476
            ],
            [
              113.5522766,
              22.1409787
            ],
            [
              113.5522646,
              22.1419078
            ],
            [
              113.5523061,
              22.1419116
            ],
            [
              113.5522555,
              22.1420904
            ],
            [
              113.5521027,
              22.1424775
            ],
            [
              113.5520894,
              22.1428015
            ],
            [
              113.5521085,
              22.1433876
            ],
            [
              113.5521613,
              22.1436573
            ],
            [
              113.552137,
              22.1444943
            ],
            [
              113.5520134,
              22.1444977
            ],
            [
              113.5520067,
              22.1445759
            ],
            [
              113.5507068,
              22.146389
            ],
            [
              113.5506709,
              22.1461992
            ],
            [
              113.5517988,
              22.1447085
            ],
            [
              113.5518057,
              22.1446961
            ],
            [
              113.5518251,
              22.1446607
            ],
            [
              113.5518322,
              22.1446245
            ],
            [
              113.5518394,
              22.1445883
            ],
            [
              113.5518842,
              22.1445068
            ],
            [
              113.5519253,
              22.1443946
            ],
            [
              113.5519236,
              22.1443354
            ],
            [
              113.5519462,
              22.1427873
            ],
            [
              113.5519295,
              22.1409424
            ],
            [
              113.5519377,
              22.1402491
            ],
            [
              113.5519434,
              22.1392618
            ],
            [
              113.5519459,
              22.1388383
            ],
            [
              113.5519134,
              22.1365146
            ],
            [
              113.5518853,
              22.1356139
            ],
            [
              113.5518787,
              22.1346063
            ],
            [
              113.5518367,
              22.1314453
            ],
            [
              113.5518418,
              22.1306701
            ],
            [
              113.5518403,
              22.1302892
            ],
            [
              113.5518457,
              22.1300755
            ],
            [
              113.5518328,
              22.1299081
            ],
            [
              113.5517405,
              22.1295719
            ],
            [
              113.5516578,
              22.1294164
            ],
            [
              113.5515188,
              22.1291541
            ],
            [
              113.551459,
              22.1290422
            ],
            [
              113.5514336,
              22.1288918
            ],
            [
              113.5514284,
              22.1288159
            ],
            [
              113.5514232,
              22.12874
            ],
            [
              113.551423,
              22.1284906
            ],
            [
              113.551428,
              22.1284034
            ],
            [
              113.5514558,
              22.1283572
            ],
            [
              113.5515436,
              22.1283603
            ],
            [
              113.5515578,
              22.1282352
            ],
            [
              113.5515555,
              22.1279759
            ],
            [
              113.551554,
              22.1279015
            ],
            [
              113.5515445,
              22.1278231
            ],
            [
              113.5515048,
              22.1276251
            ],
            [
              113.5514927,
              22.1274822
            ],
            [
              113.5516698,
              22.1274796
            ],
            [
              113.5516577,
              22.1281162
            ],
            [
              113.5516565,
              22.1281679
            ],
            [
              113.5516445,
              22.1282146
            ],
            [
              113.5516068,
              22.1283068
            ],
            [
              113.5515787,
              22.128404
            ],
            [
              113.5515713,
              22.1284565
            ],
            [
              113.5515719,
              22.1285089
            ],
            [
              113.5515719,
              22.1288785
            ],
            [
              113.5515719,
              22.1289694
            ],
            [
              113.5515999,
              22.1290651
            ],
            [
              113.5516365,
              22.1291532
            ],
            [
              113.5517063,
              22.1292306
            ],
            [
              113.5517554,
              22.1292945
            ],
            [
              113.5517897,
              22.1293559
            ],
            [
              113.5518284,
              22.1294272
            ],
            [
              113.5518738,
              22.1295507
            ],
            [
              113.5519411,
              22.1297853
            ],
            [
              113.5519649,
              22.1299806
            ],
            [
              113.5519754,
              22.1306924
            ],
            [
              113.5519983,
              22.1323985
            ],
            [
              113.5520029,
              22.1324577
            ],
            [
              113.5520289,
              22.1325367
            ],
            [
              113.5520832,
              22.132601
            ],
            [
              113.5521268,
              22.1326406
            ],
            [
              113.5522221,
              22.1326931
            ],
            [
              113.5522998,
              22.1327404
            ],
            [
              113.5523414,
              22.1327976
            ],
            [
              113.5523508,
              22.1328597
            ],
            [
              113.5523239,
              22.1330783
            ],
            [
              113.5522656,
              22.133276
            ],
            [
              113.5522525,
              22.1333564
            ],
            [
              113.5522462,
              22.1335376
            ],
            [
              113.5522527,
              22.1337025
            ]
          ]
        ]
      },
      "id": "way/405602204"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414201664",
        "addr:housename": "横琴新家园",
        "addr:housename:zh": "横琴新家园",
        "building": "apartments",
        "building:levels": "24",
        "name": "6栋",
        "name:zh": "6栋",
        "start_date": "2013"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5392416,
              22.1312147
            ],
            [
              113.5393068,
              22.1312149
            ],
            [
              113.5393066,
              22.1312868
            ],
            [
              113.5392834,
              22.1312868
            ],
            [
              113.5392832,
              22.131354
            ],
            [
              113.5392282,
              22.1313538
            ],
            [
              113.5392282,
              22.1313631
            ],
            [
              113.5391601,
              22.1313629
            ],
            [
              113.5391604,
              22.1312846
            ],
            [
              113.5391904,
              22.1312847
            ],
            [
              113.5391906,
              22.1312472
            ],
            [
              113.5391623,
              22.1312209
            ],
            [
              113.5391199,
              22.1312599
            ],
            [
              113.5389729,
              22.1311228
            ],
            [
              113.5390564,
              22.131046
            ],
            [
              113.5390832,
              22.1310711
            ],
            [
              113.5390897,
              22.1310651
            ],
            [
              113.5391266,
              22.1310995
            ],
            [
              113.5391652,
              22.1310639
            ],
            [
              113.5391969,
              22.1310934
            ],
            [
              113.5391733,
              22.1311151
            ],
            [
              113.5391861,
              22.131127
            ],
            [
              113.5391507,
              22.1311595
            ],
            [
              113.5391627,
              22.1311706
            ],
            [
              113.5391981,
              22.1311381
            ],
            [
              113.5392108,
              22.13115
            ],
            [
              113.5392344,
              22.1311284
            ],
            [
              113.539266,
              22.1311579
            ],
            [
              113.539223,
              22.1311974
            ],
            [
              113.5392416,
              22.1312147
            ]
          ]
        ]
      },
      "id": "way/414201664"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414201665",
        "addr:housename": "横琴新家园",
        "addr:housename:zh": "横琴新家园",
        "building": "apartments",
        "building:levels": "24",
        "name": "3栋",
        "name:zh": "3栋",
        "start_date": "2013"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5392684,
              22.1301005
            ],
            [
              113.5393336,
              22.1301007
            ],
            [
              113.5393334,
              22.1301727
            ],
            [
              113.5393103,
              22.1301726
            ],
            [
              113.53931,
              22.1302398
            ],
            [
              113.539255,
              22.1302396
            ],
            [
              113.539255,
              22.130249
            ],
            [
              113.5391869,
              22.1302487
            ],
            [
              113.5391872,
              22.1301704
            ],
            [
              113.5392173,
              22.1301705
            ],
            [
              113.5392174,
              22.1301331
            ],
            [
              113.5391891,
              22.1301067
            ],
            [
              113.5391467,
              22.1301457
            ],
            [
              113.5389998,
              22.1300087
            ],
            [
              113.5390832,
              22.1299319
            ],
            [
              113.5391101,
              22.1299569
            ],
            [
              113.5391165,
              22.129951
            ],
            [
              113.5391534,
              22.1299853
            ],
            [
              113.5391921,
              22.1299497
            ],
            [
              113.5392237,
              22.1299792
            ],
            [
              113.5392002,
              22.1300009
            ],
            [
              113.5392129,
              22.1300128
            ],
            [
              113.5391776,
              22.1300453
            ],
            [
              113.5391895,
              22.1300565
            ],
            [
              113.5392249,
              22.130024
            ],
            [
              113.5392377,
              22.1300359
            ],
            [
              113.5392612,
              22.1300142
            ],
            [
              113.5392928,
              22.1300437
            ],
            [
              113.5392499,
              22.1300832
            ],
            [
              113.5392684,
              22.1301005
            ]
          ]
        ]
      },
      "id": "way/414201665"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414201666",
        "addr:housename": "横琴新家园",
        "addr:housename:zh": "横琴新家园",
        "building": "apartments",
        "building:levels": "24",
        "name": "2栋",
        "name:zh": "2栋",
        "start_date": "2013"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5388605,
              22.1297611
            ],
            [
              113.5389068,
              22.1297185
            ],
            [
              113.5389616,
              22.1297695
            ],
            [
              113.5389452,
              22.1297846
            ],
            [
              113.5389963,
              22.1298323
            ],
            [
              113.5389573,
              22.1298682
            ],
            [
              113.5389644,
              22.1298748
            ],
            [
              113.538916,
              22.1299193
            ],
            [
              113.5388565,
              22.1298637
            ],
            [
              113.5388778,
              22.1298441
            ],
            [
              113.5388493,
              22.1298175
            ],
            [
              113.5388092,
              22.1298174
            ],
            [
              113.538809,
              22.1298728
            ],
            [
              113.538747,
              22.1298726
            ],
            [
              113.5387471,
              22.1298531
            ],
            [
              113.5386329,
              22.1298528
            ],
            [
              113.5386328,
              22.1298722
            ],
            [
              113.5386005,
              22.1298721
            ],
            [
              113.5386008,
              22.1297631
            ],
            [
              113.538639,
              22.1297633
            ],
            [
              113.538639,
              22.1297548
            ],
            [
              113.5386913,
              22.129755
            ],
            [
              113.5386915,
              22.1297045
            ],
            [
              113.5387363,
              22.1297046
            ],
            [
              113.5387362,
              22.1297353
            ],
            [
              113.5387543,
              22.1297354
            ],
            [
              113.5387542,
              22.1297816
            ],
            [
              113.5387712,
              22.1297816
            ],
            [
              113.5387713,
              22.1297355
            ],
            [
              113.5387894,
              22.1297355
            ],
            [
              113.5387896,
              22.1297048
            ],
            [
              113.5388344,
              22.1297049
            ],
            [
              113.5388342,
              22.129761
            ],
            [
              113.5388605,
              22.1297611
            ]
          ]
        ]
      },
      "id": "way/414201666"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414201667",
        "addr:housename": "横琴新家园",
        "addr:housename:zh": "横琴新家园",
        "building": "apartments",
        "building:levels": "24",
        "name": "5栋",
        "name:zh": "5栋",
        "start_date": "2013"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5392637,
              22.1306372
            ],
            [
              113.539329,
              22.1306375
            ],
            [
              113.5393287,
              22.1307094
            ],
            [
              113.5393056,
              22.1307093
            ],
            [
              113.5393053,
              22.1307765
            ],
            [
              113.5392503,
              22.1307763
            ],
            [
              113.5392503,
              22.1307857
            ],
            [
              113.5391822,
              22.1307855
            ],
            [
              113.5391825,
              22.1307072
            ],
            [
              113.5392126,
              22.1307073
            ],
            [
              113.5392127,
              22.1306698
            ],
            [
              113.5391844,
              22.1306434
            ],
            [
              113.539142,
              22.1306825
            ],
            [
              113.5389951,
              22.1305454
            ],
            [
              113.5390785,
              22.1304686
            ],
            [
              113.5391054,
              22.1304936
            ],
            [
              113.5391118,
              22.1304877
            ],
            [
              113.5391487,
              22.1305221
            ],
            [
              113.5391874,
              22.1304865
            ],
            [
              113.539219,
              22.130516
            ],
            [
              113.5391955,
              22.1305376
            ],
            [
              113.5392082,
              22.1305495
            ],
            [
              113.5391729,
              22.1305821
            ],
            [
              113.5391848,
              22.1305932
            ],
            [
              113.5392202,
              22.1305607
            ],
            [
              113.539233,
              22.1305726
            ],
            [
              113.5392565,
              22.1305509
            ],
            [
              113.5392881,
              22.1305804
            ],
            [
              113.5392452,
              22.13062
            ],
            [
              113.5392637,
              22.1306372
            ]
          ]
        ]
      },
      "id": "way/414201667"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414201670",
        "building": "kindergarten",
        "name": "珠海市横琴中心幼儿园",
        "name:zh": "珠海市横琴中心幼儿园",
        "name:zh-Hant": "珠海市橫琴中心幼兒園"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5373423,
              22.1297195
            ],
            [
              113.5373433,
              22.1298947
            ],
            [
              113.5373709,
              22.1298946
            ],
            [
              113.5373703,
              22.1297898
            ],
            [
              113.5374587,
              22.1297893
            ],
            [
              113.5374585,
              22.1297585
            ],
            [
              113.5375613,
              22.129758
            ],
            [
              113.5375627,
              22.1299897
            ],
            [
              113.5375088,
              22.1299899
            ],
            [
              113.5375094,
              22.1300878
            ],
            [
              113.5373972,
              22.1300884
            ],
            [
              113.5373968,
              22.1300332
            ],
            [
              113.5373725,
              22.1300333
            ],
            [
              113.5373727,
              22.1300616
            ],
            [
              113.5373022,
              22.1300619
            ],
            [
              113.5373024,
              22.1300941
            ],
            [
              113.537115,
              22.1300951
            ],
            [
              113.5371148,
              22.1300594
            ],
            [
              113.5370572,
              22.1300597
            ],
            [
              113.5370574,
              22.1300934
            ],
            [
              113.5368218,
              22.1300946
            ],
            [
              113.5368216,
              22.1300528
            ],
            [
              113.5367218,
              22.1300533
            ],
            [
              113.5367221,
              22.1300946
            ],
            [
              113.5366091,
              22.1300952
            ],
            [
              113.5366086,
              22.1300061
            ],
            [
              113.5365408,
              22.1300064
            ],
            [
              113.5365403,
              22.1299271
            ],
            [
              113.5366191,
              22.1299267
            ],
            [
              113.5366186,
              22.1298424
            ],
            [
              113.5367932,
              22.1298415
            ],
            [
              113.5367939,
              22.129961
            ],
            [
              113.5368183,
              22.1299609
            ],
            [
              113.5368171,
              22.1297581
            ],
            [
              113.5372382,
              22.1297559
            ],
            [
              113.5372379,
              22.1297201
            ],
            [
              113.5373423,
              22.1297195
            ]
          ]
        ]
      },
      "id": "way/414201670"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414201671",
        "building": "school",
        "name": "珠海市横琴新区第一小学",
        "name:zh": "珠海市横琴新区第一小学",
        "name:zh-Hant": "珠海市橫琴新區第一小學"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5370016,
              22.1302425
            ],
            [
              113.5375651,
              22.1302384
            ],
            [
              113.5375663,
              22.1303791
            ],
            [
              113.5374945,
              22.1303796
            ],
            [
              113.5374964,
              22.1305909
            ],
            [
              113.5375305,
              22.1305907
            ],
            [
              113.5375314,
              22.1306988
            ],
            [
              113.5374136,
              22.1306997
            ],
            [
              113.5374153,
              22.1309093
            ],
            [
              113.5375359,
              22.1309084
            ],
            [
              113.5375367,
              22.130999
            ],
            [
              113.5374203,
              22.1309998
            ],
            [
              113.5374206,
              22.1310363
            ],
            [
              113.5375018,
              22.1310357
            ],
            [
              113.5375038,
              22.131265
            ],
            [
              113.5375807,
              22.1312645
            ],
            [
              113.5375816,
              22.1313673
            ],
            [
              113.5369866,
              22.1313717
            ],
            [
              113.5369843,
              22.1311036
            ],
            [
              113.5373411,
              22.131101
            ],
            [
              113.5373405,
              22.1310322
            ],
            [
              113.536988,
              22.1310348
            ],
            [
              113.5369855,
              22.1307439
            ],
            [
              113.5371507,
              22.1307427
            ],
            [
              113.5371521,
              22.1309087
            ],
            [
              113.5372728,
              22.1309078
            ],
            [
              113.537271,
              22.1307013
            ],
            [
              113.5369912,
              22.1307034
            ],
            [
              113.5369903,
              22.1305927
            ],
            [
              113.5373505,
              22.1305901
            ],
            [
              113.5373486,
              22.1303675
            ],
            [
              113.5370027,
              22.1303701
            ],
            [
              113.5370016,
              22.1302425
            ]
          ]
        ]
      },
      "id": "way/414201671"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414208016",
        "building": "commercial"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5383269,
              22.1320956
            ],
            [
              113.5383236,
              22.1318984
            ],
            [
              113.5387343,
              22.1318925
            ],
            [
              113.5387375,
              22.1320867
            ],
            [
              113.5386425,
              22.132088
            ],
            [
              113.5386412,
              22.1320078
            ],
            [
              113.5385737,
              22.1320088
            ],
            [
              113.5385744,
              22.1320537
            ],
            [
              113.5384109,
              22.132056
            ],
            [
              113.5384115,
              22.1320944
            ],
            [
              113.5383269,
              22.1320956
            ]
          ]
        ]
      },
      "id": "way/414208016"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414208017",
        "building": "commercial"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5378259,
              22.132129
            ],
            [
              113.5378215,
              22.1319083
            ],
            [
              113.5379257,
              22.1319065
            ],
            [
              113.5379264,
              22.1319411
            ],
            [
              113.5382345,
              22.1319358
            ],
            [
              113.5382381,
              22.1321156
            ],
            [
              113.5381505,
              22.1321171
            ],
            [
              113.5381488,
              22.1320344
            ],
            [
              113.5380713,
              22.1320358
            ],
            [
              113.5380723,
              22.1320831
            ],
            [
              113.5379247,
              22.1320856
            ],
            [
              113.5379256,
              22.1321273
            ],
            [
              113.5378259,
              22.132129
            ]
          ]
        ]
      },
      "id": "way/414208017"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414208018",
        "building": "commercial"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5390232,
              22.1321501
            ],
            [
              113.5390178,
              22.1319109
            ],
            [
              113.5392069,
              22.1319073
            ],
            [
              113.5392123,
              22.1321464
            ],
            [
              113.5390232,
              22.1321501
            ]
          ]
        ]
      },
      "id": "way/414208018"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414208019",
        "building": "commercial"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5383062,
              22.1324745
            ],
            [
              113.5383042,
              22.1322338
            ],
            [
              113.5387316,
              22.1322306
            ],
            [
              113.5387337,
              22.1324724
            ],
            [
              113.5385625,
              22.1324736
            ],
            [
              113.538562,
              22.1324189
            ],
            [
              113.5384793,
              22.1324195
            ],
            [
              113.5384798,
              22.1324733
            ],
            [
              113.5383062,
              22.1324745
            ]
          ]
        ]
      },
      "id": "way/414208019"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414208020",
        "building": "commercial"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5378256,
              22.1324718
            ],
            [
              113.5378236,
              22.132231
            ],
            [
              113.538251,
              22.1322279
            ],
            [
              113.5382531,
              22.1324696
            ],
            [
              113.5380819,
              22.1324709
            ],
            [
              113.5380815,
              22.1324161
            ],
            [
              113.5379987,
              22.1324167
            ],
            [
              113.5379992,
              22.1324705
            ],
            [
              113.5378256,
              22.1324718
            ]
          ]
        ]
      },
      "id": "way/414208020"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414208021",
        "building": "commercial"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5387927,
              22.1324745
            ],
            [
              113.5387907,
              22.1322338
            ],
            [
              113.5392181,
              22.1322306
            ],
            [
              113.5392202,
              22.1324724
            ],
            [
              113.539049,
              22.1324736
            ],
            [
              113.5390485,
              22.1324189
            ],
            [
              113.5389658,
              22.1324195
            ],
            [
              113.5389663,
              22.1324733
            ],
            [
              113.5387927,
              22.1324745
            ]
          ]
        ]
      },
      "id": "way/414208021"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414208022",
        "name": "横琴中央汇",
        "name:zh": "横琴中央汇",
        "name:zh-Hans": "横琴中央汇",
        "name:zh-Hant": "橫琴中央匯",
        "shop": "mall"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5377772,
              22.1325242
            ],
            [
              113.5377765,
              22.1317543
            ],
            [
              113.5392872,
              22.1317531
            ],
            [
              113.5392879,
              22.132523
            ],
            [
              113.5377772,
              22.1325242
            ]
          ]
        ]
      },
      "id": "way/414208022"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414284286",
        "addr:housename": "横琴新家园",
        "addr:housename:zh": "横琴新家园",
        "building": "apartments",
        "building:levels": "24",
        "name": "7栋",
        "name:zh": "7栋",
        "start_date": "2013"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5385292,
              22.1310888
            ],
            [
              113.5385478,
              22.131106
            ],
            [
              113.5385907,
              22.1310665
            ],
            [
              113.5386224,
              22.131096
            ],
            [
              113.5385988,
              22.1311177
            ],
            [
              113.5386116,
              22.1311296
            ],
            [
              113.5385762,
              22.1311621
            ],
            [
              113.5385882,
              22.1311733
            ],
            [
              113.5386236,
              22.1311407
            ],
            [
              113.5386363,
              22.1311526
            ],
            [
              113.5386599,
              22.131131
            ],
            [
              113.5386915,
              22.1311605
            ],
            [
              113.5386528,
              22.1311961
            ],
            [
              113.5386897,
              22.1312304
            ],
            [
              113.5386832,
              22.1312364
            ],
            [
              113.53871,
              22.1312614
            ],
            [
              113.5386825,
              22.1312868
            ],
            [
              113.538707,
              22.1313097
            ],
            [
              113.5386786,
              22.1313359
            ],
            [
              113.5386648,
              22.1313231
            ],
            [
              113.5386374,
              22.1313483
            ],
            [
              113.5384796,
              22.1312011
            ],
            [
              113.538522,
              22.1311621
            ],
            [
              113.5384937,
              22.1311358
            ],
            [
              113.5384533,
              22.1311356
            ],
            [
              113.5384532,
              22.1311635
            ],
            [
              113.5383535,
              22.1311632
            ],
            [
              113.5383539,
              22.131071
            ],
            [
              113.5384516,
              22.1310713
            ],
            [
              113.5384517,
              22.1310476
            ],
            [
              113.5385294,
              22.1310478
            ],
            [
              113.5385292,
              22.1310888
            ]
          ]
        ]
      },
      "id": "way/414284286"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414284287",
        "addr:housename": "横琴新家园",
        "addr:housename:zh": "横琴新家园",
        "building": "apartments",
        "building:levels": "24",
        "name": "1栋",
        "name:zh": "1栋",
        "start_date": "2013"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5379214,
              22.1297685
            ],
            [
              113.5379477,
              22.1297685
            ],
            [
              113.5379479,
              22.1297124
            ],
            [
              113.5379928,
              22.1297126
            ],
            [
              113.5379927,
              22.1297433
            ],
            [
              113.5380108,
              22.1297434
            ],
            [
              113.5380106,
              22.1297895
            ],
            [
              113.5380276,
              22.1297896
            ],
            [
              113.5380278,
              22.1297434
            ],
            [
              113.5380459,
              22.1297435
            ],
            [
              113.538046,
              22.1297127
            ],
            [
              113.5380909,
              22.1297129
            ],
            [
              113.5380907,
              22.1297634
            ],
            [
              113.538143,
              22.1297636
            ],
            [
              113.538143,
              22.129772
            ],
            [
              113.5381811,
              22.1297721
            ],
            [
              113.5381809,
              22.1298205
            ],
            [
              113.5382,
              22.1298205
            ],
            [
              113.5381998,
              22.1298812
            ],
            [
              113.5381186,
              22.1298809
            ],
            [
              113.5381187,
              22.1298615
            ],
            [
              113.5380708,
              22.1298613
            ],
            [
              113.5380709,
              22.1298254
            ],
            [
              113.5380343,
              22.1298253
            ],
            [
              113.5380341,
              22.1298806
            ],
            [
              113.5379721,
              22.1298804
            ],
            [
              113.5379723,
              22.1298251
            ],
            [
              113.5379322,
              22.129825
            ],
            [
              113.5379035,
              22.1298513
            ],
            [
              113.5379247,
              22.1298711
            ],
            [
              113.5378648,
              22.1299263
            ],
            [
              113.5378168,
              22.1298815
            ],
            [
              113.5378239,
              22.129875
            ],
            [
              113.5377852,
              22.1298388
            ],
            [
              113.5378366,
              22.1297915
            ],
            [
              113.5378203,
              22.1297763
            ],
            [
              113.5378754,
              22.1297256
            ],
            [
              113.5379214,
              22.1297685
            ]
          ]
        ]
      },
      "id": "way/414284287"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414284288",
        "addr:housename": "横琴新家园",
        "addr:housename:zh": "横琴新家园",
        "building": "apartments",
        "building:levels": "24",
        "name": "8栋",
        "name:zh": "8栋",
        "start_date": "2013"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5379484,
              22.1310823
            ],
            [
              113.5379669,
              22.1310996
            ],
            [
              113.5380099,
              22.13106
            ],
            [
              113.5380415,
              22.1310895
            ],
            [
              113.538018,
              22.1311112
            ],
            [
              113.5380307,
              22.1311231
            ],
            [
              113.5379954,
              22.1311556
            ],
            [
              113.5380074,
              22.1311668
            ],
            [
              113.5380427,
              22.1311343
            ],
            [
              113.5380555,
              22.1311462
            ],
            [
              113.538079,
              22.1311245
            ],
            [
              113.5381106,
              22.131154
            ],
            [
              113.538072,
              22.1311896
            ],
            [
              113.5381088,
              22.131224
            ],
            [
              113.5381023,
              22.1312299
            ],
            [
              113.5381292,
              22.131255
            ],
            [
              113.5381016,
              22.1312803
            ],
            [
              113.5381262,
              22.1313033
            ],
            [
              113.5380977,
              22.1313295
            ],
            [
              113.538084,
              22.1313167
            ],
            [
              113.5380566,
              22.1313419
            ],
            [
              113.5378988,
              22.1311947
            ],
            [
              113.5379412,
              22.1311557
            ],
            [
              113.5379129,
              22.1311293
            ],
            [
              113.5378725,
              22.1311292
            ],
            [
              113.5378724,
              22.131157
            ],
            [
              113.5377727,
              22.1311567
            ],
            [
              113.537773,
              22.1310645
            ],
            [
              113.5378708,
              22.1310648
            ],
            [
              113.5378709,
              22.1310411
            ],
            [
              113.5379485,
              22.1310413
            ],
            [
              113.5379484,
              22.1310823
            ]
          ]
        ]
      },
      "id": "way/414284288"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414299098",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "E22",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "university",
        "description": "Location: Room G031, Faculty of Business Administration (E22)",
        "description:en": "Location: Room G031, Faculty of Business Administration (E22)",
        "description:zh": "所在位置: 工商管理學院 (E22), G031室",
        "email": "fba.suggestion@um.edu.mo",
        "fax": "+853 8822 2377",
        "image": "https://map.um.edu.mo/emap_images/building_E22.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "工商管理學院 Faculdade de Administração de Empresas (E22)",
        "name:en": "Faculty of Business Administration (E22)",
        "name:pt": "Faculdade de Administração de Empresas (E22)",
        "name:zh": "工商管理學院(E22)",
        "note": "Zone East, Academics",
        "operator": "Faculdade de Administração de Empresas, Universidade de Macau",
        "phone": "+853 8822 4656",
        "website": "https://fba.um.edu.mo/"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5434745,
              22.1285174
            ],
            [
              113.543074,
              22.1285217
            ],
            [
              113.5427144,
              22.1285196
            ],
            [
              113.5427139,
              22.1283956
            ],
            [
              113.5427125,
              22.1280717
            ],
            [
              113.542784,
              22.1280714
            ],
            [
              113.5427837,
              22.1280137
            ],
            [
              113.5427044,
              22.128014
            ],
            [
              113.5427042,
              22.12796
            ],
            [
              113.5427041,
              22.1279332
            ],
            [
              113.5427947,
              22.1279329
            ],
            [
              113.5427945,
              22.127892
            ],
            [
              113.5433572,
              22.12789
            ],
            [
              113.5433576,
              22.1279913
            ],
            [
              113.5434274,
              22.1279911
            ],
            [
              113.5434263,
              22.1277269
            ],
            [
              113.543547,
              22.1277265
            ],
            [
              113.5436542,
              22.1277261
            ],
            [
              113.5436567,
              22.1283315
            ],
            [
              113.5436124,
              22.1283316
            ],
            [
              113.5436128,
              22.1284306
            ],
            [
              113.5436189,
              22.1285355
            ],
            [
              113.5434745,
              22.1285174
            ]
          ]
        ]
      },
      "id": "way/414299098"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414299099",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "E33",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "university",
        "building:levels": "3",
        "description": "Location: Room 4004,  Faculty of Education (E33)",
        "description:en": "Location: Room 4004,  Faculty of Education (E33)",
        "description:zh": "所在位置: 教育學院 (E33), 4004室",
        "email": "fed.enquiry@um.edu.mo",
        "fax": "+853 2883 1695, +853 8822 2402",
        "image": "https://map.um.edu.mo/emap_images/building_E33.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "教育學院 Faculdade de Ciências da Educação (E33)",
        "name:en": "Faculty of Education (E33)",
        "name:pt": "Faculdade de Ciências da Educação (E33)",
        "name:zh": "教育學院 (E33)",
        "note": "Zone East, Academics",
        "operator": "Faculdade de Ciências da Educação (Universidade de Macau)",
        "phone": "+853 8822 8776, +853 8822 8789",
        "ref": "E32",
        "website": "https://fed.um.edu.mo"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5445709,
              22.1262546
            ],
            [
              113.5445084,
              22.126255
            ],
            [
              113.5443819,
              22.1262559
            ],
            [
              113.5443807,
              22.1261084
            ],
            [
              113.5440068,
              22.126111
            ],
            [
              113.5440066,
              22.1260868
            ],
            [
              113.5439463,
              22.1260872
            ],
            [
              113.5439467,
              22.126129
            ],
            [
              113.543788,
              22.1261301
            ],
            [
              113.5437868,
              22.1259806
            ],
            [
              113.5436297,
              22.1259817
            ],
            [
              113.5436306,
              22.1260873
            ],
            [
              113.5434363,
              22.1260886
            ],
            [
              113.5434346,
              22.1258885
            ],
            [
              113.5434341,
              22.125822
            ],
            [
              113.5436257,
              22.1258207
            ],
            [
              113.5436264,
              22.125907
            ],
            [
              113.5437827,
              22.1259059
            ],
            [
              113.5437815,
              22.1257573
            ],
            [
              113.5438534,
              22.1257568
            ],
            [
              113.5438519,
              22.1255637
            ],
            [
              113.5445331,
              22.125559
            ],
            [
              113.5445333,
              22.1255919
            ],
            [
              113.5445336,
              22.1256325
            ],
            [
              113.5446225,
              22.1256319
            ],
            [
              113.5446238,
              22.1258004
            ],
            [
              113.5445673,
              22.1258008
            ],
            [
              113.5445709,
              22.1262546
            ]
          ]
        ]
      },
      "id": "way/414299099"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414299100",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "E32",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "amenity": "academics",
        "building": "university",
        "building:levels": "3",
        "description": "Location: Room 1003, Faculty of Law (E32)",
        "description:en": "Location: Room 1003, Faculty of Law (E32)",
        "description:zh": "所在位置: 法學院 (E32), 1003室",
        "email": "fll.suggestion@um.edu.mo",
        "fax": "+853 8822 2380",
        "image": "https://map.um.edu.mo/emap_images/building_E32.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "法學院 Faculdade de Direit (E32)",
        "name:en": "Faculty of Law (E32)",
        "name:zh": "法學院 (E32)",
        "note": "Zone East, Academics",
        "operator": "Faculdade de Direit (Universidade de Macau)",
        "phone": "+853 8822 9358, +853 8822 4095",
        "ref": "E31",
        "website": "https://fll.um.edu.mo/"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5433583,
              22.126679
            ],
            [
              113.543357,
              22.1265739
            ],
            [
              113.5434007,
              22.1265734
            ],
            [
              113.5434003,
              22.1265385
            ],
            [
              113.5433578,
              22.1265389
            ],
            [
              113.5433534,
              22.1261832
            ],
            [
              113.5433937,
              22.1261828
            ],
            [
              113.5434543,
              22.1261822
            ],
            [
              113.5434549,
              22.1262295
            ],
            [
              113.5436278,
              22.1262277
            ],
            [
              113.5436273,
              22.1261876
            ],
            [
              113.5437512,
              22.1261863
            ],
            [
              113.543752,
              22.1262506
            ],
            [
              113.5442593,
              22.1262453
            ],
            [
              113.5442613,
              22.1264069
            ],
            [
              113.5443678,
              22.1264058
            ],
            [
              113.5443683,
              22.1264477
            ],
            [
              113.5443693,
              22.1265339
            ],
            [
              113.5436427,
              22.1265415
            ],
            [
              113.5436421,
              22.1264946
            ],
            [
              113.5436233,
              22.1264948
            ],
            [
              113.5436238,
              22.1265353
            ],
            [
              113.5435204,
              22.1265364
            ],
            [
              113.5435208,
              22.1265721
            ],
            [
              113.5436222,
              22.126571
            ],
            [
              113.5436234,
              22.1266749
            ],
            [
              113.5435457,
              22.1266757
            ],
            [
              113.5435462,
              22.1267196
            ],
            [
              113.5434263,
              22.1267208
            ],
            [
              113.5434257,
              22.1266783
            ],
            [
              113.5433583,
              22.126679
            ]
          ]
        ]
      },
      "id": "way/414299100"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/414299101",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "E34",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "university",
        "building:levels": "3",
        "image": "https://map.um.edu.mo/emap_images/building_E34.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "祟文樓 Edifício Cultural (E34)",
        "name:en": "Cultural Building (E34)",
        "name:pt": "Edifício Cultural (E34)",
        "name:zh": "祟文樓 (E34)",
        "note": "Zone East, Academics",
        "ref": "E34"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5433105,
              22.1257393
            ],
            [
              113.5433109,
              22.1256641
            ],
            [
              113.5434276,
              22.1256647
            ],
            [
              113.5434397,
              22.1251668
            ],
            [
              113.544326,
              22.1251627
            ],
            [
              113.5443253,
              22.1253579
            ],
            [
              113.5441866,
              22.1253615
            ],
            [
              113.5441769,
              22.125401
            ],
            [
              113.5436504,
              22.1253983
            ],
            [
              113.5436507,
              22.1253421
            ],
            [
              113.5436058,
              22.1253419
            ],
            [
              113.5436034,
              22.1257408
            ],
            [
              113.5433105,
              22.1257393
            ]
          ]
        ]
      },
      "id": "way/414299101"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/416503684",
        "building": "yes",
        "name": "11栋"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5386423,
              22.1308154
            ],
            [
              113.5385847,
              22.1308166
            ],
            [
              113.5385835,
              22.1307667
            ],
            [
              113.5385502,
              22.1307674
            ],
            [
              113.5385488,
              22.130708
            ],
            [
              113.5385643,
              22.1307077
            ],
            [
              113.5385617,
              22.1306024
            ],
            [
              113.5388843,
              22.1305955
            ],
            [
              113.5388916,
              22.1308907
            ],
            [
              113.5386443,
              22.130896
            ],
            [
              113.5386423,
              22.1308154
            ]
          ]
        ]
      },
      "id": "way/416503684"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/416503685",
        "addr:housename": "横琴新家园",
        "addr:housename:zh": "横琴新家园",
        "building": "apartments",
        "building:levels": "25",
        "name": "10栋",
        "name:zh": "10栋",
        "start_date": "2013"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5383358,
              22.1301316
            ],
            [
              113.5384788,
              22.1301321
            ],
            [
              113.5384786,
              22.1301882
            ],
            [
              113.5385049,
              22.1301883
            ],
            [
              113.5385512,
              22.1301457
            ],
            [
              113.5386059,
              22.1301967
            ],
            [
              113.5385895,
              22.1302118
            ],
            [
              113.5386407,
              22.1302595
            ],
            [
              113.5386017,
              22.1302954
            ],
            [
              113.5386087,
              22.130302
            ],
            [
              113.5385604,
              22.1303465
            ],
            [
              113.5385009,
              22.1302909
            ],
            [
              113.5385222,
              22.1302713
            ],
            [
              113.5384937,
              22.1302447
            ],
            [
              113.5384536,
              22.1302446
            ],
            [
              113.5384534,
              22.1302999
            ],
            [
              113.53836,
              22.1302996
            ],
            [
              113.5383602,
              22.1302443
            ],
            [
              113.5383201,
              22.1302441
            ],
            [
              113.5382914,
              22.1302705
            ],
            [
              113.5383126,
              22.1302903
            ],
            [
              113.5382782,
              22.130322
            ],
            [
              113.5381914,
              22.1302411
            ],
            [
              113.5382796,
              22.13016
            ],
            [
              113.5383093,
              22.1301877
            ],
            [
              113.5383356,
              22.1301877
            ],
            [
              113.5383358,
              22.1301316
            ]
          ]
        ]
      },
      "id": "way/416503685"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/416504170",
        "building": "apartments",
        "building:levels": "30",
        "start_date": "2016"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5372062,
              22.1276981
            ],
            [
              113.5371245,
              22.127638
            ],
            [
              113.5371339,
              22.1276241
            ],
            [
              113.5371574,
              22.1276415
            ],
            [
              113.5371865,
              22.1276145
            ],
            [
              113.5371273,
              22.1275641
            ],
            [
              113.5370963,
              22.1275997
            ],
            [
              113.5370306,
              22.127538
            ],
            [
              113.537086,
              22.1274779
            ],
            [
              113.5371424,
              22.1275214
            ],
            [
              113.5371555,
              22.1275031
            ],
            [
              113.5370841,
              22.1274475
            ],
            [
              113.5371612,
              22.127377
            ],
            [
              113.5373763,
              22.1275693
            ],
            [
              113.5372992,
              22.1276467
            ],
            [
              113.5372269,
              22.1275745
            ],
            [
              113.5372119,
              22.1275919
            ],
            [
              113.5372692,
              22.1276441
            ],
            [
              113.5372062,
              22.1276981
            ]
          ]
        ]
      },
      "id": "way/416504170"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/416504171",
        "building": "apartments",
        "building:levels": "30",
        "name": "珠海迎海国际公寓",
        "start_date": "2016"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.538973,
              22.1286403
            ],
            [
              113.539116,
              22.1286333
            ],
            [
              113.5391171,
              22.1286132
            ],
            [
              113.5392102,
              22.1286177
            ],
            [
              113.5392072,
              22.1286717
            ],
            [
              113.5392266,
              22.128696
            ],
            [
              113.5392379,
              22.1291372
            ],
            [
              113.5391693,
              22.1292242
            ],
            [
              113.5390895,
              22.1291572
            ],
            [
              113.5390745,
              22.1291709
            ],
            [
              113.5391217,
              22.1292115
            ],
            [
              113.5390591,
              22.129274
            ],
            [
              113.5389846,
              22.12921
            ],
            [
              113.5389994,
              22.1291953
            ],
            [
              113.5390266,
              22.1292187
            ],
            [
              113.5390525,
              22.1291905
            ],
            [
              113.5389884,
              22.1291438
            ],
            [
              113.5389607,
              22.1291732
            ],
            [
              113.5388806,
              22.1291105
            ],
            [
              113.5389045,
              22.1290842
            ],
            [
              113.538864,
              22.1290519
            ],
            [
              113.5388612,
              22.1287456
            ],
            [
              113.538973,
              22.1286403
            ]
          ]
        ]
      },
      "id": "way/416504171"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/416504172",
        "building": "apartments",
        "building:levels": "13",
        "name": "珠海横琴碧海蓝天度假公寓",
        "name:zh": "珠海横琴碧海蓝天度假公寓",
        "start_date": "2014"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.537909,
              22.1274544
            ],
            [
              113.5381217,
              22.1276506
            ],
            [
              113.5381545,
              22.1276201
            ],
            [
              113.538413,
              22.1278585
            ],
            [
              113.5384552,
              22.1278192
            ],
            [
              113.5386201,
              22.1279714
            ],
            [
              113.5385792,
              22.1280095
            ],
            [
              113.5388405,
              22.1282507
            ],
            [
              113.5388023,
              22.1282862
            ],
            [
              113.5390177,
              22.1284849
            ],
            [
              113.5388731,
              22.1286194
            ],
            [
              113.538656,
              22.1284191
            ],
            [
              113.5387024,
              22.1283759
            ],
            [
              113.5386674,
              22.1283436
            ],
            [
              113.538622,
              22.1283858
            ],
            [
              113.5385722,
              22.1283399
            ],
            [
              113.5384846,
              22.1284213
            ],
            [
              113.5384675,
              22.1284055
            ],
            [
              113.5383971,
              22.128471
            ],
            [
              113.5382872,
              22.1283697
            ],
            [
              113.5383534,
              22.1283081
            ],
            [
              113.5383257,
              22.1282824
            ],
            [
              113.5384918,
              22.1281279
            ],
            [
              113.5382927,
              22.1279442
            ],
            [
              113.5381292,
              22.1280964
            ],
            [
              113.538096,
              22.1280658
            ],
            [
              113.5380272,
              22.1281297
            ],
            [
              113.5379201,
              22.1280309
            ],
            [
              113.5379861,
              22.1279696
            ],
            [
              113.5379679,
              22.1279528
            ],
            [
              113.5380639,
              22.1278636
            ],
            [
              113.53802,
              22.1278231
            ],
            [
              113.538067,
              22.1277794
            ],
            [
              113.5380298,
              22.1277451
            ],
            [
              113.537984,
              22.1277877
            ],
            [
              113.5378485,
              22.1276626
            ],
            [
              113.5378812,
              22.1276322
            ],
            [
              113.5378692,
              22.1276211
            ],
            [
              113.5378372,
              22.1276509
            ],
            [
              113.5377671,
              22.1275863
            ],
            [
              113.537909,
              22.1274544
            ]
          ]
        ]
      },
      "id": "way/416504172"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/435508179",
        "addr:city": "氹仔 Taipa",
        "addr:housenumber": "N9",
        "addr:street": "大學大馬路 Avenida da Universidade",
        "building": "yes",
        "image": "https://map.um.edu.mo/emap_images/building_N9.jpg",
        "name": "澳大運動場 Estádio da Universidade de Macau (N9)",
        "name:en": "UM Stadium (N9)",
        "name:pt": "Estádio da Universidade de Macau (N9)",
        "name:zh": "澳大運動場 (N9)"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5404895,
              22.1345141
            ],
            [
              113.5404937,
              22.1335921
            ],
            [
              113.5407644,
              22.1335932
            ],
            [
              113.5407601,
              22.1345152
            ],
            [
              113.5404895,
              22.1345141
            ]
          ]
        ]
      },
      "id": "way/435508179"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/478108324",
        "building": "yes",
        "man_made": "works",
        "name": "荔枝碗船廠群"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5514025,
              22.1211978
            ],
            [
              113.551203,
              22.121096
            ],
            [
              113.5511676,
              22.1211556
            ],
            [
              113.5509399,
              22.1210393
            ],
            [
              113.5509673,
              22.1209934
            ],
            [
              113.5507892,
              22.1209024
            ],
            [
              113.5508047,
              22.1208763
            ],
            [
              113.5505869,
              22.120765
            ],
            [
              113.5503991,
              22.1209136
            ],
            [
              113.550305,
              22.1208116
            ],
            [
              113.5504096,
              22.1207288
            ],
            [
              113.5503537,
              22.1206682
            ],
            [
              113.5500515,
              22.1207298
            ],
            [
              113.5499894,
              22.120468
            ],
            [
              113.5498556,
              22.1205181
            ],
            [
              113.5497775,
              22.1202747
            ],
            [
              113.5500372,
              22.1202032
            ],
            [
              113.5500231,
              22.1201593
            ],
            [
              113.5503538,
              22.1200682
            ],
            [
              113.5504723,
              22.1202576
            ],
            [
              113.5505751,
              22.1203395
            ],
            [
              113.5509017,
              22.1204871
            ],
            [
              113.5510761,
              22.1205689
            ],
            [
              113.5516142,
              22.1208062
            ],
            [
              113.5514025,
              22.1211978
            ]
          ]
        ]
      },
      "id": "way/478108324"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/480773081",
        "building": "yes",
        "height": "17.6",
        "name": "中天能源控股有限公司 Sinosky Energy (Holdings) Co., Ltd."
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5522347,
              22.1323988
            ],
            [
              113.5522716,
              22.1323845
            ],
            [
              113.5523111,
              22.1324553
            ],
            [
              113.5523659,
              22.1324553
            ],
            [
              113.5524719,
              22.1324547
            ],
            [
              113.5525533,
              22.1324553
            ],
            [
              113.5525517,
              22.1324905
            ],
            [
              113.5525331,
              22.1324907
            ],
            [
              113.5525297,
              22.132528
            ],
            [
              113.5523159,
              22.132528
            ],
            [
              113.5523163,
              22.1325152
            ],
            [
              113.5522993,
              22.1325143
            ],
            [
              113.5522347,
              22.1323988
            ]
          ]
        ]
      },
      "id": "way/480773081"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/530839814",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.557676,
              22.1311568
            ],
            [
              113.5576947,
              22.1309624
            ],
            [
              113.5576249,
              22.1309475
            ],
            [
              113.5576353,
              22.1311962
            ],
            [
              113.5574868,
              22.1311944
            ],
            [
              113.5574904,
              22.131107
            ],
            [
              113.5575689,
              22.1311082
            ],
            [
              113.5575526,
              22.130844
            ],
            [
              113.5580361,
              22.1309511
            ],
            [
              113.5580262,
              22.1310118
            ],
            [
              113.5579446,
              22.1309966
            ],
            [
              113.5579258,
              22.1311133
            ],
            [
              113.5578349,
              22.1311056
            ],
            [
              113.5578506,
              22.1309917
            ],
            [
              113.5577797,
              22.130978
            ],
            [
              113.557761,
              22.1311647
            ],
            [
              113.557676,
              22.1311568
            ]
          ]
        ]
      },
      "id": "way/530839814"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/548518804",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5564424,
              22.1284201
            ],
            [
              113.5564368,
              22.1282826
            ],
            [
              113.5564441,
              22.1282823
            ],
            [
              113.5564851,
              22.1282809
            ],
            [
              113.5564842,
              22.1282589
            ],
            [
              113.5565355,
              22.1282571
            ],
            [
              113.5565342,
              22.1282244
            ],
            [
              113.5566674,
              22.1282198
            ],
            [
              113.5566693,
              22.1282661
            ],
            [
              113.5566971,
              22.1282652
            ],
            [
              113.5567165,
              22.1282645
            ],
            [
              113.5567257,
              22.1282642
            ],
            [
              113.5567249,
              22.1282443
            ],
            [
              113.5567563,
              22.1282432
            ],
            [
              113.5567552,
              22.1282169
            ],
            [
              113.5568194,
              22.1282147
            ],
            [
              113.5568204,
              22.1282393
            ],
            [
              113.5569037,
              22.1282364
            ],
            [
              113.5569044,
              22.128252
            ],
            [
              113.5569508,
              22.1282504
            ],
            [
              113.5569566,
              22.1283934
            ],
            [
              113.556957,
              22.1284025
            ],
            [
              113.5569439,
              22.128403
            ],
            [
              113.5569446,
              22.1284193
            ],
            [
              113.5569164,
              22.1284203
            ],
            [
              113.556917,
              22.1284335
            ],
            [
              113.5567422,
              22.1284397
            ],
            [
              113.5567413,
              22.1284183
            ],
            [
              113.5567266,
              22.1284188
            ],
            [
              113.5567274,
              22.128438
            ],
            [
              113.5566755,
              22.1284398
            ],
            [
              113.556489,
              22.1284463
            ],
            [
              113.5564677,
              22.1284431
            ],
            [
              113.5564507,
              22.1284376
            ],
            [
              113.5564424,
              22.1284201
            ]
          ]
        ]
      },
      "id": "way/548518804"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/548518805",
        "building": "yes",
        "name": "峰匯 Residence O"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5561655,
              22.128084
            ],
            [
              113.5564165,
              22.1281077
            ],
            [
              113.5564084,
              22.1281817
            ],
            [
              113.5564779,
              22.1281882
            ],
            [
              113.5564733,
              22.1282305
            ],
            [
              113.5563998,
              22.1282235
            ],
            [
              113.5563886,
              22.1283246
            ],
            [
              113.5561317,
              22.1283004
            ],
            [
              113.5561404,
              22.1282211
            ],
            [
              113.5561778,
              22.1282246
            ],
            [
              113.556186,
              22.1281506
            ],
            [
              113.5561584,
              22.128148
            ],
            [
              113.5561655,
              22.128084
            ]
          ]
        ]
      },
      "id": "way/548518805"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/550669771",
        "building": "yes",
        "height": "12.5",
        "man_made": "works",
        "name": "南粵科技園"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5534308,
              22.12472
            ],
            [
              113.5534662,
              22.1246598
            ],
            [
              113.5535476,
              22.1247008
            ],
            [
              113.5535931,
              22.1246232
            ],
            [
              113.5537094,
              22.1246818
            ],
            [
              113.5536622,
              22.1247623
            ],
            [
              113.5537083,
              22.1247856
            ],
            [
              113.553753,
              22.1247094
            ],
            [
              113.5539467,
              22.124807
            ],
            [
              113.5538683,
              22.1249405
            ],
            [
              113.5534308,
              22.12472
            ]
          ]
        ]
      },
      "id": "way/550669771"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/550669772",
        "building": "yes",
        "height": "12.6",
        "man_made": "works"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5533992,
              22.1253195
            ],
            [
              113.5538324,
              22.1253154
            ],
            [
              113.5538387,
              22.1258881
            ],
            [
              113.5534055,
              22.1258922
            ],
            [
              113.5533992,
              22.1253195
            ]
          ]
        ]
      },
      "id": "way/550669772"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/550669773",
        "building": "yes",
        "height": "12.6",
        "man_made": "works"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5539193,
              22.1253317
            ],
            [
              113.5544611,
              22.1253242
            ],
            [
              113.5544584,
              22.1258783
            ],
            [
              113.553922,
              22.1258808
            ],
            [
              113.5539193,
              22.1253317
            ]
          ]
        ]
      },
      "id": "way/550669773"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/550669774",
        "building": "yes",
        "height": "12.5",
        "man_made": "works",
        "name": "第4座",
        "name:zh": "第4座",
        "ref": "4"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.553686,
              22.126005
            ],
            [
              113.554032,
              22.1260075
            ],
            [
              113.554032,
              22.1265591
            ],
            [
              113.553694,
              22.1265591
            ],
            [
              113.553686,
              22.126005
            ]
          ]
        ]
      },
      "id": "way/550669774"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/550669775",
        "building": "yes",
        "height": "12.5",
        "man_made": "works",
        "name": "張權破痛油中藥廠 Fabrica de Medicina Chinesa Cheong Kun",
        "name:pt": "Fabrica de Medicina Chinesa Cheong Kun",
        "name:zh": "張權破痛油中藥廠",
        "ref": "5"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5541071,
              22.126005
            ],
            [
              113.5544558,
              22.1259976
            ],
            [
              113.5544477,
              22.1265616
            ],
            [
              113.5541044,
              22.1265616
            ],
            [
              113.5541071,
              22.126005
            ]
          ]
        ]
      },
      "id": "way/550669775"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/550669776",
        "building": "yes",
        "height": "12.5",
        "man_made": "works"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5534074,
              22.126003
            ],
            [
              113.5536072,
              22.1260035
            ],
            [
              113.5536064,
              22.1262544
            ],
            [
              113.5534066,
              22.1262538
            ],
            [
              113.5534074,
              22.126003
            ]
          ]
        ]
      },
      "id": "way/550669776"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/550669777",
        "building": "yes",
        "height": "12.5",
        "man_made": "works",
        "name": "南粵中藥廠",
        "name:zh": "南粵中藥廠",
        "ref": "3"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5534148,
              22.1263228
            ],
            [
              113.5536079,
              22.1263233
            ],
            [
              113.5536071,
              22.1265606
            ],
            [
              113.553414,
              22.1265601
            ],
            [
              113.5534148,
              22.1263228
            ]
          ]
        ]
      },
      "id": "way/550669777"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049437",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "12栋",
        "name:en": "Block 12",
        "name:zh": "12栋",
        "name:zh-Hans": "12栋",
        "name:zh-Hant": "12棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5349931,
              22.1348893
            ],
            [
              113.5350551,
              22.1346362
            ],
            [
              113.5353284,
              22.1346935
            ],
            [
              113.5352664,
              22.1349467
            ],
            [
              113.5349931,
              22.1348893
            ]
          ]
        ]
      },
      "id": "way/566049437"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049438",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "10栋",
        "name:en": "Block 10",
        "name:zh": "10栋",
        "name:zh-Hans": "10栋",
        "name:zh-Hant": "10棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5353864,
              22.1349818
            ],
            [
              113.5353778,
              22.1347223
            ],
            [
              113.5356579,
              22.1347142
            ],
            [
              113.5356665,
              22.1349737
            ],
            [
              113.5353864,
              22.1349818
            ]
          ]
        ]
      },
      "id": "way/566049438"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049439",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "9栋",
        "name:en": "Block 9",
        "name:zh": "9栋",
        "name:zh-Hans": "9栋",
        "name:zh-Hant": "9棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.535693,
              22.1351773
            ],
            [
              113.535743,
              22.1349219
            ],
            [
              113.5360187,
              22.1349681
            ],
            [
              113.5359688,
              22.1352235
            ],
            [
              113.535693,
              22.1351773
            ]
          ]
        ]
      },
      "id": "way/566049439"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049440",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "university",
        "building:levels": "4",
        "name": "珠海澳大科技研究院",
        "name:en": "Zhuhai UM Science & Technology Research Institute",
        "name:zh": "珠海澳大科技研究院",
        "name:zh-Hans": "珠海澳大科技研究院",
        "name:zh-Hant": "珠海澳大科技研究院",
        "ref": "8"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5361741,
              22.1350466
            ],
            [
              113.5362355,
              22.1347933
            ],
            [
              113.5365089,
              22.1348503
            ],
            [
              113.5364475,
              22.1351035
            ],
            [
              113.5361741,
              22.1350466
            ]
          ]
        ]
      },
      "id": "way/566049440"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049441",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "7栋",
        "name:en": "Block 7",
        "name:zh": "7栋",
        "name:zh-Hans": "7栋",
        "name:zh-Hant": "7棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5365557,
              22.1352239
            ],
            [
              113.5365476,
              22.1349644
            ],
            [
              113.5368277,
              22.1349568
            ],
            [
              113.5368358,
              22.1352163
            ],
            [
              113.5365557,
              22.1352239
            ]
          ]
        ]
      },
      "id": "way/566049441"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049442",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "6栋",
        "name:en": "Block 6",
        "name:zh": "6栋",
        "name:zh-Hans": "6栋",
        "name:zh-Hant": "6棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5368819,
              22.1350228
            ],
            [
              113.5368738,
              22.1347634
            ],
            [
              113.5371539,
              22.1347558
            ],
            [
              113.537162,
              22.1350153
            ],
            [
              113.5368819,
              22.1350228
            ]
          ]
        ]
      },
      "id": "way/566049442"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049443",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "5栋",
        "name:en": "Block 5",
        "name:zh": "5栋",
        "name:zh-Hans": "5栋",
        "name:zh-Hant": "5棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5372104,
              22.1350588
            ],
            [
              113.5372532,
              22.1348023
            ],
            [
              113.5375301,
              22.1348419
            ],
            [
              113.5374873,
              22.1350985
            ],
            [
              113.5372104,
              22.1350588
            ]
          ]
        ]
      },
      "id": "way/566049443"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049444",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "3栋",
        "name:en": "Block 3",
        "name:zh": "3栋",
        "name:zh-Hans": "3栋",
        "name:zh-Hant": "3棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5379987,
              22.1353422
            ],
            [
              113.5380036,
              22.1350827
            ],
            [
              113.5382838,
              22.1350873
            ],
            [
              113.5382788,
              22.1353468
            ],
            [
              113.5379987,
              22.1353422
            ]
          ]
        ]
      },
      "id": "way/566049444"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049445",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "4栋",
        "name:en": "Block 4",
        "name:zh": "4栋",
        "name:zh-Hans": "4栋",
        "name:zh-Hant": "4棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5376427,
              22.135193
            ],
            [
              113.5376855,
              22.1349365
            ],
            [
              113.5379625,
              22.1349761
            ],
            [
              113.5379197,
              22.1352326
            ],
            [
              113.5376427,
              22.135193
            ]
          ]
        ]
      },
      "id": "way/566049445"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049446",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "2栋",
        "name:en": "Block 2",
        "name:zh": "2栋",
        "name:zh-Hans": "栋",
        "name:zh-Hant": "2棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5383456,
              22.1351713
            ],
            [
              113.5383884,
              22.1349148
            ],
            [
              113.5386653,
              22.1349544
            ],
            [
              113.5386225,
              22.1352109
            ],
            [
              113.5383456,
              22.1351713
            ]
          ]
        ]
      },
      "id": "way/566049446"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049447",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "university",
        "building:levels": "4",
        "name": "北京大学创业训练营横琴基地",
        "name:zh": "北京大学创业训练营横琴基地",
        "name:zh-Hans": "北京大学创业训练营横琴基地",
        "name:zh-Hant": "北京大學創業訓練營橫琴基地"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5386667,
              22.1352989
            ],
            [
              113.538732,
              22.1350464
            ],
            [
              113.5390045,
              22.135107
            ],
            [
              113.5389392,
              22.1353594
            ],
            [
              113.5386667,
              22.1352989
            ]
          ]
        ]
      },
      "id": "way/566049447"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049448",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "2",
        "name": "20C栋",
        "name:en": "Block 20C",
        "name:zh": "20C栋",
        "name:zh-Hans": "20C栋",
        "name:zh-Hant": "20C棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5380134,
              22.1336047
            ],
            [
              113.5379898,
              22.1336104
            ],
            [
              113.5379655,
              22.1336118
            ],
            [
              113.5379413,
              22.1336091
            ],
            [
              113.5377655,
              22.1335793
            ],
            [
              113.5377946,
              22.1334325
            ],
            [
              113.5378931,
              22.1334492
            ],
            [
              113.5379935,
              22.1334161
            ],
            [
              113.5381562,
              22.1334438
            ],
            [
              113.5381207,
              22.133623
            ],
            [
              113.5380134,
              22.1336047
            ]
          ]
        ]
      },
      "id": "way/566049448"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049449",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "20A-20B-20D栋",
        "name:en": "Block 20A-20B-20D",
        "name:zh": "20A-20B-20D栋",
        "name:zh-Hans": "20A-20B-20D栋",
        "name:zh-Hant": "20A-20B-20D棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5377996,
              22.1331133
            ],
            [
              113.5374809,
              22.1331122
            ],
            [
              113.5374815,
              22.1329465
            ],
            [
              113.5385592,
              22.1329503
            ],
            [
              113.5385585,
              22.133116
            ],
            [
              113.537948,
              22.1331138
            ],
            [
              113.5376755,
              22.1335463
            ],
            [
              113.5371638,
              22.1335795
            ],
            [
              113.5371489,
              22.1333822
            ],
            [
              113.5376507,
              22.1333496
            ],
            [
              113.5377996,
              22.1331133
            ]
          ]
        ]
      },
      "id": "way/566049449"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049450",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "15栋",
        "name:en": "Block 15",
        "name:zh": "15栋",
        "name:zh-Hans": "15栋",
        "name:zh-Hant": "15棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.536034,
              22.1334135
            ],
            [
              113.5360061,
              22.1334486
            ],
            [
              113.5360177,
              22.1335409
            ],
            [
              113.5357561,
              22.1335692
            ],
            [
              113.535731,
              22.1333691
            ],
            [
              113.5358937,
              22.1333516
            ],
            [
              113.5358975,
              22.1333819
            ],
            [
              113.5359275,
              22.1333786
            ],
            [
              113.5359237,
              22.1333483
            ],
            [
              113.5359382,
              22.1333468
            ],
            [
              113.5359388,
              22.1333467
            ],
            [
              113.535947,
              22.1332678
            ],
            [
              113.5359258,
              22.1332659
            ],
            [
              113.5359372,
              22.1331569
            ],
            [
              113.5359584,
              22.1331588
            ],
            [
              113.5359697,
              22.1330508
            ],
            [
              113.5358698,
              22.1330419
            ],
            [
              113.5358665,
              22.1330735
            ],
            [
              113.5358045,
              22.1330679
            ],
            [
              113.5358188,
              22.13293
            ],
            [
              113.536016,
              22.1329476
            ],
            [
              113.5360142,
              22.1329655
            ],
            [
              113.5360802,
              22.1329714
            ],
            [
              113.536034,
              22.1334135
            ]
          ]
        ]
      },
      "id": "way/566049450"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049451",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "14栋",
        "name:en": "Block 14",
        "name:zh": "14栋",
        "name:zh-Hans": "14栋",
        "name:zh-Hant": "14棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5352036,
              22.1335703
            ],
            [
              113.535273,
              22.1329407
            ],
            [
              113.5353286,
              22.132946
            ],
            [
              113.5353285,
              22.1329253
            ],
            [
              113.5356939,
              22.1329246
            ],
            [
              113.5356941,
              22.1330302
            ],
            [
              113.5355418,
              22.1330305
            ],
            [
              113.5355419,
              22.1330624
            ],
            [
              113.535476,
              22.1330625
            ],
            [
              113.5354759,
              22.1330307
            ],
            [
              113.5353613,
              22.1330309
            ],
            [
              113.5353104,
              22.1334921
            ],
            [
              113.5353953,
              22.1335002
            ],
            [
              113.5353988,
              22.1334685
            ],
            [
              113.5354643,
              22.1334747
            ],
            [
              113.5354608,
              22.1335064
            ],
            [
              113.5355612,
              22.1335158
            ],
            [
              113.5355496,
              22.133621
            ],
            [
              113.535266,
              22.1335941
            ],
            [
              113.5352679,
              22.1335764
            ],
            [
              113.5352036,
              22.1335703
            ]
          ]
        ]
      },
      "id": "way/566049451"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049452",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "2",
        "name": "17D栋",
        "name:en": "Block 17D",
        "name:zh": "17D栋",
        "name:zh-Hans": "17D栋",
        "name:zh-Hant": "17D棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5362754,
              22.1343718
            ],
            [
              113.5362905,
              22.1342109
            ],
            [
              113.5367068,
              22.1342445
            ],
            [
              113.5366917,
              22.1344054
            ],
            [
              113.5362754,
              22.1343718
            ]
          ]
        ]
      },
      "id": "way/566049452"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049453",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "17A-17B-17C栋",
        "name:en": "Block 17A-17B-17C",
        "name:zh": "17A-17B-17C栋",
        "name:zh-Hans": "17A-17B-17C栋",
        "name:zh-Hant": "17A-17B-17C棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.53704,
              22.1344639
            ],
            [
              113.536787,
              22.13406
            ],
            [
              113.5363376,
              22.1340951
            ],
            [
              113.5363197,
              22.1338986
            ],
            [
              113.5369082,
              22.1338526
            ],
            [
              113.5369249,
              22.1340365
            ],
            [
              113.5370754,
              22.1342767
            ],
            [
              113.5380746,
              22.1343641
            ],
            [
              113.5380554,
              22.1345527
            ],
            [
              113.53704,
              22.1344639
            ]
          ]
        ]
      },
      "id": "way/566049453"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049454",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "2",
        "name": "17E栋",
        "name:en": "Block 17E",
        "name:zh": "17E栋",
        "name:zh-Hans": "17E栋",
        "name:zh-Hant": "17E棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5372308,
              22.1339306
            ],
            [
              113.5372544,
              22.133925
            ],
            [
              113.5372787,
              22.1339235
            ],
            [
              113.5373029,
              22.1339262
            ],
            [
              113.5374787,
              22.1339561
            ],
            [
              113.5374496,
              22.1341029
            ],
            [
              113.5373511,
              22.1340861
            ],
            [
              113.5372507,
              22.1341192
            ],
            [
              113.537007,
              22.1340778
            ],
            [
              113.5370425,
              22.1338986
            ],
            [
              113.5372308,
              22.1339306
            ]
          ]
        ]
      },
      "id": "way/566049454"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049455",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "18栋",
        "name:en": "Block 18",
        "name:zh": "18栋",
        "name:zh-Hans": "18栋"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5386905,
              22.1344045
            ],
            [
              113.5386524,
              22.1339404
            ],
            [
              113.5388441,
              22.1339269
            ],
            [
              113.5388969,
              22.1345693
            ],
            [
              113.5387052,
              22.1345828
            ],
            [
              113.5387038,
              22.1345663
            ],
            [
              113.53838,
              22.1345957
            ],
            [
              113.5380425,
              22.134149
            ],
            [
              113.5377269,
              22.1341712
            ],
            [
              113.5377134,
              22.1340066
            ],
            [
              113.5383554,
              22.1339613
            ],
            [
              113.5383689,
              22.134126
            ],
            [
              113.5381923,
              22.1341384
            ],
            [
              113.5384031,
              22.1344218
            ],
            [
              113.5386905,
              22.1344045
            ]
          ]
        ]
      },
      "id": "way/566049455"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049456",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "21栋",
        "name:en": "Block 21",
        "name:zh": "21栋",
        "name:zh-Hans": "21栋",
        "name:zh-Hant": "21棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5363434,
              22.1331081
            ],
            [
              113.5363441,
              22.1329424
            ],
            [
              113.5373282,
              22.1329459
            ],
            [
              113.5373275,
              22.1331116
            ],
            [
              113.536773,
              22.1331097
            ],
            [
              113.5366467,
              22.133305
            ],
            [
              113.5369108,
              22.1333218
            ],
            [
              113.5368975,
              22.1335007
            ],
            [
              113.5363076,
              22.1334632
            ],
            [
              113.5363208,
              22.1332843
            ],
            [
              113.5365077,
              22.1332962
            ],
            [
              113.5366287,
              22.1331091
            ],
            [
              113.5363434,
              22.1331081
            ]
          ]
        ]
      },
      "id": "way/566049456"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049458",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "19栋",
        "name:en": "Block 19",
        "name:zh": "19栋",
        "name:zh-Hans": "19栋",
        "name:zh-Hant": "19棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5384982,
              22.1335971
            ],
            [
              113.5384978,
              22.1337015
            ],
            [
              113.5383053,
              22.1337008
            ],
            [
              113.538307,
              22.1333021
            ],
            [
              113.5384994,
              22.1333028
            ],
            [
              113.5384986,
              22.1334893
            ],
            [
              113.5386934,
              22.1333821
            ],
            [
              113.5386951,
              22.1329827
            ],
            [
              113.5388817,
              22.1329833
            ],
            [
              113.5388792,
              22.1336004
            ],
            [
              113.5386925,
              22.1335997
            ],
            [
              113.538693,
              22.1334899
            ],
            [
              113.5384982,
              22.1335971
            ]
          ]
        ]
      },
      "id": "way/566049458"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049460",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "13栋",
        "name:en": "Block 13",
        "name:zh": "13栋",
        "name:zh-Hans": "13栋",
        "name:zh-Hant": "13棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5352594,
              22.1339597
            ],
            [
              113.5352112,
              22.1343966
            ],
            [
              113.5352961,
              22.1344047
            ],
            [
              113.5352996,
              22.134373
            ],
            [
              113.5353651,
              22.1343792
            ],
            [
              113.5353616,
              22.1344109
            ],
            [
              113.5355356,
              22.1344273
            ],
            [
              113.535524,
              22.1345324
            ],
            [
              113.5351668,
              22.1344986
            ],
            [
              113.5351687,
              22.1344809
            ],
            [
              113.5351044,
              22.1344748
            ],
            [
              113.5351719,
              22.1338632
            ],
            [
              113.5352362,
              22.1338693
            ],
            [
              113.5352381,
              22.1338515
            ],
            [
              113.5355212,
              22.1338783
            ],
            [
              113.5355096,
              22.1339834
            ],
            [
              113.5354098,
              22.133974
            ],
            [
              113.5354063,
              22.1340056
            ],
            [
              113.5353408,
              22.1339994
            ],
            [
              113.5353443,
              22.1339678
            ],
            [
              113.5352594,
              22.1339597
            ]
          ]
        ]
      },
      "id": "way/566049460"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/566049461",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "16栋",
        "name:en": "Block 16",
        "name:zh": "16栋",
        "name:zh-Hans": "16栋",
        "name:zh-Hant": "16棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5359413,
              22.1339487
            ],
            [
              113.536015,
              22.1339482
            ],
            [
              113.53602,
              22.1345397
            ],
            [
              113.5356688,
              22.1345422
            ],
            [
              113.5356671,
              22.1343318
            ],
            [
              113.5358322,
              22.1343306
            ],
            [
              113.5358325,
              22.1343681
            ],
            [
              113.5358658,
              22.1343679
            ],
            [
              113.5358663,
              22.1344224
            ],
            [
              113.535911,
              22.134422
            ],
            [
              113.5359093,
              22.1342216
            ],
            [
              113.535884,
              22.1342218
            ],
            [
              113.5358831,
              22.1341182
            ],
            [
              113.5359085,
              22.134118
            ],
            [
              113.5359077,
              22.1340271
            ],
            [
              113.5357393,
              22.1340044
            ],
            [
              113.5357558,
              22.1338994
            ],
            [
              113.535945,
              22.1339249
            ],
            [
              113.5359413,
              22.1339487
            ]
          ]
        ]
      },
      "id": "way/566049461"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/588761090",
        "building": "yes",
        "height": "8.4"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5542152,
              22.1292897
            ],
            [
              113.5538874,
              22.1292129
            ],
            [
              113.5539246,
              22.1290669
            ],
            [
              113.5542525,
              22.1291515
            ],
            [
              113.5542152,
              22.1292897
            ]
          ]
        ]
      },
      "id": "way/588761090"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/588761091",
        "building": "yes",
        "height": "8.4"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5543542,
              22.1291668
            ],
            [
              113.5549104,
              22.129297
            ],
            [
              113.5548301,
              22.1295914
            ],
            [
              113.5542739,
              22.1294613
            ],
            [
              113.5543542,
              22.1291668
            ]
          ]
        ]
      },
      "id": "way/588761091"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/588761092",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5541859,
              22.1295103
            ],
            [
              113.5545206,
              22.1295895
            ],
            [
              113.5544922,
              22.1296925
            ],
            [
              113.5541575,
              22.1296132
            ],
            [
              113.5541859,
              22.1295103
            ]
          ]
        ]
      },
      "id": "way/588761092"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/588761093",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5552294,
              22.1299844
            ],
            [
              113.5553836,
              22.1300241
            ],
            [
              113.5553609,
              22.1300998
            ],
            [
              113.5552067,
              22.1300601
            ],
            [
              113.5552294,
              22.1299844
            ]
          ]
        ]
      },
      "id": "way/588761093"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/588761094",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5554472,
              22.1295292
            ],
            [
              113.5556089,
              22.1295711
            ],
            [
              113.5556456,
              22.1294499
            ],
            [
              113.5557852,
              22.1294861
            ],
            [
              113.5556856,
              22.1298161
            ],
            [
              113.5554853,
              22.1297642
            ],
            [
              113.5555267,
              22.1296269
            ],
            [
              113.5554257,
              22.1296007
            ],
            [
              113.5554472,
              22.1295292
            ]
          ]
        ]
      },
      "id": "way/588761094"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/588761095",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5551234,
              22.1296991
            ],
            [
              113.5554345,
              22.1297836
            ],
            [
              113.5553862,
              22.1299798
            ],
            [
              113.5551287,
              22.1299103
            ],
            [
              113.5551234,
              22.1296991
            ]
          ]
        ]
      },
      "id": "way/588761095"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/588761096",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5572396,
              22.1298412
            ],
            [
              113.5571479,
              22.1301704
            ],
            [
              113.55695,
              22.1301231
            ],
            [
              113.5570417,
              22.1297939
            ],
            [
              113.5572396,
              22.1298412
            ]
          ]
        ]
      },
      "id": "way/588761096"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/588761097",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5567662,
              22.1299178
            ],
            [
              113.5568123,
              22.1297514
            ],
            [
              113.557005,
              22.1297972
            ],
            [
              113.5569589,
              22.1299636
            ],
            [
              113.5567662,
              22.1299178
            ]
          ]
        ]
      },
      "id": "way/588761097"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/588761098",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5564953,
              22.1296891
            ],
            [
              113.5567554,
              22.129751
            ],
            [
              113.5566519,
              22.1301243
            ],
            [
              113.5563918,
              22.1300624
            ],
            [
              113.5564953,
              22.1296891
            ]
          ]
        ]
      },
      "id": "way/588761098"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/588761101",
        "addr:housenumber": "120-136",
        "addr:street": "柏樹街 Rua de Cipreste",
        "building": "yes",
        "height": "16.3"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5561088,
              22.1309856
            ],
            [
              113.556641,
              22.1309643
            ],
            [
              113.556669,
              22.1315641
            ],
            [
              113.5563092,
              22.1315785
            ],
            [
              113.5563004,
              22.1313901
            ],
            [
              113.556128,
              22.131397
            ],
            [
              113.5561088,
              22.1309856
            ]
          ]
        ]
      },
      "id": "way/588761101"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/608088617",
        "leisure": "park",
        "name": "棕櫚公園 Parque das Palmeiras",
        "name:en": "Palmeiras Park",
        "name:pt": "Parque das Palmeiras",
        "name:zh": "棕櫚公園",
        "opening_hours": "06:00-24:00",
        "wikidata": "Q124692056"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5569247,
              22.1279596
            ],
            [
              113.5568643,
              22.1279323
            ],
            [
              113.5567731,
              22.1278702
            ],
            [
              113.5566953,
              22.1278006
            ],
            [
              113.5566082,
              22.1277137
            ],
            [
              113.5565357,
              22.1276149
            ],
            [
              113.5564848,
              22.1275211
            ],
            [
              113.5564405,
              22.1274155
            ],
            [
              113.5564298,
              22.1273348
            ],
            [
              113.5564432,
              22.1272726
            ],
            [
              113.55647,
              22.1272105
            ],
            [
              113.556517,
              22.1271608
            ],
            [
              113.5565854,
              22.1271223
            ],
            [
              113.5566712,
              22.1271037
            ],
            [
              113.556749,
              22.1270987
            ],
            [
              113.5568415,
              22.1271074
            ],
            [
              113.5569314,
              22.1271323
            ],
            [
              113.5570386,
              22.1271844
            ],
            [
              113.5571553,
              22.1272627
            ],
            [
              113.5572707,
              22.1273484
            ],
            [
              113.5573484,
              22.1274329
            ],
            [
              113.5572975,
              22.1274571
            ],
            [
              113.5572063,
              22.1275186
            ],
            [
              113.5571339,
              22.1275783
            ],
            [
              113.5570668,
              22.1276429
            ],
            [
              113.5570118,
              22.1277211
            ],
            [
              113.5569729,
              22.1277919
            ],
            [
              113.5569501,
              22.1278627
            ],
            [
              113.5569247,
              22.1279596
            ]
          ]
        ]
      },
      "id": "way/608088617"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/655515126",
        "amenity": "parking"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5469753,
              22.134646
            ],
            [
              113.546978,
              22.1344932
            ],
            [
              113.5471819,
              22.1344944
            ],
            [
              113.5471794,
              22.134646
            ],
            [
              113.5471153,
              22.1346485
            ],
            [
              113.5471175,
              22.1346932
            ],
            [
              113.5470786,
              22.1346633
            ],
            [
              113.5470517,
              22.1346543
            ],
            [
              113.5470303,
              22.1346472
            ],
            [
              113.5469753,
              22.134646
            ]
          ]
        ]
      },
      "id": "way/655515126"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/656124519",
        "amenity": "sport",
        "leisure": "pitch",
        "lit": "yes",
        "name": "7號網球場（亦稱TE7） Tennis Court 7 (aka TE7)",
        "name:en": "Tennis Court 7 (aka TE7)",
        "name:zh": "7號網球場（亦稱TE7）",
        "ref": "TE7",
        "sport": "tennis",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5405286,
              22.1335448
            ],
            [
              113.5405275,
              22.1331755
            ],
            [
              113.54072,
              22.1331751
            ],
            [
              113.540721,
              22.1335443
            ],
            [
              113.5405286,
              22.1335448
            ]
          ]
        ]
      },
      "id": "way/656124519"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/656124520",
        "amenity": "sport",
        "leisure": "pitch",
        "lit": "yes",
        "name": "8號網球場（亦稱TE8） Tennis Court 8 (aka TE8)",
        "name:en": "Tennis Court 8 (aka TE8)",
        "name:zh": "8號網球場（亦稱TE8）",
        "ref": "TE8",
        "sport": "tennis",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.540727,
              22.1333094
            ],
            [
              113.5407256,
              22.1329506
            ],
            [
              113.5408221,
              22.1329503
            ],
            [
              113.540922,
              22.1329499
            ],
            [
              113.5409223,
              22.1330366
            ],
            [
              113.5409233,
              22.1333088
            ],
            [
              113.540727,
              22.1333094
            ]
          ]
        ]
      },
      "id": "way/656124520"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/656124521",
        "amenity": "sport",
        "leisure": "pitch",
        "lit": "yes",
        "name": "9號網球場（亦稱TE9） Tennis Court 9 (aka TE9)",
        "name:en": "Tennis Court 9 (aka TE9)",
        "name:zh": "9號網球場（亦稱TE9）",
        "ref": "TE9",
        "sport": "tennis",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5416544,
              22.1332393
            ],
            [
              113.5416481,
              22.1329066
            ],
            [
              113.5417363,
              22.1329052
            ],
            [
              113.5418299,
              22.1329037
            ],
            [
              113.5418317,
              22.1329988
            ],
            [
              113.5418361,
              22.1332364
            ],
            [
              113.5416544,
              22.1332393
            ]
          ]
        ]
      },
      "id": "way/656124521"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/664646615",
        "addr:housenumber": "139",
        "addr:street": "彩虹路",
        "building": "hotel",
        "building:levels": "12",
        "layer": "1",
        "name": "珠海大横琴高级人才公寓酒店",
        "name:zh": "珠海大横琴高级人才公寓酒店",
        "start_date": "2016"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5360758,
              22.1293087
            ],
            [
              113.535658,
              22.1292748
            ],
            [
              113.535679,
              22.1290524
            ],
            [
              113.5360968,
              22.1290862
            ],
            [
              113.5360758,
              22.1293087
            ]
          ]
        ]
      },
      "id": "way/664646615"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/664646616",
        "leisure": "pitch",
        "sport": "tennis"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5379028,
              22.128816
            ],
            [
              113.5381531,
              22.1285905
            ],
            [
              113.5382786,
              22.1287101
            ],
            [
              113.5380283,
              22.1289355
            ],
            [
              113.5379028,
              22.128816
            ]
          ]
        ]
      },
      "id": "way/664646616"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/664646637",
        "leisure": "swimming_pool"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.537405,
              22.1285289
            ],
            [
              113.537442,
              22.1285108
            ],
            [
              113.5374704,
              22.1284906
            ],
            [
              113.5374791,
              22.1284623
            ],
            [
              113.5374856,
              22.1284118
            ],
            [
              113.5375052,
              22.1283775
            ],
            [
              113.5375292,
              22.1283694
            ],
            [
              113.5375554,
              22.1283775
            ],
            [
              113.5375685,
              22.1283957
            ],
            [
              113.5375706,
              22.12843
            ],
            [
              113.537575,
              22.1284562
            ],
            [
              113.5375924,
              22.1284785
            ],
            [
              113.5375924,
              22.1285027
            ],
            [
              113.5375837,
              22.128535
            ],
            [
              113.5375641,
              22.1285613
            ],
            [
              113.5375445,
              22.1285714
            ],
            [
              113.5375227,
              22.1285714
            ],
            [
              113.5375074,
              22.1285835
            ],
            [
              113.5374943,
              22.1285976
            ],
            [
              113.5374834,
              22.1286239
            ],
            [
              113.5374595,
              22.128642
            ],
            [
              113.5374202,
              22.1286501
            ],
            [
              113.5373919,
              22.12864
            ],
            [
              113.5373723,
              22.1286158
            ],
            [
              113.5373592,
              22.1285915
            ],
            [
              113.537363,
              22.1285716
            ],
            [
              113.5373708,
              22.1285507
            ],
            [
              113.537405,
              22.1285289
            ]
          ]
        ]
      },
      "id": "way/664646637"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/664646638",
        "leisure": "swimming_pool"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5373605,
              22.1286846
            ],
            [
              113.5373669,
              22.12869
            ],
            [
              113.5373711,
              22.128697
            ],
            [
              113.5373724,
              22.128705
            ],
            [
              113.5373709,
              22.1287129
            ],
            [
              113.5373668,
              22.1287197
            ],
            [
              113.5373606,
              22.128725
            ],
            [
              113.5373529,
              22.1287281
            ],
            [
              113.5373445,
              22.1287288
            ],
            [
              113.5373363,
              22.1287269
            ],
            [
              113.5373291,
              22.1287227
            ],
            [
              113.5373239,
              22.1287166
            ],
            [
              113.537321,
              22.1287092
            ],
            [
              113.5373208,
              22.1287014
            ],
            [
              113.5373233,
              22.128694
            ],
            [
              113.5373283,
              22.1286877
            ],
            [
              113.5373354,
              22.1286831
            ],
            [
              113.5373438,
              22.1286809
            ],
            [
              113.5373525,
              22.1286814
            ],
            [
              113.5373605,
              22.1286846
            ]
          ]
        ]
      },
      "id": "way/664646638"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/664646639",
        "leisure": "sports_centre",
        "sport": "swimming"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.537294,
              22.1287426
            ],
            [
              113.5372791,
              22.128728
            ],
            [
              113.5372849,
              22.1286006
            ],
            [
              113.5372956,
              22.1285753
            ],
            [
              113.5373155,
              22.1285338
            ],
            [
              113.537357,
              22.1284985
            ],
            [
              113.537405,
              22.1284578
            ],
            [
              113.5374398,
              22.1284317
            ],
            [
              113.537458,
              22.1284018
            ],
            [
              113.5374738,
              22.1283695
            ],
            [
              113.5374912,
              22.1283588
            ],
            [
              113.5375127,
              22.1283519
            ],
            [
              113.5375417,
              22.1283488
            ],
            [
              113.5375674,
              22.1283611
            ],
            [
              113.5375848,
              22.1283742
            ],
            [
              113.5375931,
              22.1283972
            ],
            [
              113.5375915,
              22.1284156
            ],
            [
              113.5375973,
              22.1284348
            ],
            [
              113.5376064,
              22.1284463
            ],
            [
              113.5376155,
              22.1284724
            ],
            [
              113.5376213,
              22.1285062
            ],
            [
              113.5376105,
              22.1285399
            ],
            [
              113.5375832,
              22.1285707
            ],
            [
              113.5375492,
              22.128586
            ],
            [
              113.5375243,
              22.1285952
            ],
            [
              113.5375036,
              22.1286213
            ],
            [
              113.5374829,
              22.1286459
            ],
            [
              113.5374448,
              22.1286643
            ],
            [
              113.5374257,
              22.1286835
            ],
            [
              113.5374116,
              22.1287288
            ],
            [
              113.5373851,
              22.1287602
            ],
            [
              113.537342,
              22.1287679
            ],
            [
              113.5373147,
              22.1287602
            ],
            [
              113.537294,
              22.1287426
            ]
          ]
        ]
      },
      "id": "way/664646639"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/666222749",
        "building": "yes",
        "height": "19.9"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5529118,
              22.1204259
            ],
            [
              113.5529053,
              22.1204029
            ],
            [
              113.5529461,
              22.120393
            ],
            [
              113.5531494,
              22.1203438
            ],
            [
              113.5531701,
              22.1204173
            ],
            [
              113.5531924,
              22.1204964
            ],
            [
              113.5529949,
              22.1205442
            ],
            [
              113.5529583,
              22.1204146
            ],
            [
              113.5529118,
              22.1204259
            ]
          ]
        ]
      },
      "id": "way/666222749"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/666222750",
        "building": "yes",
        "height": "23.9"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5524713,
              22.1206848
            ],
            [
              113.5524311,
              22.1205183
            ],
            [
              113.5527811,
              22.1204459
            ],
            [
              113.5528212,
              22.1206123
            ],
            [
              113.5524713,
              22.1206848
            ]
          ]
        ]
      },
      "id": "way/666222750"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/666225602",
        "amenity": "toilets",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5521226,
              22.1357582
            ],
            [
              113.5521186,
              22.1356328
            ],
            [
              113.55221,
              22.1356303
            ],
            [
              113.5522116,
              22.1356806
            ],
            [
              113.5521594,
              22.135682
            ],
            [
              113.5521618,
              22.1357571
            ],
            [
              113.5521226,
              22.1357582
            ]
          ]
        ]
      },
      "id": "way/666225602"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/679638314",
        "building": "yes",
        "height": "8.3"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5537041,
              22.1308497
            ],
            [
              113.5536973,
              22.1307167
            ],
            [
              113.5538007,
              22.1307122
            ],
            [
              113.5538075,
              22.1308452
            ],
            [
              113.5537041,
              22.1308497
            ]
          ]
        ]
      },
      "id": "way/679638314"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/679638316",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5522372,
              22.1323813
            ],
            [
              113.552224,
              22.1323559
            ],
            [
              113.5522517,
              22.1323435
            ],
            [
              113.5522649,
              22.1323689
            ],
            [
              113.5522372,
              22.1323813
            ]
          ]
        ]
      },
      "id": "way/679638316"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/679638318",
        "building": "roof"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5523659,
              22.1324553
            ],
            [
              113.5523653,
              22.132418
            ],
            [
              113.5523646,
              22.1323714
            ],
            [
              113.5524719,
              22.1323701
            ],
            [
              113.5524719,
              22.1324164
            ],
            [
              113.5524719,
              22.1324547
            ],
            [
              113.5523659,
              22.1324553
            ]
          ]
        ]
      },
      "id": "way/679638318"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/692621645",
        "addr:housenumber": "258-302",
        "addr:street": "榕樹街 Rua das Árvores do Pagode",
        "building": "yes",
        "height": "14.2",
        "name": "南岸都匯 The Veranda",
        "name:en": "The Veranda",
        "name:zh": "南岸都匯",
        "shop": "mall"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5574574,
              22.1293474
            ],
            [
              113.557519,
              22.1291909
            ],
            [
              113.5575566,
              22.1290766
            ],
            [
              113.5575888,
              22.128935
            ],
            [
              113.5576076,
              22.1287909
            ],
            [
              113.5576827,
              22.1287951
            ],
            [
              113.5576797,
              22.1289014
            ],
            [
              113.557755,
              22.1289075
            ],
            [
              113.5577551,
              22.1287992
            ],
            [
              113.5578436,
              22.1288033
            ],
            [
              113.5578382,
              22.1290319
            ],
            [
              113.5578516,
              22.1291238
            ],
            [
              113.5578811,
              22.1292431
            ],
            [
              113.5579214,
              22.1293673
            ],
            [
              113.5578221,
              22.1294319
            ],
            [
              113.5577792,
              22.1293201
            ],
            [
              113.5577551,
              22.1292207
            ],
            [
              113.557747,
              22.1291412
            ],
            [
              113.5576666,
              22.1291387
            ],
            [
              113.5576478,
              22.1292207
            ],
            [
              113.5576022,
              22.1293697
            ],
            [
              113.5574916,
              22.1293527
            ],
            [
              113.5574574,
              22.1293474
            ]
          ]
        ]
      },
      "id": "way/692621645"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/768988134",
        "amenity": "parking"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5552033,
              22.1252922
            ],
            [
              113.5549013,
              22.1250568
            ],
            [
              113.5550678,
              22.1248604
            ],
            [
              113.5552756,
              22.1250703
            ],
            [
              113.5553306,
              22.1251548
            ],
            [
              113.5552033,
              22.1252922
            ]
          ]
        ]
      },
      "id": "way/768988134"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/771930213",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5517914,
              22.1244421
            ],
            [
              113.5517893,
              22.1243131
            ],
            [
              113.5518574,
              22.1243103
            ],
            [
              113.5518605,
              22.1244421
            ],
            [
              113.5517914,
              22.1244421
            ]
          ]
        ]
      },
      "id": "way/771930213"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/799382586",
        "building": "roof"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5570504,
              22.1255109
            ],
            [
              113.5569716,
              22.1255907
            ],
            [
              113.5569348,
              22.1255595
            ],
            [
              113.5570136,
              22.1254796
            ],
            [
              113.5570504,
              22.1255109
            ]
          ]
        ]
      },
      "id": "way/799382586"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/799382589",
        "building": "roof"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5568318,
              22.1257091
            ],
            [
              113.5568955,
              22.1255915
            ],
            [
              113.556985,
              22.1256331
            ],
            [
              113.5569213,
              22.1257507
            ],
            [
              113.5568318,
              22.1257091
            ]
          ]
        ]
      },
      "id": "way/799382589"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/799382590",
        "access": "yes",
        "amenity": "toilets",
        "asset_ref": "JC2",
        "building": "yes",
        "name": "JC2 石排灣郊野公園公廁 JC2 Sanitários públicos do Parque de Seac Pai Van",
        "name:en": "JC2 Public toilet at Seac Pai Van Park",
        "name:pt": "JC2 Sanitários públicos do Parque de Seac Pai Van",
        "name:zh": "JC2 石排灣郊野公園公廁",
        "unisex": "yes",
        "wheelchair": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5567122,
              22.1256761
            ],
            [
              113.5567591,
              22.1256097
            ],
            [
              113.5568152,
              22.1256437
            ],
            [
              113.5567683,
              22.1257101
            ],
            [
              113.5567122,
              22.1256761
            ]
          ]
        ]
      },
      "id": "way/799382590"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/804918779",
        "fee": "yes",
        "leisure": "marina",
        "name": "路環遊艇停泊區 Yacht Berthing Area in Coloane",
        "name:en": "Yacht Berthing Area in Coloane",
        "name:pt": "Zona de Atracação de Embarcações de Recreio de Coloane",
        "name:zh": "路環遊艇停泊區",
        "seamark:harbour:category": "marina",
        "seamark:type": "harbour",
        "website": "https://bo.io.gov.mo/bo/i/2021/39/ordem42_cn.asp",
        "wikidata": "Q109411109"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5495779,
              22.1275578
            ],
            [
              113.5495797,
              22.1254782
            ],
            [
              113.5514147,
              22.1254797
            ],
            [
              113.5514126,
              22.1275592
            ],
            [
              113.5495779,
              22.1275578
            ]
          ]
        ]
      },
      "id": "way/804918779"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/818519282",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5543681,
              22.1202002
            ],
            [
              113.5543274,
              22.1201362
            ],
            [
              113.5545616,
              22.1200264
            ],
            [
              113.5545451,
              22.1200018
            ],
            [
              113.5545769,
              22.119987
            ],
            [
              113.5546335,
              22.1200625
            ],
            [
              113.5543681,
              22.1202002
            ]
          ]
        ]
      },
      "id": "way/818519282"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/823025636",
        "amenity": "shelter",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5570924,
              22.1260258
            ],
            [
              113.5570931,
              22.1259953
            ],
            [
              113.5571186,
              22.1259755
            ],
            [
              113.5571481,
              22.1259724
            ],
            [
              113.5571635,
              22.1259953
            ],
            [
              113.5571778,
              22.1260005
            ],
            [
              113.557191,
              22.1260053
            ],
            [
              113.5572141,
              22.1259891
            ],
            [
              113.5572366,
              22.1259896
            ],
            [
              113.5572491,
              22.1259985
            ],
            [
              113.5572467,
              22.1260163
            ],
            [
              113.5572278,
              22.1260264
            ],
            [
              113.5572116,
              22.1260246
            ],
            [
              113.5571977,
              22.1260488
            ],
            [
              113.5571793,
              22.1260545
            ],
            [
              113.5571581,
              22.1260494
            ],
            [
              113.5571474,
              22.1260323
            ],
            [
              113.5571333,
              22.1260432
            ],
            [
              113.5571058,
              22.1260438
            ],
            [
              113.5570924,
              22.1260258
            ]
          ]
        ]
      },
      "id": "way/823025636"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/824234536",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5548118,
              22.1290315
            ],
            [
              113.5548114,
              22.1289799
            ],
            [
              113.5548226,
              22.12898
            ],
            [
              113.5548227,
              22.128945
            ],
            [
              113.5548654,
              22.1289424
            ],
            [
              113.5548666,
              22.1289767
            ],
            [
              113.554876,
              22.1289763
            ],
            [
              113.5548783,
              22.129029
            ],
            [
              113.5548118,
              22.1290315
            ]
          ]
        ]
      },
      "id": "way/824234536"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/825690355",
        "leisure": "nature_reserve",
        "name": "路氹城生態保護二區 Zona Ecológica II do Cotai",
        "name:en": "Cotai Ecological Conservation Zone II",
        "name:pt": "Zona Ecológica II do Cotai",
        "name:zh": "路氹城生態保護二區",
        "name:zh-Hans": "路凼城生态保护二区",
        "name:zh-Hant": "路氹城生態保護二區"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5495269,
              22.1477724
            ],
            [
              113.5495279,
              22.1477207
            ],
            [
              113.5495199,
              22.1475838
            ],
            [
              113.5495479,
              22.1473985
            ],
            [
              113.5496199,
              22.1472704
            ],
            [
              113.5496756,
              22.1471451
            ],
            [
              113.5497257,
              22.1469343
            ],
            [
              113.549735,
              22.1467432
            ],
            [
              113.54988,
              22.1462029
            ],
            [
              113.5499551,
              22.1459893
            ],
            [
              113.550041,
              22.1458104
            ],
            [
              113.5502019,
              22.1455222
            ],
            [
              113.5503092,
              22.1453359
            ],
            [
              113.5503736,
              22.1451496
            ],
            [
              113.5504272,
              22.1448713
            ],
            [
              113.5504073,
              22.1447691
            ],
            [
              113.5503666,
              22.1446725
            ],
            [
              113.5502703,
              22.1445692
            ],
            [
              113.5502738,
              22.1444977
            ],
            [
              113.550331,
              22.1444042
            ],
            [
              113.5503924,
              22.144049
            ],
            [
              113.5504326,
              22.1435745
            ],
            [
              113.5504218,
              22.1430478
            ],
            [
              113.5504351,
              22.1430165
            ],
            [
              113.5504617,
              22.1429541
            ],
            [
              113.5504916,
              22.1428838
            ],
            [
              113.5505881,
              22.1427149
            ],
            [
              113.5508188,
              22.1424515
            ],
            [
              113.55091,
              22.1423074
            ],
            [
              113.5509315,
              22.1420988
            ],
            [
              113.5509247,
              22.1420227
            ],
            [
              113.5508993,
              22.141736
            ],
            [
              113.5508832,
              22.1413733
            ],
            [
              113.550843,
              22.1410355
            ],
            [
              113.5507785,
              22.1405957
            ],
            [
              113.5508456,
              22.1400118
            ],
            [
              113.550792,
              22.1383473
            ],
            [
              113.5507544,
              22.1379994
            ],
            [
              113.5507544,
              22.1376069
            ],
            [
              113.5507866,
              22.137264
            ],
            [
              113.5508188,
              22.1370205
            ],
            [
              113.5508885,
              22.1365187
            ],
            [
              113.5508832,
              22.1353311
            ],
            [
              113.5509422,
              22.1352267
            ],
            [
              113.551028,
              22.1351025
            ],
            [
              113.5511621,
              22.1348988
            ],
            [
              113.5512587,
              22.1347199
            ],
            [
              113.5514035,
              22.1314005
            ],
            [
              113.5513606,
              22.1311819
            ],
            [
              113.5512587,
              22.1310129
            ],
            [
              113.5511246,
              22.1308937
            ],
            [
              113.5508617,
              22.1307446
            ],
            [
              113.5507705,
              22.130521
            ],
            [
              113.5507759,
              22.1302824
            ],
            [
              113.5508403,
              22.1301483
            ],
            [
              113.5509368,
              22.130024
            ],
            [
              113.5510173,
              22.1298302
            ],
            [
              113.5510441,
              22.1294327
            ],
            [
              113.5510548,
              22.1283146
            ],
            [
              113.5511031,
              22.128091
            ],
            [
              113.5511836,
              22.1279866
            ],
            [
              113.5512801,
              22.1279071
            ],
            [
              113.551366,
              22.1278773
            ],
            [
              113.5515057,
              22.1278977
            ],
            [
              113.5514789,
              22.1281791
            ],
            [
              113.5514487,
              22.1282965
            ],
            [
              113.551438,
              22.1283388
            ],
            [
              113.5514293,
              22.1283649
            ],
            [
              113.5514179,
              22.1283959
            ],
            [
              113.5514098,
              22.1284829
            ],
            [
              113.5514134,
              22.1285729
            ],
            [
              113.5514085,
              22.1288692
            ],
            [
              113.5514179,
              22.1289823
            ],
            [
              113.5514373,
              22.1290717
            ],
            [
              113.5514588,
              22.1291208
            ],
            [
              113.5515185,
              22.1292158
            ],
            [
              113.5515996,
              22.1293345
            ],
            [
              113.5516942,
              22.1295034
            ],
            [
              113.5517026,
              22.1295193
            ],
            [
              113.5516948,
              22.1295252
            ],
            [
              113.5516814,
              22.1295426
            ],
            [
              113.5516754,
              22.1295562
            ],
            [
              113.5516781,
              22.1295767
            ],
            [
              113.5516841,
              22.1295954
            ],
            [
              113.5516942,
              22.1296115
            ],
            [
              113.5517056,
              22.1296196
            ],
            [
              113.5517156,
              22.1296227
            ],
            [
              113.5517351,
              22.1296264
            ],
            [
              113.5517478,
              22.1296305
            ],
            [
              113.5517559,
              22.1296612
            ],
            [
              113.5517813,
              22.1297774
            ],
            [
              113.5518291,
              22.1300115
            ],
            [
              113.5518175,
              22.130296
            ],
            [
              113.5518182,
              22.1306203
            ],
            [
              113.5518229,
              22.1312563
            ],
            [
              113.5518269,
              22.1318197
            ],
            [
              113.5518202,
              22.132534
            ],
            [
              113.5518336,
              22.1329005
            ],
            [
              113.5518551,
              22.1341403
            ],
            [
              113.5518505,
              22.1345968
            ],
            [
              113.5518524,
              22.135036
            ],
            [
              113.5518571,
              22.1352012
            ],
            [
              113.5518631,
              22.1356801
            ],
            [
              113.5519141,
              22.1380248
            ],
            [
              113.5519042,
              22.1407465
            ],
            [
              113.5518752,
              22.1412049
            ],
            [
              113.5518807,
              22.1416366
            ],
            [
              113.5518834,
              22.1419626
            ],
            [
              113.5519034,
              22.1428904
            ],
            [
              113.5519037,
              22.142904
            ],
            [
              113.551906,
              22.1430123
            ],
            [
              113.5518991,
              22.1441831
            ],
            [
              113.5519013,
              22.1442987
            ],
            [
              113.5518868,
              22.1444266
            ],
            [
              113.5518618,
              22.1445092
            ],
            [
              113.5518306,
              22.1445598
            ],
            [
              113.5518168,
              22.1445976
            ],
            [
              113.551816,
              22.1446426
            ],
            [
              113.5518011,
              22.1446782
            ],
            [
              113.5517842,
              22.1447004
            ],
            [
              113.5516918,
              22.1448214
            ],
            [
              113.5515401,
              22.145024
            ],
            [
              113.5514494,
              22.1450672
            ],
            [
              113.5513645,
              22.1451861
            ],
            [
              113.5513657,
              22.1452522
            ],
            [
              113.5511103,
              22.1455978
            ],
            [
              113.5510056,
              22.1456637
            ],
            [
              113.5509234,
              22.1457662
            ],
            [
              113.5509005,
              22.1458684
            ],
            [
              113.5501882,
              22.1468021
            ],
            [
              113.5498275,
              22.147268
            ],
            [
              113.5497127,
              22.1475686
            ],
            [
              113.549639,
              22.1477636
            ],
            [
              113.5495269,
              22.1477724
            ]
          ]
        ]
      },
      "id": "way/825690355"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/827556759",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5427024,
              22.1261677
            ],
            [
              113.5427015,
              22.1260487
            ],
            [
              113.5428388,
              22.1260479
            ],
            [
              113.5428397,
              22.1261669
            ],
            [
              113.5427024,
              22.1261677
            ]
          ]
        ]
      },
      "id": "way/827556759"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/827774634",
        "amenity": "sport",
        "hoops": "2",
        "leisure": "pitch",
        "lit": "yes",
        "name": "11號室外籃球場（亦稱BA11） Outdoor Basketball Court no. 11 (aka BA11)",
        "name:en": "Outdoor Basketball Court no. 11 (aka BA11)",
        "name:zh": "11號室外籃球場（亦稱BA11）",
        "ref": "BA11",
        "sport": "basketball",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5440333,
              22.1241234
            ],
            [
              113.5440329,
              22.1238559
            ],
            [
              113.5441763,
              22.1238557
            ],
            [
              113.5441767,
              22.1241232
            ],
            [
              113.5440333,
              22.1241234
            ]
          ]
        ]
      },
      "id": "way/827774634"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/827774635",
        "amenity": "sport",
        "hoops": "2",
        "leisure": "pitch",
        "lit": "yes",
        "name": "12號室外籃球場（亦稱BA12） Outdoor Basketball Court no. 12 (aka BA12)",
        "name:en": "Outdoor Basketball Court no. 12 (aka BA12)",
        "name:zh": "12號室外籃球場（亦稱BA12）",
        "ref": "BA12",
        "sport": "basketball",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5423314,
              22.1234678
            ],
            [
              113.5423338,
              22.123182
            ],
            [
              113.5424979,
              22.1231831
            ],
            [
              113.5424956,
              22.123469
            ],
            [
              113.5423541,
              22.123468
            ],
            [
              113.5423314,
              22.1234678
            ]
          ]
        ]
      },
      "id": "way/827774635"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/827774652",
        "leisure": "pitch",
        "sport": "tennis",
        "website": "https://facility.osa.um.edu.mo/projects/tennis-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/tennis-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/tennis-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5453565,
              22.1225743
            ],
            [
              113.5453503,
              22.1222399
            ],
            [
              113.5455595,
              22.1222366
            ],
            [
              113.5455563,
              22.1225747
            ],
            [
              113.5453565,
              22.1225743
            ]
          ]
        ]
      },
      "id": "way/827774652"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/864687780",
        "building": "yes",
        "name": "泵房",
        "name:zh": "泵房"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5457643,
              22.120857
            ],
            [
              113.5457608,
              22.120765
            ],
            [
              113.5460119,
              22.1207568
            ],
            [
              113.5460154,
              22.1208488
            ],
            [
              113.5457643,
              22.120857
            ]
          ]
        ]
      },
      "id": "way/864687780"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/874125189",
        "building": "yes",
        "name": "消防局路環行動站 Corpo de Bombeiros Posto Operacional de Coloane"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5523279,
              22.1203212
            ],
            [
              113.5521508,
              22.1201796
            ],
            [
              113.5521817,
              22.1201411
            ],
            [
              113.5521495,
              22.120115
            ],
            [
              113.5522179,
              22.120038
            ],
            [
              113.5522219,
              22.1200069
            ],
            [
              113.5523118,
              22.1199137
            ],
            [
              113.5523668,
              22.1199709
            ],
            [
              113.5522662,
              22.120079
            ],
            [
              113.5524043,
              22.1201833
            ],
            [
              113.5523922,
              22.1202007
            ],
            [
              113.5524164,
              22.1202256
            ],
            [
              113.5523279,
              22.1203212
            ]
          ]
        ]
      },
      "id": "way/874125189"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/874125190",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5525036,
              22.1199709
            ],
            [
              113.5525572,
              22.1199286
            ],
            [
              113.5526225,
              22.1200713
            ],
            [
              113.5525607,
              22.1200956
            ],
            [
              113.5525036,
              22.1199709
            ]
          ]
        ]
      },
      "id": "way/874125190"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/874125191",
        "amenity": "fire_station",
        "name": "路環消防行動站 Posto Operacional de Coloane de Corpo de Bombeiros",
        "name:en": "Coloane Fire Station",
        "name:pt": "Posto Operacional de Coloane de Corpo de Bombeiros",
        "name:zh": "路環消防行動站"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5521348,
              22.1201858
            ],
            [
              113.5521629,
              22.1201423
            ],
            [
              113.5521307,
              22.1201187
            ],
            [
              113.5522085,
              22.1200355
            ],
            [
              113.5522085,
              22.1200007
            ],
            [
              113.5523238,
              22.1198938
            ],
            [
              113.5523829,
              22.1199522
            ],
            [
              113.5525331,
              22.1198404
            ],
            [
              113.5526417,
              22.1200777
            ],
            [
              113.5525505,
              22.1201138
            ],
            [
              113.5525197,
              22.1200566
            ],
            [
              113.5524513,
              22.1202243
            ],
            [
              113.5523238,
              22.1203448
            ],
            [
              113.5521348,
              22.1201858
            ]
          ]
        ]
      },
      "id": "way/874125191"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/931437085",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5556712,
              22.1197152
            ],
            [
              113.5556784,
              22.1197121
            ],
            [
              113.5556862,
              22.1197113
            ],
            [
              113.5556945,
              22.119713
            ],
            [
              113.5557017,
              22.1197172
            ],
            [
              113.555707,
              22.1197234
            ],
            [
              113.5557096,
              22.119731
            ],
            [
              113.5557094,
              22.1197389
            ],
            [
              113.5557063,
              22.1197462
            ],
            [
              113.5557007,
              22.1197522
            ],
            [
              113.5556932,
              22.119756
            ],
            [
              113.5556848,
              22.1197573
            ],
            [
              113.555677,
              22.1197561
            ],
            [
              113.5556701,
              22.1197527
            ],
            [
              113.5556646,
              22.1197474
            ],
            [
              113.5556612,
              22.1197409
            ],
            [
              113.5556602,
              22.1197336
            ],
            [
              113.5556617,
              22.1197265
            ],
            [
              113.5556655,
              22.1197201
            ],
            [
              113.5556712,
              22.1197152
            ]
          ]
        ]
      },
      "id": "way/931437085"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/931437086",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5545849,
              22.1198481
            ],
            [
              113.5545921,
              22.1198451
            ],
            [
              113.5545999,
              22.1198442
            ],
            [
              113.5546082,
              22.1198459
            ],
            [
              113.5546154,
              22.1198501
            ],
            [
              113.5546207,
              22.1198564
            ],
            [
              113.5546233,
              22.1198639
            ],
            [
              113.5546231,
              22.1198718
            ],
            [
              113.55462,
              22.1198792
            ],
            [
              113.5546144,
              22.1198851
            ],
            [
              113.5546069,
              22.119889
            ],
            [
              113.5545985,
              22.1198902
            ],
            [
              113.5545907,
              22.119889
            ],
            [
              113.5545838,
              22.1198856
            ],
            [
              113.5545783,
              22.1198804
            ],
            [
              113.5545749,
              22.1198738
            ],
            [
              113.5545739,
              22.1198666
            ],
            [
              113.5545754,
              22.1198594
            ],
            [
              113.5545792,
              22.1198531
            ],
            [
              113.5545849,
              22.1198481
            ]
          ]
        ]
      },
      "id": "way/931437086"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/931895192",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.555171,
              22.119735
            ],
            [
              113.5551443,
              22.1196811
            ],
            [
              113.5550339,
              22.1197281
            ],
            [
              113.5549707,
              22.1196007
            ],
            [
              113.5546053,
              22.1197563
            ],
            [
              113.5545451,
              22.119635
            ],
            [
              113.5549055,
              22.1194812
            ],
            [
              113.554833,
              22.1193354
            ],
            [
              113.554497,
              22.119479
            ],
            [
              113.5544394,
              22.1193635
            ],
            [
              113.5547289,
              22.1192397
            ],
            [
              113.5546748,
              22.1191311
            ],
            [
              113.5543937,
              22.1192515
            ],
            [
              113.5543201,
              22.119104
            ],
            [
              113.5544341,
              22.1190553
            ],
            [
              113.5543846,
              22.1189561
            ],
            [
              113.5544213,
              22.1189404
            ],
            [
              113.5546467,
              22.1189719
            ],
            [
              113.5546439,
              22.1189888
            ],
            [
              113.5546117,
              22.1189988
            ],
            [
              113.5546131,
              22.1190137
            ],
            [
              113.5546826,
              22.1189888
            ],
            [
              113.5547003,
              22.1190312
            ],
            [
              113.5547646,
              22.1190082
            ],
            [
              113.5547818,
              22.1190496
            ],
            [
              113.5548447,
              22.1190271
            ],
            [
              113.5548615,
              22.1190673
            ],
            [
              113.5549765,
              22.1190261
            ],
            [
              113.554998,
              22.1190311
            ],
            [
              113.5550114,
              22.1190522
            ],
            [
              113.555006,
              22.1190659
            ],
            [
              113.5549859,
              22.1190795
            ],
            [
              113.5548618,
              22.1191289
            ],
            [
              113.5548921,
              22.1191942
            ],
            [
              113.5548586,
              22.1192075
            ],
            [
              113.5549028,
              22.1193025
            ],
            [
              113.5548791,
              22.1193119
            ],
            [
              113.5549188,
              22.1193968
            ],
            [
              113.5553153,
              22.1192376
            ],
            [
              113.5553767,
              22.1193686
            ],
            [
              113.5550721,
              22.1194911
            ],
            [
              113.55508,
              22.1195077
            ],
            [
              113.5550618,
              22.1195151
            ],
            [
              113.5550689,
              22.1195299
            ],
            [
              113.555017,
              22.1195516
            ],
            [
              113.5550615,
              22.1196429
            ],
            [
              113.5551174,
              22.1196195
            ],
            [
              113.5550949,
              22.1195736
            ],
            [
              113.5554342,
              22.1194303
            ],
            [
              113.555513,
              22.1195903
            ],
            [
              113.555171,
              22.119735
            ]
          ]
        ]
      },
      "id": "way/931895192"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/941666671",
        "building": "yes",
        "name": "路環天然氣門站",
        "name:zh": "路環天然氣門站"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5526824,
              22.1328372
            ],
            [
              113.5527344,
              22.1327716
            ],
            [
              113.5528001,
              22.1328163
            ],
            [
              113.552748,
              22.132882
            ],
            [
              113.5526824,
              22.1328372
            ]
          ]
        ]
      },
      "id": "way/941666671"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1000516463",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "11栋",
        "name:en": "Block 11",
        "name:zh": "11栋",
        "name:zh-Hans": "11栋",
        "name:zh-Hant": "11棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5351587,
              22.1351206
            ],
            [
              113.5351656,
              22.1350006
            ],
            [
              113.5352759,
              22.135006
            ],
            [
              113.5352708,
              22.1350944
            ],
            [
              113.5352876,
              22.1351408
            ],
            [
              113.5352808,
              22.1352582
            ],
            [
              113.5351211,
              22.1352503
            ],
            [
              113.5351255,
              22.1351736
            ],
            [
              113.5351587,
              22.1351206
            ]
          ]
        ]
      },
      "id": "way/1000516463"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1000516464",
        "addr:housename": "横琴·澳门青年创业谷",
        "addr:housename:zh": "横琴·澳门青年创业谷",
        "building": "commercial",
        "building:levels": "4",
        "name": "22栋",
        "name:en": "Block 22",
        "name:zh": "22栋",
        "name:zh-Hans": "22栋",
        "name:zh-Hant": "22棟"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5358984,
              22.133733
            ],
            [
              113.5359199,
              22.1335616
            ],
            [
              113.5361148,
              22.1335833
            ],
            [
              113.5362096,
              22.1335939
            ],
            [
              113.5362351,
              22.1335946
            ],
            [
              113.5363035,
              22.1335963
            ],
            [
              113.5364805,
              22.1335988
            ],
            [
              113.5366468,
              22.1336162
            ],
            [
              113.536628,
              22.1338448
            ],
            [
              113.5364751,
              22.1338299
            ],
            [
              113.536341,
              22.1338001
            ],
            [
              113.536231,
              22.1337777
            ],
            [
              113.5360909,
              22.1337589
            ],
            [
              113.5358984,
              22.133733
            ]
          ]
        ]
      },
      "id": "way/1000516464"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1009029814",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.54453,
              22.1197876
            ],
            [
              113.544525,
              22.1196934
            ],
            [
              113.5448053,
              22.1196806
            ],
            [
              113.5448103,
              22.1197748
            ],
            [
              113.54453,
              22.1197876
            ]
          ]
        ]
      },
      "id": "way/1009029814"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1017836991",
        "boundary": "national_park",
        "leisure": "nature_reserve",
        "name": "大横琴山森林公园",
        "name:yue-Hant": "大橫琴山森林公園"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.4892212,
              22.1164361
            ],
            [
              113.4880353,
              22.1164693
            ],
            [
              113.4876697,
              22.1162177
            ],
            [
              113.4867576,
              22.1161755
            ],
            [
              113.4865041,
              22.1163417
            ],
            [
              113.4861545,
              22.1164574
            ],
            [
              113.4858563,
              22.1162605
            ],
            [
              113.4857057,
              22.1160921
            ],
            [
              113.4854487,
              22.1155666
            ],
            [
              113.4843618,
              22.1153905
            ],
            [
              113.4834181,
              22.1149933
            ],
            [
              113.4825759,
              22.1145079
            ],
            [
              113.4820198,
              22.1140793
            ],
            [
              113.4818074,
              22.1135629
            ],
            [
              113.4817759,
              22.1131424
            ],
            [
              113.4818998,
              22.1125902
            ],
            [
              113.4814105,
              22.1123733
            ],
            [
              113.4809321,
              22.1120736
            ],
            [
              113.480561,
              22.111689
            ],
            [
              113.4802932,
              22.1115045
            ],
            [
              113.4796807,
              22.1114173
            ],
            [
              113.4789444,
              22.1113018
            ],
            [
              113.4784402,
              22.1109208
            ],
            [
              113.4778456,
              22.1108851
            ],
            [
              113.477082,
              22.1110079
            ],
            [
              113.4762672,
              22.1109174
            ],
            [
              113.4758772,
              22.1107884
            ],
            [
              113.4757968,
              22.1106479
            ],
            [
              113.4757659,
              22.1101875
            ],
            [
              113.4757243,
              22.1097072
            ],
            [
              113.4757153,
              22.1091542
            ],
            [
              113.4758101,
              22.1085916
            ],
            [
              113.4760471,
              22.1082355
            ],
            [
              113.4762291,
              22.1081157
            ],
            [
              113.4769173,
              22.1079814
            ],
            [
              113.4780002,
              22.107995
            ],
            [
              113.4787494,
              22.1080578
            ],
            [
              113.4790995,
              22.1080726
            ],
            [
              113.4792576,
              22.1080336
            ],
            [
              113.4795786,
              22.1075558
            ],
            [
              113.4798627,
              22.1069098
            ],
            [
              113.4800437,
              22.1062671
            ],
            [
              113.4799684,
              22.1054744
            ],
            [
              113.4798044,
              22.104664
            ],
            [
              113.4792199,
              22.104133
            ],
            [
              113.4787475,
              22.1038395
            ],
            [
              113.4780023,
              22.1034717
            ],
            [
              113.477335,
              22.1032988
            ],
            [
              113.4765116,
              22.1028709
            ],
            [
              113.4760851,
              22.1026254
            ],
            [
              113.4754275,
              22.102487
            ],
            [
              113.4745469,
              22.1023512
            ],
            [
              113.4743745,
              22.1022452
            ],
            [
              113.4745184,
              22.1019688
            ],
            [
              113.4741243,
              22.1011425
            ],
            [
              113.4740431,
              22.1006665
            ],
            [
              113.4725866,
              22.0999179
            ],
            [
              113.4721843,
              22.0998327
            ],
            [
              113.4713327,
              22.099662
            ],
            [
              113.4692964,
              22.0995594
            ],
            [
              113.4683744,
              22.0994854
            ],
            [
              113.467774,
              22.0993086
            ],
            [
              113.4675457,
              22.099131
            ],
            [
              113.4674925,
              22.0988826
            ],
            [
              113.4675845,
              22.0983624
            ],
            [
              113.4675342,
              22.098099
            ],
            [
              113.4673045,
              22.097696
            ],
            [
              113.4673089,
              22.0974606
            ],
            [
              113.4673822,
              22.0973391
            ],
            [
              113.4675092,
              22.0972673
            ],
            [
              113.4688882,
              22.0970302
            ],
            [
              113.4693449,
              22.0969971
            ],
            [
              113.4701613,
              22.0966508
            ],
            [
              113.4706879,
              22.0963741
            ],
            [
              113.4711207,
              22.0963335
            ],
            [
              113.4720229,
              22.0964067
            ],
            [
              113.4723639,
              22.0963371
            ],
            [
              113.4732102,
              22.0964553
            ],
            [
              113.4739326,
              22.0970378
            ],
            [
              113.4746952,
              22.0972127
            ],
            [
              113.4752201,
              22.09754
            ],
            [
              113.4782456,
              22.0977388
            ],
            [
              113.4804772,
              22.0976394
            ],
            [
              113.4843713,
              22.0974532
            ],
            [
              113.4876656,
              22.0976791
            ],
            [
              113.4912704,
              22.0984545
            ],
            [
              113.4976434,
              22.0986931
            ],
            [
              113.4995531,
              22.0988521
            ],
            [
              113.5009356,
              22.0990999
            ],
            [
              113.5022568,
              22.0988919
            ],
            [
              113.5027288,
              22.0985142
            ],
            [
              113.5028036,
              22.097634
            ],
            [
              113.5024284,
              22.0972417
            ],
            [
              113.5015487,
              22.0971722
            ],
            [
              113.5007118,
              22.0971622
            ],
            [
              113.4998106,
              22.0967845
            ],
            [
              113.4989952,
              22.0960091
            ],
            [
              113.4976219,
              22.0954325
            ],
            [
              113.4965276,
              22.0951741
            ],
            [
              113.4949182,
              22.0938817
            ],
            [
              113.4943389,
              22.0935437
            ],
            [
              113.4933733,
              22.0918537
            ],
            [
              113.4916996,
              22.0915157
            ],
            [
              113.490734,
              22.090959
            ],
            [
              113.4900259,
              22.089945
            ],
            [
              113.4891247,
              22.088434
            ],
            [
              113.4886311,
              22.0871813
            ],
            [
              113.4876012,
              22.0870819
            ],
            [
              113.4868072,
              22.0874995
            ],
            [
              113.4862708,
              22.0880761
            ],
            [
              113.4863352,
              22.088772
            ],
            [
              113.4867,
              22.0897064
            ],
            [
              113.4865498,
              22.0905415
            ],
            [
              113.4840821,
              22.0903626
            ],
            [
              113.4824299,
              22.090283
            ],
            [
              113.481593,
              22.0898854
            ],
            [
              113.4813355,
              22.0893088
            ],
            [
              113.4811853,
              22.088593
            ],
            [
              113.4812712,
              22.0878971
            ],
            [
              113.4810566,
              22.0871813
            ],
            [
              113.480842,
              22.0865252
            ],
            [
              113.4810995,
              22.086048
            ],
            [
              113.4817218,
              22.0856305
            ],
            [
              113.4824513,
              22.0853521
            ],
            [
              113.4830522,
              22.0848152
            ],
            [
              113.484125,
              22.0839801
            ],
            [
              113.4846678,
              22.083509
            ],
            [
              113.4851121,
              22.083145
            ],
            [
              113.4859489,
              22.0830655
            ],
            [
              113.4870218,
              22.0835029
            ],
            [
              113.4880518,
              22.0838211
            ],
            [
              113.4888743,
              22.0837075
            ],
            [
              113.4894036,
              22.0832643
            ],
            [
              113.4903692,
              22.082986
            ],
            [
              113.4919785,
              22.0819321
            ],
            [
              113.4928154,
              22.0810175
            ],
            [
              113.4923648,
              22.0803215
            ],
            [
              113.4933304,
              22.0799437
            ],
            [
              113.4940385,
              22.0799239
            ],
            [
              113.4946822,
              22.0803414
            ],
            [
              113.4971069,
              22.0789098
            ],
            [
              113.4982656,
              22.077498
            ],
            [
              113.4992527,
              22.07543
            ],
            [
              113.4986519,
              22.0744756
            ],
            [
              113.5000466,
              22.072845
            ],
            [
              113.5010122,
              22.0719701
            ],
            [
              113.5029649,
              22.0714928
            ],
            [
              113.5047888,
              22.0722484
            ],
            [
              113.5068916,
              22.0728251
            ],
            [
              113.5076641,
              22.0735211
            ],
            [
              113.5086512,
              22.0752908
            ],
            [
              113.5088014,
              22.0759868
            ],
            [
              113.5083937,
              22.076643
            ],
            [
              113.5084151,
              22.0774582
            ],
            [
              113.5103034,
              22.0784922
            ],
            [
              113.5129641,
              22.0795461
            ],
            [
              113.5133075,
              22.0801227
            ],
            [
              113.513286,
              22.0807391
            ],
            [
              113.5129856,
              22.0826082
            ],
            [
              113.5132002,
              22.0839205
            ],
            [
              113.5133075,
              22.0854316
            ],
            [
              113.5128998,
              22.0892094
            ],
            [
              113.5154962,
              22.090283
            ],
            [
              113.5214399,
              22.0921321
            ],
            [
              113.523178,
              22.0917146
            ],
            [
              113.5283922,
              22.0896667
            ],
            [
              113.5287355,
              22.0893287
            ],
            [
              113.5289287,
              22.0890702
            ],
            [
              113.5293364,
              22.0871018
            ],
            [
              113.5293149,
              22.0855708
            ],
            [
              113.5296797,
              22.0848152
            ],
            [
              113.5310101,
              22.0839801
            ],
            [
              113.5322546,
              22.0833041
            ],
            [
              113.5340785,
              22.0831848
            ],
            [
              113.5354947,
              22.0837614
            ],
            [
              113.5371899,
              22.0842386
            ],
            [
              113.5393571,
              22.0849147
            ],
            [
              113.5412239,
              22.0853123
            ],
            [
              113.5432624,
              22.0869229
            ],
            [
              113.5430693,
              22.0878971
            ],
            [
              113.5418462,
              22.0880164
            ],
            [
              113.5395717,
              22.0880562
            ],
            [
              113.5388206,
              22.0884141
            ],
            [
              113.5377478,
              22.0891298
            ],
            [
              113.5374474,
              22.0899848
            ],
            [
              113.5376834,
              22.0905017
            ],
            [
              113.5378121,
              22.0908994
            ],
            [
              113.5374474,
              22.0918736
            ],
            [
              113.5367822,
              22.0931063
            ],
            [
              113.5360526,
              22.0935835
            ],
            [
              113.5351299,
              22.0938221
            ],
            [
              113.5309886,
              22.0925297
            ],
            [
              113.5297226,
              22.091973
            ],
            [
              113.5276627,
              22.0926093
            ],
            [
              113.5260533,
              22.0930864
            ],
            [
              113.5262035,
              22.0937028
            ],
            [
              113.526461,
              22.0945577
            ],
            [
              113.5265683,
              22.0951343
            ],
            [
              113.5262679,
              22.0956313
            ],
            [
              113.5255383,
              22.0960488
            ],
            [
              113.5248088,
              22.0964664
            ],
            [
              113.5239719,
              22.0964465
            ],
            [
              113.5222124,
              22.0965061
            ],
            [
              113.5200881,
              22.0970032
            ],
            [
              113.5188436,
              22.0975996
            ],
            [
              113.5182427,
              22.0982557
            ],
            [
              113.5181569,
              22.098872
            ],
            [
              113.5185002,
              22.0992895
            ],
            [
              113.5210751,
              22.0999257
            ],
            [
              113.5228347,
              22.100383
            ],
            [
              113.5233711,
              22.1008601
            ],
            [
              113.5235857,
              22.1021524
            ],
            [
              113.5235857,
              22.1029476
            ],
            [
              113.526225,
              22.1045977
            ],
            [
              113.5274266,
              22.1051743
            ],
            [
              113.529272,
              22.1057309
            ],
            [
              113.5298084,
              22.1055122
            ],
            [
              113.5306667,
              22.1054526
            ],
            [
              113.5325121,
              22.1062876
            ],
            [
              113.5334133,
              22.1070629
            ],
            [
              113.5339068,
              22.1082358
            ],
            [
              113.5343145,
              22.1099455
            ],
            [
              113.5339712,
              22.1112377
            ],
            [
              113.533585,
              22.1130467
            ],
            [
              113.5337995,
              22.1135834
            ],
            [
              113.5340141,
              22.1139611
            ],
            [
              113.5364174,
              22.113166
            ],
            [
              113.5372971,
              22.1126491
            ],
            [
              113.5385417,
              22.1125895
            ],
            [
              113.5395073,
              22.1132256
            ],
            [
              113.5403871,
              22.1137027
            ],
            [
              113.5407518,
              22.1140804
            ],
            [
              113.541696,
              22.1155912
            ],
            [
              113.543198,
              22.1196564
            ],
            [
              113.543434,
              22.1202229
            ],
            [
              113.5434019,
              22.1206603
            ],
            [
              113.5432624,
              22.1209485
            ],
            [
              113.54308,
              22.1212367
            ],
            [
              113.5412454,
              22.122499
            ],
            [
              113.5403227,
              22.1229959
            ],
            [
              113.5399579,
              22.1231053
            ],
            [
              113.5395073,
              22.1231351
            ],
            [
              113.5369538,
              22.1225586
            ],
            [
              113.5362028,
              22.1226182
            ],
            [
              113.5357844,
              22.1228767
            ],
            [
              113.535484,
              22.1232842
            ],
            [
              113.5354518,
              22.1248644
            ],
            [
              113.5355054,
              22.1251825
            ],
            [
              113.5355698,
              22.1254707
            ],
            [
              113.5354732,
              22.125739
            ],
            [
              113.5351192,
              22.1259478
            ],
            [
              113.5344218,
              22.1259676
            ],
            [
              113.532791,
              22.1259179
            ],
            [
              113.5324155,
              22.1258484
            ],
            [
              113.5322653,
              22.1256993
            ],
            [
              113.532158,
              22.1255403
            ],
            [
              113.5302912,
              22.122976
            ],
            [
              113.5299908,
              22.1226083
            ],
            [
              113.529744,
              22.1224393
            ],
            [
              113.5292827,
              22.1224791
            ],
            [
              113.5286175,
              22.1226381
            ],
            [
              113.527373,
              22.1231649
            ],
            [
              113.5267185,
              22.1235227
            ],
            [
              113.5265469,
              22.1238109
            ],
            [
              113.5264074,
              22.1245066
            ],
            [
              113.5263967,
              22.1248446
            ],
            [
              113.5261713,
              22.1252322
            ],
            [
              113.5259139,
              22.1253713
            ],
            [
              113.5254632,
              22.1254806
            ],
            [
              113.5253238,
              22.1255602
            ],
            [
              113.5251306,
              22.1256595
            ],
            [
              113.5249483,
              22.1257589
            ],
            [
              113.5246264,
              22.1257689
            ],
            [
              113.5240363,
              22.1256496
            ],
            [
              113.5236715,
              22.1256496
            ],
            [
              113.5232209,
              22.125739
            ],
            [
              113.5226523,
              22.1255303
            ],
            [
              113.5221051,
              22.1252719
            ],
            [
              113.5214828,
              22.1249539
            ],
            [
              113.521043,
              22.1247849
            ],
            [
              113.5206031,
              22.1248545
            ],
            [
              113.5201417,
              22.1248346
            ],
            [
              113.5194229,
              22.1247352
            ],
            [
              113.5188865,
              22.1248446
            ],
            [
              113.5182857,
              22.1249738
            ],
            [
              113.5178887,
              22.1249042
            ],
            [
              113.5173522,
              22.1247154
            ],
            [
              113.5171269,
              22.1244172
            ],
            [
              113.5171162,
              22.1241787
            ],
            [
              113.5171269,
              22.123791
            ],
            [
              113.5171377,
              22.1233637
            ],
            [
              113.5170626,
              22.1229959
            ],
            [
              113.5168158,
              22.122817
            ],
            [
              113.5162794,
              22.1224195
            ],
            [
              113.5156356,
              22.1221014
            ],
            [
              113.5153352,
              22.1216243
            ],
            [
              113.515185,
              22.1212069
            ],
            [
              113.5148846,
              22.1208292
            ],
            [
              113.5142623,
              22.1205509
            ],
            [
              113.5137474,
              22.1205907
            ],
            [
              113.5131895,
              22.1207895
            ],
            [
              113.5125886,
              22.1209286
            ],
            [
              113.5117947,
              22.1208491
            ],
            [
              113.5112153,
              22.1205509
            ],
            [
              113.5096275,
              22.119557
            ],
            [
              113.5085117,
              22.1186028
            ],
            [
              113.5080396,
              22.1184637
            ],
            [
              113.5078036,
              22.1184836
            ],
            [
              113.5028469,
              22.1152433
            ],
            [
              113.5025464,
              22.1150048
            ],
            [
              113.5021388,
              22.1148457
            ],
            [
              113.5018813,
              22.1150048
            ],
            [
              113.5015165,
              22.1157801
            ],
            [
              113.5011517,
              22.1162969
            ],
            [
              113.5008513,
              22.1164758
            ],
            [
              113.5004651,
              22.1165553
            ],
            [
              113.5000144,
              22.1163168
            ],
            [
              113.4995853,
              22.1160782
            ],
            [
              113.498963,
              22.1162373
            ],
            [
              113.4985339,
              22.1167939
            ],
            [
              113.4983407,
              22.1173704
            ],
            [
              113.498448,
              22.1178276
            ],
            [
              113.4986626,
              22.1182053
            ],
            [
              113.4986197,
              22.1185432
            ],
            [
              113.4984051,
              22.1187221
            ],
            [
              113.4980189,
              22.1186426
            ],
            [
              113.4977185,
              22.1185034
            ],
            [
              113.4968172,
              22.1178673
            ],
            [
              113.4954225,
              22.1177282
            ],
            [
              113.4949075,
              22.117589
            ],
            [
              113.4943496,
              22.1171119
            ],
            [
              113.4929978,
              22.1163367
            ],
            [
              113.4898435,
              22.1155813
            ],
            [
              113.4894573,
              22.1153427
            ],
            [
              113.4888135,
              22.1145277
            ],
            [
              113.4884917,
              22.1134343
            ],
            [
              113.4878265,
              22.113156
            ],
            [
              113.4874402,
              22.1132952
            ],
            [
              113.4877407,
              22.1144084
            ],
            [
              113.4881913,
              22.1151241
            ],
            [
              113.4890596,
              22.1159942
            ],
            [
              113.4892212,
              22.1164361
            ]
          ]
        ]
      },
      "id": "way/1017836991"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1028272048",
        "building": "house"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5458036,
              22.1215278
            ],
            [
              113.545857,
              22.1213756
            ],
            [
              113.5460074,
              22.1214208
            ],
            [
              113.5459703,
              22.1215264
            ],
            [
              113.545948,
              22.1215196
            ],
            [
              113.5459316,
              22.1215663
            ],
            [
              113.5458036,
              22.1215278
            ]
          ]
        ]
      },
      "id": "way/1028272048"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1033560515",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5521238,
              22.135847
            ],
            [
              113.5521238,
              22.135783
            ],
            [
              113.5521788,
              22.135783
            ],
            [
              113.5521788,
              22.135847
            ],
            [
              113.5521238,
              22.135847
            ]
          ]
        ]
      },
      "id": "way/1033560515"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1033560516",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5521212,
              22.135927
            ],
            [
              113.552121,
              22.1359034
            ],
            [
              113.5521807,
              22.135903
            ],
            [
              113.5521809,
              22.1359266
            ],
            [
              113.5521212,
              22.135927
            ]
          ]
        ]
      },
      "id": "way/1033560516"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1041010655",
        "leisure": "park",
        "name": "荔枝碗休憩區 Zona de Lazer de Lai Chi Vun",
        "name:en": "Leisure Area in Lai Chi Vun",
        "name:pt": "Zona de Lazer de Lai Chi Vun",
        "name:zh": "荔枝碗休憩區",
        "opening_hours": "24/7"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5530148,
              22.1207833
            ],
            [
              113.5530511,
              22.1207423
            ],
            [
              113.5530551,
              22.1206988
            ],
            [
              113.5530497,
              22.1206243
            ],
            [
              113.5530943,
              22.1206023
            ],
            [
              113.5531466,
              22.1205748
            ],
            [
              113.553275,
              22.1204827
            ],
            [
              113.5533012,
              22.1204572
            ],
            [
              113.5533944,
              22.1204392
            ],
            [
              113.5533541,
              22.1206342
            ],
            [
              113.5533005,
              22.120915
            ],
            [
              113.553263,
              22.1210355
            ],
            [
              113.5531436,
              22.1210107
            ],
            [
              113.5530524,
              22.1209647
            ],
            [
              113.5530175,
              22.1208989
            ],
            [
              113.5530148,
              22.1207833
            ]
          ]
        ]
      },
      "id": "way/1041010655"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1058612710",
        "building": "yes",
        "height": "11",
        "layer": "1",
        "name": "金峰南岸 One Oasis"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5558959,
              22.1267187
            ],
            [
              113.5553675,
              22.1267411
            ],
            [
              113.5553219,
              22.1265249
            ],
            [
              113.5553139,
              22.1263187
            ],
            [
              113.5553326,
              22.1261
            ],
            [
              113.5553916,
              22.1258193
            ],
            [
              113.5558986,
              22.1260926
            ],
            [
              113.5558959,
              22.1267187
            ]
          ]
        ]
      },
      "id": "way/1058612710"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1109685824",
        "building": "yes",
        "height": "14.7"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5568082,
              22.1291822
            ],
            [
              113.5568188,
              22.1292054
            ],
            [
              113.5568433,
              22.1292592
            ],
            [
              113.5568705,
              22.1292489
            ],
            [
              113.5569452,
              22.1292207
            ],
            [
              113.5569693,
              22.1292542
            ],
            [
              113.5569886,
              22.1292447
            ],
            [
              113.5570605,
              22.1292095
            ],
            [
              113.5570726,
              22.1292291
            ],
            [
              113.5571119,
              22.1292078
            ],
            [
              113.5571477,
              22.1291884
            ],
            [
              113.5571343,
              22.1291648
            ],
            [
              113.5572281,
              22.129111
            ],
            [
              113.557247,
              22.1291002
            ],
            [
              113.5572282,
              22.1290616
            ],
            [
              113.5572374,
              22.1290561
            ],
            [
              113.5573142,
              22.1290104
            ],
            [
              113.5572966,
              22.1289772
            ],
            [
              113.557305,
              22.1289713
            ],
            [
              113.5573916,
              22.1289096
            ],
            [
              113.5574087,
              22.1288974
            ],
            [
              113.5573824,
              22.1288666
            ],
            [
              113.5573937,
              22.1288585
            ],
            [
              113.5574952,
              22.1287859
            ],
            [
              113.5574615,
              22.1287275
            ],
            [
              113.5575495,
              22.1286845
            ],
            [
              113.5576117,
              22.1286542
            ],
            [
              113.5576034,
              22.1287856
            ],
            [
              113.5575813,
              22.1289384
            ],
            [
              113.5575518,
              22.1290688
            ],
            [
              113.5575015,
              22.1292166
            ],
            [
              113.5574505,
              22.1293415
            ],
            [
              113.5574198,
              22.1295064
            ],
            [
              113.5573259,
              22.1295325
            ],
            [
              113.5566714,
              22.1293872
            ],
            [
              113.5567117,
              22.1292244
            ],
            [
              113.5568082,
              22.1291822
            ]
          ]
        ]
      },
      "id": "way/1109685824"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1109685826",
        "building": "yes",
        "name": "尚宏峰 The Grandeur"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5566971,
              22.1282652
            ],
            [
              113.5567165,
              22.1282645
            ],
            [
              113.5567257,
              22.1282642
            ],
            [
              113.5567249,
              22.1282443
            ],
            [
              113.5567563,
              22.1282432
            ],
            [
              113.5567552,
              22.1282169
            ],
            [
              113.5568194,
              22.1282147
            ],
            [
              113.5568204,
              22.1282393
            ],
            [
              113.5569037,
              22.1282364
            ],
            [
              113.5569044,
              22.128252
            ],
            [
              113.5569508,
              22.1282504
            ],
            [
              113.5569566,
              22.1283934
            ],
            [
              113.5569143,
              22.1283966
            ],
            [
              113.556917,
              22.1284335
            ],
            [
              113.5567422,
              22.1284397
            ],
            [
              113.5567413,
              22.1284183
            ],
            [
              113.5567266,
              22.1284188
            ],
            [
              113.5567099,
              22.1284196
            ],
            [
              113.5566971,
              22.1282652
            ]
          ]
        ]
      },
      "id": "way/1109685826"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1109685827",
        "building": "yes",
        "name": "雋逸峰 The Prestige"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5567099,
              22.1284196
            ],
            [
              113.5566754,
              22.1284217
            ],
            [
              113.5566755,
              22.1284398
            ],
            [
              113.556489,
              22.1284463
            ],
            [
              113.5564875,
              22.1284271
            ],
            [
              113.5564536,
              22.1284293
            ],
            [
              113.5564441,
              22.1282823
            ],
            [
              113.5564851,
              22.1282809
            ],
            [
              113.5564842,
              22.1282589
            ],
            [
              113.5565355,
              22.1282571
            ],
            [
              113.5565342,
              22.1282244
            ],
            [
              113.5566674,
              22.1282198
            ],
            [
              113.5566693,
              22.1282661
            ],
            [
              113.5566971,
              22.1282652
            ],
            [
              113.5567099,
              22.1284196
            ]
          ]
        ]
      },
      "id": "way/1109685827"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1109685828",
        "building": "yes",
        "height": "155.9",
        "name": "金峰名鑄(海曜) Grand Oasis (Residence Coast)"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5551518,
              22.1286856
            ],
            [
              113.5551742,
              22.1288814
            ],
            [
              113.5552331,
              22.1288833
            ],
            [
              113.5552413,
              22.1290339
            ],
            [
              113.5550238,
              22.1290245
            ],
            [
              113.5549811,
              22.1286931
            ],
            [
              113.5551518,
              22.1286856
            ]
          ]
        ]
      },
      "id": "way/1109685828"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1109685829",
        "building": "yes",
        "name": "金峰名鑄(尚鉑) Grand Oasis (Residence Opuence)"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5552413,
              22.1290339
            ],
            [
              113.5552331,
              22.1288833
            ],
            [
              113.5552728,
              22.1288814
            ],
            [
              113.5552575,
              22.1287307
            ],
            [
              113.5555055,
              22.1287138
            ],
            [
              113.5555096,
              22.1288739
            ],
            [
              113.5555543,
              22.1288701
            ],
            [
              113.5555543,
              22.1290546
            ],
            [
              113.5552413,
              22.1290339
            ]
          ]
        ]
      },
      "id": "way/1109685829"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1109685830",
        "building": "yes",
        "name": "金峰名鑄(珀譽) Grand Oasis (Residence Amber)"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5555543,
              22.1290546
            ],
            [
              113.555601,
              22.1287854
            ],
            [
              113.5556681,
              22.1288004
            ],
            [
              113.5556824,
              22.1287232
            ],
            [
              113.5558307,
              22.1287646
            ],
            [
              113.5558104,
              22.1288569
            ],
            [
              113.5559039,
              22.1288795
            ],
            [
              113.5558551,
              22.129113
            ],
            [
              113.5555543,
              22.1290546
            ]
          ]
        ]
      },
      "id": "way/1109685830"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1109685831",
        "building": "yes",
        "name": "金峰名鑄(盛名) Grand Oasis (Residence Imperial)"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5558551,
              22.129113
            ],
            [
              113.5559527,
              22.1288908
            ],
            [
              113.5559873,
              22.1288155
            ],
            [
              113.5560991,
              22.1288588
            ],
            [
              113.5560808,
              22.128919
            ],
            [
              113.5561357,
              22.128936
            ],
            [
              113.5560869,
              22.1290923
            ],
            [
              113.5561377,
              22.1290998
            ],
            [
              113.5560869,
              22.1291883
            ],
            [
              113.5558551,
              22.129113
            ]
          ]
        ]
      },
      "id": "way/1109685831"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1109685832",
        "building": "yes",
        "name": "金峰名鑄(御金峰) Grand Oasis (Residence Oasis)"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5560869,
              22.1291883
            ],
            [
              113.5563308,
              22.1289492
            ],
            [
              113.5564548,
              22.1291149
            ],
            [
              113.5562129,
              22.129322
            ],
            [
              113.5560869,
              22.1291883
            ]
          ]
        ]
      },
      "id": "way/1109685832"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1109685833",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5556301,
              22.1283445
            ],
            [
              113.5549786,
              22.1282125
            ],
            [
              113.5550066,
              22.1281066
            ],
            [
              113.5549296,
              22.1280049
            ],
            [
              113.5550277,
              22.1279595
            ],
            [
              113.5549296,
              22.1277843
            ],
            [
              113.5549926,
              22.127741
            ],
            [
              113.5549022,
              22.1275842
            ],
            [
              113.555002,
              22.1275312
            ],
            [
              113.5549973,
              22.1275096
            ],
            [
              113.5549382,
              22.1275297
            ],
            [
              113.5548992,
              22.1274663
            ],
            [
              113.5549343,
              22.1274166
            ],
            [
              113.5549389,
              22.1273214
            ],
            [
              113.5548922,
              22.1273235
            ],
            [
              113.5548899,
              22.1271505
            ],
            [
              113.5549576,
              22.1271505
            ],
            [
              113.5549459,
              22.1270856
            ],
            [
              113.5548992,
              22.1270834
            ],
            [
              113.5548855,
              22.1264933
            ],
            [
              113.5550875,
              22.1264884
            ],
            [
              113.5551187,
              22.1270683
            ],
            [
              113.5550673,
              22.1270726
            ],
            [
              113.5550627,
              22.1271289
            ],
            [
              113.5551374,
              22.1271116
            ],
            [
              113.5552261,
              22.1273582
            ],
            [
              113.5551467,
              22.1273755
            ],
            [
              113.5551491,
              22.1274598
            ],
            [
              113.5551841,
              22.1274555
            ],
            [
              113.5552845,
              22.1276242
            ],
            [
              113.5551351,
              22.1277042
            ],
            [
              113.5552775,
              22.1279443
            ],
            [
              113.5551934,
              22.1280006
            ],
            [
              113.5552902,
              22.1281243
            ],
            [
              113.5552549,
              22.1281454
            ],
            [
              113.5552819,
              22.1281823
            ],
            [
              113.5553198,
              22.1281913
            ],
            [
              113.5553252,
              22.1281269
            ],
            [
              113.5556651,
              22.1281974
            ],
            [
              113.5556301,
              22.1283445
            ]
          ]
        ]
      },
      "id": "way/1109685833"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1109685834",
        "addr:housenumber": "363-433",
        "addr:street": "石排灣馬路 Estrada de Seac Pai Van",
        "building": "commercial",
        "name": "政府(路環)辦公大樓 Edifício de Escritórios do Governo (Coloane)",
        "name:en": "Government Office Building (Coloane)",
        "name:pt": "Edifício de Escritórios do Governo (Coloane)",
        "name:zh": "政府(路環)辦公大樓"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5551016,
              22.1263852
            ],
            [
              113.5548548,
              22.1263827
            ],
            [
              113.5548629,
              22.1258784
            ],
            [
              113.5547,
              22.1258814
            ],
            [
              113.5546287,
              22.1258824
            ],
            [
              113.5546241,
              22.1252199
            ],
            [
              113.5546858,
              22.1252199
            ],
            [
              113.5552759,
              22.1256373
            ],
            [
              113.5551884,
              22.1259401
            ],
            [
              113.5551558,
              22.1259412
            ],
            [
              113.5551016,
              22.1263852
            ]
          ]
        ]
      },
      "id": "way/1109685834"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1112207335",
        "amenity": "parking",
        "description": "Location: Northern side of UM Stadium (N9)",
        "description:en": "Location: Northern side of UM Stadium (N9)",
        "description:zh": "所在位置: 澳大運動場北面(N9)",
        "fee": "yes",
        "image": "https://map.um.edu.mo/emap_images/car-park_P1A.jpg",
        "name": "P1A訪客停車場 Visitor Car Park P1A",
        "name:en": "Visitor Car Park P1A",
        "name:zh": "P1A訪客停車場",
        "payment:cash": "yes",
        "website": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:en": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:zh": "https://sfs.cmdo.um.edu.mo/%e6%88%91%e5%80%91%e7%9a%84%e6%9c%8d%e5%8b%99/%e5%81%9c%e8%bb%8a%e5%a0%b4%e7%ae%a1%e7%90%86/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.541075,
              22.13568
            ],
            [
              113.5410687,
              22.1349418
            ],
            [
              113.5417558,
              22.1349071
            ],
            [
              113.5417614,
              22.1357128
            ],
            [
              113.541075,
              22.13568
            ]
          ]
        ]
      },
      "id": "way/1112207335"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1193491428",
        "addr:housenumber": "5",
        "addr:street": "荔枝碗馬路 Estrada de Lai Chi Vun",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5521733,
              22.1209573
            ],
            [
              113.5522106,
              22.1208553
            ],
            [
              113.5522356,
              22.1208638
            ],
            [
              113.5521998,
              22.1209655
            ],
            [
              113.5521733,
              22.1209573
            ]
          ]
        ]
      },
      "id": "way/1193491428"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1193491429",
        "addr:housenumber": "6",
        "addr:street": "荔枝碗馬路 Estrada de Lai Chi Vun",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5521998,
              22.1209655
            ],
            [
              113.5522356,
              22.1208638
            ],
            [
              113.5522668,
              22.120872
            ],
            [
              113.5522285,
              22.1209746
            ],
            [
              113.5521998,
              22.1209655
            ]
          ]
        ]
      },
      "id": "way/1193491429"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1193491430",
        "addr:housenumber": "29-29A",
        "addr:street": "荔枝碗馬路 Estrada de Lai Chi Vun",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5528053,
              22.1212442
            ],
            [
              113.5528693,
              22.1212113
            ],
            [
              113.5528907,
              22.1212619
            ],
            [
              113.5528356,
              22.1212913
            ],
            [
              113.5528053,
              22.1212442
            ]
          ]
        ]
      },
      "id": "way/1193491430"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203447964",
        "addr:housename": "大横琴高级人才公寓",
        "addr:housename:zh": "大横琴高级人才公寓",
        "building": "apartments",
        "building:levels": "31",
        "start_date": "2020"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5358133,
              22.1275973
            ],
            [
              113.535811,
              22.1273998
            ],
            [
              113.5362012,
              22.1273959
            ],
            [
              113.5362035,
              22.1275935
            ],
            [
              113.5358133,
              22.1275973
            ]
          ]
        ]
      },
      "id": "way/1203447964"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203447965",
        "addr:housename": "大横琴高级人才公寓",
        "addr:housename:zh": "大横琴高级人才公寓",
        "building": "apartments",
        "building:levels": "28",
        "start_date": "2020"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5361512,
              22.1278915
            ],
            [
              113.5362869,
              22.1277676
            ],
            [
              113.5365372,
              22.1280031
            ],
            [
              113.5364015,
              22.1281269
            ],
            [
              113.5361512,
              22.1278915
            ]
          ]
        ]
      },
      "id": "way/1203447965"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203447966",
        "addr:housename": "大横琴高级人才公寓",
        "addr:housename:zh": "大横琴高级人才公寓",
        "building": "apartments",
        "building:levels": "24",
        "start_date": "2020"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5362821,
              22.1287536
            ],
            [
              113.5361492,
              22.1286273
            ],
            [
              113.5364046,
              22.1283966
            ],
            [
              113.5365376,
              22.1285229
            ],
            [
              113.5362821,
              22.1287536
            ]
          ]
        ]
      },
      "id": "way/1203447966"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203849261",
        "amenity": "sport",
        "hoops": "2",
        "leisure": "pitch",
        "lit": "yes",
        "name": "7號室外籃球場（亦稱BA7） Outdoor Basketball Court no. 7 (aka BA7)",
        "name:en": "Outdoor Basketball Court no. 7 (aka BA7)",
        "name:zh": "7號室外籃球場（亦稱BA7）",
        "ref": "BA7",
        "sport": "basketball",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5415617,
              22.127099
            ],
            [
              113.5415604,
              22.1268523
            ],
            [
              113.5417012,
              22.1268517
            ],
            [
              113.5417025,
              22.1270983
            ],
            [
              113.5415617,
              22.127099
            ]
          ]
        ]
      },
      "id": "way/1203849261"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203849263",
        "amenity": "sport",
        "leisure": "pitch",
        "lit": "yes",
        "name": "4號網球場（亦稱TE4） Tennis Court 4 (aka TE4)",
        "name:en": "Tennis Court 4 (aka TE4)",
        "name:zh": "4號網球場（亦稱TE4）",
        "ref": "TE4",
        "sport": "tennis",
        "website": "https://facility.osa.um.edu.mo/projects/tennis-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/tennis-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/tennis-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5419579,
              22.1271562
            ],
            [
              113.5419597,
              22.1268582
            ],
            [
              113.5421069,
              22.126859
            ],
            [
              113.5421051,
              22.127157
            ],
            [
              113.5419579,
              22.1271562
            ]
          ]
        ]
      },
      "id": "way/1203849263"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203849264",
        "amenity": "sport",
        "leisure": "pitch",
        "lit": "yes",
        "name": "5號網球場（亦稱TE5） Tennis Court 5 (aka TE5)",
        "name:en": "Tennis Court 5 (aka TE5)",
        "name:zh": "5號網球場（亦稱TE5）",
        "ref": "TE5",
        "sport": "tennis",
        "website": "https://facility.osa.um.edu.mo/projects/tennis-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/tennis-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/tennis-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5421336,
              22.1271525
            ],
            [
              113.5421354,
              22.1268545
            ],
            [
              113.5422826,
              22.1268553
            ],
            [
              113.5422808,
              22.1271533
            ],
            [
              113.5421336,
              22.1271525
            ]
          ]
        ]
      },
      "id": "way/1203849264"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203849265",
        "amenity": "sport",
        "leisure": "pitch",
        "lit": "yes",
        "name": "6號網球場（亦稱TE6） Tennis Court 6 (aka TE6)",
        "name:en": "Tennis Court 6 (aka TE6)",
        "name:zh": "6號網球場（亦稱TE6）",
        "ref": "TE6",
        "sport": "tennis",
        "website": "https://facility.osa.um.edu.mo/projects/tennis-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/tennis-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/tennis-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.542324,
              22.1271562
            ],
            [
              113.5423258,
              22.1268583
            ],
            [
              113.5424731,
              22.126859
            ],
            [
              113.5424712,
              22.127157
            ],
            [
              113.542324,
              22.1271562
            ]
          ]
        ]
      },
      "id": "way/1203849265"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203849266",
        "amenity": "sport",
        "hoops": "2",
        "leisure": "pitch",
        "lit": "yes",
        "name": "8號室外籃球場（亦稱BA8） Outdoor Basketball Court no. 8 (aka BA8)",
        "name:en": "Outdoor Basketball Court no. 8 (aka BA8)",
        "name:zh": "8號室外籃球場（亦稱BA8）",
        "ref": "BA8",
        "sport": "basketball",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5432877,
              22.1272497
            ],
            [
              113.5431431,
              22.1272488
            ],
            [
              113.5431451,
              22.1269786
            ],
            [
              113.5432897,
              22.1269796
            ],
            [
              113.5432877,
              22.1272497
            ]
          ]
        ]
      },
      "id": "way/1203849266"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203849267",
        "amenity": "sport",
        "hoops": "2",
        "leisure": "pitch",
        "lit": "yes",
        "name": "9號室外籃球場（亦稱BA9） Outdoor Basketball Court no. 9 (aka BA9)",
        "name:en": "Outdoor Basketball Court no. 9 (aka BA9)",
        "name:zh": "9號室外籃球場（亦稱BA9）",
        "ref": "BA9",
        "sport": "basketball",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5434756,
              22.1272488
            ],
            [
              113.543331,
              22.1272478
            ],
            [
              113.543333,
              22.1269777
            ],
            [
              113.5434777,
              22.1269786
            ],
            [
              113.5434756,
              22.1272488
            ]
          ]
        ]
      },
      "id": "way/1203849267"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203849268",
        "amenity": "sport",
        "hoops": "2",
        "leisure": "pitch",
        "lit": "yes",
        "name": "3號室外籃球場（亦稱BA3） Outdoor Basketball Court no. 3 (aka BA3)",
        "name:en": "Outdoor Basketball Court no. 3 (aka BA3)",
        "name:zh": "3號室外籃球場（亦稱BA3）",
        "ref": "BA3",
        "sport": "basketball",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5416726,
              22.1278627
            ],
            [
              113.5416681,
              22.1275869
            ],
            [
              113.5418197,
              22.1275848
            ],
            [
              113.5418241,
              22.1278606
            ],
            [
              113.5416726,
              22.1278627
            ]
          ]
        ]
      },
      "id": "way/1203849268"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203849269",
        "amenity": "sport",
        "hoops": "2",
        "leisure": "pitch",
        "lit": "yes",
        "name": "4號室外籃球場（亦稱BA4） Outdoor Basketball Court no. 4 (aka BA4)",
        "name:en": "Outdoor Basketball Court no. 4 (aka BA4)",
        "name:zh": "4號室外籃球場（亦稱BA4）",
        "ref": "BA4",
        "sport": "basketball",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5418529,
              22.1278597
            ],
            [
              113.5418485,
              22.1275839
            ],
            [
              113.5420001,
              22.1275818
            ],
            [
              113.5420045,
              22.1278576
            ],
            [
              113.5418529,
              22.1278597
            ]
          ]
        ]
      },
      "id": "way/1203849269"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203849270",
        "amenity": "sport",
        "hoops": "2",
        "leisure": "pitch",
        "lit": "yes",
        "name": "5號室外籃球場（亦稱BA5） Outdoor Basketball Court no. 5 (aka BA5)",
        "name:en": "Outdoor Basketball Court no. 5 (aka BA5)",
        "name:zh": "5號室外籃球場（亦稱BA5）",
        "ref": "BA5",
        "sport": "basketball",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.542038,
              22.1278572
            ],
            [
              113.5420335,
              22.1275814
            ],
            [
              113.5421851,
              22.1275793
            ],
            [
              113.5421895,
              22.1278551
            ],
            [
              113.542038,
              22.1278572
            ]
          ]
        ]
      },
      "id": "way/1203849270"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203850122",
        "amenity": "sport",
        "hoops": "2",
        "leisure": "pitch",
        "lit": "yes",
        "name": "13號室外籃球場（亦稱BA13） Outdoor Basketball Court no. 13 (aka BA13)",
        "name:en": "Outdoor Basketball Court no. 13 (aka BA13)",
        "name:zh": "13號室外籃球場（亦稱BA13）",
        "ref": "BA13",
        "sport": "basketball",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5425146,
              22.1234669
            ],
            [
              113.542517,
              22.1231811
            ],
            [
              113.5426811,
              22.1231822
            ],
            [
              113.5426788,
              22.1234681
            ],
            [
              113.5425381,
              22.1234671
            ],
            [
              113.5425146,
              22.1234669
            ]
          ]
        ]
      },
      "id": "way/1203850122"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203850123",
        "amenity": "sport",
        "hoops": "2",
        "leisure": "pitch",
        "lit": "yes",
        "name": "14號室外籃球場（亦稱BA14） Outdoor Basketball Court no. 14 (aka BA14)",
        "name:en": "Outdoor Basketball Court no. 14 (aka BA14)",
        "name:zh": "14號室外籃球場（亦稱BA14）",
        "ref": "BA14",
        "sport": "basketball",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5427004,
              22.1234658
            ],
            [
              113.5427028,
              22.12318
            ],
            [
              113.5428669,
              22.1231811
            ],
            [
              113.5428656,
              22.1233397
            ],
            [
              113.5428646,
              22.123467
            ],
            [
              113.5428426,
              22.1234668
            ],
            [
              113.5427004,
              22.1234658
            ]
          ]
        ]
      },
      "id": "way/1203850123"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203850125",
        "amenity": "sport",
        "hoops": "2",
        "leisure": "pitch",
        "lit": "yes",
        "name": "10號室外籃球場（亦稱BA10） Outdoor Basketball Court no. 10 (aka BA10)",
        "name:en": "Outdoor Basketball Court no. 10 (aka BA10)",
        "name:zh": "10號室外籃球場（亦稱BA10）",
        "ref": "BA10",
        "sport": "basketball",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5440352,
              22.1244049
            ],
            [
              113.5440348,
              22.1241375
            ],
            [
              113.5441782,
              22.1241373
            ],
            [
              113.5441787,
              22.1244047
            ],
            [
              113.5440352,
              22.1244049
            ]
          ]
        ]
      },
      "id": "way/1203850125"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203850127",
        "amenity": "sport",
        "leisure": "pitch",
        "lit": "yes",
        "name": "草地滾球場（亦稱LBG） Lawn Bowling Green (aka LBG)",
        "name:en": "Lawn Bowling Green (aka LBG)",
        "name:zh": "草地滾球場（亦稱LBG）",
        "ref": "LBG",
        "sport": "rollingball",
        "website": "https://facility.osa.um.edu.mo/projects/lawn-bowling-green/",
        "website:en": "https://facility.osa.um.edu.mo/projects/lawn-bowling-green/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/lawn-bowling-green/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5440927,
              22.1237959
            ],
            [
              113.5440941,
              22.1234431
            ],
            [
              113.5444614,
              22.1234443
            ],
            [
              113.54446,
              22.1237971
            ],
            [
              113.5440927,
              22.1237959
            ]
          ]
        ]
      },
      "id": "way/1203850127"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203851011",
        "access": "permissive",
        "amenity": "bbq",
        "covered": "no",
        "fuel": "charcoal"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5428202,
              22.123064
            ],
            [
              113.5428198,
              22.1230199
            ],
            [
              113.5428945,
              22.1230193
            ],
            [
              113.5428949,
              22.1230634
            ],
            [
              113.5428202,
              22.123064
            ]
          ]
        ]
      },
      "id": "way/1203851011"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203851012",
        "access": "permissive",
        "amenity": "bbq",
        "covered": "no",
        "fuel": "charcoal"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5428197,
              22.1230113
            ],
            [
              113.5428193,
              22.1229672
            ],
            [
              113.542894,
              22.1229666
            ],
            [
              113.5428941,
              22.1229768
            ],
            [
              113.5428944,
              22.1230107
            ],
            [
              113.5428197,
              22.1230113
            ]
          ]
        ]
      },
      "id": "way/1203851012"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203851013",
        "access": "permissive",
        "amenity": "bbq",
        "covered": "no",
        "fuel": "charcoal"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.542819,
              22.1229535
            ],
            [
              113.5428186,
              22.1229094
            ],
            [
              113.5428934,
              22.1229089
            ],
            [
              113.5428938,
              22.122953
            ],
            [
              113.542819,
              22.1229535
            ]
          ]
        ]
      },
      "id": "way/1203851013"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203851014",
        "access": "permissive",
        "amenity": "bbq",
        "covered": "no",
        "fuel": "charcoal"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.542819,
              22.1228995
            ],
            [
              113.5428186,
              22.1228554
            ],
            [
              113.5428934,
              22.1228548
            ],
            [
              113.5428938,
              22.1228989
            ],
            [
              113.542819,
              22.1228995
            ]
          ]
        ]
      },
      "id": "way/1203851014"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203851015",
        "access": "permissive",
        "amenity": "bbq",
        "covered": "no",
        "fuel": "charcoal"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5428176,
              22.1228442
            ],
            [
              113.5428173,
              22.1228001
            ],
            [
              113.542892,
              22.1227995
            ],
            [
              113.5428924,
              22.1228436
            ],
            [
              113.5428176,
              22.1228442
            ]
          ]
        ]
      },
      "id": "way/1203851015"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203851016",
        "access": "permissive",
        "amenity": "bbq",
        "covered": "no",
        "fuel": "charcoal"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.542817,
              22.1227939
            ],
            [
              113.5428166,
              22.1227498
            ],
            [
              113.5428913,
              22.1227492
            ],
            [
              113.5428917,
              22.1227933
            ],
            [
              113.542817,
              22.1227939
            ]
          ]
        ]
      },
      "id": "way/1203851016"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203853303",
        "amenity": "sport",
        "leisure": "pitch",
        "lit": "yes",
        "name": "網球練習場（亦稱TEP） Tennis Practice Court (aka TEP)",
        "name:en": "Tennis Practice Court (aka TEP)",
        "name:zh": "網球練習場（亦稱TEP）",
        "ref": "TEP",
        "sport": "tennis",
        "website": "https://facility.osa.um.edu.mo/projects/tennis-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/tennis-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/tennis-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5408844,
              22.1306321
            ],
            [
              113.5408858,
              22.1304725
            ],
            [
              113.5410554,
              22.1304737
            ],
            [
              113.5410541,
              22.1306334
            ],
            [
              113.5408844,
              22.1306321
            ]
          ]
        ]
      },
      "id": "way/1203853303"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203853304",
        "amenity": "sport",
        "leisure": "pitch",
        "lit": "no",
        "name": "1號網球場（亦稱TE1） Tennis Court 1 (aka TE1)",
        "name:en": "Tennis Court 1 (aka TE1)",
        "name:zh": "1號網球場（亦稱TE1）",
        "ref": "TE1",
        "sport": "tennis",
        "website": "https://facility.osa.um.edu.mo/projects/tennis-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/tennis-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/tennis-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.541138,
              22.1307056
            ],
            [
              113.5411406,
              22.1304095
            ],
            [
              113.5413053,
              22.1304107
            ],
            [
              113.5413027,
              22.1307068
            ],
            [
              113.541138,
              22.1307056
            ]
          ]
        ]
      },
      "id": "way/1203853304"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203853305",
        "amenity": "sport",
        "leisure": "pitch",
        "lit": "yes",
        "name": "2號網球場（亦稱TE2） Tennis Court 2 (aka TE2)",
        "name:en": "Tennis Court 2 (aka TE2)",
        "name:zh": "2號網球場（亦稱TE2）",
        "ref": "TE2",
        "sport": "tennis",
        "website": "https://facility.osa.um.edu.mo/projects/tennis-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/tennis-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/tennis-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5413281,
              22.1307072
            ],
            [
              113.5413308,
              22.1304111
            ],
            [
              113.5414955,
              22.1304124
            ],
            [
              113.5414929,
              22.1307085
            ],
            [
              113.5413281,
              22.1307072
            ]
          ]
        ]
      },
      "id": "way/1203853305"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203853306",
        "amenity": "sport",
        "leisure": "pitch",
        "lit": "yes",
        "name": "3號網球場（亦稱TE3） Tennis Court 3 (aka TE3)",
        "name:en": "Tennis Court 3 (aka TE3)",
        "name:zh": "3號網球場（亦稱TE3）",
        "ref": "TE3",
        "sport": "tennis",
        "website": "https://facility.osa.um.edu.mo/projects/tennis-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/tennis-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/tennis-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5415078,
              22.1307072
            ],
            [
              113.5415105,
              22.1304111
            ],
            [
              113.5416752,
              22.1304124
            ],
            [
              113.5416726,
              22.1307085
            ],
            [
              113.5415078,
              22.1307072
            ]
          ]
        ]
      },
      "id": "way/1203853306"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203853307",
        "amenity": "sport",
        "hoops": "2",
        "leisure": "pitch",
        "lit": "yes",
        "name": "1號室外籃球場（亦稱BA1） Outdoor Basketball Court no. 1 (aka BA1)",
        "name:en": "Outdoor Basketball Court no. 1 (aka BA1)",
        "name:zh": "1號室外籃球場（亦稱BA1）",
        "ref": "BA1",
        "sport": "basketball",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5416969,
              22.130706
            ],
            [
              113.5416996,
              22.1304098
            ],
            [
              113.5418643,
              22.1304111
            ],
            [
              113.5418617,
              22.1307072
            ],
            [
              113.5416969,
              22.130706
            ]
          ]
        ]
      },
      "id": "way/1203853307"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203853308",
        "amenity": "sport",
        "hoops": "2",
        "leisure": "pitch",
        "lit": "yes",
        "name": "2號室外籃球場（亦稱BA2） Outdoor Basketball Court no. 2 (aka BA2)",
        "name:en": "Outdoor Basketball Court no. 2 (aka BA2)",
        "name:zh": "2號室外籃球場（亦稱BA2）",
        "ref": "BA2",
        "sport": "basketball",
        "website": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:en": "https://facility.osa.um.edu.mo/projects/basketball-courts/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/basketball-courts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5418699,
              22.130706
            ],
            [
              113.5418726,
              22.1304098
            ],
            [
              113.5420373,
              22.1304111
            ],
            [
              113.5420347,
              22.1307072
            ],
            [
              113.5418699,
              22.130706
            ]
          ]
        ]
      },
      "id": "way/1203853308"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203853310",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5410793,
              22.1307138
            ],
            [
              113.5410825,
              22.1303963
            ],
            [
              113.5411158,
              22.1303966
            ],
            [
              113.5411125,
              22.1307141
            ],
            [
              113.5410793,
              22.1307138
            ]
          ]
        ]
      },
      "id": "way/1203853310"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1203853311",
        "amenity": "sport",
        "leisure": "pitch",
        "lit": "yes",
        "name": "排球場（亦稱VB） Volleyball Court (aka VB)",
        "name:en": "Volleyball Court (aka VB)",
        "name:zh": "排球場（亦稱VB）",
        "ref": "VB",
        "sport": "volleyball",
        "website": "https://facility.osa.um.edu.mo/projects/volleyball-court-managed-by-sports-bureau/",
        "website:en": "https://facility.osa.um.edu.mo/projects/volleyball-court-managed-by-sports-bureau/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/volleyball-court-managed-by-sports-bureau/?lang=zh-hant"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.541504,
              22.1331185
            ],
            [
              113.5415014,
              22.1330049
            ],
            [
              113.5414992,
              22.1329049
            ],
            [
              113.5415602,
              22.1329038
            ],
            [
              113.5416288,
              22.1329025
            ],
            [
              113.5416335,
              22.133116
            ],
            [
              113.541504,
              22.1331185
            ]
          ]
        ]
      },
      "id": "way/1203853311"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1204344910",
        "leisure": "swimming_pool"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5447042,
              22.1226691
            ],
            [
              113.5446707,
              22.1226678
            ],
            [
              113.5446533,
              22.1226616
            ],
            [
              113.5446398,
              22.1226455
            ],
            [
              113.5446398,
              22.1226281
            ],
            [
              113.5446452,
              22.1226094
            ],
            [
              113.5446506,
              22.1225747
            ],
            [
              113.5446345,
              22.1225473
            ],
            [
              113.5446144,
              22.1225237
            ],
            [
              113.5446103,
              22.1225038
            ],
            [
              113.5446184,
              22.1224815
            ],
            [
              113.5446264,
              22.1224715
            ],
            [
              113.5446519,
              22.1224703
            ],
            [
              113.5446881,
              22.1224703
            ],
            [
              113.5447042,
              22.122479
            ],
            [
              113.5447217,
              22.1224802
            ],
            [
              113.5447377,
              22.1224653
            ],
            [
              113.5447605,
              22.1224467
            ],
            [
              113.5447941,
              22.1224566
            ],
            [
              113.5448169,
              22.1224479
            ],
            [
              113.544841,
              22.1224728
            ],
            [
              113.5448786,
              22.1225088
            ],
            [
              113.5449751,
              22.1224181
            ],
            [
              113.5449872,
              22.1224455
            ],
            [
              113.5449912,
              22.1224753
            ],
            [
              113.5449872,
              22.1224976
            ],
            [
              113.5449724,
              22.1225101
            ],
            [
              113.5449456,
              22.1225237
            ],
            [
              113.5449175,
              22.1225262
            ],
            [
              113.544892,
              22.1225411
            ],
            [
              113.5448812,
              22.1225635
            ],
            [
              113.5448745,
              22.1225983
            ],
            [
              113.5448638,
              22.1226219
            ],
            [
              113.5448383,
              22.1226318
            ],
            [
              113.5448196,
              22.1226343
            ],
            [
              113.5447874,
              22.1226343
            ],
            [
              113.5447565,
              22.122638
            ],
            [
              113.5447364,
              22.1226455
            ],
            [
              113.5447042,
              22.1226691
            ]
          ]
        ]
      },
      "id": "way/1204344910"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1213753850",
        "leisure": "playground"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.557417,
              22.1257902
            ],
            [
              113.5573955,
              22.1257343
            ],
            [
              113.557598,
              22.1255964
            ],
            [
              113.5576624,
              22.1257058
            ],
            [
              113.557417,
              22.1257902
            ]
          ]
        ]
      },
      "id": "way/1213753850"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1213759110",
        "amenity": "toilets",
        "building": "yes",
        "name": "T13 橫琴澳大校區大學北(近旅遊巴站)公廁",
        "name:zh": "T13 橫琴澳大校區大學北(近旅遊巴站)公廁",
        "ref": "T13"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5469969,
              22.1360488
            ],
            [
              113.5469972,
              22.1360053
            ],
            [
              113.54704,
              22.1360056
            ],
            [
              113.5470403,
              22.1359636
            ],
            [
              113.5471206,
              22.1359641
            ],
            [
              113.5471202,
              22.1360128
            ],
            [
              113.5470903,
              22.1360126
            ],
            [
              113.54709,
              22.1360495
            ],
            [
              113.5469969,
              22.1360488
            ]
          ]
        ]
      },
      "id": "way/1213759110"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1213759111",
        "addr:city": "氹仔 Taipa",
        "addr:postcode": "999078",
        "addr:province": "Macau",
        "addr:street": "凱旋大馬路 Avenida da Vitória",
        "amenity": "police",
        "fax": "+853 2850 6209",
        "name": "海島警務廳路環警司處橫琴島澳門大學新校區分站  Departamento Policial das Ilhas - Comissariado de Coloane - Posto do Novo Campus da Universidade de Macau na Ilha de Hengqin",
        "name:pt": "Departamento Policial das Ilhas - Comissariado de Coloane - Posto do Novo Campus da Universidade de Macau na Ilha de Hengqin",
        "name:zh": "海島警務廳路環警司處橫琴島澳門大學新校區分站",
        "opening_hours": "24/7",
        "operator": "海島警務廳路環警司處橫琴島澳門大學新校區分站  Departamento Policial das Ilhas - Comissariado de Coloane - Posto do Novo Campus da Universidade de Macau na Ilha de Hengqin",
        "phone": "+853 2850 6207"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5468636,
              22.1353416
            ],
            [
              113.5468651,
              22.1347953
            ],
            [
              113.5470433,
              22.1347971
            ],
            [
              113.5470731,
              22.1348079
            ],
            [
              113.5471029,
              22.1348423
            ],
            [
              113.5471142,
              22.1348681
            ],
            [
              113.5471271,
              22.1349085
            ],
            [
              113.5471307,
              22.1349548
            ],
            [
              113.5471277,
              22.1353407
            ],
            [
              113.5468636,
              22.1353416
            ]
          ]
        ]
      },
      "id": "way/1213759111"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1228553188",
        "building": "yes",
        "name": "隧道通風口",
        "name:zh": "隧道通風口"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.54693,
              22.1317501
            ],
            [
              113.5469167,
              22.1316529
            ],
            [
              113.5470021,
              22.1316429
            ],
            [
              113.5470154,
              22.1317401
            ],
            [
              113.54693,
              22.1317501
            ]
          ]
        ]
      },
      "id": "way/1228553188"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1242682555",
        "building": "yes",
        "height": "4.9"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5526718,
              22.1345688
            ],
            [
              113.5526667,
              22.134463
            ],
            [
              113.5527124,
              22.1344612
            ],
            [
              113.5527175,
              22.1345669
            ],
            [
              113.5526718,
              22.1345688
            ]
          ]
        ]
      },
      "id": "way/1242682555"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1242682565",
        "amenity": "toilets",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5552196,
              22.1336542
            ],
            [
              113.5551736,
              22.1335801
            ],
            [
              113.5552561,
              22.1335362
            ],
            [
              113.5553021,
              22.1336103
            ],
            [
              113.5552196,
              22.1336542
            ]
          ]
        ]
      },
      "id": "way/1242682565"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1265037934",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.557203,
              22.1311899
            ],
            [
              113.5571883,
              22.1309626
            ],
            [
              113.5572929,
              22.1309551
            ],
            [
              113.5573076,
              22.1311837
            ],
            [
              113.557203,
              22.1311899
            ]
          ]
        ]
      },
      "id": "way/1265037934"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1315452872",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5469076,
              22.1351098
            ],
            [
              113.5469077,
              22.1349897
            ],
            [
              113.5471141,
              22.1349898
            ],
            [
              113.5471139,
              22.13511
            ],
            [
              113.5469076,
              22.1351098
            ]
          ]
        ]
      },
      "id": "way/1315452872"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1318571882",
        "addr:housenumber": "79-83",
        "addr:street": "黃蟬街 Rua da Alamanda",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5569744,
              22.1288411
            ],
            [
              113.5570568,
              22.1290002
            ],
            [
              113.5570206,
              22.1290146
            ],
            [
              113.5570551,
              22.1290775
            ],
            [
              113.5569188,
              22.1291173
            ],
            [
              113.5569087,
              22.1291035
            ],
            [
              113.5568821,
              22.1291141
            ],
            [
              113.5568222,
              22.1290451
            ],
            [
              113.5569744,
              22.1288411
            ]
          ]
        ]
      },
      "id": "way/1318571882"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1318571883",
        "addr:housenumber": "65-71",
        "addr:street": "黃蟬街 Rua da Alamanda",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5569744,
              22.1288411
            ],
            [
              113.5570563,
              22.1287484
            ],
            [
              113.5571753,
              22.1289498
            ],
            [
              113.5571821,
              22.1289612
            ],
            [
              113.5571516,
              22.1289767
            ],
            [
              113.5571685,
              22.1290054
            ],
            [
              113.5571655,
              22.1290301
            ],
            [
              113.5570914,
              22.1290636
            ],
            [
              113.5570568,
              22.1290002
            ],
            [
              113.5569744,
              22.1288411
            ]
          ]
        ]
      },
      "id": "way/1318571883"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1318571884",
        "addr:housenumber": "51-57",
        "addr:street": "黃蟬街 Rua da Alamanda",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5571753,
              22.1289498
            ],
            [
              113.5570563,
              22.1287484
            ],
            [
              113.5571472,
              22.1286735
            ],
            [
              113.557252,
              22.1288322
            ],
            [
              113.5572631,
              22.1288514
            ],
            [
              113.5572288,
              22.1288684
            ],
            [
              113.5572459,
              22.1288982
            ],
            [
              113.5572449,
              22.1289154
            ],
            [
              113.5571753,
              22.1289498
            ]
          ]
        ]
      },
      "id": "way/1318571884"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1318571885",
        "addr:housenumber": "37-43",
        "addr:street": "黃蟬街 Rua da Alamanda",
        "building": "yes",
        "height": "30.4"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.557252,
              22.1288322
            ],
            [
              113.5571472,
              22.1286735
            ],
            [
              113.557248,
              22.1285775
            ],
            [
              113.5573384,
              22.128716
            ],
            [
              113.5573565,
              22.1287278
            ],
            [
              113.5573162,
              22.1287536
            ],
            [
              113.5573307,
              22.1287737
            ],
            [
              113.5573286,
              22.1287929
            ],
            [
              113.557252,
              22.1288322
            ]
          ]
        ]
      },
      "id": "way/1318571885"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1318571886",
        "addr:housenumber": "23-29",
        "addr:street": "黃蟬街 Rua da Alamanda",
        "building": "yes",
        "height": "31"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5573384,
              22.128716
            ],
            [
              113.557248,
              22.1285775
            ],
            [
              113.5573462,
              22.1284703
            ],
            [
              113.5574309,
              22.1286163
            ],
            [
              113.5574024,
              22.1286305
            ],
            [
              113.5574144,
              22.1286512
            ],
            [
              113.5574113,
              22.1286751
            ],
            [
              113.5573384,
              22.128716
            ]
          ]
        ]
      },
      "id": "way/1318571886"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1318571887",
        "addr:housenumber": "9-15",
        "addr:street": "黃蟬街 Rua da Alamanda",
        "building": "yes",
        "height": "31.2"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5574309,
              22.1286163
            ],
            [
              113.5573462,
              22.1284703
            ],
            [
              113.5574464,
              22.1283831
            ],
            [
              113.5575236,
              22.1285226
            ],
            [
              113.5575308,
              22.1285355
            ],
            [
              113.5575138,
              22.1285435
            ],
            [
              113.5575275,
              22.1285684
            ],
            [
              113.5574743,
              22.1286167
            ],
            [
              113.5574402,
              22.1286311
            ],
            [
              113.5574309,
              22.1286163
            ]
          ]
        ]
      },
      "id": "way/1318571887"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1318571888",
        "addr:housenumber": "3-5",
        "addr:street": "黃蟬街 Rua da Alamanda",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5575236,
              22.1285226
            ],
            [
              113.5574464,
              22.1283831
            ],
            [
              113.5575508,
              22.1282855
            ],
            [
              113.5576373,
              22.1284416
            ],
            [
              113.5576009,
              22.1284556
            ],
            [
              113.557608,
              22.1284718
            ],
            [
              113.5576045,
              22.1284865
            ],
            [
              113.5575236,
              22.1285226
            ]
          ]
        ]
      },
      "id": "way/1318571888"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1326414729",
        "amenity": "bicycle_parking"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5427168,
              22.1277589
            ],
            [
              113.5427182,
              22.1277396
            ],
            [
              113.5426605,
              22.1277402
            ],
            [
              113.5426641,
              22.1277211
            ],
            [
              113.5427187,
              22.1277218
            ],
            [
              113.5427195,
              22.1277042
            ],
            [
              113.5428603,
              22.1277042
            ],
            [
              113.5428644,
              22.1276408
            ],
            [
              113.5428925,
              22.1276346
            ],
            [
              113.5428939,
              22.1277042
            ],
            [
              113.5430347,
              22.1277067
            ],
            [
              113.543036,
              22.1277564
            ],
            [
              113.5427168,
              22.1277589
            ]
          ]
        ]
      },
      "id": "way/1326414729"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1340529902",
        "addr:housenumber": "10-30",
        "addr:street": "黃蟬街 Rua da Alamanda",
        "building": "yes",
        "height": "27.1"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5574952,
              22.1287859
            ],
            [
              113.5574615,
              22.1287275
            ],
            [
              113.5575495,
              22.1286845
            ],
            [
              113.5575961,
              22.1288023
            ],
            [
              113.5575175,
              22.1288357
            ],
            [
              113.5574988,
              22.1287939
            ],
            [
              113.5574952,
              22.1287859
            ]
          ]
        ]
      },
      "id": "way/1340529902"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1340529903",
        "addr:housenumber": "34-38",
        "addr:street": "黃蟬街 Rua da Alamanda",
        "building": "yes",
        "height": "26.7"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5574988,
              22.1287939
            ],
            [
              113.5575175,
              22.1288357
            ],
            [
              113.5575667,
              22.1289227
            ],
            [
              113.5574607,
              22.1289764
            ],
            [
              113.5573937,
              22.1288585
            ],
            [
              113.5574988,
              22.1287939
            ]
          ]
        ]
      },
      "id": "way/1340529903"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1340529904",
        "addr:housenumber": "44-48",
        "addr:street": "黃蟬街 Rua da Alamanda",
        "building": "yes",
        "height": "26"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5573916,
              22.1289096
            ],
            [
              113.5574825,
              22.1290593
            ],
            [
              113.557381,
              22.129112
            ],
            [
              113.557305,
              22.1289713
            ],
            [
              113.5573916,
              22.1289096
            ]
          ]
        ]
      },
      "id": "way/1340529904"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1340529905",
        "addr:housenumber": "54-58",
        "addr:street": "黃蟬街 Rua da Alamanda",
        "building": "yes",
        "height": "25.3"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5573142,
              22.1290104
            ],
            [
              113.5573984,
              22.1291646
            ],
            [
              113.5573078,
              22.1292061
            ],
            [
              113.5572374,
              22.1290561
            ],
            [
              113.5573142,
              22.1290104
            ]
          ]
        ]
      },
      "id": "way/1340529905"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1340529906",
        "addr:housenumber": "66-70",
        "addr:street": "黃蟬街 Rua da Alamanda",
        "building": "yes",
        "height": "24.2"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5571343,
              22.1291648
            ],
            [
              113.5572281,
              22.129111
            ],
            [
              113.5573121,
              22.129284
            ],
            [
              113.5572127,
              22.1293244
            ],
            [
              113.5571477,
              22.1291884
            ],
            [
              113.5571343,
              22.1291648
            ]
          ]
        ]
      },
      "id": "way/1340529906"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1340529907",
        "addr:housenumber": "102-106",
        "addr:street": "黃蟬街 Rua da Alamanda",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5568188,
              22.1292054
            ],
            [
              113.5568433,
              22.1292592
            ],
            [
              113.5568801,
              22.1293448
            ],
            [
              113.5567875,
              22.1293718
            ],
            [
              113.5567342,
              22.1292366
            ],
            [
              113.5568188,
              22.1292054
            ]
          ]
        ]
      },
      "id": "way/1340529907"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1340529908",
        "addr:housenumber": "92-94",
        "addr:street": "黃蟬街 Rua da Alamanda",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5568705,
              22.1292489
            ],
            [
              113.5569452,
              22.1292207
            ],
            [
              113.5569693,
              22.1292542
            ],
            [
              113.5570222,
              22.1293624
            ],
            [
              113.556936,
              22.1294
            ],
            [
              113.5568705,
              22.1292489
            ]
          ]
        ]
      },
      "id": "way/1340529908"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1340529909",
        "addr:housenumber": "80-84",
        "addr:street": "黃蟬街 Rua da Alamanda",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5570605,
              22.1292095
            ],
            [
              113.5570726,
              22.1292291
            ],
            [
              113.5571119,
              22.1292078
            ],
            [
              113.5571758,
              22.1293518
            ],
            [
              113.5570679,
              22.1293941
            ],
            [
              113.5569886,
              22.1292447
            ],
            [
              113.5570605,
              22.1292095
            ]
          ]
        ]
      },
      "id": "way/1340529909"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1346863019",
        "addr:housename": "横琴新家园",
        "addr:housename:zh": "横琴新家园",
        "building": "apartments",
        "building:levels": "24",
        "name": "9栋",
        "name:zh": "9栋",
        "start_date": "2013"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5378895,
              22.1305343
            ],
            [
              113.5379082,
              22.1305172
            ],
            [
              113.5378655,
              22.1304774
            ],
            [
              113.5378974,
              22.1304481
            ],
            [
              113.5379208,
              22.1304699
            ],
            [
              113.5379336,
              22.1304581
            ],
            [
              113.5379687,
              22.1304908
            ],
            [
              113.5379808,
              22.1304797
            ],
            [
              113.5379457,
              22.130447
            ],
            [
              113.5379585,
              22.1304351
            ],
            [
              113.5379351,
              22.1304133
            ],
            [
              113.537967,
              22.130384
            ],
            [
              113.5380054,
              22.1304199
            ],
            [
              113.5380425,
              22.1303857
            ],
            [
              113.5380489,
              22.1303917
            ],
            [
              113.538076,
              22.1303669
            ],
            [
              113.5381033,
              22.1303924
            ],
            [
              113.5381143,
              22.1303823
            ],
            [
              113.5381698,
              22.1304341
            ],
            [
              113.5380109,
              22.1305803
            ],
            [
              113.5379688,
              22.130541
            ],
            [
              113.5379403,
              22.1305672
            ],
            [
              113.5379402,
              22.1306047
            ],
            [
              113.5379702,
              22.1306048
            ],
            [
              113.5379699,
              22.1306971
            ],
            [
              113.5378703,
              22.1306968
            ],
            [
              113.5378707,
              22.1306062
            ],
            [
              113.5378451,
              22.1306061
            ],
            [
              113.5378453,
              22.1305342
            ],
            [
              113.5378895,
              22.1305343
            ]
          ]
        ]
      },
      "id": "way/1346863019"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1346868192",
        "access": "private",
        "leisure": "pitch",
        "sport": "basketball"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.536563,
              22.130243
            ],
            [
              113.5367057,
              22.1302436
            ],
            [
              113.5367044,
              22.1304862
            ],
            [
              113.5365616,
              22.1304855
            ],
            [
              113.536563,
              22.130243
            ]
          ]
        ]
      },
      "id": "way/1346868192"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1346868193",
        "access": "private",
        "leisure": "pitch",
        "sport": "basketball"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5363933,
              22.1302447
            ],
            [
              113.5365361,
              22.1302454
            ],
            [
              113.5365347,
              22.130488
            ],
            [
              113.536392,
              22.1304873
            ],
            [
              113.5363933,
              22.1302447
            ]
          ]
        ]
      },
      "id": "way/1346868193"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1346868691",
        "amenity": "parking",
        "parking": "surface"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5380182,
              22.1346542
            ],
            [
              113.5380135,
              22.1346989
            ],
            [
              113.5376054,
              22.1346623
            ],
            [
              113.5375487,
              22.134654
            ],
            [
              113.5368938,
              22.1345581
            ],
            [
              113.536457,
              22.1345605
            ],
            [
              113.5364083,
              22.1345159
            ],
            [
              113.5368975,
              22.1345132
            ],
            [
              113.5375563,
              22.1346097
            ],
            [
              113.5376115,
              22.1346177
            ],
            [
              113.5380182,
              22.1346542
            ]
          ]
        ]
      },
      "id": "way/1346868691"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1346868692",
        "amenity": "parking",
        "parking": "surface"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5375048,
              22.1347363
            ],
            [
              113.5368867,
              22.1346458
            ],
            [
              113.5363807,
              22.1346485
            ],
            [
              113.5363419,
              22.1346061
            ],
            [
              113.5368902,
              22.1346031
            ],
            [
              113.5374676,
              22.1346876
            ],
            [
              113.5375048,
              22.1347363
            ]
          ]
        ]
      },
      "id": "way/1346868692"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1346868693",
        "amenity": "parking",
        "parking": "surface"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5378991,
              22.1348681
            ],
            [
              113.5382259,
              22.1347858
            ],
            [
              113.5382395,
              22.1348322
            ],
            [
              113.5379128,
              22.1349145
            ],
            [
              113.5378991,
              22.1348681
            ]
          ]
        ]
      },
      "id": "way/1346868693"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1347028570",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5359602,
              22.1293471
            ],
            [
              113.5355479,
              22.1293137
            ],
            [
              113.5355765,
              22.1290107
            ],
            [
              113.5361322,
              22.1290557
            ],
            [
              113.5362096,
              22.1290223
            ],
            [
              113.53628,
              22.1289632
            ],
            [
              113.5366149,
              22.1289904
            ],
            [
              113.5365895,
              22.1292598
            ],
            [
              113.5363168,
              22.1292377
            ],
            [
              113.5359602,
              22.1293471
            ]
          ]
        ]
      },
      "id": "way/1347028570"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1347028572",
        "addr:housenumber": "139",
        "addr:street": "彩虹路",
        "landuse": "commercial",
        "name": "大橫琴高級人才酒店",
        "name:en": "Dahengqin Superior Talent Hotel",
        "name:zh": "大橫琴高級人才酒店",
        "start_date": "2016",
        "tourism": "hotel"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5355932,
              22.1288346
            ],
            [
              113.5366344,
              22.128919
            ],
            [
              113.5366182,
              22.1293627
            ],
            [
              113.5362062,
              22.1293617
            ],
            [
              113.5355427,
              22.1293689
            ],
            [
              113.5355479,
              22.1293137
            ],
            [
              113.5355765,
              22.1290107
            ],
            [
              113.5355932,
              22.1288346
            ]
          ]
        ]
      },
      "id": "way/1347028572"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1359240146",
        "amenity": "shelter",
        "building": "yes",
        "shelter_type": "gazebo"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5517312,
              22.1295995
            ],
            [
              113.5517069,
              22.1295588
            ],
            [
              113.5517316,
              22.1295462
            ],
            [
              113.5517559,
              22.1295869
            ],
            [
              113.5517312,
              22.1295995
            ]
          ]
        ]
      },
      "id": "way/1359240146"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1363006924",
        "amenity": "shelter",
        "building": "yes",
        "shelter_type": "gazebo"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5559509,
              22.1211682
            ],
            [
              113.555937,
              22.1211553
            ],
            [
              113.555943,
              22.121138
            ],
            [
              113.5559621,
              22.1211343
            ],
            [
              113.5559752,
              22.1211464
            ],
            [
              113.5559701,
              22.1211641
            ],
            [
              113.5559509,
              22.1211682
            ]
          ]
        ]
      },
      "id": "way/1363006924"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1363006925",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5563338,
              22.1198865
            ],
            [
              113.5562884,
              22.1198676
            ],
            [
              113.5563361,
              22.1197971
            ],
            [
              113.5564076,
              22.1197382
            ],
            [
              113.5566779,
              22.119573
            ],
            [
              113.5567154,
              22.1196204
            ],
            [
              113.5564542,
              22.1197771
            ],
            [
              113.5563929,
              22.1198287
            ],
            [
              113.5563338,
              22.1198865
            ]
          ]
        ]
      },
      "id": "way/1363006925"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1363006926",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5562441,
              22.1198013
            ],
            [
              113.5563792,
              22.1196845
            ],
            [
              113.5564088,
              22.119714
            ],
            [
              113.5562714,
              22.1198308
            ],
            [
              113.5562441,
              22.1198013
            ]
          ]
        ]
      },
      "id": "way/1363006926"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1363006928",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5562187,
              22.1197872
            ],
            [
              113.5561795,
              22.1197499
            ],
            [
              113.5563326,
              22.1196309
            ],
            [
              113.5563659,
              22.1196648
            ],
            [
              113.5562187,
              22.1197872
            ]
          ]
        ]
      },
      "id": "way/1363006928"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1363006931",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.556296,
              22.11958
            ],
            [
              113.5563289,
              22.1196178
            ],
            [
              113.55612,
              22.1197736
            ],
            [
              113.5560871,
              22.1197358
            ],
            [
              113.556296,
              22.11958
            ]
          ]
        ]
      },
      "id": "way/1363006931"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1363006946",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5556787,
              22.1198725
            ],
            [
              113.5559143,
              22.1198444
            ],
            [
              113.5559388,
              22.1199703
            ],
            [
              113.5558733,
              22.119983
            ],
            [
              113.555883,
              22.1200328
            ],
            [
              113.555682,
              22.120035
            ],
            [
              113.5556787,
              22.1198725
            ]
          ]
        ]
      },
      "id": "way/1363006946"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1371621758",
        "building": "yes",
        "height": "17.3"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5528416,
              22.1305226
            ],
            [
              113.5531372,
              22.1305213
            ],
            [
              113.5531386,
              22.1305446
            ],
            [
              113.5532571,
              22.1305433
            ],
            [
              113.5532557,
              22.1306634
            ],
            [
              113.5528388,
              22.1306686
            ],
            [
              113.5528416,
              22.1305226
            ]
          ]
        ]
      },
      "id": "way/1371621758"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1371621759",
        "building": "yes",
        "height": "8.7"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5524236,
              22.1304565
            ],
            [
              113.5524224,
              22.1304004
            ],
            [
              113.5525054,
              22.1303989
            ],
            [
              113.5525066,
              22.1304551
            ],
            [
              113.5524236,
              22.1304565
            ]
          ]
        ]
      },
      "id": "way/1371621759"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1371621760",
        "building": "yes",
        "height": "9.7"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5525308,
              22.1304013
            ],
            [
              113.5527462,
              22.1303966
            ],
            [
              113.5527481,
              22.1304709
            ],
            [
              113.5525327,
              22.1304756
            ],
            [
              113.5525308,
              22.1304013
            ]
          ]
        ]
      },
      "id": "way/1371621760"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1371621761",
        "building": "yes",
        "height": "8"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5528539,
              22.1304099
            ],
            [
              113.5530495,
              22.1304046
            ],
            [
              113.5530515,
              22.1304667
            ],
            [
              113.5528558,
              22.130472
            ],
            [
              113.5528539,
              22.1304099
            ]
          ]
        ]
      },
      "id": "way/1371621761"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1371621762",
        "building": "yes",
        "height": "8"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5531769,
              22.1295893
            ],
            [
              113.5531934,
              22.1295322
            ],
            [
              113.5532218,
              22.1295392
            ],
            [
              113.5532053,
              22.1295963
            ],
            [
              113.5531769,
              22.1295893
            ]
          ]
        ]
      },
      "id": "way/1371621762"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1371621763",
        "building": "yes",
        "height": "18.5"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.553237,
              22.1307512
            ],
            [
              113.5534024,
              22.1307446
            ],
            [
              113.5534071,
              22.1308466
            ],
            [
              113.5532418,
              22.1308532
            ],
            [
              113.553237,
              22.1307512
            ]
          ]
        ]
      },
      "id": "way/1371621763"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1371621764",
        "building": "yes",
        "height": "7.3"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5528346,
              22.1288448
            ],
            [
              113.5528449,
              22.1288073
            ],
            [
              113.5529621,
              22.128835
            ],
            [
              113.5529518,
              22.1288725
            ],
            [
              113.5528346,
              22.1288448
            ]
          ]
        ]
      },
      "id": "way/1371621764"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1371621765",
        "building": "yes",
        "height": "9.9"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5534224,
              22.1289456
            ],
            [
              113.5534674,
              22.1289569
            ],
            [
              113.5534263,
              22.1290968
            ],
            [
              113.5533813,
              22.1290854
            ],
            [
              113.5534224,
              22.1289456
            ]
          ]
        ]
      },
      "id": "way/1371621765"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1371621766",
        "building": "yes",
        "height": "11"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5564397,
              22.1268528
            ],
            [
              113.5563533,
              22.1262368
            ],
            [
              113.5566409,
              22.1262806
            ],
            [
              113.5566964,
              22.1262948
            ],
            [
              113.5569191,
              22.1263773
            ],
            [
              113.5571409,
              22.1264523
            ],
            [
              113.5573045,
              22.1265333
            ],
            [
              113.5576334,
              22.1267123
            ],
            [
              113.5576786,
              22.1267403
            ],
            [
              113.5577608,
              22.1268178
            ],
            [
              113.5578308,
              22.1268963
            ],
            [
              113.5580186,
              22.1270933
            ],
            [
              113.5582096,
              22.1274049
            ],
            [
              113.5583344,
              22.1276899
            ],
            [
              113.5584299,
              22.1280004
            ],
            [
              113.5585012,
              22.1282329
            ],
            [
              113.5585417,
              22.1286919
            ],
            [
              113.5579376,
              22.1287159
            ],
            [
              113.5579053,
              22.1284459
            ],
            [
              113.558017,
              22.1283604
            ],
            [
              113.5580526,
              22.1282809
            ],
            [
              113.5580364,
              22.1281984
            ],
            [
              113.5579555,
              22.1281219
            ],
            [
              113.5578632,
              22.1280859
            ],
            [
              113.5575814,
              22.1273043
            ],
            [
              113.5576041,
              22.1272428
            ],
            [
              113.5576122,
              22.1271678
            ],
            [
              113.5575943,
              22.1270988
            ],
            [
              113.5575474,
              22.1270688
            ],
            [
              113.5574518,
              22.1270673
            ],
            [
              113.5573887,
              22.1270688
            ],
            [
              113.5572575,
              22.1269578
            ],
            [
              113.5571118,
              22.1269338
            ],
            [
              113.5566324,
              22.1268708
            ],
            [
              113.5564397,
              22.1268528
            ]
          ]
        ]
      },
      "id": "way/1371621766"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1371621767",
        "building": "yes",
        "height": "10.2"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5526445,
              22.1208121
            ],
            [
              113.5527363,
              22.12077
            ],
            [
              113.5527615,
              22.1208172
            ],
            [
              113.5526697,
              22.1208594
            ],
            [
              113.5526445,
              22.1208121
            ]
          ]
        ]
      },
      "id": "way/1371621767"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1371621768",
        "building": "yes",
        "height": "14.7"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5528752,
              22.1208559
            ],
            [
              113.5528415,
              22.1208145
            ],
            [
              113.5528733,
              22.1207922
            ],
            [
              113.5528631,
              22.1207797
            ],
            [
              113.5529329,
              22.1207309
            ],
            [
              113.5529768,
              22.1207849
            ],
            [
              113.5528752,
              22.1208559
            ]
          ]
        ]
      },
      "id": "way/1371621768"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1371621769",
        "building": "yes",
        "height": "27.8"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5527937,
              22.1201453
            ],
            [
              113.5528489,
              22.1201574
            ],
            [
              113.5528278,
              22.1202397
            ],
            [
              113.5527889,
              22.1202312
            ],
            [
              113.5527973,
              22.1201986
            ],
            [
              113.552781,
              22.120195
            ],
            [
              113.5527937,
              22.1201453
            ]
          ]
        ]
      },
      "id": "way/1371621769"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1371621770",
        "building": "yes",
        "height": "27.7"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5528178,
              22.1201072
            ],
            [
              113.5528256,
              22.1200757
            ],
            [
              113.552814,
              22.1200734
            ],
            [
              113.5528275,
              22.1200229
            ],
            [
              113.5528799,
              22.120035
            ],
            [
              113.5528581,
              22.1201162
            ],
            [
              113.5528178,
              22.1201072
            ]
          ]
        ]
      },
      "id": "way/1371621770"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1371621772",
        "building": "yes",
        "height": "33.8"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5507538,
              22.1197243
            ],
            [
              113.5507691,
              22.1195988
            ],
            [
              113.5509275,
              22.1196171
            ],
            [
              113.55091,
              22.1197425
            ],
            [
              113.5507538,
              22.1197243
            ]
          ]
        ]
      },
      "id": "way/1371621772"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1371621774",
        "building": "yes",
        "height": "46.7"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5514129,
              22.1198359
            ],
            [
              113.5520828,
              22.1199335
            ],
            [
              113.5520308,
              22.11989
            ],
            [
              113.552079,
              22.1198218
            ],
            [
              113.5522135,
              22.1199264
            ],
            [
              113.552216,
              22.1199558
            ],
            [
              113.5522072,
              22.1199781
            ],
            [
              113.5521856,
              22.1199934
            ],
            [
              113.5520879,
              22.1199816
            ],
            [
              113.5520739,
              22.1200557
            ],
            [
              113.5518303,
              22.1200251
            ],
            [
              113.5518342,
              22.1199969
            ],
            [
              113.5514028,
              22.1199264
            ],
            [
              113.5514129,
              22.1198359
            ]
          ]
        ]
      },
      "id": "way/1371621774"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1376976963",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.551684,
              22.1214842
            ],
            [
              113.551887,
              22.1211127
            ],
            [
              113.5519394,
              22.1211372
            ],
            [
              113.552016,
              22.120997
            ],
            [
              113.5521832,
              22.1210753
            ],
            [
              113.5519706,
              22.1214648
            ],
            [
              113.5518599,
              22.1214129
            ],
            [
              113.551793,
              22.1215353
            ],
            [
              113.551684,
              22.1214842
            ]
          ]
        ]
      },
      "id": "way/1376976963"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1376976964",
        "building": "yes"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.551383,
              22.1212892
            ],
            [
              113.5516004,
              22.1208778
            ],
            [
              113.5517242,
              22.120934
            ],
            [
              113.5515069,
              22.1213453
            ],
            [
              113.551383,
              22.1212892
            ]
          ]
        ]
      },
      "id": "way/1376976964"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "way/1377221839",
        "amenity": "shelter",
        "building": "yes",
        "name": "蘇澳亭",
        "name:zh": "蘇澳亭"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              113.5449147,
              22.1257171
            ],
            [
              113.5449141,
              22.1256919
            ],
            [
              113.5449136,
              22.1256688
            ],
            [
              113.5449664,
              22.1256677
            ],
            [
              113.544967,
              22.125692
            ],
            [
              113.5449675,
              22.1257161
            ],
            [
              113.5449147,
              22.1257171
            ]
          ]
        ]
      },
      "id": "way/1377221839"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2165427382",
        "asset_ref": "C655",
        "bus": "yes",
        "highway": "bus_stop",
        "name": "石排灣郊野公園 Parque de Seac Pai Van",
        "name:en": "Seac Pai Van Park",
        "name:pt": "Parque de Seac Pai Van",
        "name:zh": "石排灣郊野公園",
        "public_transport": "platform",
        "ref": "C655",
        "route_ref": "15;21A;25;26;26A;50;N3",
        "shelter": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5551595,
          22.1252319
        ]
      },
      "id": "node/2165427382"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2165428254",
        "asset_ref": "C654",
        "bus": "yes",
        "highway": "bus_stop",
        "local_ref": "B",
        "name": "聯生圓形地總站 Rotunda da Concórdia/ Terminal",
        "name:pt": "Rotunda da Concórdia/ Terminal",
        "name:zh": "聯生圓形地總站",
        "public_transport": "platform",
        "route_ref": "15;21A;25;26;26A;50;N3",
        "shelter": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5549759,
          22.1256771
        ]
      },
      "id": "node/2165428254"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2165428506",
        "asset_ref": "C657",
        "bus": "yes",
        "highway": "bus_stop",
        "name": "路環警察訓練營-1 Est. do Campo / PSP-1",
        "name:pt": "Est. do Campo / PSP-1",
        "name:zh": "路環警察訓練營-1",
        "public_transport": "platform",
        "route_ref": "15;21A;25;26;26A;50;N3",
        "shelter": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5535309,
          22.1204702
        ]
      },
      "id": "node/2165428506"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2165428507",
        "asset_ref": "C656",
        "bus": "yes",
        "highway": "bus_stop",
        "name": "路環警察訓練營-2 Est. do Campo / PSP-2",
        "name:pt": "Est. do Campo / PSP-2",
        "name:zh": "路環警察訓練營-2",
        "public_transport": "platform",
        "route_ref": "15;21A;25;26;26A;50;N3",
        "shelter": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5533456,
          22.1205118
        ]
      },
      "id": "node/2165428507"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2392889289",
        "museum": "nature",
        "name": "土地暨自然博物館 Museu Natural e Agrário",
        "name:en": "Natural and Agrarian Museum",
        "name:pt": "Museu Natural e Agrário",
        "name:zh": "土地暨自然博物館",
        "opening_hours": "Mo-Fr 10:00-17:00",
        "operator": "iam",
        "operator:type": "government",
        "tourism": "museum",
        "website": "https://nature.iacm.gov.mo",
        "wikidata": "Q10927675",
        "wikimedia_commons": "Category:Natural and Agrarian Museum",
        "wikipedia": "en:Natural and Agrarian Museum"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5567544,
          22.1257575
        ]
      },
      "id": "node/2392889289"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2492640348",
        "asset_ref": "T551",
        "bus": "yes",
        "highway": "bus_stop",
        "image": "http://www.dsat.gov.mo/bres/bus_stop_img/t551_1.jpg",
        "name": "T551 澳大/研究生宿舍 UM / Postgarduate House",
        "name:en": "T551 UM / Postgarduate House",
        "name:pt": "T551 Um / Residência de E. de Pós-Graduação",
        "name:zh": "T551 澳大/研究生宿舍",
        "public_transport": "platform",
        "route_ref": "71;71S;72;73",
        "shelter": "yes",
        "tactile_paving": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5461955,
          22.1248107
        ]
      },
      "id": "node/2492640348"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2492714502",
        "asset_ref": "T559",
        "bus": "yes",
        "highway": "bus_stop",
        "image": "http://www.dsat.gov.mo/bres/bus_stop_img/t559_1.jpg",
        "name": "T559 大學南 University South",
        "name:en": "T559 University South",
        "name:pt": "T559 Sul da Universidade",
        "name:zh": "T559 大學南",
        "public_transport": "platform",
        "ref": "T559",
        "route_ref": "71;71S;72;73",
        "shelter": "yes",
        "tactile_paving": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5461875,
          22.1241639
        ]
      },
      "id": "node/2492714502"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2561573383",
        "asset_ref": "T552",
        "bus": "yes",
        "highway": "bus_stop",
        "image": "http://www.dsat.gov.mo/bres/bus_stop_img/t552_1.jpg",
        "name": "T552 澳大/中央教學樓 UM / Central Teaching Building",
        "name:en": "T552 UM / Central Teaching Building",
        "name:pt": "T552 UM / Sala de Aulas: Edifício Central",
        "name:zh": "T552 澳大/中央教學樓",
        "public_transport": "platform",
        "route_ref": "71;71S;72;73",
        "shelter": "yes",
        "tactile_paving": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5464616,
          22.1281889
        ]
      },
      "id": "node/2561573383"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2561573384",
        "asset_ref": "T553",
        "bus": "yes",
        "highway": "bus_stop",
        "image": "http://www.dsat.gov.mo/bres/bus_stop_img/t553_1.jpg",
        "name": "T553 澳大/大學展館 UM / University Gallery",
        "name:en": "T553 UM / University Gallery",
        "name:pt": "T553 UM / Galeria da Universidade",
        "name:zh": "T553 澳大/大學展館",
        "public_transport": "platform",
        "ref": "T553",
        "route_ref": "71;71S;72;73",
        "shelter": "yes",
        "tactile_paving": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5463655,
          22.1310649
        ]
      },
      "id": "node/2561573384"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2597928920",
        "asset_ref": "T555",
        "bus": "yes",
        "highway": "bus_stop",
        "image": "http://www.dsat.gov.mo/bres/bus_stop_img/t555_1.jpg",
        "name": "T555 澳大/綜合體育館 UM / Sport Complex",
        "name:en": "T555 UM / Sport Complex",
        "name:pt": "T555 UM / Complexo Desportivo",
        "name:zh": "T555 澳大/綜合體育館",
        "public_transport": "platform",
        "route_ref": "71;71S;72;73",
        "shelter": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5432263,
          22.1339277
        ]
      },
      "id": "node/2597928920"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2597928921",
        "asset_ref": "T550/2",
        "bus": "yes",
        "highway": "bus_stop",
        "image": "http://www.dsat.gov.mo/bres/bus_stop_img/t550_2.jpg",
        "local_ref": "A",
        "name": "T550/2 澳門大學總站(A車道) University of Macau / Terminal (Lane A)",
        "name:en": "T550/2 University of Macau / Terminal (Lane A)",
        "name:pt": "T550/2 Universidade de Macau / Terminal (Lane A)",
        "name:zh": "T550/2 澳門大學總站(A車道)",
        "public_transport": "platform",
        "route_ref": "72",
        "shelter": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5462997,
          22.135698
        ]
      },
      "id": "node/2597928921"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2597928922",
        "asset_ref": "T554",
        "bus": "yes",
        "highway": "bus_stop",
        "image": "http://www.dsat.gov.mo/bres/bus_stop_img/t554_1.jpg",
        "name": "T554 澳大/大學會堂 UM / University Hall",
        "name:en": "T554 UM / University Hall",
        "name:pt": "T554 UM / Aula Magna da Universidade",
        "name:zh": "T554 澳大/大學會堂",
        "public_transport": "platform",
        "ref": "T554",
        "route_ref": "71;71S;72;73",
        "shelter": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5463541,
          22.1341062
        ]
      },
      "id": "node/2597928922"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2597928924",
        "asset_ref": "T558",
        "bus": "yes",
        "highway": "bus_stop",
        "image": "http://www.dsat.gov.mo/bres/bus_stop_img/t558_1.jpg",
        "is_in": "T558 Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "T558 大學大馬路 University Avenue",
        "name:en": "T558 University Avenue",
        "name:pt": "T558 Avenida da Universidade",
        "name:zh": "T558 大學大馬路",
        "public_transport": "platform",
        "ref": "T558",
        "route_ref": "71;71S;72;73",
        "shelter": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5468585,
          22.1305253
        ]
      },
      "id": "node/2597928924"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2772915210",
        "bus": "yes",
        "highway": "bus_stop",
        "name": "濠江路口",
        "public_transport": "platform",
        "route_ref": "14;86;K10;K11"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5401026,
          22.1324004
        ]
      },
      "id": "node/2772915210"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2772915211",
        "bus": "yes",
        "highway": "bus_stop",
        "name": "横琴新家园",
        "name:zh-Hant": "橫琴新家園",
        "public_transport": "platform",
        "route_ref": "14;86;K10;K11"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5402472,
          22.1280445
        ]
      },
      "id": "node/2772915211"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2772915212",
        "bus": "yes",
        "highway": "bus_stop",
        "name": "横琴新家园",
        "name:zh-Hant": "橫琴新家園",
        "public_transport": "platform",
        "route_ref": "14;86;K10;K11"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5397519,
          22.128455
        ]
      },
      "id": "node/2772915212"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2772915213",
        "bus": "yes",
        "highway": "bus_stop",
        "name": "粗沙环",
        "name:zh-Hant": "粗沙環",
        "public_transport": "platform",
        "route_ref": "14;63;86;K10;K11"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5374555,
          22.1269248
        ]
      },
      "id": "node/2772915213"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2772915214",
        "bus": "yes",
        "highway": "bus_stop",
        "name": "粗沙环",
        "name:zh-Hant": "粗沙環",
        "public_transport": "platform",
        "route_ref": "14;63;86;K10;K11"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5400324,
          22.1246527
        ]
      },
      "id": "node/2772915214"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2929238176",
        "asset_ref": "T556",
        "bus": "yes",
        "highway": "bus_stop",
        "image": "http://www.dsat.gov.mo/bres/bus_stop_img/t556_1.jpg",
        "name": "T556 澳大/行政樓 UM / Administration Building",
        "name:en": "T556 UM / Administration Building",
        "name:pt": "T556 UM / Edifício Administrativo",
        "name:zh": "T556 澳大/行政樓",
        "public_transport": "platform",
        "route_ref": "71;71S;72;73",
        "shelter": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5435897,
          22.1340304
        ]
      },
      "id": "node/2929238176"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931446524",
        "access": "private",
        "amenity": "parking",
        "description": "Location: Staff Quarters (S21-S35) Regular Parking Area",
        "description:en": "Location: Staff Quarters (S21-S35) Regular Parking Area",
        "description:zh": "所在位置: 教職員宿舍定位泊車區(S21-S35)",
        "fee": "yes",
        "image": "https://map.um.edu.mo/emap_images/car-park_P7.jpg",
        "name": "P7住客停車場 Resident Car Park P7",
        "name:en": "Resident Car Park P7",
        "name:zh": "P7住客停車場",
        "payment:cash": "yes",
        "website": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:en": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:zh": "https://sfs.cmdo.um.edu.mo/%e6%88%91%e5%80%91%e7%9a%84%e6%9c%8d%e5%8b%99/%e5%81%9c%e8%bb%8a%e5%a0%b4%e7%ae%a1%e7%90%86/?lang=zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5461923,
          22.1226756
        ]
      },
      "id": "node/2931446524"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931447057",
        "amenity": "bicycle_parking",
        "capacity": "60",
        "covered": "no"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5442582,
          22.1233972
        ]
      },
      "id": "node/2931447057"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931447429",
        "description": "Location: G/F, University Mall (S8)",
        "description:en": "Location: G/F, University Mall (S8)",
        "description:zh": "所在位置: 薈萃坊 (S8), G樓",
        "image": "https://map.um.edu.mo/emap_images/retail-shop_cits-travel-agency.jpg",
        "name": "澳門中國國際旅行社 CITS (Macao) Travel Agency",
        "name:en": "China International Travel Service Lda (Macao)",
        "name:pt": "Serviço de Viagem Internacional da China Lda",
        "name:zh": "澳門中國國際旅行社",
        "opening_hours": "Tu-Su 10:00-19:00",
        "shop": "travel_agency",
        "short_name": "中國國旅",
        "website": "https://css.cmdo.um.edu.mo/outlets/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5443718,
          22.1241139
        ]
      },
      "id": "node/2931447429"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931447451",
        "amenity": "restaurant",
        "description": "Location: Room G013, University Mall (S8)",
        "description:en": "Location: Room G013, University Mall (S8)",
        "description:zh": "所在位置: 薈萃坊 (S8), G013室",
        "image": "https://map.um.edu.mo/emap_images/dining-outlet_padaria-da-guia.jpg",
        "name": "東望洋餅店 Padaria da Guia (Bakery)",
        "name:en": "Padaria da Guia (Bakery)",
        "name:zh": "東望洋餅店",
        "opening_hours": "Mo-Su 08:00-22:00",
        "shop": "bakery",
        "website": "https://css.cmdo.um.edu.mo/portfolio-items/padaria-da-guia/?portfolioCats=159%2C158%2C247"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5442718,
          22.1242756
        ]
      },
      "id": "node/2931447451"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931447460",
        "description": "Location: 2/F, University Mall (S8)",
        "description:en": "Location: 2/F, University Mall (S8)",
        "description:zh": "所在位置: 薈萃坊 (S8), 2樓",
        "image": "https://map.um.edu.mo/emap_images/retail-shop_luen-fung-supermarket.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "聯豐超級市場 Luen Fung Supermarket",
        "name:en": "Luen Fung Supermarket",
        "name:pt": "Supermercado Luen Fung",
        "name:zh": "聯豐超級市場",
        "opening_hours": "Mo-Su 08:30-23:00",
        "shop": "supermarket",
        "short_name": "聯豐",
        "website": "https://css.cmdo.um.edu.mo/outlets/",
        "wheelchair": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5442545,
          22.124085
        ]
      },
      "id": "node/2931447460"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931447476",
        "amenity": "bicycle_parking"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5440913,
          22.1245353
        ]
      },
      "id": "node/2931447476"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931447758",
        "access": "yes",
        "amenity": "bicycle_parking",
        "capacity": "50",
        "covered": "no",
        "fee": "no",
        "surveillance": "none"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5460411,
          22.1251884
        ]
      },
      "id": "node/2931447758"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931448068",
        "amenity": "bicycle_parking"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5440773,
          22.1266295
        ]
      },
      "id": "node/2931448068"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931448299",
        "amenity": "bicycle_parking"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5419181,
          22.1282396
        ]
      },
      "id": "node/2931448299"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931448402",
        "amenity": "drinking_water",
        "indoor": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5454186,
          22.1283748
        ]
      },
      "id": "node/2931448402"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931448403",
        "amenity": "bicycle_parking"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5446344,
          22.1283928
        ]
      },
      "id": "node/2931448403"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931448405",
        "access": "yes",
        "amenity": "parking",
        "capacity": "550",
        "capacity:parent": "no",
        "capacity:women": "no",
        "description": "Location: UM Wu Yee Sun Library (E2) & Central Teaching Buildings (E3-E7)",
        "description:en": "Location: UM Wu Yee Sun Library (E2) & Central Teaching Buildings (E3-E7)",
        "description:zh": "所在位置: 澳門大學伍宜孫圖書館(E2)及中央教學樓(E3-E7)",
        "fee": "yes",
        "image": "https://map.um.edu.mo/emap_images/car-park_P5A.jpg",
        "name": "P5A訪客停車場 Visitor Car Park P5A",
        "name:en": "Visitor Car Park P5A",
        "name:zh": "P5A訪客停車場",
        "opening_hours": "24/7",
        "payment:cash": "yes",
        "website": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:en": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:zh": "https://sfs.cmdo.um.edu.mo/%e6%88%91%e5%80%91%e7%9a%84%e6%9c%8d%e5%8b%99/%e5%81%9c%e8%bb%8a%e5%a0%b4%e7%ae%a1%e7%90%86/?lang=zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5448577,
          22.1278848
        ]
      },
      "id": "node/2931448405"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931448428",
        "access": "private",
        "amenity": "parking",
        "description": "Location: Humanities & Social Sciences Building (E21) & Faculty of Business Administration (E22)",
        "description:en": "Location: Humanities & Social Sciences Building (E21) & Faculty of Business Administration (E22)",
        "description:zh": "所在位置: 人文社科樓(E21)及工商管理學院(E21)",
        "fee": "no",
        "image": "https://map.um.edu.mo/emap_images/car-park_P4.jpg",
        "layer": "-1",
        "name": "P4職員停車場 Staff Car Park P4",
        "name:en": "Staff Car Park P4",
        "name:zh": "P4職員停車場",
        "parking": "underground",
        "website": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:en": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:zh": "https://sfs.cmdo.um.edu.mo/%e6%88%91%e5%80%91%e7%9a%84%e6%9c%8d%e5%8b%99/%e5%81%9c%e8%bb%8a%e5%a0%b4%e7%ae%a1%e7%90%86/?lang=zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5425705,
          22.1298204
        ]
      },
      "id": "node/2931448428"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931448451",
        "amenity": "bicycle_parking"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5423749,
          22.1289895
        ]
      },
      "id": "node/2931448451"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931448473",
        "amenity": "bicycle_parking",
        "capacity": "50",
        "covered": "no"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.546382,
          22.1294888
        ]
      },
      "id": "node/2931448473"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931448635",
        "amenity": "restaurant",
        "description": "Location: Room G036,  UM Wu Yee Sun Library",
        "description:en": "Location: Room G036,  UM Wu Yee Sun Library",
        "description:zh": "所在位置: 澳門大學伍宜孫圖書館, G036室",
        "image": "https://map.um.edu.mo/emap_images/dining-outlet_cafe-rose-garden.jpg",
        "name": "玫瑰園 Café Rose Garden",
        "name:en": "Café Rose Garden",
        "name:zh": "玫瑰園",
        "opening_hours": "Mo-Su 08:00-22:00",
        "website": "https://css.cmdo.um.edu.mo/portfolio-items/caferosegarden/?portfolioCats=159%2C158%2C247"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5450764,
          22.130596
        ]
      },
      "id": "node/2931448635"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931448921",
        "amenity": "bicycle_parking"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5422332,
          22.1314874
        ]
      },
      "id": "node/2931448921"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931448974",
        "amenity": "bicycle_parking"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5425576,
          22.1319922
        ]
      },
      "id": "node/2931448974"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931449198",
        "amenity": "bicycle_parking"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5421135,
          22.1330515
        ]
      },
      "id": "node/2931449198"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931449457",
        "access": "private",
        "amenity": "parking",
        "description": "Location: Administration Building (N6)",
        "description:en": "Location: Administration Building (N6)",
        "description:zh": "所在位置: 行政樓(N6)",
        "image": "https://map.um.edu.mo/emap_images/car-park_P2.jpg",
        "name": "P2職員停車場 Staff Car Park P2",
        "name:en": "Staff Car Park P2",
        "name:zh": "P2職員停車場",
        "opening_hours": "24/7",
        "website": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:en": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:zh": "https://sfs.cmdo.um.edu.mo/%e6%88%91%e5%80%91%e7%9a%84%e6%9c%8d%e5%8b%99/%e5%81%9c%e8%bb%8a%e5%a0%b4%e7%ae%a1%e7%90%86/?lang=zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5437131,
          22.1343848
        ]
      },
      "id": "node/2931449457"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931449461",
        "access": "yes",
        "amenity": "parking",
        "description": "Location: UM Guest House (N1) & University Hall (N2)",
        "description:en": "Location: UM Guest House (N1) & University Hall (N2)",
        "description:zh": "所在位置: 聚賢樓(N1)及大學會堂(N2)",
        "image": "https://map.um.edu.mo/emap_images/car-park_P3.jpg",
        "name": "P3訪客停車場 Visitor Car Park P3",
        "name:en": "Visitor Car Park P3",
        "name:zh": "P3訪客停車場",
        "opening_hours": "24/7",
        "website": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:en": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:zh": "https://sfs.cmdo.um.edu.mo/%e6%88%91%e5%80%91%e7%9a%84%e6%9c%8d%e5%8b%99/%e5%81%9c%e8%bb%8a%e5%a0%b4%e7%ae%a1%e7%90%86/?lang=zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.546095,
          22.1332581
        ]
      },
      "id": "node/2931449461"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2931449477",
        "access": "yes",
        "amenity": "parking",
        "description": "Location: UM Sports Complex (N8)",
        "description:en": "Location: UM Sports Complex (N8)",
        "description:zh": "所在位置: 澳大綜合體育館(N8)",
        "fee": "yes",
        "image": "https://map.um.edu.mo/emap_images/car-park_P1.jpg",
        "name": "P1訪客停車場 Visitor Car Park P1",
        "name:en": "Visitor Car Park P1",
        "name:zh": "P1訪客停車場",
        "payment:cash": "yes",
        "website": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:en": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:zh": "https://sfs.cmdo.um.edu.mo/%e6%88%91%e5%80%91%e7%9a%84%e6%9c%8d%e5%8b%99/%e5%81%9c%e8%bb%8a%e5%a0%b4%e7%ae%a1%e7%90%86/?lang=zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5428093,
          22.1345372
        ]
      },
      "id": "node/2931449477"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2948030377",
        "amenity": "restaurant",
        "description": "Location: Room E5-G081, E6-G091, Central Teaching Building (E5)",
        "description:en": "Location: Room E5-G081, E6-G091, Central Teaching Building (E5)",
        "description:zh": "所在位置: 中央教學樓 (E5) E5-G081, E6-G091室",
        "image": "https://map.um.edu.mo/emap_images/dining-outlet_next-kitchen.jpg",
        "name": "時光屋 Next Kitchen",
        "name:en": "Next Kitchen",
        "name:zh": "時光屋",
        "opening_hours": "Mo-Su 08:00-20:00",
        "website": "https://css.cmdo.um.edu.mo/portfolio-items/nextkitchen/?portfolioCats=159%2C158%2C247"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5451277,
          22.128045
        ]
      },
      "id": "node/2948030377"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3005526042",
        "leisure": "marina",
        "seamark:harbour:category": "marina",
        "seamark:type": "harbour"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.547382,
          22.1355756
        ]
      },
      "id": "node/3005526042"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3016306583",
        "description": "Location: G/F, University Mall (S8)",
        "description:en": "Location: G/F, University Mall (S8)",
        "description:zh": "所在位置: 薈萃坊 (S8), G樓",
        "image": "https://map.um.edu.mo/emap_images/retail-shop_excel.jpg",
        "name": "卓越科技有限公司 Excel Technology Lda",
        "name:en": "Excel Technology Lda",
        "name:zh": "卓越科技有限公司",
        "opening_hours": "Mo-Fr 10:00-18:00; Sa 10:00-14:00",
        "shop": "computer",
        "short_name": "卓越科技",
        "website": "https://css.cmdo.um.edu.mo/outlets/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5443332,
          22.1240753
        ]
      },
      "id": "node/3016306583"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3048670120",
        "description": "Location: G/F, University Mall (S8)",
        "description:en": "Location: G/F, University Mall (S8)",
        "description:zh": "所在位置: 薈萃坊 (S8), G樓",
        "image": "https://map.um.edu.mo/emap_images/retail-shop_u-tech.jpg",
        "name": "U-Tech",
        "name:en": "U-Tech",
        "name:zh": "U-Tech",
        "shop": "electronics",
        "website": "https://css.cmdo.um.edu.mo/outlets/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5443948,
          22.124076
        ]
      },
      "id": "node/3048670120"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3048670121",
        "amenity": "restaurant",
        "description": "Location: Room G006,  UM Guest House (N1)",
        "description:en": "Location: Room G006,  UM Guest House (N1)",
        "description:zh": "所在位置: 聚賢樓 (N1), G006室",
        "diet:local": "yes",
        "image": "https://map.um.edu.mo/emap_images/dining-outlet_grand-plaza.jpg",
        "name": "萬豪軒 Grand Plaza",
        "name:en": "Grand Plaza",
        "name:zh": "萬豪軒",
        "opening_hours": "Mo-Su 08:00-15:00,17:30-22:00",
        "website": "https://css.cmdo.um.edu.mo/portfolio-items/grandplaza/?portfolioCats=159%2C158%2C247"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.545715,
          22.1335289
        ]
      },
      "id": "node/3048670121"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3048670334",
        "amenity": "toilets",
        "asset_ref": "T13",
        "name": "T13 橫琴澳大校區大學北(近旅遊巴站)公廁 T13 Zona Norte do campus da Universidade de Macau em Hengqin (perto da paragem dos autocarros de turismo)",
        "name:en": "T13 Public toilet in the north of the Campus of University of Macau in Hengqin (near coach stop)",
        "name:pt": "T13 Zona Norte do campus da Universidade de Macau em Hengqin (perto da paragem dos autocarros de turismo)",
        "name:zh": "T13 橫琴澳大校區大學北(近旅遊巴站)公廁",
        "opening_hours": "24/7"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5470999,
          22.135987
        ]
      },
      "id": "node/3048670334"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3124646948",
        "leisure": "park",
        "name": "路環健康徑公園 Trilha da Saúde de Coloane",
        "name:pt": "Trilha da Saúde de Coloane",
        "name:zh": "路環健康徑公園"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5555707,
          22.1237609
        ]
      },
      "id": "node/3124646948"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3129295768",
        "bus": "yes",
        "highway": "bus_stop",
        "name": "濠江路口",
        "public_transport": "platform",
        "route_ref": "14;86;K10;K11"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5394055,
          22.1340052
        ]
      },
      "id": "node/3129295768"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3129295769",
        "bus": "yes",
        "highway": "bus_stop",
        "name": "横琴医院",
        "name:zh-Hant": "橫琴醫院",
        "public_transport": "platform",
        "route_ref": "14;63;86;K10;K11"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5441811,
          22.1207739
        ]
      },
      "id": "node/3129295769"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3265327576",
        "bus": "yes",
        "highway": "bus_stop",
        "name": "横琴医院",
        "name:zh-Hant": "橫琴醫院",
        "public_transport": "platform",
        "route_ref": "14;63;86;K10;K11"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5437509,
          22.1214593
        ]
      },
      "id": "node/3265327576"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3290013561",
        "amenity": "bank",
        "atm": "yes",
        "brand": "中国银行",
        "brand:en": "Bank of China",
        "brand:wikidata": "Q790068",
        "brand:wikipedia": "en:Bank of China",
        "brand:zh": "中国银行",
        "description": "Location: Room G005, University Mall",
        "description:en": "Location: Room G005, University Mall",
        "description:zh": "所在位置: 薈萃坊, G005室",
        "fax": "+853 2850 6232",
        "image": "https://map.um.edu.mo/emap_images/bank_BOC.jpg",
        "loc_name": "中銀",
        "name": "中国银行",
        "name:en": "Bank of China",
        "name:pt": "Banco da China",
        "name:zh": "中国银行",
        "official_name": "Bank of China",
        "official_name:pt": "Banco da China (Universidade de Macau Sub-Branch)",
        "official_name:zh": "中國銀行 (澳門大學支行)",
        "opening_hours": "24/7",
        "phone": "+853 8792 3262",
        "short_name": "澳門大學支行 24 Hrs Self-service Banking Center",
        "website": "http://www.bocmacau.com/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5442747,
          22.1241574
        ]
      },
      "id": "node/3290013561"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3290013581",
        "amenity": "toilets"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5542629,
          22.124456
        ]
      },
      "id": "node/3290013581"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3343839670",
        "amenity": "recycling",
        "location": "overground",
        "recycling:cans": "yes",
        "recycling:paper": "yes",
        "recycling:scrap_metal": "yes",
        "recycling_type": "container"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5461456,
          22.1246693
        ]
      },
      "id": "node/3343839670"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3343839671",
        "amenity": "recycling",
        "location": "overground",
        "recycling:cans": "yes",
        "recycling:paper": "yes",
        "recycling:scrap_metal": "yes",
        "recycling_type": "container"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5463752,
          22.1280287
        ]
      },
      "id": "node/3343839671"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3343839672",
        "amenity": "recycling",
        "location": "overground",
        "recycling:cans": "yes",
        "recycling:paper": "yes",
        "recycling:scrap_metal": "yes",
        "recycling_type": "container"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5463202,
          22.1312014
        ]
      },
      "id": "node/3343839672"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3343839673",
        "amenity": "recycling",
        "recycling:cans": "yes",
        "recycling:paper": "yes",
        "recycling:scrap_metal": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5436023,
          22.1342023
        ]
      },
      "id": "node/3343839673"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3376142625",
        "asset_ref": "T550/4",
        "bus": "yes",
        "highway": "bus_stop",
        "image": "http://www.dsat.gov.mo/bres/bus_stop_img/t550_4.jpg",
        "local_ref": "B",
        "name": "T550/4 澳門大學總站(B車道) University of Macau / Terminal (Lane B)",
        "name:en": "T550/4 University of Macau / Terminal (Lane B)",
        "name:pt": "T550/4 Universidade de Macau / Terminal (Lane B)",
        "name:zh": "T550/4 澳門大學總站(B車道)",
        "public_transport": "platform",
        "route_ref": "73",
        "shelter": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5463043,
          22.1358021
        ]
      },
      "id": "node/3376142625"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3379489559",
        "brand": "Circle K",
        "brand:wikidata": "Q3268010",
        "brand:wikipedia": "en:Circle K",
        "description": "Location: G/F, Staff Quarter (S24)",
        "description:en": "Location: G/F, Staff Quarter (S24)",
        "description:zh": "所在位置: 教職員宿舍 (S24), G樓",
        "image": "https://map.um.edu.mo/emap_images/retail-shop_S24-circle-k.jpg",
        "name": "OK便利店 Circle K (S24)",
        "name:en": "Circle K (S24)",
        "name:pt": "OK (loja de conveniência)",
        "name:zh": "OK便利店 (S24)",
        "opening_hours": "24/7",
        "shop": "convenience",
        "website": "https://css.cmdo.um.edu.mo/outlets/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5446039,
          22.1230747
        ]
      },
      "id": "node/3379489559"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3396928056",
        "asset_ref": "T550/1",
        "bus": "yes",
        "highway": "bus_stop",
        "image": "http://www.dsat.gov.mo/bres/bus_stop_img/t550_1.jpg",
        "local_ref": "A",
        "name": "T550/1 澳門大學總站(A車道) University of Macau / Terminal (Lane A)",
        "name:en": "T550/1 University of Macau / Terminal (Lane A)",
        "name:pt": "T550/1 Universidade de Macau / Terminal (Lane A)",
        "name:zh": "T550/1 澳門大學總站(A車道)",
        "public_transport": "platform",
        "route_ref": "71;71S;",
        "shelter": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5466619,
          22.1357057
        ]
      },
      "id": "node/3396928056"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4071460691",
        "amenity": "post_office",
        "email": "macpost@macaupost.gov.mo",
        "image": "https://map.um.edu.mo/emap_images/post-office_S8.jpg",
        "name": "澳門大學郵政分局 Estação Postal da Universidade de Macau",
        "name:en": "Post Office of UM",
        "name:pt": "Estação Postal da Universidade de Macau",
        "name:zh": "澳門大學郵政分局",
        "opening_hours": "Mo-Fr 10:00-13:00 14:00-18:00",
        "website": "https://fds.cmdo.um.edu.mo/portfolio-items/um-post-office",
        "wheelchair": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5445094,
          22.1241719
        ]
      },
      "id": "node/4071460691"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4072761722",
        "tourism": "artwork"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5569328,
          22.1260587
        ]
      },
      "id": "node/4072761722"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5261477922",
        "access": "yes",
        "amenity": "bicycle_parking",
        "capacity": "50",
        "covered": "no",
        "fee": "no",
        "surveillance": "none"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5463062,
          22.1304652
        ]
      },
      "id": "node/5261477922"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5444925024",
        "amenity": "toilets",
        "asset_ref": "T12",
        "name": "T12 橫琴澳大校區大學南(近河邊)公廁 T12 Zona Sul do campus da Universidade de Macau em Hengqin (perto do rio)",
        "name:en": "T12 Public toilet in the south of the Campus of University of Macau in Hengqin (near riverside)",
        "name:pt": "T12 Zona Sul do campus da Universidade de Macau em Hengqin (perto do rio)",
        "name:zh": "T12 橫琴澳大校區大學南(近河邊)公廁",
        "opening_hours": "24/7"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5465579,
          22.1255024
        ]
      },
      "id": "node/5444925024"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5948720273",
        "information": "guidepost",
        "name": "1-03-01",
        "tourism": "information"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5564906,
          22.1231161
        ]
      },
      "id": "node/5948720273"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5948720274",
        "information": "guidepost",
        "name": "1-03-02",
        "tourism": "information"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5557222,
          22.1224068
        ]
      },
      "id": "node/5948720274"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5948720275",
        "information": "guidepost",
        "name": "1-03-03",
        "tourism": "information"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5554511,
          22.1211547
        ]
      },
      "id": "node/5948720275"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5948720276",
        "information": "guidepost",
        "name": "1-03-04",
        "tourism": "information"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5563661,
          22.1217589
        ]
      },
      "id": "node/5948720276"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5948720277",
        "information": "guidepost",
        "name": "1-03-05",
        "tourism": "information"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5563224,
          22.1229362
        ]
      },
      "id": "node/5948720277"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5948720279",
        "information": "guidepost",
        "name": "1-01-02",
        "tourism": "information"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5565187,
          22.1218944
        ]
      },
      "id": "node/5948720279"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5948720280",
        "information": "guidepost",
        "name": "1-01-03",
        "tourism": "information"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5560041,
          22.1212317
        ]
      },
      "id": "node/5948720280"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5948720281",
        "information": "guidepost",
        "name": "1-01-04",
        "tourism": "information"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5573234,
          22.1209571
        ]
      },
      "id": "node/5948720281"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6700039151",
        "information": "guidepost",
        "name": "1-03-06",
        "tourism": "information"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5569059,
          22.1228309
        ]
      },
      "id": "node/6700039151"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7545205408",
        "access": "yes",
        "amenity": "parking",
        "fee": "yes",
        "name": "南岸都匯停車場 The Veranda Car Park",
        "name:en": "The Veranda Car Park",
        "name:zh": "南岸都匯停車場",
        "payment:cash": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5575095,
          22.1293111
        ]
      },
      "id": "node/7545205408"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7618120966",
        "access": "yes",
        "amenity": "sport",
        "description": "Location: Room G015a, UM Sports Complex",
        "description:en": "Location: Room G015a, UM Sports Complex",
        "description:zh": "所在位置: 澳大綜合體育館, G015a室",
        "image": "https://map.um.edu.mo/emap_images/building_N8.jpg",
        "leisure": "swimming_pool",
        "lit": "yes",
        "location": "indoor",
        "name": "澳大游泳館 UM Swimming Pool",
        "name:en": "UM Swimming Pool",
        "name:pt": "Piscina da Universidade de Macau",
        "name:zh": "澳大游泳館",
        "sport": "swimming",
        "swimming_pool": "indoor",
        "website": "https://facility.osa.um.edu.mo/projects/swimming-pool/",
        "website:en": "https://facility.osa.um.edu.mo/projects/swimming-pool/",
        "website:zh": "https://facility.osa.um.edu.mo/projects/swimming-pool/?lang=zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5422323,
          22.1335893
        ]
      },
      "id": "node/7618120966"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7619085100",
        "access": "yes",
        "amenity": "parking",
        "description": "Location: Postgraduate Houses (S1-S2) & University Mall (S8)",
        "description:en": "Location: Postgraduate Houses (S1-S2) & University Mall (S8)",
        "description:zh": "所在位置: 研究生宿舍(S1-S2)及薈萃坊(S8)",
        "fee": "yes",
        "image": "https://map.um.edu.mo/emap_images/car-park_P6.jpg",
        "name": "P6訪客停車場 Visitor Car Park P6",
        "name:en": "Visitor Car Park P6",
        "name:zh": "P6訪客停車場",
        "website": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:en": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:zh": "https://sfs.cmdo.um.edu.mo/%e6%88%91%e5%80%91%e7%9a%84%e6%9c%8d%e5%8b%99/%e5%81%9c%e8%bb%8a%e5%a0%b4%e7%ae%a1%e7%90%86/?lang=zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5456047,
          22.1252629
        ]
      },
      "id": "node/7619085100"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7729882691",
        "artwork_type": "sculpture",
        "material": "stone",
        "name": "博雅之璧 A Muralha da Grande Sabedoria",
        "name:en": "the Wall of Great Wisdom",
        "name:pt": "A Muralha da Grande Sabedoria",
        "name:zh": "博雅之璧",
        "tourism": "artwork"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5442256,
          22.1329644
        ]
      },
      "id": "node/7729882691"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7823597184",
        "bus": "yes",
        "highway": "bus_stop",
        "name": "澳大河隧/西堤馬路 Túnel S. da UM/ Est. do Dique Oeste",
        "name:pt": "Túnel S. da UM/ Est. do Dique Oeste",
        "name:zh": "澳大河隧/西堤馬路",
        "public_transport": "platform"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5522264,
          22.1340108
        ]
      },
      "id": "node/7823597184"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7823627285",
        "bus": "yes",
        "highway": "bus_stop",
        "name": "澳大河隧/高爾夫俱樂部 Túnel S. da UM/ Clube de Golfe",
        "name:pt": "Túnel S. da UM/ Clube de Golfe",
        "name:zh": "澳大河隧/高爾夫俱樂部",
        "public_transport": "platform"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5526204,
          22.1348211
        ]
      },
      "id": "node/7823627285"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/8863181563",
        "information": "guidepost",
        "name": "C6",
        "tourism": "information"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5571395,
          22.1230251
        ]
      },
      "id": "node/8863181563"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/9467897112",
        "fee": "no",
        "garden:type": "botanical",
        "leisure": "garden",
        "name": "香徑藥谷生態園區及南藥園 Jardim Ecológico do Trilho de Plantas Medicinais e Aromáticas e Jardim de Plantas Medicinais Chinesas do Sul",
        "name:en": "Ecological Trail Garden of Medicinal and Aromatic Plants and South China Medicinal Plants Garden",
        "name:pt": "Jardim Ecológico do Trilho de Plantas Medicinais e Aromáticas e Jardim de Plantas Medicinais Chinesas do Sul",
        "name:zh": "香徑藥谷生態園區及南藥園"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5575816,
          22.1243981
        ]
      },
      "id": "node/9467897112"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/9726948600",
        "amenity": "toilets",
        "asset_ref": "JC9",
        "name": "JC9 棕櫚公園公廁 JC9 Sanitário Público do Parque das Palmeiras",
        "name:en": "JC9 Public toilet at Palmeiras Park",
        "name:pt": "JC9 Sanitário Público do Parque das Palmeiras",
        "name:zh": "JC9 棕櫚公園公廁"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5570342,
          22.1274509
        ]
      },
      "id": "node/9726948600"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/9726948601",
        "amenity": "toilets",
        "asset_ref": "JC2",
        "name": "JC2 石排灣郊野公園公廁 JC2 Sanitários públicos do Parque de Seac Pai Van",
        "name:en": "JC2 Public toilet at Seac Pai Van Park",
        "name:pt": "JC2 Sanitários públicos do Parque de Seac Pai Van",
        "name:zh": "JC2 石排灣郊野公園公廁"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5567679,
          22.1256638
        ]
      },
      "id": "node/9726948601"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/9726948605",
        "amenity": "toilets",
        "asset_ref": "T11",
        "name": "T11 橫琴河底行人隧道(氹仔出入口側)公廁 T11 Túnel subaquático para peões do Novo Campus da Universidade de Macau na Ilha Henqin (saída na Taipa)",
        "name:en": "T11 Public toilet next to entrance and exit of Hengqin Tunnel in Taipa",
        "name:pt": "T11 Túnel subaquático para peões do Novo Campus da Universidade de Macau na Ilha Henqin (saída na Taipa)",
        "name:zh": "T11 橫琴河底行人隧道(氹仔出入口側)公廁",
        "opening_hours": "24/7"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5521652,
          22.1356608
        ]
      },
      "id": "node/9726948605"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/9869532745",
        "information": "guidepost",
        "name": "C3",
        "tourism": "information"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5561088,
          22.1222075
        ]
      },
      "id": "node/9869532745"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/9869532746",
        "information": "guidepost",
        "name": "C4",
        "tourism": "information"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5559883,
          22.1212387
        ]
      },
      "id": "node/9869532746"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/9869532770",
        "information": "guidepost",
        "name": "C5",
        "tourism": "information"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5557528,
          22.1239065
        ]
      },
      "id": "node/9869532770"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/10556610977",
        "amenity": "restaurant",
        "description": "Location: G/F, Research Building N21",
        "description:en": "Location: G/F, Research Building N21",
        "description:zh": "所在位置: 科研大樓 N21, G樓",
        "image": "https://map.um.edu.mo/emap_images/dining-outlet_azucar.jpg",
        "name": "糖主 Azucar",
        "name:en": "Azucar",
        "name:zh": "糖主",
        "website": "https://css.cmdo.um.edu.mo/outlets/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5455417,
          22.1352028
        ]
      },
      "id": "node/10556610977"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/10591605628",
        "bus": "yes",
        "highway": "bus_stop",
        "local_ref": "A",
        "name": "聯生圓形地總站 Rotunda da Concórdia/ Terminal",
        "name:pt": "Rotunda da Concórdia/ Terminal",
        "name:zh": "聯生圓形地總站",
        "public_transport": "platform",
        "ref": "C654/1",
        "shelter": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5549918,
          22.125581
        ]
      },
      "id": "node/10591605628"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/10591605629",
        "bus": "yes",
        "highway": "bus_stop",
        "local_ref": "C",
        "name": "聯生圓形地總站 Rotunda da Concórdia/ Terminal",
        "name:pt": "Rotunda da Concórdia/ Terminal",
        "name:zh": "聯生圓形地總站",
        "public_transport": "platform",
        "shelter": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5549409,
          22.1257813
        ]
      },
      "id": "node/10591605629"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/10920886495",
        "amenity": "restaurant",
        "brand": "賽百味",
        "brand:en": "Subway",
        "brand:zh": "賽百味",
        "cuisine": "sandwich",
        "description": "Location: G/F, University Mall (S8)",
        "description:en": "Location: G/F, University Mall (S8)",
        "description:zh": "所在位置: 薈萃坊 (S8), G樓",
        "image": "https://map.um.edu.mo/emap_images/dining-outlet_subway.jpg",
        "name": "賽百味 Subway",
        "name:en": "Subway",
        "name:zh": "賽百味",
        "not:brand:wikidata": "Q244457",
        "takeaway": "yes",
        "website": "https://css.cmdo.um.edu.mo/portfolio-items/subway/?portfolioCats=159%2C158%2C247"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5445273,
          22.1244462
        ]
      },
      "id": "node/10920886495"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/10920886498",
        "brand": "OK便利店",
        "brand:en": "Circle K",
        "brand:wikidata": "Q3268010",
        "description": "Location: G/F, Research Building (N22)",
        "description:en": "Location: G/F, Research Building (N22)",
        "description:zh": "所在位置: 科研大樓 (N22), G樓",
        "image": "https://map.um.edu.mo/emap_images/retail-shop_N22-circle-k.jpg",
        "name": "OK便利店 Circle K (N22)",
        "name:en": "Circle K (N22)",
        "name:zh": "OK便利店 (N22)",
        "shop": "convenience",
        "website": "https://css.cmdo.um.edu.mo/outlets/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5435437,
          22.1349796
        ]
      },
      "id": "node/10920886498"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11149695110",
        "amenity": "clinic",
        "description": "Location: Room G002, UM Sports Complex",
        "description:en": "Location: Room G002, UM Sports Complex",
        "description:zh": "所在位置: 澳大綜合體育館, G002室",
        "email": "hseo@um.edu.mo",
        "fax": "+853 88222352",
        "healthcare": "clinic",
        "image": "https://map.um.edu.mo/emap_images/building_N8.jpg",
        "name": "澳門大學醫療中心 Medical Center of University of Macau",
        "name:en": "Medical Center of University of Macau",
        "name:zh": "澳門大學醫療中心",
        "phone": "+853 88224123",
        "website": "https://hseo.um.edu.mo/health-and-hygiene-affairs/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.542904,
          22.1338084
        ]
      },
      "id": "node/11149695110"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11158362101",
        "leisure": "fitness_centre",
        "name": "健身室 Fitness Room",
        "name:en": "Fitness Room",
        "name:zh": "健身室"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5422452,
          22.1343194
        ]
      },
      "id": "node/11158362101"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11162232236",
        "amenity": "bank",
        "atm": "yes",
        "description": "Location: G/F, UM Guest House",
        "description:en": "Location: G/F, UM Guest House",
        "description:zh": "所在位置: 聚賢樓, G樓",
        "drive_through": "no",
        "image": "https://map.um.edu.mo/emap_images/bank_BNU.jpg",
        "name": "大西洋銀行 Banco Nacional Ultramarino",
        "name:en": "BNU Bank",
        "name:pt": "Banco Nacional Ultramarino",
        "name:zh": "大西洋銀行",
        "opening_hours": "24/7 Self-service Banking Center",
        "operator": "大西洋銀行 Banco Nacional Ultramarino",
        "website": "https://www.bnu.com.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5459242,
          22.1335258
        ]
      },
      "id": "node/11162232236"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11236669768",
        "asset_ref": "T550/3",
        "bus": "yes",
        "highway": "bus_stop",
        "image": "http://www.dsat.gov.mo/bres/bus_stop_img/t550_3.jpg",
        "local_ref": "B",
        "name": "T550/3 澳門大學總站(B車道) University of Macau / Terminal (Lane B)",
        "name:en": "T550/3 University of Macau / Terminal (Lane B)",
        "name:pt": "T550/3 Universidade de Macau / Terminal (Lane B)",
        "name:zh": "T550/3 澳門大學總站(B車道)",
        "public_transport": "platform",
        "route_ref": "701X;701XS;"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5466517,
          22.1357957
        ]
      },
      "id": "node/11236669768"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11245062465",
        "access": "yes",
        "amenity": "toilets",
        "unisex": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5550701,
          22.1258598
        ]
      },
      "id": "node/11245062465"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11285365841",
        "description": "Location:  Research Building (N23)",
        "description:en": "Location:  Research Building (N23)",
        "description:zh": "所在位置: 科研大樓 (N23)",
        "email": "iapme.enquiry@um.edu.mo",
        "fax": "+853 8822 2454",
        "image": "https://map.um.edu.mo/emap_images/building_N23.jpg",
        "name": "應用物理及材料工程研究院 Institute of Applied Physics and Materials Engineering",
        "name:en": "Institute of Applied Physics and Materials Engineering",
        "name:zh": "應用物理及材料工程研究院",
        "office": "university",
        "phone": "+853 8822 4142",
        "website": "https://iapme.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5455348,
          22.1356033
        ]
      },
      "id": "node/11285365841"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11285379926",
        "description": "Location: G023, E12",
        "description:en": "Location: Room G023, Honours College (E12)",
        "description:zh": "所在位置: 榮譽學院 (E12), G023室",
        "email": "HC.enquiry@um.edu.mo",
        "fax": "+853 8822 2332",
        "image": "https://map.um.edu.mo/emap_images/building_E12.jpg",
        "name": "榮譽學院 Honours College (HC)",
        "name:en": "Honours College (HC)",
        "name:zh": "榮譽學院 (HC)",
        "office": "university",
        "phone": "+853 8822 4974",
        "website": "https://hc.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5437109,
          22.130706
        ]
      },
      "id": "node/11285379926"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11285446604",
        "description": "Location:  Research Building (N22)",
        "description:en": "Location:  Research Building (N22)",
        "description:zh": "所在位置: 科研大樓 (N22)",
        "email": "sklqrcm@um.edu.mo",
        "fax": "+853 2884 1358",
        "image": "https://map.um.edu.mo/emap_images/building_N22.jpg",
        "name": "中華醫藥研究院 Institute of Chinese Medical Sciences",
        "name:en": "Institute of Chinese Medical Sciences",
        "name:zh": "中華醫藥研究院",
        "office": "university",
        "phone": "+853 8822 4685 , +853 8822 4697",
        "website": "https://sklqrcm.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.54305,
          22.1350048
        ]
      },
      "id": "node/11285446604"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11295472303",
        "amenity": "restaurant",
        "description": "Location: G/F, UM Guest House (N1)",
        "description:en": "Location: G/F, UM Guest House (N1)",
        "description:zh": "所在位置: 聚賢樓 (N1), G樓",
        "image": "https://map.um.edu.mo/emap_images/dining-outlet_eysee-bakery.jpg",
        "name": "香榭里法式餐廳 Le Bistro by Élysée",
        "name:en": "Le Bistro by Élysée",
        "name:zh": "香榭里法式餐廳",
        "website": "https://css.cmdo.um.edu.mo/portfolio-items/elysee/?portfolioCats=159%2C158%2C247"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5458206,
          22.1337317
        ]
      },
      "id": "node/11295472303"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11295480975",
        "leisure": "fitness_centre",
        "name": "職員小型健身室 Staff Mini Fitness Room",
        "name:en": "Staff Mini Fitness Room",
        "name:zh": "職員小型健身室"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5451403,
          22.1337904
        ]
      },
      "id": "node/11295480975"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11299554350",
        "amenity": "administration",
        "description": "Location: Room 1012, Administration Building",
        "description:en": "Location: Room 1012, Administration Building",
        "description:zh": "所在位置: 行政樓, 1012室",
        "email": "fo@um.edu.mo",
        "fax": "8822 2363",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "會計處 Accounts Section",
        "name:en": "Accounts Section",
        "name:zh": "會計處",
        "phone": "8822 8349",
        "website": "https://fo.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5441529,
          22.1336769
        ]
      },
      "id": "node/11299554350"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11328837806",
        "description": "Location: Room 4092, Faculty of Arts and Humanities (E21A)",
        "description:en": "Location: Room 4092, Faculty of Arts and Humanities (E21A)",
        "description:zh": "所在位置: 人文學院 (E21A), 4092室",
        "email": "fah.enquiry@um.edu.mo",
        "fax": "+853 8822 2321",
        "image": "https://map.um.edu.mo/emap_images/building_E21A.jpg",
        "name": "人文學院 Faculty of Arts and Humanities (FAH)",
        "name:en": "Faculty of Arts and Humanities (FAH)",
        "name:zh": "人文學院 (FAH)",
        "office": "university",
        "phone": "+853 8822 8357",
        "website": "https://fah.um.edu.mo"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.543289,
          22.1295479
        ]
      },
      "id": "node/11328837806"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11330274247",
        "amenity": "printing",
        "description": "Location: 3/F,  Central Teaching Building E6",
        "description:en": "Location: 3/F,  Central Teaching Building E6",
        "description:zh": "所在位置: 中央教學樓東六座, 3樓",
        "image": "https://map.um.edu.mo/emap_images/printing_E6-3F.jpg",
        "name": "打印區域 (E6 三樓電腦室走廊) Printing Area (E6 3/F Computer Room corridor)",
        "name:en": "Printing Area (E6 3/F Computer Room corridor)",
        "name:zh": "打印區域 (E6 三樓電腦室走廊)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5450197,
          22.1285247
        ]
      },
      "id": "node/11330274247"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11350152382",
        "amenity": "administration",
        "description": "Location: Room 1012,  Administration Building",
        "description:en": "Location: Room 1012,  Administration Building",
        "description:zh": "所在位置: 行政樓, 1012室",
        "email": "fo@um.edu.mo",
        "fax": "+853 8822 2362",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "預算處 Budget Section",
        "name:en": "Budget Section",
        "name:zh": "預算處",
        "phone": "+853 8822 8349",
        "website": "https://fo.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5442327,
          22.1336803
        ]
      },
      "id": "node/11350152382"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11365426820",
        "amenity": "bank",
        "atm": "yes",
        "description": "Location: Room G003, University Mall",
        "description:en": "Location: Room G003, University Mall",
        "description:zh": "所在位置: 薈萃坊, G003室",
        "image": "https://map.um.edu.mo/emap_images/bank_TAIFUNG.jpg",
        "name": "大豐銀行 Tai Fung Bank",
        "name:en": "Tai Fung Bank",
        "name:zh": "大豐銀行",
        "opening_hours": "24/7 Self-service Banking Center",
        "website": "https://css.cmdo.um.edu.mo/outlets/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5445269,
          22.1243195
        ]
      },
      "id": "node/11365426820"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11365454859",
        "description": "Location: Bus Stop,  Anthony Lau Building (E4)",
        "description:en": "Location: Bus Stop,  Anthony Lau Building (E4)",
        "description:zh": "所在位置: 劉少榮樓 (E4) 巴士站",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.546191,
          22.1282871
        ]
      },
      "id": "node/11365454859"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11372891127",
        "amenity": "food_court",
        "description": "Location: 1/F , University Mall (S8)",
        "description:en": "Location: 1/F , University Mall (S8)",
        "description:zh": "所在位置: 薈萃坊 (S8), 1樓",
        "image": "https://map.um.edu.mo/emap_images/dining-outlet_kou-fu-food-court.jpg",
        "name": "口福美食廣場 Kou Fu Food Court",
        "name:en": "Kou Fu Food Court",
        "name:zh": "口福美食廣場",
        "website": "https://css.cmdo.um.edu.mo/outlets/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5445801,
          22.1242646
        ]
      },
      "id": "node/11372891127"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11372920671",
        "amenity": "restaurant",
        "description": "Location: Room 1008 , 1009, University Mall (S8)",
        "description:en": "Location: Room 1008 , 1009, University Mall (S8)",
        "description:zh": "所在位置: 薈萃坊 (S8), 1008 , 1009室",
        "image": "https://map.um.edu.mo/emap_images/dining-outlet_siu-gwan-gon.jpg",
        "name": "小郡肝 Siu Gwan Gon",
        "name:en": "Siu Gwan Gon",
        "name:zh": "小郡肝",
        "opening_hours": "Mo-Su 10:30-22:00",
        "website": "https://css.cmdo.um.edu.mo/portfolio-items/siu-gwan-gon/?portfolioCats=159%2C158%2C247"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5442731,
          22.1242117
        ]
      },
      "id": "node/11372920671"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11379218816",
        "description": "Location: Room G001, Faculty of Business Administration (E22)",
        "description:en": "Location: Room G001, Faculty of Business Administration (E22)",
        "description:zh": "所在位置: 工商管理學院 (E22), G001室",
        "email": "APAEM_info@um.edu.mo",
        "fax": "+853 8822 2329",
        "image": "https://map.um.edu.mo/emap_images/building_E22.jpg",
        "name": "亞太經濟與管理研究所 Asia-Pacific Academy of Economics and Management",
        "name:en": "Asia-Pacific Academy of Economics and Management",
        "name:zh": "亞太經濟與管理研究所",
        "office": "university",
        "phone": "+853 8822 8137",
        "website": "https://apaem.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5430175,
          22.1280847
        ]
      },
      "id": "node/11379218816"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11379224679",
        "description": "Location: Room 4031, Faculty of Social Sciences (E21B)",
        "description:en": "Location: Room 4031, Faculty of Social Sciences (E21B)",
        "description:zh": "所在位置: 社會科學學院 (E21B), 4031室",
        "email": "fss.enquiry@um.edu.mo",
        "fax": "+853 8822 2337",
        "image": "https://map.um.edu.mo/emap_images/building_E21B.jpg",
        "name": "社會科學學院 Faculty of Social Sciences (FSS)",
        "name:en": "Faculty of Social Sciences (FSS)",
        "name:zh": "社會科學學院 (FSS)",
        "office": "university",
        "phone": "+853 8822 4018",
        "website": "https://fss.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5432955,
          22.1290109
        ]
      },
      "id": "node/11379224679"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11379244162",
        "description": "Location: Room 2035, Faculty of Business Administration (E22)",
        "description:en": "Location: Room 2035, Faculty of Business Administration (E22)",
        "description:zh": "所在位置: 工商管理學院 (E22), 2035室",
        "email": "Gaming@um.edu.mo",
        "fax": "+853 8822 2334",
        "image": "https://map.um.edu.mo/emap_images/building_E22.jpg",
        "name": "博彩研究所 The Institute for the Study of Commercial Gaming",
        "name:en": "The Institute for the Study of Commercial Gaming",
        "name:zh": "博彩研究所",
        "office": "university",
        "phone": "+853 8822 4173",
        "website": "https://www.um.edu.mo/iscg/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5433382,
          22.1283605
        ]
      },
      "id": "node/11379244162"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11379256150",
        "description": "Location: Room 2001, Faculty of Business Administration (E22)",
        "description:en": "Location: Room 2001, Faculty of Business Administration (E22)",
        "description:zh": "所在位置: 工商管理學院 (E22), 2001室",
        "email": "fba.brtc@um.edu.mo",
        "fax": "+853 8822 2378",
        "image": "https://map.um.edu.mo/emap_images/building_E22.jpg",
        "name": "商業研究及培訓中心 Business Research and Training Center",
        "name:en": "Business Research and Training Center",
        "name:zh": "商業研究及培訓中心",
        "office": "university",
        "phone": "+853 8822 4743",
        "website": "https://www.um.edu.mo/fba/brtc/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.542921,
          22.1283791
        ]
      },
      "id": "node/11379256150"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11380948651",
        "description": "Location: 3rd Floor,  Research Building (N21)",
        "description:en": "Location: 3rd Floor,  Research Building (N21)",
        "description:zh": "所在位置: 科研大樓 (N21) 3樓",
        "email": "amsv.enquiry@um.edu.mo",
        "fax": "+853 8822 2441",
        "image": "https://map.um.edu.mo/emap_images/building_N21.jpg",
        "name": "微電子研究院 Institute of Microelectronics",
        "name:en": "Institute of Microelectronics",
        "name:zh": "微電子研究院",
        "office": "university",
        "phone": "+853 8822 4700",
        "website": "https://ime.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5453734,
          22.1350502
        ]
      },
      "id": "node/11380948651"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11380967121",
        "description": "Location: Room 1014, Cultural Building (E34)",
        "description:en": "Location: Room 1014, Cultural Building (E34)",
        "description:zh": "所在位置: 崇文樓 (E34), 1014室",
        "email": "fss.cad@um.edu.mo",
        "image": "https://map.um.edu.mo/emap_images/building_E34.jpg",
        "name": "藝術設計中心 Centre for Arts and Design",
        "name:en": "Centre for Arts and Design",
        "name:zh": "藝術設計中心",
        "office": "university",
        "phone": "+853 8822 4597",
        "website": "https://cad.fss.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.543514,
          22.125415
        ]
      },
      "id": "node/11380967121"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11380977674",
        "description": "Location: Room 1003,  Research Building (N21)",
        "description:en": "Location: Room 1003,  Research Building (N21)",
        "description:zh": "所在位置: 科研大樓 (N21)",
        "email": "ICI.enquiry@um.edu.mo",
        "fax": "+853 8822 2456",
        "image": "https://map.um.edu.mo/emap_images/building_N21.jpg",
        "name": "協同創新研究所 Institute of Collaborative Innovation",
        "name:en": "Institute of Collaborative Innovation",
        "name:zh": "協同創新研究所",
        "office": "university",
        "phone": "+853 8822 4600",
        "website": "https://ici.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5456331,
          22.1349555
        ]
      },
      "id": "node/11380977674"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11380980144",
        "description": "Location: G/F, BOC Centennial Building (E3)",
        "description:en": "Location: G/F, BOC Centennial Building (E3)",
        "description:zh": "所在位置: 中銀百年紀念大樓 (E3), G樓",
        "email": "cce.enquiry@um.edu.mo",
        "fax": "+853 2883 8321",
        "image": "https://map.um.edu.mo/emap_images/building_E3.jpg",
        "name": "持續進修中心 Centre for Continuing Education",
        "name:en": "Centre for Continuing Education",
        "name:zh": "持續進修中心",
        "office": "university",
        "phone": "+853 8822 4545",
        "website": "https://cce.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5460559,
          22.1289182
        ]
      },
      "id": "node/11380980144"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11380983957",
        "description": "Location: Room 6019, Administration Building (N6)",
        "description:en": "Location: Room 6019, Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 6019室",
        "email": "spo.enquiry@um.edu.mo",
        "fax": "+853 8822 2422",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "策略及規劃辦公室 Strategy and Planning Office",
        "name:en": "Strategy and Planning Office",
        "name:zh": "策略及規劃辦公室",
        "office": "university",
        "phone": "+853 8822 8072",
        "website": "https://spo.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5438703,
          22.1340913
        ]
      },
      "id": "node/11380983957"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11381003339",
        "description": "Location: Room 2016, Central Teaching Building (E7)",
        "description:en": "Location: Room 2016, Central Teaching Building (E7)",
        "description:zh": "所在位置: 中央教學樓 (E7), 2016室",
        "email": "fah.elc@um.edu.mo",
        "fax": "+853 8822 2319",
        "image": "https://map.um.edu.mo/emap_images/building_E7.jpg",
        "name": "英語中心 English Language Centre",
        "name:en": "English Language Centre",
        "name:zh": "英語中心",
        "office": "university",
        "phone": "+853 8822 8120",
        "website": "https://fah.um.edu.mo/english-language-centre/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5448847,
          22.1288161
        ]
      },
      "id": "node/11381003339"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11381005337",
        "description": "Location: Room 2022, Research Building (N23)",
        "description:en": "Location: Room 2022, Research Building (N23)",
        "description:zh": "所在位置: 科研大樓 (N23), 2022室",
        "email": "cert@umac.mo",
        "fax": "+853 2883 0604",
        "image": "https://map.um.edu.mo/emap_images/building_N23.jpg",
        "name": "工程研究及檢測中心 Centre for Engineering Research and Testing",
        "name:en": "Centre for Engineering Research and Testing",
        "name:zh": "工程研究及檢測中心",
        "office": "university",
        "phone": "+853 8822 9100",
        "website": "https://www.fst.um.edu.mo/cert/web/aboutus.html"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5451176,
          22.1356789
        ]
      },
      "id": "node/11381005337"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11381011008",
        "description": "Location: Room G031, Cultural Building (E34)",
        "description:en": "Location: Room G031, Cultural Building (E34)",
        "description:zh": "所在位置: 崇文樓 (E34), G031室",
        "email": "cchc.info@um.edu.mo",
        "fax": "+853 8822 2383",
        "image": "https://map.um.edu.mo/emap_images/building_E34.jpg",
        "name": "中國歷史文化中心 Centre for Chinese History and Culture",
        "name:en": "Centre for Chinese History and Culture",
        "name:zh": "中國歷史文化中心",
        "office": "university",
        "phone": "+853 8822 2708",
        "website": "https://cchc.fah.um.edu.mo"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5438158,
          22.1252394
        ]
      },
      "id": "node/11381011008"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11381015226",
        "description": "Location: 3/F, Research Building (N21)",
        "description:en": "Location: 3/F, Research Building (N21)",
        "description:zh": "所在位置: 科研大樓 (N21), 3樓",
        "email": "amsv.enquiry@um.edu.mo",
        "fax": "+853 8822 2441",
        "image": "https://map.um.edu.mo/emap_images/unit_AMSV.png",
        "name": "模擬與混合信號超大規模集成電路國家重點實驗室 State Key Laboratory of Analog and Mixed-Signal VLSI (AMSV)",
        "name:en": "State Key Laboratory of Analog and Mixed-Signal VLSI (AMSV)",
        "name:zh": "模擬與混合信號超大規模集成電路國家重點實驗室",
        "office": "university",
        "phone": "+853 8822 4700",
        "website": "https://ime.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5451272,
          22.1350646
        ]
      },
      "id": "node/11381015226"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11381015227",
        "description": "Location: Research Building (N22)",
        "description:en": "Location: Research Building (N22)",
        "description:zh": "所在位置: 科研大樓 (N22)",
        "email": "sklqrcm@um.edu.mo",
        "fax": "+853 2884 1358",
        "image": "https://map.um.edu.mo/emap_images/building_N22.jpg",
        "name": "中藥質量研究國家重點實驗室 State Key Laboratory of Quality Research in Chinese Medicine",
        "name:en": "State Key Laboratory of Quality Research in Chinese Medicine",
        "name:zh": "中藥質量研究國家重點實驗室",
        "office": "university",
        "phone": "+853 8822 4685",
        "website": "https://sklqrcm.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5428454,
          22.1350123
        ]
      },
      "id": "node/11381015227"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11381015869",
        "description": "Location: 3rd Floor, Cultural Building (E34)",
        "description:en": "Location: 3rd Floor, Cultural Building (E34)",
        "description:zh": "所在位置: 崇文樓 (E34) 3樓",
        "email": "fah.enquiry@um.edu.mo",
        "fax": "+853 8822 2387",
        "image": "https://map.um.edu.mo/emap_images/building_E34.jpg",
        "name": "人文社科高等研究院 Institute of Advanced Studies in Humanities and Social Sciences",
        "name:en": "Institute of Advanced Studies in Humanities and Social Sciences",
        "name:zh": "人文社科高等研究院",
        "office": "university",
        "phone": "+853 8822 2082",
        "website": "https://ias.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5435619,
          22.1252719
        ]
      },
      "id": "node/11381015869"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11381017680",
        "description": "Location: Room G025, Cultural Building (E34)",
        "description:en": "Location: Room G025, Cultural Building (E34)",
        "description:zh": "所在位置: 崇文樓 (E34), G025室",
        "email": "CMS.info@um.edu.mo",
        "fax": "+853 2886 0009",
        "image": "https://map.um.edu.mo/emap_images/building_E34.jpg",
        "name": "澳門研究中心 Centre for Macau Studies",
        "name:en": "Centre for Macau Studies",
        "name:zh": "澳門研究中心",
        "office": "university",
        "phone": "+853 8822 8130",
        "website": "https://cms.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5434916,
          22.1256377
        ]
      },
      "id": "node/11381017680"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11381018978",
        "description": "Location: Research Building (N21)",
        "description:en": "Location: Building (N21)",
        "description:zh": "所在位置: 科研大樓 (N21)",
        "email": "iotsc.enquiry@um.edu.mo",
        "fax": "+853 8822 2466",
        "image": "https://map.um.edu.mo/emap_images/building_N21.jpg",
        "name": "智慧城市物聯網國家重點實驗室 State Key Laboratory of Internet of Things for Smart City",
        "name:en": "State Key Laboratory of Internet of Things for Smart City",
        "name:zh": "智慧城市物聯網國家重點實驗室",
        "office": "university",
        "phone": "+853 8822 4200",
        "website": "https://skliotsc.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5448507,
          22.1350647
        ]
      },
      "id": "node/11381018978"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11393744116",
        "amenity": "administration",
        "description": "Location: Room 2026,  Administration Building (N6)",
        "description:en": "Location: Room 2026,  Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 2026室",
        "email": "aao@um.edu.mo",
        "fax": "+853 8822 2424",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "學務部 Academic Affairs Office",
        "name:en": "Academic Affairs Office",
        "name:zh": "學務部",
        "phone": "+853 8822 4807",
        "website": "https://aao.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5439933,
          22.1337112
        ]
      },
      "id": "node/11393744116"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11393744117",
        "amenity": "administration",
        "description": "Location: Room 3018,  Administration Building (N6)",
        "description:en": "Location: Room 3018,  Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 3018室",
        "email": "cmdo.suggestion@um.edu.mo",
        "fax": "+853 8822 2385",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "校園管理及發展部 Campus Management and Development Office",
        "name:en": "Campus Management and Development Office",
        "name:zh": "校園管理及發展部",
        "phone": "+853 8822 8679",
        "website": "https://cmdo.um.edu.mo/?lang=zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.543929,
          22.1337192
        ]
      },
      "id": "node/11393744117"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11393744118",
        "amenity": "administration",
        "description": "Location: Room 3013,  Administration Building (N6)",
        "description:en": "Location: Room 3013,  Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 3013室",
        "email": "css.suggestion@um.edu.mo",
        "fax": "+853 8822 2438",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "校園服務處 Campus Services Section",
        "name:en": "Campus Services Section",
        "name:zh": "校園服務處",
        "phone": "+853 8822 8427",
        "website": "https://css.cmdo.um.edu.mo/?lang=zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5439268,
          22.1337907
        ]
      },
      "id": "node/11393744118"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11393744119",
        "amenity": "administration",
        "description": "Location: Room G012,  Administration Building (N6)",
        "description:en": "Location: Room G012,  Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), G012室",
        "email": "co@um.edu.mo",
        "fax": "+853 8822 2360",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "傳訊部 Communications Office",
        "name:en": "Communications Office",
        "name:zh": "傳訊部",
        "phone": "+853 8822 8400",
        "website": "https://www.um.edu.mo/co/chi/index.php"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5440792,
          22.133755
        ]
      },
      "id": "node/11393744119"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11393744120",
        "amenity": "administration",
        "description": "Location: Room 3025,  Administration Building (N6)",
        "description:en": "Location: Room 3025,  Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 3025室",
        "email": "cfm_enquiry@um.edu.mo",
        "fax": "+853 8822 2310",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "工程及設施維護處 Construction and Facilities Maintenance Section",
        "name:en": "Construction and Facilities Maintenance Section",
        "name:zh": "工程及設施維護處",
        "phone": "+853 8822 4107",
        "website": "https://cfm.cmdo.um.edu.mo/?lang=zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5441972,
          22.1336357
        ]
      },
      "id": "node/11393744120"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11393744121",
        "amenity": "administration",
        "description": "Location: Room 3019,  Administration Building (N6)",
        "description:en": "Location: Room 3019,  Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 3019室",
        "email": "ems.suggestion@um.edu.mo",
        "fax": "+853 8822 2467",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "機電處 Electrical and Mechanical Section",
        "name:en": "Electrical and Mechanical Section",
        "name:zh": "機電處",
        "phone": "+853 8822 8474",
        "website": "https://ems.cmdo.um.edu.mo/?lang=zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5438775,
          22.1337013
        ]
      },
      "id": "node/11393744121"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11393744122",
        "amenity": "administration",
        "description": "Location: Room 1012,  Administration Building (N6)",
        "description:en": "Location: Room 1012,  Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 3019室",
        "email": "fo@um.edu.mo",
        "fax": "+853 8822 2362",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "財務部 Finance Office",
        "name:en": "Finance Office",
        "name:zh": "財務部",
        "phone": "+853 8822 8349",
        "website": "https://fo.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5439805,
          22.1338106
        ]
      },
      "id": "node/11393744122"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11393744123",
        "amenity": "administration",
        "description": "Location: Room G018,  Administration Building (N6)",
        "description:en": "Location: Room G018,  Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), G018室",
        "email": "gao.enquiry@um.edu.mo",
        "fax": "+853 8822 2347",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "全球事務部 Global Affairs Office",
        "name:en": "Global Affairs Office",
        "name:zh": "全球事務部",
        "phone": "+853 8822 4386, +853 8822 4630",
        "website": "https://gao.um.edu.mo/zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5444418,
          22.1336993
        ]
      },
      "id": "node/11393744123"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11393744124",
        "amenity": "administration",
        "description": "Location: Room 1012,  Administration Building (N6)",
        "description:en": "Location: Room 1012,  Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 4018室",
        "fax": "+853 8822 2412, +853 8822 2411",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "人力資源服務處 Human Resources Services Section",
        "name:en": "Human Resources Services Section",
        "name:zh": "人力資源服務處",
        "phone": "+853 8822 8406, +853 8822 8577, +853 8822 8405",
        "website": "https://hrs.admo.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5444397,
          22.1337748
        ]
      },
      "id": "node/11393744124"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11393744125",
        "amenity": "administration",
        "description": "Location: Room 2017,  Administration Building (N6)",
        "description:en": "Location: Room 2017,  Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 2017室",
        "email": "icto.suggestion@um.edu.mo",
        "fax": "+853 8822 2408",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "資訊及通訊科技部 Information and Communication Technology Office",
        "name:en": "Information and Communication Technology Office",
        "name:zh": "資訊及通訊科技部",
        "phone": "+853 8822 8617, +853 8822 8688, +853 8822 8611",
        "website": "https://icto.um.edu.mo/?lang=zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5442959,
          22.133755
        ]
      },
      "id": "node/11393744125"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11393744126",
        "amenity": "administration",
        "description": "Location: Room 2012,  Administration Building",
        "description:en": "Location: Room 2012,  Administration Building",
        "description:zh": "所在位置: 行政樓, 2012室",
        "fax": "+853 8822 2408",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "資訊管理處 Information Management Section",
        "name:en": "Information Management Section",
        "name:zh": "資訊管理處",
        "phone": "+853 8822 8500",
        "website": "https://icto.um.edu.mo/about-icto/information-management-section-ims/?lang=zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.544298,
          22.1336973
        ]
      },
      "id": "node/11393744126"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399326913",
        "amenity": "administration",
        "description": "Location: UM Wu Yee Sun Library (E2)",
        "description:en": "Location: UM Wu Yee Sun Library (E2)",
        "description:zh": "所在位置: 澳門大學伍宜孫圖書館 (E2)",
        "fax": "+853 8822 2442",
        "image": "https://map.um.edu.mo/emap_images/building_E2.jpg",
        "name": "圖書館資源及發展處 Library Resources and Development Section",
        "name:en": "Library Resources and Development Section",
        "name:zh": "圖書館資源及發展處",
        "phone": "+853 8822 8170",
        "website": "https://library.umac.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5451761,
          22.1300452
        ]
      },
      "id": "node/11399326913"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399326914",
        "amenity": "administration",
        "description": "Location: UM Wu Yee Sun Library (E2)",
        "description:en": "Location: UM Wu Yee Sun Library (E2)",
        "description:zh": "所在位置: 澳門大學伍宜孫圖書館 (E2)",
        "image": "https://map.um.edu.mo/emap_images/building_E2.jpg",
        "name": "圖書館服務及推廣處 Library Services and Outreach Section",
        "name:en": "Library Services and Outreach Section",
        "name:zh": "圖書館服務及推廣處",
        "phone": "+853 8822 8160, +853 8822 2442",
        "website": "https://library.umac.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5450353,
          22.1299406
        ]
      },
      "id": "node/11399326914"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399326915",
        "amenity": "administration",
        "description": "Location: UM Wu Yee Sun Library (E2)",
        "description:en": "Location: UM Wu Yee Sun Library (E2)",
        "description:zh": "所在位置: 澳門大學伍宜孫圖書館 (E2)",
        "email": "lib_suggestion@um.edu.mo",
        "image": "https://map.um.edu.mo/emap_images/building_E2.jpg",
        "name": "大學圖書館 University Library",
        "name:en": "University Library",
        "name:zh": "大學圖書館",
        "phone": "+853 8822 8160, +853 8822 8170",
        "website": "https://library.umac.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5450899,
          22.1301511
        ]
      },
      "id": "node/11399326915"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399335703",
        "amenity": "administration",
        "description": "Location: Room 2071,  Anthony Lau Building (E4)",
        "description:en": "Location: Room 2071,  Anthony Lau Building (E4)",
        "description:zh": "所在位置: 劉少榮樓 (E4), 2071室",
        "fax": "+ 853 8822 2408",
        "image": "https://map.um.edu.mo/emap_images/office_e4_2071.jpg",
        "name": "電腦教學暨技術服務處 Academic Computing and Technology Services Section",
        "name:en": "Academic Computing and Technology Services Section",
        "name:zh": "電腦教學暨技術服務處",
        "phone": "+853 8822 8617, +853 8822 8688, +853 8822 8611",
        "website": "https://icto.um.edu.mo/about-icto/academic-computing-and-technology-services-section-acts/?lang=zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5458273,
          22.1284208
        ]
      },
      "id": "node/11399335703"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399335704",
        "description": "Location: Room 3114,  Central Teaching Building (E6)",
        "description:en": "Location: Room 3114,  Central Teaching Building (E6)",
        "description:zh": "所在位置: 中央教學樓 (E6), 3114室",
        "email": "ctle@um.edu.mo",
        "fax": "+853 8822 2349",
        "image": "https://map.um.edu.mo/emap_images/building_E6.jpg",
        "layer": "2",
        "name": "教與學優化中心 Centre for Teaching and Learning Enhancement",
        "name:en": "Centre for Teaching and Learning Enhancement",
        "name:zh": "教與學優化中心",
        "office": "university",
        "phone": "+853 8822 4583",
        "website": "https://ctle.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5450205,
          22.1287474
        ]
      },
      "id": "node/11399335704"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399335705",
        "amenity": "administration",
        "description": "Location: Room 2062,  Anthony Lau Building (E4)",
        "description:en": "Location: Room 2062,  Anthony Lau Building (E4)",
        "description:zh": "所在位置: 劉少榮樓 (E4), 2062室",
        "fax": "+853 8822 2408",
        "image": "https://map.um.edu.mo/emap_images/building_E4.jpg",
        "name": "資訊基建暨用户服務處 Infrastructure and User Services Section",
        "name:en": "Infrastructure and User Services Section",
        "name:zh": "資訊基建暨用户服務處",
        "phone": "+853 8822 8600",
        "website": "https://icto.um.edu.mo/about-icto/infrastructure-and-user-services-section-ius/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5460432,
          22.1286012
        ]
      },
      "id": "node/11399335705"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399359299",
        "amenity": "administration",
        "description": "Location: Room 1012, Administration Building (N6)",
        "description:en": "Location: Room 1012, Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 1012室",
        "email": "fo@um.edu.mo",
        "fax": "+853 8822 2365",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "出納處 Treasury Section",
        "name:en": "Treasury Section",
        "name:zh": "出納處",
        "phone": "+853 8822 8349",
        "website": "https://fo.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5442637,
          22.1336439
        ]
      },
      "id": "node/11399359299"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399359300",
        "amenity": "administration",
        "description": "Location: Room 6011, Administration Building (N6)",
        "description:en": "Location: Room 6011, Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 6011室",
        "email": "uco.suggestion@um.edu.mo",
        "fax": "+853 8822 2333",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "校董會(行政辦公室) University Council Office",
        "name:en": "University Council Office",
        "name:zh": "校董會(行政辦公室)",
        "phone": "+853 8822 4316, +853 8822 4380",
        "website": "https://www.um.edu.mo/uc/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5441969,
          22.1339222
        ]
      },
      "id": "node/11399359300"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399363817",
        "amenity": "administration",
        "description": "Location: Room 4018, Administration Building (N6)",
        "description:en": "Location: Room 4018, Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 4018室",
        "fax": "+853 8822 2436",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "行政部 Office of Administration",
        "name:en": "Office of Administration",
        "name:zh": "行政部",
        "phone": "+853 8822 8536",
        "website": "https://admo.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5440713,
          22.1338787
        ]
      },
      "id": "node/11399363817"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399363818",
        "amenity": "administration",
        "description": "Location: Room 4011, Administration Building (N6)",
        "description:en": "Location: Room 4011, Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 4011室",
        "email": "hseo.suggestion@um.edu.mo",
        "fax": "+853 8822 2352",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "安健及環境事務辦公室 Office of Health, Safety and Environmental Affairs",
        "name:en": "Office of Health, Safety and Environmental Affairs",
        "name:zh": "安健及環境事務辦公室",
        "phone": "+853 8822 4436",
        "website": "https://hseo.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5443856,
          22.1338856
        ]
      },
      "id": "node/11399363818"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399363819",
        "amenity": "administration",
        "description": "Location: Room 4011, Administration Building (N6)",
        "description:en": "Location: Room 4011, Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 4011室",
        "email": "hseo.suggestion@um.edu.mo",
        "fax": "+853 8822 2352",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "安健及環境事務辦公室 Office of Health, Safety and Environmental Affairs",
        "name:en": "Office of Health, Safety and Environmental Affairs",
        "name:zh": "安健及環境事務辦公室",
        "phone": "+853 8822 4436",
        "website": "https://hseo.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5444157,
          22.1338429
        ]
      },
      "id": "node/11399363819"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399375127",
        "amenity": "administration",
        "description": "Location: Room 1017, UM Sports Complex (N8)",
        "description:en": "Location: Room 1017, UM Sports Complex (N8)",
        "description:zh": "所在位置: 澳大綜合體育館 (N8), 1017室",
        "email": "osa.suggestion@um.edu.mo",
        "fax": "+853 8822 2407",
        "image": "https://map.um.edu.mo/emap_images/building_N8.jpg",
        "name": "體育事務部 Office of Sports Affairs",
        "name:en": "Office of Sports Affairs",
        "name:zh": "體育事務部",
        "phone": "+853 8822 4412, +853 8822 2512",
        "website": "https://www.um.edu.mo/osa/en/index.html"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5426126,
          22.1343212
        ]
      },
      "id": "node/11399375127"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399375128",
        "amenity": "administration",
        "description": "Location: Room 4012, Administration Building (N6)",
        "description:en": "Location: Room 4012, Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 4012室",
        "fax": "+853 2883 1103",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "採購處 Procurement Section",
        "name:en": "Procurement Section",
        "name:zh": "採購處",
        "phone": "+853 8822 4835, +853 8822 4888, +853 8822 4885",
        "website": "https://pct.admo.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5446013,
          22.1337252
        ]
      },
      "id": "node/11399375128"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399375129",
        "amenity": "administration",
        "description": "Location: G/F , Administration Building (N6)",
        "description:en": "Location: G/F , Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), G樓",
        "fax": "+853 8822 2360",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "公共關係處 Public Relations Section",
        "name:en": "Public Relations Section",
        "name:zh": "公共關係處",
        "phone": "+853 8822 8400",
        "website": "https://www.um.edu.mo/co/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5446034,
          22.1336648
        ]
      },
      "id": "node/11399375129"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399375130",
        "amenity": "administration",
        "description": "Location: Room 4009, Administration Building (N6)",
        "description:en": "Location: Room 4009, Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 4009室",
        "email": "pub.enquiry@um.edu.mo",
        "fax": "+853 8822 2361",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "出版中心 Publications Centre",
        "name:en": "Publications Centre",
        "name:zh": "出版中心",
        "phone": "+853 8822 4504, +853 8822 4505",
        "website": "https://www.um.edu.mo/intranet/pub/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5437568,
          22.1338742
        ]
      },
      "id": "node/11399375130"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399375131",
        "amenity": "administration",
        "description": "Location: 6/F , Administration Building (N6)",
        "description:en": "Location: 6/F , Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 6樓",
        "email": "umrector@um.edu.mo",
        "fax": "+853 2883 1694",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "校長辦公室 Rector’s Office",
        "name:en": "Rector’s Office",
        "name:zh": "校長辦公室",
        "phone": "+853 8822 4631",
        "website": "https://rto.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5441983,
          22.1340555
        ]
      },
      "id": "node/11399375131"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399375132",
        "amenity": "administration",
        "description": "Location: Room G002, Administration Building",
        "description:en": "Location: Room G002, Administration Building",
        "description:zh": "所在位置: 行政樓, G002室",
        "email": "registry@um.edu.mo",
        "fax": "+853 8822 2425",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "註冊處 Registry",
        "name:en": "Registry",
        "name:zh": "註冊處",
        "phone": "+853 8822 4007",
        "website": "https://reg.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5437598,
          22.1337913
        ]
      },
      "id": "node/11399375132"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399375133",
        "amenity": "administration",
        "description": "Location: Room 3012, Administration Building (N6)",
        "description:en": "Location: Room 3012, Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 3012室",
        "email": "sfs.suggestion@um.edu.mo",
        "fax": "+853 8822 2436",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "保安及設施服務處 Security and Facilities Services Section",
        "name:en": "Security and Facilities Services Section",
        "name:zh": "保安及設施服務處",
        "phone": "+853 8822 8536",
        "website": "https://sfs.cmdo.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5437598,
          22.133721
        ]
      },
      "id": "node/11399375133"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399375134",
        "amenity": "administration",
        "description": "Location: 2/F , Student Activity Centre (E31)",
        "description:en": "Location: 2/F , Student Activity Centre (E31)",
        "description:zh": "所在位置: 學生活動中心 (E31), 2樓",
        "email": "sao@um.edu.mo",
        "fax": "+853 8822 2370",
        "image": "https://map.um.edu.mo/emap_images/building_E31.jpg",
        "name": "學生事務部 Student Affairs Office",
        "name:en": "Student Affairs Office",
        "name:zh": "學生事務部",
        "phone": "+853 8822 4842",
        "website": "https://www.um.edu.mo/sao/en/sao_index.php"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5444608,
          22.1270415
        ]
      },
      "id": "node/11399375134"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399375135",
        "amenity": "administration",
        "description": "Location: 2/F , Student Activity Centre (E31)",
        "description:en": "Location: 2/F , Student Activity Centre (E31)",
        "description:zh": "所在位置: 學生活動中心 (E31), 2樓",
        "email": "scs@um.edu.mo",
        "fax": "+853 8822 2369",
        "image": "https://map.um.edu.mo/emap_images/building_E31.jpg",
        "name": "學生輔導處 Student Counselling Section",
        "name:en": "Student Counselling Section",
        "name:zh": "學生輔導處",
        "phone": "+853 8822 4823",
        "website": "https://www.um.edu.mo/sao/scs/en/scs_index.php"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5443687,
          22.1268944
        ]
      },
      "id": "node/11399375135"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399375136",
        "amenity": "administration",
        "description": "Location: 2/F , Student Activity Centre (E31)",
        "description:en": "Location: 2/F , Student Activity Centre (E31)",
        "description:zh": "所在位置: 學生活動中心 (E31), 2樓",
        "email": "sds@um.edu.mo",
        "fax": "+853 8822 2346",
        "image": "https://map.um.edu.mo/emap_images/building_E31.jpg",
        "name": "學生發展處 Student Development Section",
        "name:en": "Student Development Section",
        "name:zh": "學生發展處",
        "phone": "+853 8822 4890",
        "website": "https://www.um.edu.mo/sao/sds/en/sds_index.php"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5440836,
          22.1269044
        ]
      },
      "id": "node/11399375136"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11399375137",
        "amenity": "administration",
        "description": "Location: 2/F , Student Activity Centre (E31)",
        "description:en": "Location: 2/F , Student Activity Centre (E31)",
        "description:zh": "所在位置: 學生活動中心 (E31), 2樓",
        "email": "srs@um.edu.mo",
        "fax": "+853 8822 2368",
        "image": "https://map.um.edu.mo/emap_images/building_E31.jpg",
        "name": "學生資源處 Student Resources Section",
        "name:en": "Student Resources Section",
        "name:zh": "學生資源處",
        "phone": "+853 8822 2546",
        "website": "https://srs.sao.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5439194,
          22.1269228
        ]
      },
      "id": "node/11399375137"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11418768723",
        "amenity": "atm",
        "branch": "BCM",
        "description": "Location: G/F, Faculty of Science and Technology",
        "description:en": "Location: G/F, Faculty of Science and Technology",
        "description:zh": "所在位置: 科技學院, G樓",
        "image": "https://map.um.edu.mo/emap_images/atm_E11-BCM.jpg",
        "name": "自動櫃員機 (E11) ATM (E11)",
        "name:en": "ATM (E11)",
        "name:zh": "自動櫃員機 (E11)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5432475,
          22.1320091
        ]
      },
      "id": "node/11418768723"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11418920578",
        "amenity": "atm",
        "description": "Location: G/F, Central Teaching Building E6",
        "description:en": "Location: G/F, Central Teaching Building E6",
        "description:zh": "所在位置: 中央教學樓東六座, G樓",
        "image": "https://map.um.edu.mo/emap_images/atm_E6-BNU.jpg",
        "name": "自動櫃員機 (E6) ATM (E6)",
        "name:en": "ATM (E6)",
        "name:zh": "自動櫃員機 (E6)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5450197,
          22.128463
        ]
      },
      "id": "node/11418920578"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11418920580",
        "amenity": "printing",
        "description": "Location: G/F, Faculty of Science and Technology",
        "description:en": "Location: G/F, Faculty of Science and Technology",
        "description:zh": "所在位置: 科技學院, G樓",
        "image": "https://map.um.edu.mo/emap_images/printing_E11-GF.jpg",
        "name": "打印區域 (E11 學習共享空間) Printing Area (E11 Learning Commons)",
        "name:en": "Printing Area (E11 Learning Commons)",
        "name:zh": "打印區域 (E11 學習共享空間)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5435626,
          22.1321734
        ]
      },
      "id": "node/11418920580"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11418920581",
        "amenity": "printing",
        "description": "Location: G/F, Faculty of Law",
        "description:en": "Location: G/F, Faculty of Law",
        "description:zh": "所在位置: 法學院, G樓",
        "image": "https://map.um.edu.mo/emap_images/printing_E32-GF.jpg",
        "name": "打印區域 (E32 學習共享空間) Printing Area (E11 Learning Commons)",
        "name:en": "Printing Area (E32 Learning Commons)",
        "name:zh": "打印區域 (E32 學習共享空間)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5438826,
          22.126371
        ]
      },
      "id": "node/11418920581"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11418967685",
        "amenity": "atm",
        "branch": "Bank of China",
        "description": "Location: G/F, Administration Building",
        "description:en": "Location: G/F, Administration Building",
        "description:zh": "所在位置: 行政樓, G樓",
        "image": "https://map.um.edu.mo/emap_images/atm_N6-BOC.jpg",
        "name": "自動櫃員機 (N6) ATM (N6)",
        "name:en": "ATM (N6)",
        "name:zh": "自動櫃員機 (N6)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5437054,
          22.1338562
        ]
      },
      "id": "node/11418967685"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11418967686",
        "amenity": "atm",
        "description": "Location: G/F, University Mall",
        "description:en": "Location: G/F, University Mall",
        "description:zh": "所在位置: 薈萃坊, G樓",
        "image": "https://map.um.edu.mo/emap_images/atm_S8-BOC.jpg",
        "name": "自動櫃員機 (S8) ATM (S8)",
        "name:en": "ATM (S8)",
        "name:zh": "自動櫃員機 (S8)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5444374,
          22.1241133
        ]
      },
      "id": "node/11418967686"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11418968235",
        "amenity": "printing",
        "description": "Location: G/F, UM Wu Yee Sun Library",
        "description:en": "Location: G/F, UM Wu Yee Sun Library",
        "description:zh": "所在位置: 澳門大學伍宜孫圖書館, G樓",
        "image": "https://map.um.edu.mo/emap_images/printing_E2-GF-A.jpg",
        "name": "打印區域 (E2 地面層) Printing Area (E2 G/F)",
        "name:en": "Printing Area (E2 G/F)",
        "name:zh": "打印區域 (E2 地面層)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5448879,
          22.1299375
        ]
      },
      "id": "node/11418968235"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11418976779",
        "amenity": "atm",
        "branch": "Bank of China",
        "description": "Location: G/F, UM Wu Yee Sun Library",
        "description:en": "Location: G/F, UM Wu Yee Sun Library",
        "description:zh": "所在位置: 澳門大學伍宜孫圖書館, G樓",
        "image": "https://map.um.edu.mo/emap_images/atm_E2-BOC.jpg",
        "name": "自動櫃員機 (E2) ATM (E2)",
        "name:en": "ATM (E2)",
        "name:zh": "自動櫃員機 (E2)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.544948,
          22.1304086
        ]
      },
      "id": "node/11418976779"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11418977599",
        "amenity": "printing",
        "description": "Location: 1/F, Faculty of Social Sciences",
        "description:en": "Location: 1/F, Faculty of Social Sciences",
        "description:zh": "所在位置: 社會科學學院, 1樓",
        "image": "https://map.um.edu.mo/emap_images/printing_E21B-GF.jpg",
        "name": "打印區域 (E21B 一樓) Printing Area (E21B 1/F)",
        "name:en": "Printing Area (E21B 1/F)",
        "name:zh": "打印區域 (E21B 一樓)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.54306,
          22.1289866
        ]
      },
      "id": "node/11418977599"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11419002045",
        "amenity": "atm",
        "branch": "Bank of China",
        "description": "Location: G/F, BOC Centennial Building",
        "description:en": "Location: G/F, BOC Centennial Building",
        "description:zh": "所在位置: 中銀百年紀念大樓, G樓",
        "image": "https://map.um.edu.mo/emap_images/atm_E3-BOC.jpg",
        "name": "自動櫃員機 (E3) ATM (E3)",
        "name:en": "ATM (E3)",
        "name:zh": "自動櫃員機 (E3)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5459867,
          22.1291185
        ]
      },
      "id": "node/11419002045"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11419056263",
        "amenity": "printing",
        "description": "Location: 3/F, UM Wu Yee Sun Library",
        "description:en": "Location: 3/F, UM Wu Yee Sun Library",
        "description:zh": "所在位置: 澳門大學伍宜孫圖書館, 3樓",
        "image": "https://map.um.edu.mo/emap_images/printing_E2-3F.jpg",
        "name": "打印區域 (E2 三樓) Printing Area (E2 3/F)",
        "name:en": "Printing Area (E2 3/F)",
        "name:zh": "打印區域 (E2 三樓)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5448476,
          22.1299397
        ]
      },
      "id": "node/11419056263"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11419061494",
        "amenity": "printing",
        "description": "Location: 2/F, Central Teaching Building E6",
        "description:en": "Location: 2/F, Central Teaching Building E6",
        "description:zh": "所在位置: 中央教學樓東六座, 2樓",
        "image": "https://map.um.edu.mo/emap_images/printing_E6-2F.jpg",
        "name": "打印區域 (E6 二樓電腦室走廊) Printing Area (E6 2/F Computer Room corridor)",
        "name:en": "Printing Area (E6 2/F Computer Room corridor)",
        "name:zh": "打印區域 (E6 二樓電腦室走廊)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5450206,
          22.1285803
        ]
      },
      "id": "node/11419061494"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11419061527",
        "amenity": "printing",
        "description": "Location: G/F, Faculty of Business Administration",
        "description:en": "Location: G/F, Faculty of Business Administration",
        "description:zh": "所在位置: 工商管理學院, G樓",
        "image": "https://map.um.edu.mo/emap_images/printing_E22-GF.jpg",
        "name": "打印區域 (E22 地面) Printing Area (E22 G/F)",
        "name:en": "Printing Area (E22 G/F)",
        "name:zh": "打印區域 (E22 地面)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5431572,
          22.1282531
        ]
      },
      "id": "node/11419061527"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11419061926",
        "amenity": "printing",
        "description": "Location: G/F, Central Teaching Building E6",
        "description:en": "Location: G/F, Central Teaching Building E6",
        "description:zh": "所在位置: 中央教學樓東六座, G樓",
        "image": "https://map.um.edu.mo/emap_images/printing_E6-G111i.jpg",
        "name": "打印室 (E6-G111i) Printing Room (E6-G111i)",
        "name:en": "Printing Room (E6-G111i)",
        "name:zh": "打印室 (E6-G111i)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.544978,
          22.1285254
        ]
      },
      "id": "node/11419061926"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11419077825",
        "amenity": "printing",
        "description": "Location: G/F, Faculty of Health Sciences",
        "description:en": "Location: G/F, Faculty of Health Sciences",
        "description:zh": "所在位置: 健康科學學院, G樓",
        "image": "https://map.um.edu.mo/emap_images/printing_E12-GF.jpg",
        "name": "打印區域 (E12 地面) Printing Area (E12 G/F)",
        "name:en": "Printing Area (E12 G/F)",
        "name:zh": "打印區域 (E12 地面)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5432453,
          22.1310818
        ]
      },
      "id": "node/11419077825"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11419079924",
        "amenity": "printing",
        "description": "Location: 1/F, Faculty of Education",
        "description:en": "Location: 1/F, Faculty of Education",
        "description:zh": "所在位置: 教育學院, 1樓",
        "image": "https://map.um.edu.mo/emap_images/printing_E33-1F.jpg",
        "name": "打印區域 (E33 一樓) Printing Area (E32 Learning Commons)",
        "name:en": "Printing Area (E33 1/F)",
        "name:zh": "打印區域 (E33 一樓)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5441932,
          22.125677
        ]
      },
      "id": "node/11419079924"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11419087664",
        "amenity": "printing",
        "description": "Location: G/F, Faculty of Arts and Humanities",
        "description:en": "Location: G/F, Faculty of Arts and Humanities",
        "description:zh": "所在位置: 人文學院, G樓",
        "image": "https://map.um.edu.mo/emap_images/printing_E21A-GF.jpg",
        "name": "打印區域 (E21A 學習共享空間) Printing Area (E21A Learning Commons)",
        "name:en": "Printing Area (E21A Learning Commons)",
        "name:zh": "打印區域 (E21A 學習共享空間)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5430387,
          22.1295532
        ]
      },
      "id": "node/11419087664"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11521352599",
        "amenity": "administration",
        "description": "Location: Room 2026, Administration Building",
        "description:en": "Location: Room 2026, Administration Building",
        "description:zh": "所在位置: 行政樓, 2026室",
        "email": "aao@um.edu.mo",
        "fax": "+853 8822 2424",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "校友及發展辦公室 Alumni and Development Office",
        "name:en": "Alumni and Development Office",
        "name:zh": "校友及發展辦公室",
        "phone": "+853 8822 4807",
        "website": "https://aao.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5440773,
          22.1336903
        ]
      },
      "id": "node/11521352599"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11521390235",
        "description": "Location: Room G001, Administration Building (N6)",
        "description:en": "Location: Room G001, Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), G001室",
        "email": "gradschool@um.edu.mo",
        "fax": "+853 8822 2327",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "研究生院 Graduate School",
        "name:en": "Graduate School",
        "name:zh": "研究生院",
        "office": "university",
        "phone": "+853 8822 4898",
        "website": "https://grs.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.544369,
          22.1336996
        ]
      },
      "id": "node/11521390235"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11530160257",
        "amenity": "bus_station",
        "bus": "yes",
        "description": "Location: E32 Faculty of Law",
        "description:en": "Location: E32 Faculty of Law",
        "description:zh": "所在位置: E32 法學院",
        "highway": "bus_stop",
        "image": "https://map.um.edu.mo/emap_images/campus-loop_07.jpg",
        "name": "環校穿梭巴士站 Campus Loop Shuttle Bus Stop #7",
        "name:en": "Campus Loop Shuttle Bus Stop #7",
        "name:zh": "環校穿梭巴士站 #7",
        "public_transport": "platform",
        "route_ref": "UM Campus Loop Shuttle Bus",
        "route_ref:en": "UM Campus Loop Shuttle Bus",
        "route_ref:zh": "澳大環校穿梭巴士",
        "website": "https://campusloop.cmdo.um.edu.mo/en_US/busstopinfo",
        "website:en": "https://campusloop.cmdo.um.edu.mo/en_US/busstopinfo",
        "website:zh": "https://campusloop.cmdo.um.edu.mo/zh_TW/busstopinfo"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5431321,
          22.1262956
        ]
      },
      "id": "node/11530160257"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11530162180",
        "amenity": "printing",
        "description": "Location: 1/F, Central Teaching Building E6",
        "description:en": "Location: 1/F, Central Teaching Building E6",
        "description:zh": "所在位置: 中央教學樓東六座, 1樓",
        "image": "https://map.um.edu.mo/emap_images/printing_E6-1091a.jpg",
        "name": "打印室 (E6-1091a) Printing Room (E6-1091a)",
        "name:en": "Printing Room (E6-1091a)",
        "name:zh": "打印室 (E6-1091a)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.544981,
          22.1285812
        ]
      },
      "id": "node/11530162180"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11530180107",
        "amenity": "bus_station",
        "bus": "yes",
        "description": "Location: N2 University Hall",
        "description:en": "Location: N2 University Hall",
        "description:zh": "所在位置: N2 大學會堂",
        "highway": "bus_stop",
        "image": "https://map.um.edu.mo/emap_images/campus-loop_03.jpg",
        "name": "環校穿梭巴士站 Campus Loop Shuttle Bus Stop #3",
        "name:en": "Campus Loop Shuttle Bus Stop #3",
        "name:zh": "環校穿梭巴士站 #3",
        "public_transport": "platform",
        "route_ref": "UM Campus Loop Shuttle Bus",
        "route_ref:en": "UM Campus Loop Shuttle Bus",
        "route_ref:zh": "澳大環校穿梭巴士",
        "website": "https://campusloop.cmdo.um.edu.mo/en_US/busstopinfo",
        "website:en": "https://campusloop.cmdo.um.edu.mo/en_US/busstopinfo",
        "website:zh": "https://campusloop.cmdo.um.edu.mo/zh_TW/busstopinfo"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5463546,
          22.1342349
        ]
      },
      "id": "node/11530180107"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11530180131",
        "amenity": "bus_station",
        "bus": "yes",
        "description": "Location: E21 Humanities and Social Sciences Building",
        "description:en": "Location: E21 Humanities and Social Sciences Building",
        "description:zh": "所在位置: E21 人文社科樓",
        "highway": "bus_stop",
        "image": "https://map.um.edu.mo/emap_images/campus-loop_06.jpg",
        "name": "環校穿梭巴士站 Campus Loop Shuttle Bus Stop #6",
        "name:en": "Campus Loop Shuttle Bus Stop #6",
        "name:zh": "環校穿梭巴士站 #6",
        "public_transport": "platform",
        "route_ref": "UM Campus Loop Shuttle Bus",
        "route_ref:en": "UM Campus Loop Shuttle Bus",
        "route_ref:zh": "澳大環校穿梭巴士",
        "website": "https://campusloop.cmdo.um.edu.mo/en_US/busstopinfo",
        "website:en": "https://campusloop.cmdo.um.edu.mo/en_US/busstopinfo",
        "website:zh": "https://campusloop.cmdo.um.edu.mo/zh_TW/busstopinfo"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5422665,
          22.1292807
        ]
      },
      "id": "node/11530180131"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11530195016",
        "amenity": "bus_station",
        "bus": "yes",
        "description": "Location: E4 Anthony Lau Building",
        "description:en": "Location: E4 Anthony Lau Building",
        "description:zh": "所在位置: E4 劉少榮樓",
        "highway": "bus_stop",
        "image": "https://map.um.edu.mo/emap_images/campus-loop_02.jpg",
        "name": "環校穿梭巴士站 Campus Loop Shuttle Bus Stop #2",
        "name:en": "Campus Loop Shuttle Bus Stop #2",
        "name:zh": "環校穿梭巴士站 #2",
        "public_transport": "platform",
        "route_ref": "UM Campus Loop Shuttle Bus",
        "route_ref:en": "UM Campus Loop Shuttle Bus",
        "route_ref:zh": "澳大環校穿梭巴士",
        "website": "https://campusloop.cmdo.um.edu.mo/en_US/busstopinfo",
        "website:en": "https://campusloop.cmdo.um.edu.mo/en_US/busstopinfo",
        "website:zh": "https://campusloop.cmdo.um.edu.mo/zh_TW/busstopinfo"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5464622,
          22.1281652
        ]
      },
      "id": "node/11530195016"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11530199273",
        "amenity": "bus_station",
        "bus": "yes",
        "description": "Location: E11 Faculty of Science and Technology",
        "description:en": "Location: E11 Faculty of Science and Technology",
        "description:zh": "所在位置: E11 科技學院",
        "highway": "bus_stop",
        "image": "https://map.um.edu.mo/emap_images/campus-loop_05.jpg",
        "name": "環校穿梭巴士站 Campus Loop Shuttle Bus Stop #5",
        "name:en": "Campus Loop Shuttle Bus Stop #5",
        "name:zh": "環校穿梭巴士站 #5",
        "public_transport": "platform",
        "route_ref": "UM Campus Loop Shuttle Bus",
        "route_ref:en": "UM Campus Loop Shuttle Bus",
        "route_ref:zh": "澳大環校穿梭巴士",
        "website": "https://campusloop.cmdo.um.edu.mo/en_US/busstopinfo",
        "website:en": "https://campusloop.cmdo.um.edu.mo/en_US/busstopinfo",
        "website:zh": "https://campusloop.cmdo.um.edu.mo/zh_TW/busstopinfo"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.542478,
          22.132587
        ]
      },
      "id": "node/11530199273"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11530209502",
        "amenity": "bus_station",
        "bus": "yes",
        "description": "Location: PGH Postgraduate Houses Bus Stop",
        "description:en": "Location: PGH Postgraduate Houses Bus Stop",
        "description:zh": "所在位置: PGH 研究生宿舍巴士站",
        "highway": "bus_stop",
        "image": "https://map.um.edu.mo/emap_images/campus-loop_01.jpg",
        "name": "環校穿梭巴士站 Campus Loop Shuttle Bus Stop #1",
        "name:en": "Campus Loop Shuttle Bus Stop #1",
        "name:zh": "環校穿梭巴士站 #1",
        "public_transport": "platform",
        "route_ref": "UM Campus Loop Shuttle Bus",
        "route_ref:en": "UM Campus Loop Shuttle Bus",
        "route_ref:zh": "澳大環校穿梭巴士",
        "website": "https://campusloop.cmdo.um.edu.mo/en_US/busstopinfo",
        "website:en": "https://campusloop.cmdo.um.edu.mo/en_US/busstopinfo",
        "website:zh": "https://campusloop.cmdo.um.edu.mo/zh_TW/busstopinfo"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5461854,
          22.1244961
        ]
      },
      "id": "node/11530209502"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11530214723",
        "amenity": "bus_station",
        "bus": "yes",
        "description": "Location: N6 Administration Building",
        "description:en": "Location: N6 Administration Building",
        "description:zh": "所在位置: N6 行政樓",
        "highway": "bus_stop",
        "image": "https://map.um.edu.mo/emap_images/campus-loop_04.jpg",
        "name": "環校穿梭巴士站 Campus Loop Shuttle Bus Stop #4",
        "name:en": "Campus Loop Shuttle Bus Stop #4",
        "name:zh": "環校穿梭巴士站 #4",
        "public_transport": "platform",
        "route_ref": "UM Campus Loop Shuttle Bus",
        "route_ref:en": "UM Campus Loop Shuttle Bus",
        "route_ref:zh": "澳大環校穿梭巴士",
        "website": "https://campusloop.cmdo.um.edu.mo/en_US/busstopinfo",
        "website:en": "https://campusloop.cmdo.um.edu.mo/en_US/busstopinfo",
        "website:zh": "https://campusloop.cmdo.um.edu.mo/zh_TW/busstopinfo"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5436029,
          22.133804
        ]
      },
      "id": "node/11530214723"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11530223580",
        "amenity": "bus_station",
        "bus": "yes",
        "description": "Location: S4 Postgraduate House S4 (near Corridor)",
        "description:en": "Location: S4 Postgraduate House S4 (near Corridor)",
        "description:zh": "所在位置: S4 研究生宿舍南四座(近連廊)",
        "highway": "bus_stop",
        "image": "https://map.um.edu.mo/emap_images/campus-loop_08.jpg",
        "name": "環校穿梭巴士站 Campus Loop Shuttle Bus Stop #8",
        "name:en": "Campus Loop Shuttle Bus Stop #8",
        "name:zh": "環校穿梭巴士站 #8",
        "public_transport": "platform",
        "route_ref": "UM Campus Loop Shuttle Bus",
        "route_ref:en": "UM Campus Loop Shuttle Bus",
        "route_ref:zh": "澳大環校穿梭巴士",
        "website": "https://campusloop.cmdo.um.edu.mo/en_US/busstopinfo",
        "website:en": "https://campusloop.cmdo.um.edu.mo/en_US/busstopinfo",
        "website:zh": "https://campusloop.cmdo.um.edu.mo/zh_TW/busstopinfo"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.544663,
          22.1233051
        ]
      },
      "id": "node/11530223580"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11542069552",
        "amenity": "administration",
        "description": "Location: Room 5011, Administration Building (N6)",
        "description:en": "Location: Room 5011, Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), 5011室",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "研究服務及知識轉移辦公室 Research Services and Knowledge Transfer Office",
        "name:en": "Research Services and Knowledge Transfer Office",
        "name:zh": "研究服務及知識轉移辦公室",
        "website": "https://www.um.edu.mo/research/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5441402,
          22.1338288
        ]
      },
      "id": "node/11542069552"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807840",
        "description": "Location: UM Wu Yee Sun Library (E2)",
        "description:en": "Location: UM Wu Yee Sun Library (E2)",
        "description:zh": "所在位置: 澳門大學伍宜孫圖書館 (E2)",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5454543,
          22.130488
        ]
      },
      "id": "node/11629807840"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807841",
        "description": "Location: UM Wu Yee Sun Library (E2)",
        "description:en": "Location: UM Wu Yee Sun Library (E2)",
        "description:zh": "所在位置: 澳門大學伍宜孫圖書館 (E2)",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5454495,
          22.1295953
        ]
      },
      "id": "node/11629807841"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807842",
        "description": "Location: UM Wu Yee Sun Library (E2)",
        "description:en": "Location: UM Wu Yee Sun Library (E2)",
        "description:zh": "所在位置: 澳門大學伍宜孫圖書館 (E2)",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5454902,
          22.1300806
        ]
      },
      "id": "node/11629807842"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807843",
        "description": "Location: UM Wu Yee Sun Library (E2)",
        "description:en": "Location: UM Wu Yee Sun Library (E2)",
        "description:zh": "所在位置: 澳門大學伍宜孫圖書館 (E2)",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5444386,
          22.1301584
        ]
      },
      "id": "node/11629807843"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807844",
        "description": "Location: UM Wu Yee Sun Library (E2)",
        "description:en": "Location: UM Wu Yee Sun Library (E2)",
        "description:zh": "所在位置: 澳門大學伍宜孫圖書館 (E2)",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5444404,
          22.1298797
        ]
      },
      "id": "node/11629807844"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807845",
        "description": "Location: University Gallery (E1)",
        "description:en": "Location: University Gallery (E1)",
        "description:zh": "所在位置: 大學展館 (E1)",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5456031,
          22.1307626
        ]
      },
      "id": "node/11629807845"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807846",
        "description": "Location: Avenida da Universidade",
        "description:en": "Location: Avenida da Universidade",
        "description:zh": "所在位置: 大學大馬路",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5463842,
          22.1296345
        ]
      },
      "id": "node/11629807846"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807847",
        "description": "Location: G/F corridor, BOC Centennial Building",
        "description:en": "Location: G/F corridor, BOC Centennial Building",
        "description:zh": "所在位置: 中銀百年紀念大樓, G樓走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5457664,
          22.1291562
        ]
      },
      "id": "node/11629807847"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807848",
        "description": "Location: G/F corridor, Central Teaching Building (E7)",
        "description:en": "Location: G/F corridor, Central Teaching Building (E7)",
        "description:zh": "所在位置: 中央教學樓東七座, G樓走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5453831,
          22.1291934
        ]
      },
      "id": "node/11629807848"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807849",
        "description": "Location: Bus Stop,  UM Guest House (N1)",
        "description:en": "Location: Bus Stop,  UM Guest House (N1)",
        "description:zh": "所在位置: 聚賢樓 (N1) 巴士站",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (N1 Bus Stop)",
        "name:en": "Outdoor WiFi AP (N1 Bus Stop)",
        "name:zh": "室外無線網熱點 (N1 巴士站)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5461006,
          22.1338493
        ]
      },
      "id": "node/11629807849"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807850",
        "description": "Location: G/F corridor, Administration Building (N6)",
        "description:en": "Location: G/F corridor, Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), G樓走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (N6 South - 2)",
        "name:en": "Outdoor WiFi AP (N6 South - 2)",
        "name:zh": "室外無線網熱點 (N6 南面 - 2)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5446237,
          22.1336115
        ]
      },
      "id": "node/11629807850"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807851",
        "description": "Location: G/F corridor, Administration Building (N6)",
        "description:en": "Location: G/F corridor, Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), G樓走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (N6 Staff Bus Stop)",
        "name:en": "Outdoor WiFi AP (N6 Staff Bus Stop)",
        "name:zh": "室外無線網熱點 (N6 員工巴士站)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5436608,
          22.1337159
        ]
      },
      "id": "node/11629807851"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807852",
        "description": "Location: G/F corridor, Administration Building (N6)",
        "description:en": "Location: G/F corridor, Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6), G樓走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (N6 South - 1)",
        "name:en": "Outdoor WiFi AP (N6 South - 1)",
        "name:zh": "室外無線網熱點 (N6 南面 - 1)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5438509,
          22.1334079
        ]
      },
      "id": "node/11629807852"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807853",
        "description": "Location: Bus Stop,  Administration Building (N6)",
        "description:en": "Location: Bus Stop,  Administration Building (N6)",
        "description:zh": "所在位置: 行政樓 (N6) 巴士站",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (N6 Bus Stop)",
        "name:en": "Outdoor WiFi AP (N6 Bus Stop)",
        "name:zh": "室外無線網熱點 (N6 巴士站)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5436667,
          22.1340708
        ]
      },
      "id": "node/11629807853"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807854",
        "description": "Location: Central Avenue, Faculty of Science and Technology (E11)",
        "description:en": "Location: Central Avenue, Faculty of Science and Technology (E11)",
        "description:zh": "所在位置: 科技學院 (E11), 中央大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (E11 East - 1)",
        "name:en": "Outdoor WiFi AP (E11 East - 1)",
        "name:zh": "室外無線網熱點 (E11 東面 - 1)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5438882,
          22.1328521
        ]
      },
      "id": "node/11629807854"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807855",
        "description": "Location: Central Avenue, Faculty of Science and Technology (E11)",
        "description:en": "Location: Central Avenue, Faculty of Science and Technology (E11)",
        "description:zh": "所在位置: 科技學院 (E11), 中央大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (E11 East - 2)",
        "name:en": "Outdoor WiFi AP (E11 East - 2)",
        "name:zh": "室外無線網熱點 (E11 東面 - 2)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5438829,
          22.132557
        ]
      },
      "id": "node/11629807855"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807856",
        "description": "Location: Central Avenue, Faculty of Science and Technology (E11)",
        "description:en": "Location: Central Avenue, Faculty of Science and Technology (E11)",
        "description:zh": "所在位置: 科技學院 (E11), 中央大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (E11 East - 3)",
        "name:en": "Outdoor WiFi AP (E11 East - 3)",
        "name:zh": "室外無線網熱點 (E11 東面 - 3)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5438716,
          22.1320324
        ]
      },
      "id": "node/11629807856"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807857",
        "description": "Location: Central Avenue, Faculty of Health Sciences (E12)",
        "description:en": "Location: Central Avenue, Faculty of Health Sciences (E12)",
        "description:zh": "所在位置: 健康科學學院 (E12), 中央大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5437714,
          22.1313432
        ]
      },
      "id": "node/11629807857"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807858",
        "description": "Location: Central Avenue, Faculty of Health Sciences (E12)",
        "description:en": "Location: Central Avenue, Faculty of Health Sciences (E12)",
        "description:zh": "所在位置: 健康科學學院 (E12), 中央大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5435258,
          22.1303818
        ]
      },
      "id": "node/11629807858"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807859",
        "description": "Location: Central Avenue, Faculty of Business Administration (E22)",
        "description:en": "Location: Central Avenue, Faculty of Business Administration (E22)",
        "description:zh": "所在位置: 工商管理學院 (E22), 中央大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5436824,
          22.1285202
        ]
      },
      "id": "node/11629807859"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807860",
        "description": "Location: Central Avenue, Faculty of Social Sciences (E21B)",
        "description:en": "Location: Central Avenue, Faculty of Social Sciences (E21B)",
        "description:zh": "所在位置: 社會科學學院 (E21B), 中央大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5439288,
          22.1290776
        ]
      },
      "id": "node/11629807860"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807861",
        "description": "Location: G/F corridor, Faculty of Social Sciences (E21B)",
        "description:en": "Location: G/F corridor, Faculty of Social Sciences (E21B)",
        "description:zh": "所在位置: 社會科學學院 (E21B), G層走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.543486,
          22.1288678
        ]
      },
      "id": "node/11629807861"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807862",
        "description": "Location: G/F corridor, Faculty of Business Administration (E22)",
        "description:en": "Location: G/F corridor, Faculty of Business Administration (E22)",
        "description:zh": "所在位置: 工商管理學院 (E22), G層走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5429339,
          22.1285465
        ]
      },
      "id": "node/11629807862"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807863",
        "description": "Location: Central Avenue, Central Teaching Building E6",
        "description:en": "Location: Central Avenue, Central Teaching Building E6",
        "description:zh": "所在位置: 中央教學樓東六座, 中央大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5446168,
          22.1288497
        ]
      },
      "id": "node/11629807863"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807864",
        "description": "Location: Central Avenue, Student Activity Centre (E31)",
        "description:en": "Location: Central Avenue, Student Activity Centre (E31)",
        "description:zh": "所在位置: 學生活動中心 (E31), 中央大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.543824,
          22.1274252
        ]
      },
      "id": "node/11629807864"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807865",
        "description": "Location: Central Avenue, Student Activity Centre (E31)",
        "description:en": "Location: Central Avenue, Student Activity Centre (E31)",
        "description:zh": "所在位置: 學生活動中心 (E31), 中央大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5441549,
          22.1272187
        ]
      },
      "id": "node/11629807865"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807866",
        "description": "Location: G/F corridor, Student Activity Centre (E31)",
        "description:en": "Location: G/F corridor, Student Activity Centre (E31)",
        "description:zh": "所在位置: 學生活動中心 (E31), G層走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5447606,
          22.1268703
        ]
      },
      "id": "node/11629807866"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629807867",
        "description": "Location: G/F corridor, Central Teaching Building (E5)",
        "description:en": "Location: G/F corridor, Central Teaching Building (E5)",
        "description:zh": "所在位置: 中央教學樓 (E5), G層走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5448082,
          22.1279009
        ]
      },
      "id": "node/11629807867"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848771",
        "description": "Location: G/F corridor, Faculty of Law (E32)",
        "description:en": "Location: G/F corridor, Faculty of Law (E32)",
        "description:zh": "所在位置: 法學院 (E32), G層走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.544539,
          22.1264105
        ]
      },
      "id": "node/11629848771"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848772",
        "description": "Location: G/F corridor, Faculty of Education",
        "description:en": "Location: G/F corridor, Faculty of Education",
        "description:zh": "所在位置: 教育學院, G層走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5446955,
          22.1256912
        ]
      },
      "id": "node/11629848772"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848773",
        "description": "Location: Bus Stop,  Postgraduates House (S1)",
        "description:en": "Location: Bus Stop,  Postgraduates House (S1)",
        "description:zh": "所在位置: 研究生宿舍 (S1) 巴士站",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5460924,
          22.1247373
        ]
      },
      "id": "node/11629848773"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848774",
        "description": "Location: Bus Stop,  Postgraduates House (S3)",
        "description:en": "Location: Bus Stop,  Postgraduates House (S3)",
        "description:zh": "所在位置: 研究生宿舍 (S3) 巴士站",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5460851,
          22.124297
        ]
      },
      "id": "node/11629848774"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848775",
        "description": "Location: G/F corridor, Postgraduates House (S4)",
        "description:en": "Location: G/F corridor, Postgraduates House (S4)",
        "description:zh": "所在位置: 研究生宿舍 (S4), G層走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5449142,
          22.1239995
        ]
      },
      "id": "node/11629848775"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848776",
        "description": "Location: G/F corridor, Postgraduates House (S3)",
        "description:en": "Location: G/F corridor, Postgraduates House (S3)",
        "description:zh": "所在位置: 研究生宿舍 (S3), G層走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5459143,
          22.1235494
        ]
      },
      "id": "node/11629848776"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848777",
        "description": "Location: G/F corridor, Staff Quarters S24",
        "description:en": "Location: G/F corridor, Staff Quarters S24",
        "description:zh": "所在位置: 教職員宿舍南二十四座 (S24), G層走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5445768,
          22.1227811
        ]
      },
      "id": "node/11629848777"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848778",
        "description": "Location: G/F corridor, Cheong Kun Lun College (W34)",
        "description:en": "Location: G/F corridor, Cheong Kun Lun College (W34)",
        "description:zh": "所在位置: 張崑崙書院 (W34), G層走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (Island 3)",
        "name:en": "Outdoor WiFi AP (Island 3)",
        "name:zh": "室外無線網熱點 (島3)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.541884,
          22.1259348
        ]
      },
      "id": "node/11629848778"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848779",
        "description": "Location: G/F corridor, Cheng Yu Tung College (W23)",
        "description:en": "Location: G/F corridor, Cheng Yu Tung College (W23)",
        "description:zh": "所在位置: 鄭裕彤書院 (W23), G層走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (Island 2)",
        "name:en": "Outdoor WiFi AP (Island 2)",
        "name:zh": "室外無線網熱點 (島2)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.541829,
          22.1286625
        ]
      },
      "id": "node/11629848779"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848780",
        "description": "Location: G/F corridor, Moon Chun Memorial College (W11)",
        "description:en": "Location: G/F corridor, Moon Chun Memorial College (W11)",
        "description:zh": "所在位置: 滿珍紀念書院 (W11), G層走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (Island 1)",
        "name:en": "Outdoor WiFi AP (Island 1)",
        "name:zh": "室外無線網熱點 (島1)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5421055,
          22.1318241
        ]
      },
      "id": "node/11629848780"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848781",
        "description": "Location: Alumni Avenue, Cultural Building (E34)",
        "description:en": "Location: Alumni Avenue, Cultural Building (E34)",
        "description:zh": "所在位置: 祟文樓 (E34), 校友大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (Island 3 Covered Walkway)",
        "name:en": "Outdoor WiFi AP (Island 3 Covered Walkway)",
        "name:zh": "室外無線網熱點 (島3連廊)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.543059,
          22.1261407
        ]
      },
      "id": "node/11629848781"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848782",
        "description": "Location: Alumni Avenue, Faculty of Law (E32)",
        "description:en": "Location: Alumni Avenue, Faculty of Law (E32)",
        "description:zh": "所在位置: 法學院 (E32), 校友大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5432418,
          22.1262654
        ]
      },
      "id": "node/11629848782"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848783",
        "description": "Location: Alumni Avenue, Faculty of Social Sciences (E21B)",
        "description:en": "Location: Alumni Avenue, Faculty of Social Sciences (E21B)",
        "description:zh": "所在位置: 社會科學學院 (E21B), 校友大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (Island 2 Covered Walkway)",
        "name:en": "Outdoor WiFi AP (Island 2 Covered Walkway)",
        "name:zh": "室外無線網熱點 (島2連廊)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5421929,
          22.1288817
        ]
      },
      "id": "node/11629848783"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848784",
        "description": "Location: Alumni Avenue, Chao Kuang Piu College (W21)",
        "description:en": "Location: Alumni Avenue, Chao Kuang Piu College (W21)",
        "description:zh": "所在位置: 曹光彪書院 (W21), 校友大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.542045,
          22.1292813
        ]
      },
      "id": "node/11629848784"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848785",
        "description": "Location: Alumni Avenue, Moon Chun Memorial College (W11)",
        "description:en": "Location: Alumni Avenue, Moon Chun Memorial College (W11)",
        "description:zh": "所在位置: 滿珍紀念書院 (W11), 校友大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (Island 1 Covered Walkway)",
        "name:en": "Outdoor WiFi AP (Island 1 Covered Walkway)",
        "name:zh": "室外無線網熱點 (島1連廊)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5424301,
          22.1318571
        ]
      },
      "id": "node/11629848785"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848786",
        "description": "Location: Alumni Avenue, Moon Chun Memorial College (W11)",
        "description:en": "Location: Alumni Avenue, Moon Chun Memorial College (W11)",
        "description:zh": "所在位置: 滿珍紀念書院 (W11), 校友大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (W11 East)",
        "name:en": "Outdoor WiFi AP (W11 East)",
        "name:zh": "室外無線網熱點 (W11 東面)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5422607,
          22.1322167
        ]
      },
      "id": "node/11629848786"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848787",
        "description": "Location: G/F corridor, Staff Quarters S24",
        "description:en": "Location: G/F corridor, Staff Quarters S24",
        "description:zh": "所在位置: 教職員宿舍南二十四座 (S24), G層走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5446626,
          22.1231754
        ]
      },
      "id": "node/11629848787"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848788",
        "description": "Location: G/F corridor, Cheng Yu Tung College (W23)",
        "description:en": "Location: G/F corridor, Cheng Yu Tung College (W23)",
        "description:zh": "所在位置: 鄭裕彤書院 (W23), G層走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (Island 2 Outdoor Sports Venue)",
        "name:en": "Outdoor WiFi AP (Island 2 Outdoor Sports Venue)",
        "name:zh": "室外無線網熱點 (島2室外體育場地)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5418017,
          22.1279873
        ]
      },
      "id": "node/11629848788"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848789",
        "description": "Location: G/F corridor, Henry Fok Pearl Jubilee College (W14)",
        "description:en": "Location: G/F corridor, Henry Fok Pearl Jubilee College (W14)",
        "description:zh": "所在位置: 霍英東珍禧書院 (W14), G層走廊",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP (Island 1 Outdoor Sports Venue)",
        "name:en": "Outdoor WiFi AP (Island 1 Outdoor Sports Venue)",
        "name:zh": "室外無線網熱點 (島1室外體育場地)",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5417288,
          22.1308961
        ]
      },
      "id": "node/11629848789"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848790",
        "description": "Location: Central Avenue, Central Teaching Building E6",
        "description:en": "Location: Central Avenue, Central Teaching Building E6",
        "description:zh": "所在位置: 中央教學樓東六座, 中央大道",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5447655,
          22.1283624
        ]
      },
      "id": "node/11629848790"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11629848791",
        "description": "Location: The Statue of Confucius, Anthony Lau Building (E4)",
        "description:en": "Location: The Statue of Confucius, Anthony Lau Building (E4)",
        "description:zh": "所在位置: 孔子像, 劉少榮樓 (E4)",
        "internet_access": "wlan",
        "internet_access:fee": "no",
        "internet_access:ssid": "UM_PUBLIC_WIFI",
        "name": "Outdoor WiFi AP",
        "name:en": "Outdoor WiFi AP",
        "name:zh": "室外無線網熱點",
        "website": "https://icto.um.edu.mo/wireless-network-service/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5458513,
          22.1286479
        ]
      },
      "id": "node/11629848791"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11659081917",
        "bus": "yes",
        "highway": "bus_stop",
        "name": "子期南道中",
        "public_transport": "platform"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5352182,
          22.1303595
        ]
      },
      "id": "node/11659081917"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11659081918",
        "bus": "yes",
        "highway": "bus_stop",
        "name": "子期南道中",
        "public_transport": "platform"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5350296,
          22.1303074
        ]
      },
      "id": "node/11659081918"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11668687169",
        "amenity": "printing",
        "description": "Location: 1/F, UM Wu Yee Sun Library",
        "description:en": "Location: 1/F, UM Wu Yee Sun Library",
        "description:zh": "所在位置: 澳門大學伍宜孫圖書館, 1樓",
        "image": "https://map.um.edu.mo/emap_images/printing_E2-1F.jpg",
        "name": "打印區域 (E2 一樓) Printing Area (E2 1/F)",
        "name:en": "Printing Area (E2 1/F)",
        "name:zh": "打印區域 (E2 一樓)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5448025,
          22.1299379
        ]
      },
      "id": "node/11668687169"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11671916297",
        "description": "Location: G/F, Postgraduate House (S1)",
        "description:en": "Location: G/F, Postgraduate House (S1)",
        "description:zh": "所在位置: 研究生宿舍 (S1), G樓",
        "image": "https://map.um.edu.mo/emap_images/retail-shop_renabee-logistics.jpg",
        "name": "窩蜂物流 Renabee Logistics",
        "name:en": "Renabee Logistics",
        "name:zh": "窩蜂物流",
        "shop": "yes",
        "website": "https://css.cmdo.um.edu.mo/outlets/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5456335,
          22.1251679
        ]
      },
      "id": "node/11671916297"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11671987788",
        "description": "Location: G/F, Library (E2)",
        "description:en": "Location: G/F, Library (E2)",
        "description:zh": "所在位置: 圖書館 (E2), G樓",
        "image": "https://map.um.edu.mo/emap_images/retail-shop_plaza-cultural-macau.jpg",
        "name": "澳門文化廣場 Plaza Cultural Macau",
        "name:en": "Plaza Cultural Macau",
        "name:zh": "澳門文化廣場",
        "shop": "books",
        "website": "https://css.cmdo.um.edu.mo/outlets/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5450872,
          22.1297579
        ]
      },
      "id": "node/11671987788"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11672019717",
        "description": "Location: G/F, Central Teaching Building (E6)",
        "description:en": "Location: G/F, Central Teaching Building (E6)",
        "description:zh": "所在位置: 中央教學樓 (E6), G樓",
        "image": "https://map.um.edu.mo/emap_images/retail-shop_E6-7-eleven.jpg",
        "name": "7-11便利店 7-Eleven (E6)",
        "name:en": "7-Eleven (E6)",
        "name:zh": "7-11便利店 (E6)",
        "shop": "yes",
        "website": "https://css.cmdo.um.edu.mo/outlets/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5453745,
          22.1286235
        ]
      },
      "id": "node/11672019717"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11675045174",
        "description": "Location: Room 4045, Faculty of Health Sciences (E12)",
        "description:en": "Location: Room 4045, Faculty of Health Sciences (E12)",
        "description:zh": "所在位置: 健康科學學院 (E12), 4045室",
        "email": "fhs.enquiry@um.edu.mo",
        "fax": "+853 8822 2314",
        "image": "https://map.um.edu.mo/emap_images/building_E12.jpg",
        "name": "健康科學學院 Faculty of Health Sciences (FHS)",
        "name:en": "Faculty of Health Sciences (FHS)",
        "name:zh": "健康科學學院 (FHS)",
        "office": "university",
        "phone": "+853 8822 4296",
        "website": "https://fhs.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5432697,
          22.1308537
        ]
      },
      "id": "node/11675045174"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11675123415",
        "description": "Location: Room 4040, Faculty of Science and Technology (E11)",
        "description:en": "Location: Room 4040, Faculty of Science and Technology (E11)",
        "description:zh": "所在位置: 科技學院 (E11), 4040室",
        "email": "fst.enquiry@um.edu.mo",
        "fax": "+853 8822 2426",
        "image": "https://map.um.edu.mo/emap_images/building_E11.jpg",
        "name": "科技學院 Faculty of Science and Technology (FST)",
        "name:en": "Faculty of Science and Technology (FST)",
        "name:zh": "科技學院 (FST)",
        "office": "university",
        "phone": "+853 8822 4963",
        "website": "https://www.fst.um.edu.mo"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5433166,
          22.1323941
        ]
      },
      "id": "node/11675123415"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11675123416",
        "description": "Location: Room G031, Faculty of Business Administration (E22)",
        "description:en": "Location: Room G031, Faculty of Business Administration (E22)",
        "description:zh": "所在位置: 工商管理學院 (E22), G031室",
        "email": "fba.suggestion@um.edu.mo",
        "fax": "+853 8822 2377",
        "image": "https://map.um.edu.mo/emap_images/building_E22.jpg",
        "name": "工商管理學院 Faculty of Business Administration (FBA)",
        "name:en": "Faculty of Business Administration (FBA)",
        "name:zh": "工商管理學院 (FBA)",
        "office": "university",
        "phone": "+853 8822 4656",
        "website": "https://fba.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5431557,
          22.1281951
        ]
      },
      "id": "node/11675123416"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11675123417",
        "description": "Location: Room 4004,  Faculty of Education (E33)",
        "description:en": "Location: Room 4004,  Faculty of Education (E33)",
        "description:zh": "所在位置: 教育學院 (E33), 4004室",
        "email": "fed.enquiry@um.edu.mo",
        "fax": "+853 2883 1695, +853 8822 2402",
        "image": "https://map.um.edu.mo/emap_images/building_E33.jpg",
        "name": "教育學院 Faculty of Education (FED)",
        "name:en": "Faculty of Education (FED)",
        "name:zh": "教育學院 (FED)",
        "office": "university",
        "phone": "+853 8822 8776, +853 8822 8789",
        "website": "https://fed.um.edu.mo"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5441481,
          22.1258471
        ]
      },
      "id": "node/11675123417"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11675123418",
        "description": "Location: Room 1003, Faculty of Law (E32)",
        "description:en": "Location: Room 1003, Faculty of Law (E32)",
        "description:zh": "所在位置: 法學院 (E32), 1003室",
        "email": "fll.suggestion@um.edu.mo",
        "fax": "+853 8822 2380",
        "image": "https://map.um.edu.mo/emap_images/building_E32.jpg",
        "name": "法學院 Faculty of Law (FLL)",
        "name:en": "Faculty of Law (FLL)",
        "name:zh": "法學院 (FLL)",
        "office": "university",
        "phone": "+853 8822 9358, +853 8822 4095",
        "website": "https://fll.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.543786,
          22.1263813
        ]
      },
      "id": "node/11675123418"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11690728666",
        "bus": "yes",
        "highway": "bus_stop",
        "name": "高级人才公寓",
        "name:zh-Hant": "高級人才公寓",
        "public_transport": "platform"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5355099,
          22.1285397
        ]
      },
      "id": "node/11690728666"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11700019998",
        "amenity": "drinking_water"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5521187,
          22.1353464
        ]
      },
      "id": "node/11700019998"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11700019999",
        "amenity": "drinking_water"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5568016,
          22.1256903
        ]
      },
      "id": "node/11700019999"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11752085696",
        "amenity": "parking",
        "layer": "-1",
        "parking": "underground"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5547138,
          22.1258057
        ]
      },
      "id": "node/11752085696"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11909386115",
        "amenity": "administration",
        "description": "Location: Room 2085, Central Teaching Building (E5)",
        "description:en": "Location: Room 2085, Central Teaching Building (E5)",
        "description:zh": "所在位置: 中央教學樓 (E5), 2085室",
        "email": "icto.helpdesk@um.edu.mo",
        "image": "https://map.um.edu.mo/emap_images/unit_ICTO-HelpDesk.jpg",
        "layer": "2",
        "name": "資訊及通訊科技部服務中心 ICTO Help Desk",
        "name:en": "ICTO Help Desk",
        "name:zh": "資訊及通訊科技部服務中心",
        "phone": "+853 8822 8600",
        "website": "https://icto.um.edu.mo/help-desk-services/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5453185,
          22.1281699
        ]
      },
      "id": "node/11909386115"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11936659985",
        "access": "yes",
        "amenity": "parking",
        "capacity": "550",
        "capacity:parent": "no",
        "capacity:women": "no",
        "description": "Location: UM Wu Yee Sun Library (E2) & Central Teaching Buildings (E3-E7)",
        "description:en": "Location: UM Wu Yee Sun Library (E2) & Central Teaching Buildings (E3-E7)",
        "description:zh": "所在位置: 澳門大學伍宜孫圖書館(E2)及中央教學樓(E3-E7)",
        "fee": "yes",
        "image": "https://map.um.edu.mo/emap_images/car-park_P5B.jpg",
        "name": "P5B訪客停車場 Visitor Car Park P5B",
        "name:en": "Visitor Car Park P5B",
        "name:zh": "P5B訪客停車場",
        "opening_hours": "24/7",
        "payment:cash": "yes",
        "website": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:en": "https://sfs.cmdo.um.edu.mo/our-services/car-park-management/",
        "website:zh": "https://sfs.cmdo.um.edu.mo/%e6%88%91%e5%80%91%e7%9a%84%e6%9c%8d%e5%8b%99/%e5%81%9c%e8%bb%8a%e5%a0%b4%e7%ae%a1%e7%90%86/?lang=zh-hant"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5463125,
          22.1290502
        ]
      },
      "id": "node/11936659985"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/11963747345",
        "name": "天沐河露营地",
        "tourism": "camp_site"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5350511,
          22.1351567
        ]
      },
      "id": "node/11963747345"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/12714939737",
        "description": "Location: 2/F, University Mall (S8)",
        "description:en": "Location: 2/F, University Mall (S8)",
        "description:zh": "所在位置: 薈萃坊 (S8), 2樓",
        "image": "https://map.um.edu.mo/emap_images/building_S8.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "筷子 Chopsticks",
        "name:en": "Chopsticks",
        "name:pt": "Chopsticks",
        "name:zh": "筷子",
        "shop": "restaurant",
        "website": "https://css.cmdo.um.edu.mo/outlets/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5443675,
          22.1242099
        ]
      },
      "id": "node/12714939737"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/12714946418",
        "description": "Location: 3/F, University Mall (S8)",
        "description:en": "Location: 3/F, University Mall (S8)",
        "description:zh": "所在位置: 薈萃坊 (S8), 3樓",
        "image": "https://map.um.edu.mo/emap_images/building_S8.jpg",
        "is_in": "Universidade de Macau;Nossa Senhora do Carmo;Taipa",
        "name": "上手屋 The K Style",
        "name:en": "The K Style",
        "name:pt": "The K Style",
        "name:zh": "上手屋",
        "shop": "hairdresser",
        "website": "https://css.cmdo.um.edu.mo/outlets/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.544368,
          22.1241582
        ]
      },
      "id": "node/12714946418"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/12780222126",
        "amenity": "restaurant",
        "brand": "麥當勞",
        "brand:en": "McDonald's",
        "brand:zh": "麥當勞",
        "cuisine": "burger",
        "description": "Location: G016, G017, G018, Postgraduates House (S1)",
        "description:en": "Location: G016, G017, G018, Postgraduates House (S1)",
        "description:zh": "所在位置: 研究生宿舍 (S1), G016, G017, G018",
        "image": "https://map.um.edu.mo/emap_images/dining-outlet_mcdonalds.jpg",
        "name": "麥當勞 McDonald's",
        "name:en": "McDonald's",
        "name:zh": "麥當勞",
        "not:brand:wikidata": "Q38076",
        "takeaway": "yes",
        "website": "https://css.cmdo.um.edu.mo/portfolio-items/mcdonalds/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5454495,
          22.1250957
        ]
      },
      "id": "node/12780222126"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/12900954985",
        "amenity": "administration",
        "description": "Location: Room 5037,  Administration Building",
        "description:en": "Location: Room 5037,  Administration Building",
        "description:zh": "所在位置: 行政樓, 5037室",
        "email": "fo@um.edu.mo",
        "fax": "+853 8822 2362",
        "image": "https://map.um.edu.mo/emap_images/building_N6.jpg",
        "name": "內部審計辦公室 Internal Audit Office (IAO)",
        "name:en": "Internal Audit Office (IAO)",
        "name:zh": "內部審計辦公室 (IAO)",
        "phone": "+853 8822 8581"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5441874,
          22.1337224
        ]
      },
      "id": "node/12900954985"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/12905374397",
        "amenity": "administration",
        "description": "Location: Room G003C, Central Teaching Building (E7)",
        "description:en": "Location: Room G003C, Central Teaching Building (E7)",
        "description:zh": "所在位置: 中央教學樓 (E7), G003C室",
        "name": "保安中心 Security Centre",
        "name:en": "Security Centre",
        "name:zh": "保安中心",
        "website": "https://sfs.cmdo.um.edu.mo/"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5450749,
          22.1289727
        ]
      },
      "id": "node/12905374397"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/12905463213",
        "asset_ref": "T557",
        "bus": "yes",
        "highway": "bus_stop",
        "image": "http://www.dsat.gov.mo/bres/bus_stop_img/t557_1.jpg",
        "name": "T557 大學北 University North",
        "name:en": "T557 University North",
        "name:pt": "T557 Norte da Universidade",
        "name:zh": "T557 大學北",
        "public_transport": "platform",
        "route_ref": "71;71S;72;73",
        "shelter": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          113.5465708,
          22.1341027
        ]
      },
      "id": "node/12905463213"
    }
  ]
